webpackJsonp(["2"],{

/***/ "./node_modules/bootstrap/dist/css/bootstrap.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/chain-function/index.js":
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),

/***/ "./node_modules/chickencurry/index.js":
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__("./node_modules/chickencurry/lib/merge.js"),
    countDefinedItems = __webpack_require__("./node_modules/chickencurry/lib/countDefinedItems.js"),
    slice = Array.prototype.slice,
    __;


function curry(fn, length, curryArgs) {
  return function() {
    var args = slice.call(arguments),
      concatArgs = curryArgs.concat(args),
      mergedArgs = [];

    if (length <= countDefinedItems(concatArgs)) {
      mergedArgs = merge(args, curryArgs);
      return fn.apply(null, mergedArgs);
    } else {
      if (length >= concatArgs.length) {
        return curry(fn, length, concatArgs);
      } else {
        return curry(fn, length, merge(args, curryArgs));
      }
    }
  };
}

module.exports = function(fn) {
  var args = slice.call(arguments, 1);

  return curry(fn, fn.length, args);
};

module.exports.n = function(fn, length) {
  var args = slice.call(arguments, 2);

  return curry(fn, length, args);
};

module.exports.__ = __;


/***/ }),

/***/ "./node_modules/chickencurry/lib/countDefinedItems.js":
/***/ (function(module, exports, __webpack_require__) {

var forEach = __webpack_require__("./node_modules/chickencurry/lib/forEach.js");

module.exports = function(args) {
  var count = 0;

  forEach(args, function(key, item) {
    if (typeof item !== 'undefined') {
      count = count + 1;
    }
  });

  return count;
};


/***/ }),

/***/ "./node_modules/chickencurry/lib/forEach.js":
/***/ (function(module, exports) {

module.exports = function forEach(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(i, arr[i]);
  }
};


/***/ }),

/***/ "./node_modules/chickencurry/lib/map.js":
/***/ (function(module, exports, __webpack_require__) {

var forEach = __webpack_require__("./node_modules/chickencurry/lib/forEach.js");

module.exports = function map(arr, fn) {
  var newArr = [];

  forEach(arr, function(key, item) {
    newArr.push(fn(key, item));
  });

  return newArr;
};


/***/ }),

/***/ "./node_modules/chickencurry/lib/merge.js":
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__("./node_modules/chickencurry/lib/map.js");

module.exports = function merge(args, curryArgs) {
  var mergedArgs = [];

  mergedArgs = map(curryArgs, function(key, item) {
    if (typeof item === 'undefined') {
      return args.shift();
    } else {
      return item;
    }
  });

  return mergedArgs.concat(args);
};


/***/ }),

/***/ "./node_modules/date-fns/difference_in_calendar_days/index.js":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("./node_modules/date-fns/start_of_day/index.js")

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),

/***/ "./node_modules/date-fns/format/index.js":
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__("./node_modules/date-fns/get_day_of_year/index.js")
var getISOWeek = __webpack_require__("./node_modules/date-fns/get_iso_week/index.js")
var getISOYear = __webpack_require__("./node_modules/date-fns/get_iso_year/index.js")
var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")
var isValid = __webpack_require__("./node_modules/date-fns/is_valid/index.js")
var enLocale = __webpack_require__("./node_modules/date-fns/locale/en/index.js")

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),

/***/ "./node_modules/date-fns/get_day_of_year/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")
var startOfYear = __webpack_require__("./node_modules/date-fns/start_of_year/index.js")
var differenceInCalendarDays = __webpack_require__("./node_modules/date-fns/difference_in_calendar_days/index.js")

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),

/***/ "./node_modules/date-fns/get_iso_week/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")
var startOfISOWeek = __webpack_require__("./node_modules/date-fns/start_of_iso_week/index.js")
var startOfISOYear = __webpack_require__("./node_modules/date-fns/start_of_iso_year/index.js")

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),

/***/ "./node_modules/date-fns/get_iso_year/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")
var startOfISOWeek = __webpack_require__("./node_modules/date-fns/start_of_iso_week/index.js")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),

/***/ "./node_modules/date-fns/is_date/index.js":
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),

/***/ "./node_modules/date-fns/is_valid/index.js":
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__("./node_modules/date-fns/is_date/index.js")

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),

/***/ "./node_modules/date-fns/locale/_lib/build_formatting_tokens_reg_exp/index.js":
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),

/***/ "./node_modules/date-fns/locale/en/build_distance_in_words_locale/index.js":
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),

/***/ "./node_modules/date-fns/locale/en/build_format_locale/index.js":
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__("./node_modules/date-fns/locale/_lib/build_formatting_tokens_reg_exp/index.js")

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),

/***/ "./node_modules/date-fns/locale/en/index.js":
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__("./node_modules/date-fns/locale/en/build_distance_in_words_locale/index.js")
var buildFormatLocale = __webpack_require__("./node_modules/date-fns/locale/en/build_format_locale/index.js")

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),

/***/ "./node_modules/date-fns/parse/index.js":
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__("./node_modules/date-fns/is_date/index.js")

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone)
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset()
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),

/***/ "./node_modules/date-fns/start_of_day/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),

/***/ "./node_modules/date-fns/start_of_iso_week/index.js":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("./node_modules/date-fns/start_of_week/index.js")

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),

/***/ "./node_modules/date-fns/start_of_iso_year/index.js":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("./node_modules/date-fns/get_iso_year/index.js")
var startOfISOWeek = __webpack_require__("./node_modules/date-fns/start_of_iso_week/index.js")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),

/***/ "./node_modules/date-fns/start_of_week/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),

/***/ "./node_modules/date-fns/start_of_year/index.js":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("./node_modules/date-fns/parse/index.js")

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),

/***/ "./node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("./node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":".","REACT_APP_COMMIT_SHA":"865943b97b","REACT_APP_COPYRIGHT_DATE":"2017","REACT_APP_COMPANY_NAME":"ON Semiconductor","REACT_APP_COMPANY_URL":"https://onsemi.com","REACT_APP_TOOL_NAME":"Boost Powertrain","REACT_APP_PRODUCT_LINK":"/PowerSolutions/product.do?id=","REACT_APP_DATASHEET_LINK":"/PowerSolutions/supportDoc.do?type=Datasheets&part=","REACT_APP_FEEDBACK_LINK":"/design/boost-api/feedback.html","REACT_APP_LEGAL_LINK":"/PowerSolutions/content.do?id=1108","REACT_APP_LOGGER_DIFF":"true","REACT_APP_MAX_DECIMAL_PLACES":"6","REACT_APP_API_DELAY":"500","REACT_APP_API_TIMEOUT":"25000","REACT_APP_LEFT_PANE_SIZE":"7","REACT_APP_PANEL_OFFSET":"0","REACT_APP_INITIAL_DESIGN_NAME":"Untitled Design","REACT_APP_TRACKING_ID":"UA-53160035-1","REACT_APP_ROLLBAR_CODE_VERSION":"0.0.1","REACT_APP_ROLLBAR_API_TOKEN":"4c5d12f6f54543d4b283608826989868","REACT_APP_BASE_PATH":"/site/design-tools/boost-powertrain","REACT_APP_API_BASE":"/","REACT_APP_API_REDIRECT_TIMEOUT":"2500","REACT_APP_API_LOGIN":"/PowerSolutions/myon/login.do","REACT_APP_API_LOGOUT":"/PowerSolutions/myon/logout.do","REACT_APP_API_ROOT_PATH":"/design/boost-api/v1/ws/","REACT_APP_IE11_FIXED_TABLES":".TableSelectionGroup__tableFixed, .LargeTable__tableFixed","REACT_APP_FEATURE_RESPONSIVE_SVGS":"false"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("./node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "./node_modules/detect-passive-events/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafrex/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports.default = detectPassiveEvents;

/***/ }),

/***/ "./node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__("./node_modules/dom-helpers/class/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "./node_modules/dom-helpers/transition/properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__("./node_modules/dom-helpers/util/inDOM.js");

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),

/***/ "./node_modules/dom-helpers/util/inDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/dom-helpers/util/requestAnimationFrame.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__("./node_modules/dom-helpers/util/inDOM.js");

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/domelementtype/index.js":
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),

/***/ "./node_modules/domhandler/index.js":
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__("./node_modules/domelementtype/index.js");

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__("./node_modules/domhandler/lib/node.js");
var ElementPrototype = __webpack_require__("./node_modules/domhandler/lib/element.js");

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),

/***/ "./node_modules/domhandler/lib/element.js":
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__("./node_modules/domhandler/lib/node.js");
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),

/***/ "./node_modules/domhandler/lib/node.js":
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),

/***/ "./node_modules/entities/lib/decode_codepoint.js":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("./node_modules/entities/maps/decode.json");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "./node_modules/entities/maps/decode.json":
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ "./node_modules/entities/maps/entities.json":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "./node_modules/entities/maps/legacy.json":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ "./node_modules/entities/maps/xml.json":
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ "./node_modules/events/events.js":
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ "./node_modules/fbjs/lib/hyphenate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),

/***/ "./node_modules/fbjs/lib/hyphenateStyleName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__("./node_modules/fbjs/lib/hyphenate.js");

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),

/***/ "./node_modules/fbjs/lib/memoizeStringOnly.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),

/***/ "./node_modules/html-to-react/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parser = __webpack_require__("./node_modules/html-to-react/lib/parser.js");
var processingInstructions = __webpack_require__("./node_modules/html-to-react/lib/processing-instructions.js");
var isValidNodeDefinitions = __webpack_require__("./node_modules/html-to-react/lib/is-valid-node-definitions.js");
var processNodeDefinitions = __webpack_require__("./node_modules/html-to-react/lib/process-node-definitions.js");

module.exports = {
  Parser: parser,
  ProcessingInstructions: processingInstructions,
  IsValidNodeDefinitions: isValidNodeDefinitions,
  ProcessNodeDefinitions: processNodeDefinitions,
};


/***/ }),

/***/ "./node_modules/html-to-react/lib/camel-case-attribute-names.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// These are all sourced from https://facebook.github.io/react/docs/tags-and-attributes.html -
// all attributes regardless of whether they have a different case to their HTML equivalents are
// listed to reduce the chance of human error and make it easier to just copy-paste the new list if
// it changes.

var HTML_ATTRIBUTES = [
  'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency',
  'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding',
  'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className',
  'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords',
  'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download',
  'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate',
  'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang',
  'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType',
  'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth',
  'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted',
  'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster',
  'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role',
  'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected',
  'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start',
  'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width',
  'wmode', 'wrap',
];

var NON_STANDARD_ATTRIBUTES = [
  'autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef',
  'itemID', 'security', 'unselectable', 'results', 'autoSave',
];

var SVG_ATTRIBUTES = [
  'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic',
  'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth',
  'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode',
  'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation',
  'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType',
  'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant',
  'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode',
  'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill',
  'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity',
  'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle',
  'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName',
  'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef',
  'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic',
  'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix',
  'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust',
  'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight',
  'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits',
  'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order',
  'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness',
  'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform',
  'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ',
  'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY',
  'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures',
  'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope',
  'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset',
  'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity',
  'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray',
  'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity',
  'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY',
  'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1',
  'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange',
  'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values',
  'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox',
  'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2',
  'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole',
  'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang',
  'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan',
];

var camelCaseMap = HTML_ATTRIBUTES
  .concat(NON_STANDARD_ATTRIBUTES)
  .concat(SVG_ATTRIBUTES)
  .reduce(function (soFar, attr) {
    var lower = attr.toLowerCase();
    if (lower !== attr) {
      soFar[lower] = attr;
    }
    return soFar;
  }, {});

module.exports = camelCaseMap;


/***/ }),

/***/ "./node_modules/html-to-react/lib/is-valid-node-definitions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function alwaysValid() {
  return true;
}

module.exports = {
  alwaysValid: alwaysValid,
};


/***/ }),

/***/ "./node_modules/html-to-react/lib/parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find = __webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/find.js");
var reject = __webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/reject.js");
var addIndex = __webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/addIndex.js");
var map = __webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/map.js");
var HtmlParser = __webpack_require__("./node_modules/htmlparser2/lib/Parser.js");
var DomHandler = __webpack_require__("./node_modules/domhandler/index.js");
var ProcessingInstructions = __webpack_require__("./node_modules/html-to-react/lib/processing-instructions.js");
var IsValidNodeDefinitions = __webpack_require__("./node_modules/html-to-react/lib/is-valid-node-definitions.js");
var utils = __webpack_require__("./node_modules/html-to-react/lib/utils.js");

function Html2ReactParser(options) {
  function parseHtmlToTree(html) {
    options = options || {};
    options.decodeEntities = true;
    var handler = new DomHandler();
    var parser = new HtmlParser(handler, options);
    parser.parseComplete(html);
    return handler.dom.filter(function (element) {
      return element.type !== 'directive';
    });
  };

  function traverseDom(node, isValidNode, processingInstructions, index) {
    if (isValidNode(node)) {
      var processingInstruction = find(function (processingInstruction) {
        return processingInstruction.shouldProcessNode(node);
      }, processingInstructions);
      if (processingInstruction != null) {
        var children = reject(function (x) {return x == null || x === false;},
          addIndex(map)(function (child, i) {
            return traverseDom(child, isValidNode, processingInstructions, i);
          }, node.children || []));

        if (processingInstruction.replaceChildren) {
          return utils.createElement(node, index, node.data, [
            processingInstruction.processNode(node, children, index),
          ]);
        }

        return processingInstruction.processNode(node, children, index);
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  function parseWithInstructions(html, isValidNode, processingInstructions) {
    var domTree = parseHtmlToTree(html);

    var list = domTree.map(function (domTreeItem, index) {
      return traverseDom(domTreeItem, isValidNode, processingInstructions, index);
    });
    return list.length <= 1 ? list[0] : list;
  };

  function parse(html) {
    var processingInstructions = new ProcessingInstructions();
    return parseWithInstructions(html,
      IsValidNodeDefinitions.alwaysValid,
      processingInstructions.defaultProcessingInstructions);
  };

  return {
    parse: parse,
    parseWithInstructions: parseWithInstructions,
  };
};

module.exports = Html2ReactParser;


/***/ }),

/***/ "./node_modules/html-to-react/lib/process-node-definitions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__("./node_modules/html-to-react/lib/utils.js");

// eslint-disable-next-line max-len
// https://github.com/facebook/react/blob/15.0-stable/src/renderers/dom/shared/ReactDOMComponent.js#L457
var voidElementTags = [
  'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param',
  'source', 'track', 'wbr', 'menuitem', 'textarea',
];

function ProcessNodeDefinitions() {
  function processDefaultNode(node, children, index) {
    if (node.type === 'text') {
      return node.data;
    } else if (node.type === 'comment') {
      // FIXME: The following doesn't work as the generated HTML results in
      // "&lt;!--  This is a comment  --&gt;"
      // return '<!-- ' + node.data + ' -->';
      return false;
    }

    if (voidElementTags.indexOf(node.name) > -1) {
      return utils.createElement(node, index);
    } else {
      return utils.createElement(node, index, node.data, children);
    }
  }

  return {
    processDefaultNode: processDefaultNode,
  };
}

module.exports = ProcessNodeDefinitions;


/***/ }),

/***/ "./node_modules/html-to-react/lib/processing-instructions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ShouldProcessNodeDefinitions = __webpack_require__("./node_modules/html-to-react/lib/should-process-node-definitions.js");
var ProcessNodeDefinitions = __webpack_require__("./node_modules/html-to-react/lib/process-node-definitions.js");

function ProcessingInstructions() {
  var processNodeDefinitions = new ProcessNodeDefinitions();

  return {
    defaultProcessingInstructions: [{
      shouldProcessNode: ShouldProcessNodeDefinitions.shouldProcessEveryNode,
      processNode: processNodeDefinitions.processDefaultNode,
    },],
  };
};

module.exports = ProcessingInstructions;


/***/ }),

/***/ "./node_modules/html-to-react/lib/should-process-node-definitions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function shouldProcessEveryNode(node) {
  return true;
}

module.exports = {
  shouldProcessEveryNode: shouldProcessEveryNode,
};


/***/ }),

/***/ "./node_modules/html-to-react/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var camelize = __webpack_require__("./node_modules/underscore.string.fp/camelize.js");
var toPairs = __webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/toPairs.js");
var reduce = __webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/reduce.js");
var React = __webpack_require__("./node_modules/react/index.js");
var camelCaseAttrMap = __webpack_require__("./node_modules/html-to-react/lib/camel-case-attribute-names.js");

function createStyleJsonFromString(styleString) {
  styleString = styleString || '';
  var styles = styleString.split(/;(?!base64)/);
  var singleStyle, key, value, jsonStyles = {};
  for (var i = 0; i < styles.length; ++i) {
    singleStyle = styles[i].split(':');
    if (singleStyle.length > 2) {
      singleStyle[1] = singleStyle.slice(1).join(':');
    }

    key = singleStyle[0];
    value = singleStyle[1];
    if (typeof value === 'string'){
      value = value.trim();
    }

    if (key != null && value != null && key.length > 0 && value.length > 0) {
      jsonStyles[camelize(key)] = value;
    }
  }
  return jsonStyles;
}

function createElement(node, index, data, children) {
  var elementProps = {
    key: index,
  };
  if (node.attribs) {
    elementProps = reduce(function(result, keyAndValue) {
      var key = keyAndValue[0];
      var value = keyAndValue[1];
      key = camelCaseAttrMap[key.replace(/[-:]/, '')] || key;
      if (key === 'style') {
        value = createStyleJsonFromString(value);
      } else if (key === 'class') {
        key = 'className';
      } else if (key === 'for') {
        key = 'htmlFor';
      }
      if (typeof value === 'string') {
        value = value;
      }
      result[key] = value || key;
      return result;
    }, elementProps, toPairs(node.attribs));
  }

  children = children || [];
  var allChildren = data != null ? [data,].concat(children) : children;
  return React.createElement.apply(
    null, [node.name, elementProps,].concat(allChildren)
  );
}

module.exports = {
  createElement: createElement,
};


/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/addIndex.js":
/***/ (function(module, exports, __webpack_require__) {

var _concat = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_concat.js");

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var curryN = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/curryN.js");

/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */


var addIndex = /*#__PURE__*/_curry1(function addIndex(fn) {
  return curryN(fn.length, function () {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function () {
      var result = origFn.apply(this, _concat(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});
module.exports = addIndex;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/bind.js":
/***/ (function(module, exports, __webpack_require__) {

var _arity = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_arity.js");

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */


var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
module.exports = bind;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/curryN.js":
/***/ (function(module, exports, __webpack_require__) {

var _arity = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_arity.js");

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _curryN = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curryN.js");

/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */


var curryN = /*#__PURE__*/_curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});
module.exports = curryN;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/filter.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _dispatchable = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_dispatchable.js");

var _filter = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_filter.js");

var _isObject = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isObject.js");

var _reduce = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_reduce.js");

var _xfilter = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xfilter.js");

var keys = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/keys.js");

/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */


var filter = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['filter'], _xfilter, function (pred, filterable) {
  return _isObject(filterable) ? _reduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, keys(filterable)) :
  // else
  _filter(pred, filterable);
}));
module.exports = filter;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/find.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _dispatchable = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_dispatchable.js");

var _xfind = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xfind.js");

/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */


var find = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['find'], _xfind, function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));
module.exports = find;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_arity.js":
/***/ (function(module, exports) {

function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}
module.exports = _arity;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_complement.js":
/***/ (function(module, exports) {

function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}
module.exports = _complement;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_concat.js":
/***/ (function(module, exports) {

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}
module.exports = _concat;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js":
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isPlaceholder.js");

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
module.exports = _curry1;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var _isPlaceholder = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isPlaceholder.js");

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}
module.exports = _curry2;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_curry3.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _isPlaceholder = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isPlaceholder.js");

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}
module.exports = _curry3;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_curryN.js":
/***/ (function(module, exports, __webpack_require__) {

var _arity = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_arity.js");

var _isPlaceholder = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isPlaceholder.js");

/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
}
module.exports = _curryN;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_dispatchable.js":
/***/ (function(module, exports, __webpack_require__) {

var _isArray = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isArray.js");

var _isTransformer = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isTransformer.js");

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */


function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
module.exports = _dispatchable;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_filter.js":
/***/ (function(module, exports) {

function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}
module.exports = _filter;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_has.js":
/***/ (function(module, exports) {

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

var _has = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_has.js");

var toString = Object.prototype.toString;
var _isArguments = function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
};

module.exports = _isArguments;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isArray.js":
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var _isArray = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isArray.js");

var _isString = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isString.js");

/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */


var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
  if (_isArray(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== 'object') {
    return false;
  }
  if (_isString(x)) {
    return false;
  }
  if (x.nodeType === 1) {
    return !!x.length;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});
module.exports = _isArrayLike;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isObject.js":
/***/ (function(module, exports) {

function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}
module.exports = _isObject;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isPlaceholder.js":
/***/ (function(module, exports) {

function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = _isPlaceholder;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isString.js":
/***/ (function(module, exports) {

function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_isTransformer.js":
/***/ (function(module, exports) {

function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}
module.exports = _isTransformer;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_map.js":
/***/ (function(module, exports) {

function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}
module.exports = _map;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_reduce.js":
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isArrayLike.js");

var _xwrap = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xwrap.js");

var bind = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/bind.js");

function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}

function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}

function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
}

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

function _reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = _xwrap(fn);
  }
  if (_isArrayLike(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}
module.exports = _reduce;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_reduced.js":
/***/ (function(module, exports) {

function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
module.exports = _reduced;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_xfBase.js":
/***/ (function(module, exports) {

module.exports = {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_xfilter.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _xfBase = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xfBase.js");

var XFilter = /*#__PURE__*/function () {

  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;
  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter = /*#__PURE__*/_curry2(function _xfilter(f, xf) {
  return new XFilter(f, xf);
});
module.exports = _xfilter;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_xfind.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _reduced = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_reduced.js");

var _xfBase = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xfBase.js");

var XFind = /*#__PURE__*/function () {

  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = _xfBase.init;
  XFind.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return XFind;
}();

var _xfind = /*#__PURE__*/_curry2(function _xfind(f, xf) {
  return new XFind(f, xf);
});
module.exports = _xfind;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_xmap.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _xfBase = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xfBase.js");

var XMap = /*#__PURE__*/function () {

  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap = /*#__PURE__*/_curry2(function _xmap(f, xf) {
  return new XMap(f, xf);
});
module.exports = _xmap;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/internal/_xwrap.js":
/***/ (function(module, exports) {

var XWrap = /*#__PURE__*/function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap(fn) {
  return new XWrap(fn);
}
module.exports = _xwrap;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/keys.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var _has = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_has.js");

var _isArguments = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_isArguments.js");

// cover IE < 9 keys issues


var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {
  'use strict';

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
};
var keys = /*#__PURE__*/_curry1(_keys);
module.exports = keys;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/map.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var _dispatchable = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_dispatchable.js");

var _map = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_map.js");

var _reduce = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_reduce.js");

var _xmap = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_xmap.js");

var curryN = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/curryN.js");

var keys = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/keys.js");

/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */


var map = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));
module.exports = map;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/reduce.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry3.js");

var _reduce = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_reduce.js");

/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */


var reduce = /*#__PURE__*/_curry3(_reduce);
module.exports = reduce;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/reject.js":
/***/ (function(module, exports, __webpack_require__) {

var _complement = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_complement.js");

var _curry2 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry2.js");

var filter = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/filter.js");

/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */


var reject = /*#__PURE__*/_curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});
module.exports = reject;

/***/ }),

/***/ "./node_modules/html-to-react/node_modules/ramda/src/toPairs.js":
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_curry1.js");

var _has = /*#__PURE__*/__webpack_require__("./node_modules/html-to-react/node_modules/ramda/src/internal/_has.js");

/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */


var toPairs = /*#__PURE__*/_curry1(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (_has(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});
module.exports = toPairs;

/***/ }),

/***/ "./node_modules/htmlparser2/lib/Parser.js":
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__("./node_modules/htmlparser2/lib/Tokenizer.js");

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
	input: true,
	option: true,
	optgroup: true,
	select: true,
	button: true,
	datalist: true,
	textarea: true
};

var openImpliesClose = {
	tr      : { tr:true, th:true, td:true },
	th      : { th:true },
	td      : { thead:true, th:true, td:true },
	body    : { head:true, link:true, script:true },
	li      : { li:true },
	p       : { p:true },
	h1      : { p:true },
	h2      : { p:true },
	h3      : { p:true },
	h4      : { p:true },
	h5      : { p:true },
	h6      : { p:true },
	select  : formTags,
	input   : formTags,
	output  : formTags,
	button  : formTags,
	datalist: formTags,
	textarea: formTags,
	option  : { option:true },
	optgroup: { optgroup:true }
};

var voidElements = {
	__proto__: null,
	area: true,
	base: true,
	basefont: true,
	br: true,
	col: true,
	command: true,
	embed: true,
	frame: true,
	hr: true,
	img: true,
	input: true,
	isindex: true,
	keygen: true,
	link: true,
	meta: true,
	param: true,
	source: true,
	track: true,
	wbr: true,

	//common self closing svg elements
	path: true,
	circle: true,
	ellipse: true,
	line: true,
	rect: true,
	use: true,
	stop: true,
	polyline: true,
	polygon: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options){
	this._options = options || {};
	this._cbs = cbs || {};

	this._tagname = "";
	this._attribname = "";
	this._attribvalue = "";
	this._attribs = null;
	this._stack = [];

	this.startIndex = 0;
	this.endIndex = null;

	this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
									!!this._options.lowerCaseTags :
									!this._options.xmlMode;
	this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
									!!this._options.lowerCaseAttributeNames :
									!this._options.xmlMode;

	if(this._options.Tokenizer) {
		Tokenizer = this._options.Tokenizer;
	}
	this._tokenizer = new Tokenizer(this._options, this);

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__("./node_modules/inherits/inherits_browser.js")(Parser, __webpack_require__("./node_modules/events/events.js").EventEmitter);

Parser.prototype._updatePosition = function(initialOffset){
	if(this.endIndex === null){
		if(this._tokenizer._sectionStart <= initialOffset){
			this.startIndex = 0;
		} else {
			this.startIndex = this._tokenizer._sectionStart - initialOffset;
		}
	}
	else this.startIndex = this.endIndex + 1;
	this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data){
	this._updatePosition(1);
	this.endIndex--;

	if(this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name){
	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	this._tagname = name;

	if(!this._options.xmlMode && name in openImpliesClose) {
		for(
			var el;
			(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
			this.onclosetag(el)
		);
	}

	if(this._options.xmlMode || !(name in voidElements)){
		this._stack.push(name);
	}

	if(this._cbs.onopentagname) this._cbs.onopentagname(name);
	if(this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function(){
	this._updatePosition(1);

	if(this._attribs){
		if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
		this._attribs = null;
	}

	if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
		this._cbs.onclosetag(this._tagname);
	}

	this._tagname = "";
};

Parser.prototype.onclosetag = function(name){
	this._updatePosition(1);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
		var pos = this._stack.lastIndexOf(name);
		if(pos !== -1){
			if(this._cbs.onclosetag){
				pos = this._stack.length - pos;
				while(pos--) this._cbs.onclosetag(this._stack.pop());
			}
			else this._stack.length = pos;
		} else if(name === "p" && !this._options.xmlMode){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	} else if(!this._options.xmlMode && (name === "br" || name === "p")){
		this.onopentagname(name);
		this._closeCurrentTag();
	}
};

Parser.prototype.onselfclosingtag = function(){
	if(this._options.xmlMode || this._options.recognizeSelfClosing){
		this._closeCurrentTag();
	} else {
		this.onopentagend();
	}
};

Parser.prototype._closeCurrentTag = function(){
	var name = this._tagname;

	this.onopentagend();

	//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length - 1] === name){
		if(this._cbs.onclosetag){
			this._cbs.onclosetag(name);
		}
		this._stack.pop();
	}
};

Parser.prototype.onattribname = function(name){
	if(this._lowerCaseAttributeNames){
		name = name.toLowerCase();
	}
	this._attribname = name;
};

Parser.prototype.onattribdata = function(value){
	this._attribvalue += value;
};

Parser.prototype.onattribend = function(){
	if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
	if(
		this._attribs &&
		!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	){
		this._attribs[this._attribname] = this._attribvalue;
	}
	this._attribname = "";
	this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value){
	var idx = value.search(re_nameEnd),
	    name = idx < 0 ? value : value.substr(0, idx);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	return name;
};

Parser.prototype.ondeclaration = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("!" + name, "!" + value);
	}
};

Parser.prototype.onprocessinginstruction = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("?" + name, "?" + value);
	}
};

Parser.prototype.oncomment = function(value){
	this._updatePosition(4);

	if(this._cbs.oncomment) this._cbs.oncomment(value);
	if(this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value){
	this._updatePosition(1);

	if(this._options.xmlMode || this._options.recognizeCDATA){
		if(this._cbs.oncdatastart) this._cbs.oncdatastart();
		if(this._cbs.ontext) this._cbs.ontext(value);
		if(this._cbs.oncdataend) this._cbs.oncdataend();
	} else {
		this.oncomment("[CDATA[" + value + "]]");
	}
};

Parser.prototype.onerror = function(err){
	if(this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function(){
	if(this._cbs.onclosetag){
		for(
			var i = this._stack.length;
			i > 0;
			this._cbs.onclosetag(this._stack[--i])
		);
	}
	if(this._cbs.onend) this._cbs.onend();
};


//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function(){
	if(this._cbs.onreset) this._cbs.onreset();
	this._tokenizer.reset();

	this._tagname = "";
	this._attribname = "";
	this._attribs = null;
	this._stack = [];

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data){
	this.reset();
	this.end(data);
};

Parser.prototype.write = function(chunk){
	this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk){
	this._tokenizer.end(chunk);
};

Parser.prototype.pause = function(){
	this._tokenizer.pause();
};

Parser.prototype.resume = function(){
	this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),

/***/ "./node_modules/htmlparser2/lib/Tokenizer.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__("./node_modules/entities/lib/decode_codepoint.js"),
    entityMap = __webpack_require__("./node_modules/entities/maps/entities.json"),
    legacyMap = __webpack_require__("./node_modules/entities/maps/legacy.json"),
    xmlMap    = __webpack_require__("./node_modules/entities/maps/xml.json"),

    i = 0,

    TEXT                      = i++,
    BEFORE_TAG_NAME           = i++, //after <
    IN_TAG_NAME               = i++,
    IN_SELF_CLOSING_TAG       = i++,
    BEFORE_CLOSING_TAG_NAME   = i++,
    IN_CLOSING_TAG_NAME       = i++,
    AFTER_CLOSING_TAG_NAME    = i++,

    //attributes
    BEFORE_ATTRIBUTE_NAME     = i++,
    IN_ATTRIBUTE_NAME         = i++,
    AFTER_ATTRIBUTE_NAME      = i++,
    BEFORE_ATTRIBUTE_VALUE    = i++,
    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
    IN_ATTRIBUTE_VALUE_NQ     = i++,

    //declarations
    BEFORE_DECLARATION        = i++, // !
    IN_DECLARATION            = i++,

    //processing instructions
    IN_PROCESSING_INSTRUCTION = i++, // ?

    //comments
    BEFORE_COMMENT            = i++,
    IN_COMMENT                = i++,
    AFTER_COMMENT_1           = i++,
    AFTER_COMMENT_2           = i++,

    //cdata
    BEFORE_CDATA_1            = i++, // [
    BEFORE_CDATA_2            = i++, // C
    BEFORE_CDATA_3            = i++, // D
    BEFORE_CDATA_4            = i++, // A
    BEFORE_CDATA_5            = i++, // T
    BEFORE_CDATA_6            = i++, // A
    IN_CDATA                  = i++, // [
    AFTER_CDATA_1             = i++, // ]
    AFTER_CDATA_2             = i++, // ]

    //special tags
    BEFORE_SPECIAL            = i++, //S
    BEFORE_SPECIAL_END        = i++,   //S

    BEFORE_SCRIPT_1           = i++, //C
    BEFORE_SCRIPT_2           = i++, //R
    BEFORE_SCRIPT_3           = i++, //I
    BEFORE_SCRIPT_4           = i++, //P
    BEFORE_SCRIPT_5           = i++, //T
    AFTER_SCRIPT_1            = i++, //C
    AFTER_SCRIPT_2            = i++, //R
    AFTER_SCRIPT_3            = i++, //I
    AFTER_SCRIPT_4            = i++, //P
    AFTER_SCRIPT_5            = i++, //T

    BEFORE_STYLE_1            = i++, //T
    BEFORE_STYLE_2            = i++, //Y
    BEFORE_STYLE_3            = i++, //L
    BEFORE_STYLE_4            = i++, //E
    AFTER_STYLE_1             = i++, //T
    AFTER_STYLE_2             = i++, //Y
    AFTER_STYLE_3             = i++, //L
    AFTER_STYLE_4             = i++, //E

    BEFORE_ENTITY             = i++, //&
    BEFORE_NUMERIC_ENTITY     = i++, //#
    IN_NAMED_ENTITY           = i++,
    IN_NUMERIC_ENTITY         = i++,
    IN_HEX_ENTITY             = i++, //X

    j = 0,

    SPECIAL_NONE              = j++,
    SPECIAL_SCRIPT            = j++,
    SPECIAL_STYLE             = j++;

function whitespace(c){
	return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function characterState(char, SUCCESS){
	return function(c){
		if(c === char) this._state = SUCCESS;
	};
}

function ifElseState(upper, SUCCESS, FAILURE){
	var lower = upper.toLowerCase();

	if(upper === lower){
		return function(c){
			if(c === lower){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	} else {
		return function(c){
			if(c === lower || c === upper){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	}
}

function consumeSpecialNameChar(upper, NEXT_STATE){
	var lower = upper.toLowerCase();

	return function(c){
		if(c === lower || c === upper){
			this._state = NEXT_STATE;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
}

function Tokenizer(options, cbs){
	this._state = TEXT;
	this._buffer = "";
	this._sectionStart = 0;
	this._index = 0;
	this._bufferOffset = 0; //chars removed from _buffer
	this._baseState = TEXT;
	this._special = SPECIAL_NONE;
	this._cbs = cbs;
	this._running = true;
	this._ended = false;
	this._xmlMode = !!(options && options.xmlMode);
	this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c){
	if(c === "<"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._state = BEFORE_TAG_NAME;
		this._sectionStart = this._index;
	} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._baseState = TEXT;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeTagName = function(c){
	if(c === "/"){
		this._state = BEFORE_CLOSING_TAG_NAME;
	} else if(c === "<"){
		this._cbs.ontext(this._getSection());
		this._sectionStart = this._index;
	} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
		this._state = TEXT;
	} else if(c === "!"){
		this._state = BEFORE_DECLARATION;
		this._sectionStart = this._index + 1;
	} else if(c === "?"){
		this._state = IN_PROCESSING_INSTRUCTION;
		this._sectionStart = this._index + 1;
	} else {
		this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
						BEFORE_SPECIAL : IN_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInTagName = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._emitToken("onopentagname");
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
	if(whitespace(c));
	else if(c === ">"){
		this._state = TEXT;
	} else if(this._special !== SPECIAL_NONE){
		if(c === "s" || c === "S"){
			this._state = BEFORE_SPECIAL_END;
		} else {
			this._state = TEXT;
			this._index--;
		}
	} else {
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInCloseingTagName = function(c){
	if(c === ">" || whitespace(c)){
		this._emitToken("onclosetag");
		this._state = AFTER_CLOSING_TAG_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c){
	//skip everything until ">"
	if(c === ">"){
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeAttributeName = function(c){
	if(c === ">"){
		this._cbs.onopentagend();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c === "/"){
		this._state = IN_SELF_CLOSING_TAG;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInSelfClosingTag = function(c){
	if(c === ">"){
		this._cbs.onselfclosingtag();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateInAttributeName = function(c){
	if(c === "=" || c === "/" || c === ">" || whitespace(c)){
		this._cbs.onattribname(this._getSection());
		this._sectionStart = -1;
		this._state = AFTER_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterAttributeName = function(c){
	if(c === "="){
		this._state = BEFORE_ATTRIBUTE_VALUE;
	} else if(c === "/" || c === ">"){
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(!whitespace(c)){
		this._cbs.onattribend();
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c){
	if(c === "\""){
		this._state = IN_ATTRIBUTE_VALUE_DQ;
		this._sectionStart = this._index + 1;
	} else if(c === "'"){
		this._state = IN_ATTRIBUTE_VALUE_SQ;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_VALUE_NQ;
		this._sectionStart = this._index;
		this._index--; //reconsume token
	}
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
	if(c === "\""){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
	if(c === "'"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
	if(whitespace(c) || c === ">"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeDeclaration = function(c){
	this._state = c === "[" ? BEFORE_CDATA_1 :
					c === "-" ? BEFORE_COMMENT :
						IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c){
	if(c === ">"){
		this._cbs.ondeclaration(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateInProcessingInstruction = function(c){
	if(c === ">"){
		this._cbs.onprocessinginstruction(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeComment = function(c){
	if(c === "-"){
		this._state = IN_COMMENT;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
	}
};

Tokenizer.prototype._stateInComment = function(c){
	if(c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c){
	if(c === "-"){
		this._state = AFTER_COMMENT_2;
	} else {
		this._state = IN_COMMENT;
	}
};

Tokenizer.prototype._stateAfterComment2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "-"){
		this._state = IN_COMMENT;
	}
	// else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);

Tokenizer.prototype._stateBeforeCdata6 = function(c){
	if(c === "["){
		this._state = IN_CDATA;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
		this._index--;
	}
};

Tokenizer.prototype._stateInCdata = function(c){
	if(c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);

Tokenizer.prototype._stateAfterCdata2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "]") {
		this._state = IN_CDATA;
	}
	//else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c){
	if(c === "c" || c === "C"){
		this._state = BEFORE_SCRIPT_1;
	} else if(c === "t" || c === "T"){
		this._state = BEFORE_STYLE_1;
	} else {
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	}
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
	if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
		this._state = AFTER_SCRIPT_1;
	} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
		this._state = AFTER_STYLE_1;
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);

Tokenizer.prototype._stateBeforeScript5 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_SCRIPT;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 6;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);

Tokenizer.prototype._stateBeforeStyle4 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_STYLE;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 5;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function(){
	//offset = 1
	if(this._sectionStart + 1 < this._index){
		var entity = this._buffer.substring(this._sectionStart + 1, this._index),
		    map = this._xmlMode ? xmlMap : entityMap;

		if(map.hasOwnProperty(entity)){
			this._emitPartial(map[entity]);
			this._sectionStart = this._index + 1;
		}
	}
};


//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function(){
	var start = this._sectionStart + 1,
	    limit = this._index - start;

	if(limit > 6) limit = 6; //the max length of legacy entities is 6

	while(limit >= 2){ //the min length of legacy entities is 2
		var entity = this._buffer.substr(start, limit);

		if(legacyMap.hasOwnProperty(entity)){
			this._emitPartial(legacyMap[entity]);
			this._sectionStart += limit + 1;
			return;
		} else {
			limit--;
		}
	}
};

Tokenizer.prototype._stateInNamedEntity = function(c){
	if(c === ";"){
		this._parseNamedEntityStrict();
		if(this._sectionStart + 1 < this._index && !this._xmlMode){
			this._parseLegacyEntity();
		}
		this._state = this._baseState;
	} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
		if(this._xmlMode);
		else if(this._sectionStart + 1 === this._index);
		else if(this._baseState !== TEXT){
			if(c !== "="){
				this._parseNamedEntityStrict();
			}
		} else {
			this._parseLegacyEntity();
		}

		this._state = this._baseState;
		this._index--;
	}
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base){
	var sectionStart = this._sectionStart + offset;

	if(sectionStart !== this._index){
		//parse entity
		var entity = this._buffer.substring(sectionStart, this._index);
		var parsed = parseInt(entity, base);

		this._emitPartial(decodeCodePoint(parsed));
		this._sectionStart = this._index;
	} else {
		this._sectionStart--;
	}

	this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(2, 10);
		this._sectionStart++;
	} else if(c < "0" || c > "9"){
		if(!this._xmlMode){
			this._decodeNumericEntity(2, 10);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._stateInHexEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(3, 16);
		this._sectionStart++;
	} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
		if(!this._xmlMode){
			this._decodeNumericEntity(3, 16);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._cleanup = function (){
	if(this._sectionStart < 0){
		this._buffer = "";
		this._bufferOffset += this._index;
		this._index = 0;
	} else if(this._running){
		if(this._state === TEXT){
			if(this._sectionStart !== this._index){
				this._cbs.ontext(this._buffer.substr(this._sectionStart));
			}
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._sectionStart === this._index){
			//the section just started
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else {
			//remove everything unnecessary
			this._buffer = this._buffer.substr(this._sectionStart);
			this._index -= this._sectionStart;
			this._bufferOffset += this._sectionStart;
		}

		this._sectionStart = 0;
	}
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".write() after done!"));

	this._buffer += chunk;
	this._parse();
};

Tokenizer.prototype._parse = function(){
	while(this._index < this._buffer.length && this._running){
		var c = this._buffer.charAt(this._index);
		if(this._state === TEXT) {
			this._stateText(c);
		} else if(this._state === BEFORE_TAG_NAME){
			this._stateBeforeTagName(c);
		} else if(this._state === IN_TAG_NAME) {
			this._stateInTagName(c);
		} else if(this._state === BEFORE_CLOSING_TAG_NAME){
			this._stateBeforeCloseingTagName(c);
		} else if(this._state === IN_CLOSING_TAG_NAME){
			this._stateInCloseingTagName(c);
		} else if(this._state === AFTER_CLOSING_TAG_NAME){
			this._stateAfterCloseingTagName(c);
		} else if(this._state === IN_SELF_CLOSING_TAG){
			this._stateInSelfClosingTag(c);
		}

		/*
		*	attributes
		*/
		else if(this._state === BEFORE_ATTRIBUTE_NAME){
			this._stateBeforeAttributeName(c);
		} else if(this._state === IN_ATTRIBUTE_NAME){
			this._stateInAttributeName(c);
		} else if(this._state === AFTER_ATTRIBUTE_NAME){
			this._stateAfterAttributeName(c);
		} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
			this._stateBeforeAttributeValue(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
			this._stateInAttributeValueDoubleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
			this._stateInAttributeValueSingleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
			this._stateInAttributeValueNoQuotes(c);
		}

		/*
		*	declarations
		*/
		else if(this._state === BEFORE_DECLARATION){
			this._stateBeforeDeclaration(c);
		} else if(this._state === IN_DECLARATION){
			this._stateInDeclaration(c);
		}

		/*
		*	processing instructions
		*/
		else if(this._state === IN_PROCESSING_INSTRUCTION){
			this._stateInProcessingInstruction(c);
		}

		/*
		*	comments
		*/
		else if(this._state === BEFORE_COMMENT){
			this._stateBeforeComment(c);
		} else if(this._state === IN_COMMENT){
			this._stateInComment(c);
		} else if(this._state === AFTER_COMMENT_1){
			this._stateAfterComment1(c);
		} else if(this._state === AFTER_COMMENT_2){
			this._stateAfterComment2(c);
		}

		/*
		*	cdata
		*/
		else if(this._state === BEFORE_CDATA_1){
			this._stateBeforeCdata1(c);
		} else if(this._state === BEFORE_CDATA_2){
			this._stateBeforeCdata2(c);
		} else if(this._state === BEFORE_CDATA_3){
			this._stateBeforeCdata3(c);
		} else if(this._state === BEFORE_CDATA_4){
			this._stateBeforeCdata4(c);
		} else if(this._state === BEFORE_CDATA_5){
			this._stateBeforeCdata5(c);
		} else if(this._state === BEFORE_CDATA_6){
			this._stateBeforeCdata6(c);
		} else if(this._state === IN_CDATA){
			this._stateInCdata(c);
		} else if(this._state === AFTER_CDATA_1){
			this._stateAfterCdata1(c);
		} else if(this._state === AFTER_CDATA_2){
			this._stateAfterCdata2(c);
		}

		/*
		* special tags
		*/
		else if(this._state === BEFORE_SPECIAL){
			this._stateBeforeSpecial(c);
		} else if(this._state === BEFORE_SPECIAL_END){
			this._stateBeforeSpecialEnd(c);
		}

		/*
		* script
		*/
		else if(this._state === BEFORE_SCRIPT_1){
			this._stateBeforeScript1(c);
		} else if(this._state === BEFORE_SCRIPT_2){
			this._stateBeforeScript2(c);
		} else if(this._state === BEFORE_SCRIPT_3){
			this._stateBeforeScript3(c);
		} else if(this._state === BEFORE_SCRIPT_4){
			this._stateBeforeScript4(c);
		} else if(this._state === BEFORE_SCRIPT_5){
			this._stateBeforeScript5(c);
		}

		else if(this._state === AFTER_SCRIPT_1){
			this._stateAfterScript1(c);
		} else if(this._state === AFTER_SCRIPT_2){
			this._stateAfterScript2(c);
		} else if(this._state === AFTER_SCRIPT_3){
			this._stateAfterScript3(c);
		} else if(this._state === AFTER_SCRIPT_4){
			this._stateAfterScript4(c);
		} else if(this._state === AFTER_SCRIPT_5){
			this._stateAfterScript5(c);
		}

		/*
		* style
		*/
		else if(this._state === BEFORE_STYLE_1){
			this._stateBeforeStyle1(c);
		} else if(this._state === BEFORE_STYLE_2){
			this._stateBeforeStyle2(c);
		} else if(this._state === BEFORE_STYLE_3){
			this._stateBeforeStyle3(c);
		} else if(this._state === BEFORE_STYLE_4){
			this._stateBeforeStyle4(c);
		}

		else if(this._state === AFTER_STYLE_1){
			this._stateAfterStyle1(c);
		} else if(this._state === AFTER_STYLE_2){
			this._stateAfterStyle2(c);
		} else if(this._state === AFTER_STYLE_3){
			this._stateAfterStyle3(c);
		} else if(this._state === AFTER_STYLE_4){
			this._stateAfterStyle4(c);
		}

		/*
		* entities
		*/
		else if(this._state === BEFORE_ENTITY){
			this._stateBeforeEntity(c);
		} else if(this._state === BEFORE_NUMERIC_ENTITY){
			this._stateBeforeNumericEntity(c);
		} else if(this._state === IN_NAMED_ENTITY){
			this._stateInNamedEntity(c);
		} else if(this._state === IN_NUMERIC_ENTITY){
			this._stateInNumericEntity(c);
		} else if(this._state === IN_HEX_ENTITY){
			this._stateInHexEntity(c);
		}

		else {
			this._cbs.onerror(Error("unknown _state"), this._state);
		}

		this._index++;
	}

	this._cleanup();
};

Tokenizer.prototype.pause = function(){
	this._running = false;
};
Tokenizer.prototype.resume = function(){
	this._running = true;

	if(this._index < this._buffer.length){
		this._parse();
	}
	if(this._ended){
		this._finish();
	}
};

Tokenizer.prototype.end = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".end() after done!"));
	if(chunk) this.write(chunk);

	this._ended = true;

	if(this._running) this._finish();
};

Tokenizer.prototype._finish = function(){
	//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart < this._index){
		this._handleTrailingData();
	}

	this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function(){
	var data = this._buffer.substr(this._sectionStart);

	if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
		this._cbs.oncdata(data);
	} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
		this._cbs.oncomment(data);
	} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
		this._parseLegacyEntity();
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(2, 10);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(3, 16);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(
		this._state !== IN_TAG_NAME &&
		this._state !== BEFORE_ATTRIBUTE_NAME &&
		this._state !== BEFORE_ATTRIBUTE_VALUE &&
		this._state !== AFTER_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_VALUE_SQ &&
		this._state !== IN_ATTRIBUTE_VALUE_DQ &&
		this._state !== IN_ATTRIBUTE_VALUE_NQ &&
		this._state !== IN_CLOSING_TAG_NAME
	){
		this._cbs.ontext(data);
	}
	//else, ignore remaining data
	//TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function(){
	Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
};

Tokenizer.prototype.getAbsoluteIndex = function(){
	return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function(){
	return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name){
	this._cbs[name](this._getSection());
	this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value){
	if(this._baseState !== TEXT){
		this._cbs.onattribdata(value); //TODO implement the new event
	} else {
		this._cbs.ontext(value);
	}
};


/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "./node_modules/lodash/_Hash.js":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("./node_modules/lodash/_hashClear.js"),
    hashDelete = __webpack_require__("./node_modules/lodash/_hashDelete.js"),
    hashGet = __webpack_require__("./node_modules/lodash/_hashGet.js"),
    hashHas = __webpack_require__("./node_modules/lodash/_hashHas.js"),
    hashSet = __webpack_require__("./node_modules/lodash/_hashSet.js");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "./node_modules/lodash/_LazyWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("./node_modules/lodash/_baseCreate.js"),
    baseLodash = __webpack_require__("./node_modules/lodash/_baseLodash.js");

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),

/***/ "./node_modules/lodash/_ListCache.js":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("./node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__("./node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__("./node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__("./node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__("./node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "./node_modules/lodash/_LodashWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("./node_modules/lodash/_baseCreate.js"),
    baseLodash = __webpack_require__("./node_modules/lodash/_baseLodash.js");

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "./node_modules/lodash/_MapCache.js":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("./node_modules/lodash/_mapCacheClear.js"),
    mapCacheDelete = __webpack_require__("./node_modules/lodash/_mapCacheDelete.js"),
    mapCacheGet = __webpack_require__("./node_modules/lodash/_mapCacheGet.js"),
    mapCacheHas = __webpack_require__("./node_modules/lodash/_mapCacheHas.js"),
    mapCacheSet = __webpack_require__("./node_modules/lodash/_mapCacheSet.js");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "./node_modules/lodash/_SetCache.js":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js"),
    setCacheAdd = __webpack_require__("./node_modules/lodash/_setCacheAdd.js"),
    setCacheHas = __webpack_require__("./node_modules/lodash/_setCacheHas.js");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "./node_modules/lodash/_Stack.js":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
    stackClear = __webpack_require__("./node_modules/lodash/_stackClear.js"),
    stackDelete = __webpack_require__("./node_modules/lodash/_stackDelete.js"),
    stackGet = __webpack_require__("./node_modules/lodash/_stackGet.js"),
    stackHas = __webpack_require__("./node_modules/lodash/_stackHas.js"),
    stackSet = __webpack_require__("./node_modules/lodash/_stackSet.js");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_Uint8Array.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "./node_modules/lodash/_apply.js":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "./node_modules/lodash/_arrayEach.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "./node_modules/lodash/_arrayEvery.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),

/***/ "./node_modules/lodash/_arrayFilter.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "./node_modules/lodash/_arrayIncludes.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("./node_modules/lodash/_baseIndexOf.js");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "./node_modules/lodash/_arrayIncludesWith.js":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("./node_modules/lodash/_baseTimes.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "./node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayPush.js":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "./node_modules/lodash/_arrayReduce.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ "./node_modules/lodash/_arraySome.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "./node_modules/lodash/_asciiSize.js":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("./node_modules/lodash/_baseProperty.js");

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),

/***/ "./node_modules/lodash/_asciiToArray.js":
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ "./node_modules/lodash/_asciiWords.js":
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ "./node_modules/lodash/_assignMergeValue.js":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__("./node_modules/lodash/eq.js");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "./node_modules/lodash/_assignValue.js":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__("./node_modules/lodash/eq.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "./node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("./node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseAssign.js":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "./node_modules/lodash/_baseAssignIn.js":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "./node_modules/lodash/_baseAssignValue.js":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "./node_modules/lodash/_baseClone.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
    arrayEach = __webpack_require__("./node_modules/lodash/_arrayEach.js"),
    assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
    baseAssign = __webpack_require__("./node_modules/lodash/_baseAssign.js"),
    baseAssignIn = __webpack_require__("./node_modules/lodash/_baseAssignIn.js"),
    cloneBuffer = __webpack_require__("./node_modules/lodash/_cloneBuffer.js"),
    copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js"),
    copySymbols = __webpack_require__("./node_modules/lodash/_copySymbols.js"),
    copySymbolsIn = __webpack_require__("./node_modules/lodash/_copySymbolsIn.js"),
    getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js"),
    getAllKeysIn = __webpack_require__("./node_modules/lodash/_getAllKeysIn.js"),
    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    initCloneArray = __webpack_require__("./node_modules/lodash/_initCloneArray.js"),
    initCloneByTag = __webpack_require__("./node_modules/lodash/_initCloneByTag.js"),
    initCloneObject = __webpack_require__("./node_modules/lodash/_initCloneObject.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isMap = __webpack_require__("./node_modules/lodash/isMap.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    isSet = __webpack_require__("./node_modules/lodash/isSet.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "./node_modules/lodash/_baseCreate.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "./node_modules/lodash/_baseEach.js":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
    createBaseEach = __webpack_require__("./node_modules/lodash/_createBaseEach.js");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "./node_modules/lodash/_baseEvery.js":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js");

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),

/***/ "./node_modules/lodash/_baseFilter.js":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js");

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ "./node_modules/lodash/_baseFindIndex.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "./node_modules/lodash/_baseFlatten.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
    isFlattenable = __webpack_require__("./node_modules/lodash/_isFlattenable.js");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "./node_modules/lodash/_baseFor.js":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("./node_modules/lodash/_createBaseFor.js");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash/_baseForOwn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "./node_modules/lodash/_baseGet.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseHasIn.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "./node_modules/lodash/_baseInRange.js":
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

module.exports = baseInRange;


/***/ }),

/***/ "./node_modules/lodash/_baseIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("./node_modules/lodash/_baseFindIndex.js"),
    baseIsNaN = __webpack_require__("./node_modules/lodash/_baseIsNaN.js"),
    strictIndexOf = __webpack_require__("./node_modules/lodash/_strictIndexOf.js");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqual.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("./node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__("./node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__("./node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMap.js":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMatch.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
    baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNaN.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "./node_modules/lodash/_baseIsSet.js":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_baseIteratee.js":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("./node_modules/lodash/_baseMatches.js"),
    baseMatchesProperty = __webpack_require__("./node_modules/lodash/_baseMatchesProperty.js"),
    identity = __webpack_require__("./node_modules/lodash/identity.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    property = __webpack_require__("./node_modules/lodash/property.js");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
    nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseKeysIn.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
    nativeKeysIn = __webpack_require__("./node_modules/lodash/_nativeKeysIn.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_baseLodash.js":
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),

/***/ "./node_modules/lodash/_baseMap.js":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "./node_modules/lodash/_baseMatches.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("./node_modules/lodash/_baseIsMatch.js"),
    getMatchData = __webpack_require__("./node_modules/lodash/_getMatchData.js"),
    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js"),
    get = __webpack_require__("./node_modules/lodash/get.js"),
    hasIn = __webpack_require__("./node_modules/lodash/hasIn.js"),
    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
    isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "./node_modules/lodash/_baseMerge.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
    assignMergeValue = __webpack_require__("./node_modules/lodash/_assignMergeValue.js"),
    baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
    baseMergeDeep = __webpack_require__("./node_modules/lodash/_baseMergeDeep.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js"),
    safeGet = __webpack_require__("./node_modules/lodash/_safeGet.js");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "./node_modules/lodash/_baseMergeDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("./node_modules/lodash/_assignMergeValue.js"),
    cloneBuffer = __webpack_require__("./node_modules/lodash/_cloneBuffer.js"),
    cloneTypedArray = __webpack_require__("./node_modules/lodash/_cloneTypedArray.js"),
    copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js"),
    initCloneObject = __webpack_require__("./node_modules/lodash/_initCloneObject.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isArrayLikeObject = __webpack_require__("./node_modules/lodash/isArrayLikeObject.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js"),
    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js"),
    safeGet = __webpack_require__("./node_modules/lodash/_safeGet.js"),
    toPlainObject = __webpack_require__("./node_modules/lodash/toPlainObject.js");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "./node_modules/lodash/_basePick.js":
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__("./node_modules/lodash/_basePickBy.js"),
    hasIn = __webpack_require__("./node_modules/lodash/hasIn.js");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ "./node_modules/lodash/_basePickBy.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js"),
    baseSet = __webpack_require__("./node_modules/lodash/_baseSet.js"),
    castPath = __webpack_require__("./node_modules/lodash/_castPath.js");

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ "./node_modules/lodash/_baseProperty.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyOf.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ "./node_modules/lodash/_baseReduce.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ "./node_modules/lodash/_baseRest.js":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("./node_modules/lodash/identity.js"),
    overRest = __webpack_require__("./node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__("./node_modules/lodash/_setToString.js");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "./node_modules/lodash/_baseSet.js":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
    castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ "./node_modules/lodash/_baseSetData.js":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("./node_modules/lodash/identity.js"),
    metaMap = __webpack_require__("./node_modules/lodash/_metaMap.js");

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),

/***/ "./node_modules/lodash/_baseSetToString.js":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("./node_modules/lodash/constant.js"),
    defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js"),
    identity = __webpack_require__("./node_modules/lodash/identity.js");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "./node_modules/lodash/_baseSlice.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ "./node_modules/lodash/_baseSome.js":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "./node_modules/lodash/_baseTimes.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "./node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "./node_modules/lodash/_baseUniq.js":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
    arrayIncludes = __webpack_require__("./node_modules/lodash/_arrayIncludes.js"),
    arrayIncludesWith = __webpack_require__("./node_modules/lodash/_arrayIncludesWith.js"),
    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js"),
    createSet = __webpack_require__("./node_modules/lodash/_createSet.js"),
    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "./node_modules/lodash/_baseUnset.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    last = __webpack_require__("./node_modules/lodash/last.js"),
    parent = __webpack_require__("./node_modules/lodash/_parent.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ "./node_modules/lodash/_baseValues.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js");

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ "./node_modules/lodash/_cacheHas.js":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "./node_modules/lodash/_castFunction.js":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("./node_modules/lodash/identity.js");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ "./node_modules/lodash/_castPath.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
    stringToPath = __webpack_require__("./node_modules/lodash/_stringToPath.js"),
    toString = __webpack_require__("./node_modules/lodash/toString.js");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "./node_modules/lodash/_castSlice.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("./node_modules/lodash/_baseSlice.js");

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ "./node_modules/lodash/_cloneArrayBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "./node_modules/lodash/_cloneBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_cloneDataView.js":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "./node_modules/lodash/_cloneRegExp.js":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "./node_modules/lodash/_cloneSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "./node_modules/lodash/_cloneTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_composeArgs.js":
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),

/***/ "./node_modules/lodash/_composeArgsRight.js":
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),

/***/ "./node_modules/lodash/_copyArray.js":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "./node_modules/lodash/_copyObject.js":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("./node_modules/lodash/_assignValue.js"),
    baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "./node_modules/lodash/_copySymbols.js":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "./node_modules/lodash/_copySymbolsIn.js":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
    getSymbolsIn = __webpack_require__("./node_modules/lodash/_getSymbolsIn.js");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "./node_modules/lodash/_countHolders.js":
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),

/***/ "./node_modules/lodash/_createAssigner.js":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("./node_modules/lodash/_baseRest.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "./node_modules/lodash/_createBaseEach.js":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "./node_modules/lodash/_createBaseFor.js":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "./node_modules/lodash/_createBind.js":
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__("./node_modules/lodash/_createCtor.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),

/***/ "./node_modules/lodash/_createCaseFirst.js":
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__("./node_modules/lodash/_castSlice.js"),
    hasUnicode = __webpack_require__("./node_modules/lodash/_hasUnicode.js"),
    stringToArray = __webpack_require__("./node_modules/lodash/_stringToArray.js"),
    toString = __webpack_require__("./node_modules/lodash/toString.js");

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ "./node_modules/lodash/_createCompounder.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__("./node_modules/lodash/_arrayReduce.js"),
    deburr = __webpack_require__("./node_modules/lodash/deburr.js"),
    words = __webpack_require__("./node_modules/lodash/words.js");

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ "./node_modules/lodash/_createCtor.js":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("./node_modules/lodash/_baseCreate.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),

/***/ "./node_modules/lodash/_createCurry.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("./node_modules/lodash/_apply.js"),
    createCtor = __webpack_require__("./node_modules/lodash/_createCtor.js"),
    createHybrid = __webpack_require__("./node_modules/lodash/_createHybrid.js"),
    createRecurry = __webpack_require__("./node_modules/lodash/_createRecurry.js"),
    getHolder = __webpack_require__("./node_modules/lodash/_getHolder.js"),
    replaceHolders = __webpack_require__("./node_modules/lodash/_replaceHolders.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),

/***/ "./node_modules/lodash/_createHybrid.js":
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__("./node_modules/lodash/_composeArgs.js"),
    composeArgsRight = __webpack_require__("./node_modules/lodash/_composeArgsRight.js"),
    countHolders = __webpack_require__("./node_modules/lodash/_countHolders.js"),
    createCtor = __webpack_require__("./node_modules/lodash/_createCtor.js"),
    createRecurry = __webpack_require__("./node_modules/lodash/_createRecurry.js"),
    getHolder = __webpack_require__("./node_modules/lodash/_getHolder.js"),
    reorder = __webpack_require__("./node_modules/lodash/_reorder.js"),
    replaceHolders = __webpack_require__("./node_modules/lodash/_replaceHolders.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),

/***/ "./node_modules/lodash/_createPartial.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("./node_modules/lodash/_apply.js"),
    createCtor = __webpack_require__("./node_modules/lodash/_createCtor.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),

/***/ "./node_modules/lodash/_createRecurry.js":
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__("./node_modules/lodash/_isLaziable.js"),
    setData = __webpack_require__("./node_modules/lodash/_setData.js"),
    setWrapToString = __webpack_require__("./node_modules/lodash/_setWrapToString.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),

/***/ "./node_modules/lodash/_createSet.js":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("./node_modules/lodash/_Set.js"),
    noop = __webpack_require__("./node_modules/lodash/noop.js"),
    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "./node_modules/lodash/_createWrap.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__("./node_modules/lodash/_baseSetData.js"),
    createBind = __webpack_require__("./node_modules/lodash/_createBind.js"),
    createCurry = __webpack_require__("./node_modules/lodash/_createCurry.js"),
    createHybrid = __webpack_require__("./node_modules/lodash/_createHybrid.js"),
    createPartial = __webpack_require__("./node_modules/lodash/_createPartial.js"),
    getData = __webpack_require__("./node_modules/lodash/_getData.js"),
    mergeData = __webpack_require__("./node_modules/lodash/_mergeData.js"),
    setData = __webpack_require__("./node_modules/lodash/_setData.js"),
    setWrapToString = __webpack_require__("./node_modules/lodash/_setWrapToString.js"),
    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),

/***/ "./node_modules/lodash/_customOmitClone.js":
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ "./node_modules/lodash/_deburrLetter.js":
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__("./node_modules/lodash/_basePropertyOf.js");

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ "./node_modules/lodash/_defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "./node_modules/lodash/_equalArrays.js":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__("./node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "./node_modules/lodash/_equalByTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js"),
    eq = __webpack_require__("./node_modules/lodash/eq.js"),
    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
    mapToArray = __webpack_require__("./node_modules/lodash/_mapToArray.js"),
    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "./node_modules/lodash/_equalObjects.js":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "./node_modules/lodash/_flatRest.js":
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__("./node_modules/lodash/flatten.js"),
    overRest = __webpack_require__("./node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__("./node_modules/lodash/_setToString.js");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_getAllKeysIn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
    getSymbolsIn = __webpack_require__("./node_modules/lodash/_getSymbolsIn.js"),
    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_getData.js":
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__("./node_modules/lodash/_metaMap.js"),
    noop = __webpack_require__("./node_modules/lodash/noop.js");

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),

/***/ "./node_modules/lodash/_getFuncName.js":
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__("./node_modules/lodash/_realNames.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),

/***/ "./node_modules/lodash/_getHolder.js":
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),

/***/ "./node_modules/lodash/_getMapData.js":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("./node_modules/lodash/_isKeyable.js");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "./node_modules/lodash/_getMatchData.js":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__("./node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "./node_modules/lodash/_getPrototype.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_getSymbols.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "./node_modules/lodash/_getSymbolsIn.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"),
    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
    Promise = __webpack_require__("./node_modules/lodash/_Promise.js"),
    Set = __webpack_require__("./node_modules/lodash/_Set.js"),
    WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js"),
    baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "./node_modules/lodash/_getWrapDetails.js":
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),

/***/ "./node_modules/lodash/_hasPath.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "./node_modules/lodash/_hasUnicode.js":
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ "./node_modules/lodash/_hasUnicodeWord.js":
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ "./node_modules/lodash/_hashClear.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "./node_modules/lodash/_hashDelete.js":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "./node_modules/lodash/_hashGet.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "./node_modules/lodash/_hashHas.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "./node_modules/lodash/_hashSet.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "./node_modules/lodash/_initCloneArray.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "./node_modules/lodash/_initCloneByTag.js":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("./node_modules/lodash/_cloneArrayBuffer.js"),
    cloneDataView = __webpack_require__("./node_modules/lodash/_cloneDataView.js"),
    cloneRegExp = __webpack_require__("./node_modules/lodash/_cloneRegExp.js"),
    cloneSymbol = __webpack_require__("./node_modules/lodash/_cloneSymbol.js"),
    cloneTypedArray = __webpack_require__("./node_modules/lodash/_cloneTypedArray.js");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "./node_modules/lodash/_initCloneObject.js":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("./node_modules/lodash/_baseCreate.js"),
    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "./node_modules/lodash/_insertWrapDetails.js":
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),

/***/ "./node_modules/lodash/_isFlattenable.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("./node_modules/lodash/eq.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "./node_modules/lodash/_isKey.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "./node_modules/lodash/_isKeyable.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "./node_modules/lodash/_isLaziable.js":
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__("./node_modules/lodash/_LazyWrapper.js"),
    getData = __webpack_require__("./node_modules/lodash/_getData.js"),
    getFuncName = __webpack_require__("./node_modules/lodash/_getFuncName.js"),
    lodash = __webpack_require__("./node_modules/lodash/wrapperLodash.js");

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "./node_modules/lodash/_isStrictComparable.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheClear.js":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("./node_modules/lodash/_Hash.js"),
    ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__("./node_modules/lodash/_Map.js");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapToArray.js":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_memoizeCapped.js":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("./node_modules/lodash/memoize.js");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "./node_modules/lodash/_mergeData.js":
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__("./node_modules/lodash/_composeArgs.js"),
    composeArgsRight = __webpack_require__("./node_modules/lodash/_composeArgsRight.js"),
    replaceHolders = __webpack_require__("./node_modules/lodash/_replaceHolders.js");

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),

/***/ "./node_modules/lodash/_metaMap.js":
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js");

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),

/***/ "./node_modules/lodash/_nativeCreate.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeysIn.js":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_overRest.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("./node_modules/lodash/_apply.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "./node_modules/lodash/_parent.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js"),
    baseSlice = __webpack_require__("./node_modules/lodash/_baseSlice.js");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ "./node_modules/lodash/_realNames.js":
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),

/***/ "./node_modules/lodash/_reorder.js":
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),

/***/ "./node_modules/lodash/_replaceHolders.js":
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_safeGet.js":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "./node_modules/lodash/_setCacheAdd.js":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "./node_modules/lodash/_setCacheHas.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_setData.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__("./node_modules/lodash/_baseSetData.js"),
    shortOut = __webpack_require__("./node_modules/lodash/_shortOut.js");

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),

/***/ "./node_modules/lodash/_setToArray.js":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "./node_modules/lodash/_setToString.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("./node_modules/lodash/_baseSetToString.js"),
    shortOut = __webpack_require__("./node_modules/lodash/_shortOut.js");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "./node_modules/lodash/_setWrapToString.js":
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__("./node_modules/lodash/_getWrapDetails.js"),
    insertWrapDetails = __webpack_require__("./node_modules/lodash/_insertWrapDetails.js"),
    setToString = __webpack_require__("./node_modules/lodash/_setToString.js"),
    updateWrapDetails = __webpack_require__("./node_modules/lodash/_updateWrapDetails.js");

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),

/***/ "./node_modules/lodash/_shortOut.js":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "./node_modules/lodash/_stackClear.js":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "./node_modules/lodash/_stackDelete.js":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "./node_modules/lodash/_stackGet.js":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "./node_modules/lodash/_stackHas.js":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "./node_modules/lodash/_stackSet.js":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
    MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "./node_modules/lodash/_strictIndexOf.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_stringSize.js":
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__("./node_modules/lodash/_asciiSize.js"),
    hasUnicode = __webpack_require__("./node_modules/lodash/_hasUnicode.js"),
    unicodeSize = __webpack_require__("./node_modules/lodash/_unicodeSize.js");

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),

/***/ "./node_modules/lodash/_stringToArray.js":
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__("./node_modules/lodash/_asciiToArray.js"),
    hasUnicode = __webpack_require__("./node_modules/lodash/_hasUnicode.js"),
    unicodeToArray = __webpack_require__("./node_modules/lodash/_unicodeToArray.js");

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ "./node_modules/lodash/_stringToPath.js":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("./node_modules/lodash/_memoizeCapped.js");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "./node_modules/lodash/_toKey.js":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "./node_modules/lodash/_unicodeSize.js":
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),

/***/ "./node_modules/lodash/_unicodeToArray.js":
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ "./node_modules/lodash/_unicodeWords.js":
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ "./node_modules/lodash/_updateWrapDetails.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__("./node_modules/lodash/_arrayEach.js"),
    arrayIncludes = __webpack_require__("./node_modules/lodash/_arrayIncludes.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),

/***/ "./node_modules/lodash/_wrapperClone.js":
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__("./node_modules/lodash/_LazyWrapper.js"),
    LodashWrapper = __webpack_require__("./node_modules/lodash/_LodashWrapper.js"),
    copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js");

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),

/***/ "./node_modules/lodash/ary.js":
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__("./node_modules/lodash/_createWrap.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),

/***/ "./node_modules/lodash/camelCase.js":
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__("./node_modules/lodash/capitalize.js"),
    createCompounder = __webpack_require__("./node_modules/lodash/_createCompounder.js");

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),

/***/ "./node_modules/lodash/capitalize.js":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("./node_modules/lodash/toString.js"),
    upperFirst = __webpack_require__("./node_modules/lodash/upperFirst.js");

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),

/***/ "./node_modules/lodash/castArray.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "./node_modules/lodash/clone.js":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("./node_modules/lodash/_baseClone.js");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "./node_modules/lodash/constant.js":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "./node_modules/lodash/curry.js":
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__("./node_modules/lodash/_createWrap.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),

/***/ "./node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    now = __webpack_require__("./node_modules/lodash/now.js"),
    toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "./node_modules/lodash/deburr.js":
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__("./node_modules/lodash/_deburrLetter.js"),
    toString = __webpack_require__("./node_modules/lodash/toString.js");

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ "./node_modules/lodash/eq.js":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "./node_modules/lodash/every.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__("./node_modules/lodash/_arrayEvery.js"),
    baseEvery = __webpack_require__("./node_modules/lodash/_baseEvery.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js");

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),

/***/ "./node_modules/lodash/filter.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
    baseFilter = __webpack_require__("./node_modules/lodash/_baseFilter.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ "./node_modules/lodash/findIndex.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("./node_modules/lodash/_baseFindIndex.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ "./node_modules/lodash/first.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/lodash/head.js");


/***/ }),

/***/ "./node_modules/lodash/flatten.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("./node_modules/lodash/_baseFlatten.js");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ "./node_modules/lodash/forEach.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__("./node_modules/lodash/_arrayEach.js"),
    baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
    castFunction = __webpack_require__("./node_modules/lodash/_castFunction.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ "./node_modules/lodash/fp/_baseConvert.js":
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__("./node_modules/lodash/fp/_mapping.js"),
    fallbackHolder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),

/***/ "./node_modules/lodash/fp/_falseOptions.js":
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),

/***/ "./node_modules/lodash/fp/_mapping.js":
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),

/***/ "./node_modules/lodash/fp/_util.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__("./node_modules/lodash/ary.js"),
  'assign': __webpack_require__("./node_modules/lodash/_baseAssign.js"),
  'clone': __webpack_require__("./node_modules/lodash/clone.js"),
  'curry': __webpack_require__("./node_modules/lodash/curry.js"),
  'forEach': __webpack_require__("./node_modules/lodash/_arrayEach.js"),
  'isArray': __webpack_require__("./node_modules/lodash/isArray.js"),
  'isError': __webpack_require__("./node_modules/lodash/isError.js"),
  'isFunction': __webpack_require__("./node_modules/lodash/isFunction.js"),
  'isWeakMap': __webpack_require__("./node_modules/lodash/isWeakMap.js"),
  'iteratee': __webpack_require__("./node_modules/lodash/iteratee.js"),
  'keys': __webpack_require__("./node_modules/lodash/_baseKeys.js"),
  'rearg': __webpack_require__("./node_modules/lodash/rearg.js"),
  'toInteger': __webpack_require__("./node_modules/lodash/toInteger.js"),
  'toPath': __webpack_require__("./node_modules/lodash/toPath.js")
};


/***/ }),

/***/ "./node_modules/lodash/fp/clone.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('clone', __webpack_require__("./node_modules/lodash/clone.js"), __webpack_require__("./node_modules/lodash/fp/_falseOptions.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/convert.js":
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__("./node_modules/lodash/fp/_baseConvert.js"),
    util = __webpack_require__("./node_modules/lodash/fp/_util.js");

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),

/***/ "./node_modules/lodash/fp/curry.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('curry', __webpack_require__("./node_modules/lodash/curry.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/every.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('every', __webpack_require__("./node_modules/lodash/every.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/head.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('head', __webpack_require__("./node_modules/lodash/head.js"), __webpack_require__("./node_modules/lodash/fp/_falseOptions.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/isNumber.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('isNumber', __webpack_require__("./node_modules/lodash/isNumber.js"), __webpack_require__("./node_modules/lodash/fp/_falseOptions.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/omit.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('omit', __webpack_require__("./node_modules/lodash/omit.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/pick.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('pick', __webpack_require__("./node_modules/lodash/pick.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/placeholder.js":
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),

/***/ "./node_modules/lodash/fp/set.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('set', __webpack_require__("./node_modules/lodash/set.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/setWith.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('setWith', __webpack_require__("./node_modules/lodash/setWith.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/fp/tail.js":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("./node_modules/lodash/fp/convert.js"),
    func = convert('tail', __webpack_require__("./node_modules/lodash/tail.js"), __webpack_require__("./node_modules/lodash/fp/_falseOptions.js"));

func.placeholder = __webpack_require__("./node_modules/lodash/fp/placeholder.js");
module.exports = func;


/***/ }),

/***/ "./node_modules/lodash/get.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "./node_modules/lodash/hasIn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("./node_modules/lodash/_baseHasIn.js"),
    hasPath = __webpack_require__("./node_modules/lodash/_hasPath.js");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "./node_modules/lodash/head.js":
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),

/***/ "./node_modules/lodash/identity.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "./node_modules/lodash/inRange.js":
/***/ (function(module, exports, __webpack_require__) {

var baseInRange = __webpack_require__("./node_modules/lodash/_baseInRange.js"),
    toFinite = __webpack_require__("./node_modules/lodash/toFinite.js"),
    toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

module.exports = inRange;


/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__("./node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "./node_modules/lodash/isArrayLikeObject.js":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isEmpty.js":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "./node_modules/lodash/isEqual.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "./node_modules/lodash/isError.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js"),
    isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "./node_modules/lodash/isMap.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__("./node_modules/lodash/_baseIsMap.js"),
    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "./node_modules/lodash/isNil.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ "./node_modules/lodash/isNull.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),

/***/ "./node_modules/lodash/isNumber.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "./node_modules/lodash/isSet.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__("./node_modules/lodash/_baseIsSet.js"),
    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "./node_modules/lodash/isString.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "./node_modules/lodash/isWeakMap.js":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),

/***/ "./node_modules/lodash/iteratee.js":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("./node_modules/lodash/_baseClone.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),

/***/ "./node_modules/lodash/kebabCase.js":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("./node_modules/lodash/_createCompounder.js");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),

/***/ "./node_modules/lodash/keys.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
    baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "./node_modules/lodash/keysIn.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
    baseKeysIn = __webpack_require__("./node_modules/lodash/_baseKeysIn.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "./node_modules/lodash/last.js":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "./node_modules/lodash/map.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    baseMap = __webpack_require__("./node_modules/lodash/_baseMap.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ "./node_modules/lodash/mapKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
    baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js");

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ "./node_modules/lodash/mapValues.js":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
    baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ "./node_modules/lodash/memoize.js":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "./node_modules/lodash/merge.js":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("./node_modules/lodash/_baseMerge.js"),
    createAssigner = __webpack_require__("./node_modules/lodash/_createAssigner.js");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "./node_modules/lodash/noop.js":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "./node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "./node_modules/lodash/omit.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    baseClone = __webpack_require__("./node_modules/lodash/_baseClone.js"),
    baseUnset = __webpack_require__("./node_modules/lodash/_baseUnset.js"),
    castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
    customOmitClone = __webpack_require__("./node_modules/lodash/_customOmitClone.js"),
    flatRest = __webpack_require__("./node_modules/lodash/_flatRest.js"),
    getAllKeysIn = __webpack_require__("./node_modules/lodash/_getAllKeysIn.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ "./node_modules/lodash/pick.js":
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__("./node_modules/lodash/_basePick.js"),
    flatRest = __webpack_require__("./node_modules/lodash/_flatRest.js");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ "./node_modules/lodash/pickBy.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    basePickBy = __webpack_require__("./node_modules/lodash/_basePickBy.js"),
    getAllKeysIn = __webpack_require__("./node_modules/lodash/_getAllKeysIn.js");

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),

/***/ "./node_modules/lodash/property.js":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("./node_modules/lodash/_baseProperty.js"),
    basePropertyDeep = __webpack_require__("./node_modules/lodash/_basePropertyDeep.js"),
    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "./node_modules/lodash/rearg.js":
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__("./node_modules/lodash/_createWrap.js"),
    flatRest = __webpack_require__("./node_modules/lodash/_flatRest.js");

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),

/***/ "./node_modules/lodash/reduce.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__("./node_modules/lodash/_arrayReduce.js"),
    baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    baseReduce = __webpack_require__("./node_modules/lodash/_baseReduce.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),

/***/ "./node_modules/lodash/set.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__("./node_modules/lodash/_baseSet.js");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ "./node_modules/lodash/setWith.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__("./node_modules/lodash/_baseSet.js");

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ }),

/***/ "./node_modules/lodash/size.js":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
    isString = __webpack_require__("./node_modules/lodash/isString.js"),
    stringSize = __webpack_require__("./node_modules/lodash/_stringSize.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),

/***/ "./node_modules/lodash/slice.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("./node_modules/lodash/_baseSlice.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js"),
    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ "./node_modules/lodash/snakeCase.js":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("./node_modules/lodash/_createCompounder.js");

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ "./node_modules/lodash/some.js":
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__("./node_modules/lodash/_arraySome.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    baseSome = __webpack_require__("./node_modules/lodash/_baseSome.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "./node_modules/lodash/startCase.js":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("./node_modules/lodash/_createCompounder.js"),
    upperFirst = __webpack_require__("./node_modules/lodash/upperFirst.js");

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),

/***/ "./node_modules/lodash/stubArray.js":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "./node_modules/lodash/tail.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("./node_modules/lodash/_baseSlice.js");

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

module.exports = tail;


/***/ }),

/***/ "./node_modules/lodash/toFinite.js":
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ "./node_modules/lodash/toInteger.js":
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__("./node_modules/lodash/toFinite.js");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "./node_modules/lodash/toPath.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    copyArray = __webpack_require__("./node_modules/lodash/_copyArray.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js"),
    stringToPath = __webpack_require__("./node_modules/lodash/_stringToPath.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js"),
    toString = __webpack_require__("./node_modules/lodash/toString.js");

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),

/***/ "./node_modules/lodash/toPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("./node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__("./node_modules/lodash/keysIn.js");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "./node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("./node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "./node_modules/lodash/uniq.js":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("./node_modules/lodash/_baseUniq.js");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "./node_modules/lodash/upperFirst.js":
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__("./node_modules/lodash/_createCaseFirst.js");

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ "./node_modules/lodash/values.js":
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__("./node_modules/lodash/_baseValues.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ "./node_modules/lodash/words.js":
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__("./node_modules/lodash/_asciiWords.js"),
    hasUnicodeWord = __webpack_require__("./node_modules/lodash/_hasUnicodeWord.js"),
    toString = __webpack_require__("./node_modules/lodash/toString.js"),
    unicodeWords = __webpack_require__("./node_modules/lodash/_unicodeWords.js");

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ "./node_modules/lodash/wrapperLodash.js":
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__("./node_modules/lodash/_LazyWrapper.js"),
    LodashWrapper = __webpack_require__("./node_modules/lodash/_LodashWrapper.js"),
    baseLodash = __webpack_require__("./node_modules/lodash/_baseLodash.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js"),
    wrapperClone = __webpack_require__("./node_modules/lodash/_wrapperClone.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),

/***/ "./node_modules/ms/index.js":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/react-dom/cjs/react-dom-server.browser.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__("./node_modules/fbjs/lib/invariant.js"),q=__webpack_require__("./node_modules/object-assign/index.js"),t=__webpack_require__("./node_modules/react/index.js"),w=__webpack_require__("./node_modules/fbjs/lib/emptyFunction.js"),x=__webpack_require__("./node_modules/fbjs/lib/emptyObject.js"),y=__webpack_require__("./node_modules/fbjs/lib/hyphenateStyleName.js"),z=__webpack_require__("./node_modules/fbjs/lib/memoizeStringOnly.js");
function A(a){for(var b=arguments.length-1,d="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);p(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var C="function"===typeof Symbol&&Symbol["for"],aa=C?Symbol["for"]("react.call"):60104,ba=C?Symbol["for"]("react.return"):60105,ca=C?Symbol["for"]("react.portal"):60106,E=C?Symbol["for"]("react.fragment"):60107,da=C?Symbol["for"]("react.strict_mode"):60108,F=C?Symbol["for"]("react.provider"):60109,ea=C?Symbol["for"]("react.context"):60110,fa=C?Symbol["for"]("react.async_mode"):60111,ha=C?Symbol["for"]("react.forward_ref"):60112,ia=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
G={},H={};function ja(a){if(H.hasOwnProperty(a))return!0;if(G.hasOwnProperty(a))return!1;if(ia.test(a))return H[a]=!0;G[a]=!0;return!1}function ka(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function la(a,b,d,c){if(null===b||"undefined"===typeof b||ka(a,b,d,c))return!0;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,k){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=k;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);var ma=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ma.exec(a);if(b){var d="",c,k=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="\x26quot;";break;case 38:b="\x26amp;";break;case 39:b="\x26#x27;";break;case 60:b="\x26lt;";break;case 62:b="\x26gt;";break;default:continue}k!==c&&(d+=a.substring(k,c));k=c+1;d+=b}a=k!==c?d+a.substring(k,c):d}return a}var N={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function O(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var P={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},na=q({menuitem:!0},P),Q={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,
fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},oa=["Webkit","ms","Moz","O"];Object.keys(Q).forEach(function(a){oa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Q[b]=Q[a]})});var R=t.Children.toArray,S=w.thatReturns("");w.thatReturns("");var pa={listing:!0,pre:!0,textarea:!0};
function T(a){return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}var qa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,U={},ra=z(function(a){return y(a)});function sa(a){var b="";t.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ta(a,b){if(a=a.contextTypes){var d={},c;for(c in a)d[c]=b[c];b=d}else b=x;return b}var ua={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};
function V(a,b){void 0===a&&A("152",T(b)||"Component")}
function va(a,b){function d(c,k){var d=ta(k,b),f=[],h=!1,g={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},e=void 0;if(k.prototype&&k.prototype.isReactComponent){if(e=new k(c.props,d,g),"function"===typeof k.getDerivedStateFromProps){var v=k.getDerivedStateFromProps.call(null,c.props,e.state);null!=v&&(e.state=q({},e.state,v))}}else if(e=k(c.props,
d,g),null==e||null==e.render){a=e;V(a,k);return}e.props=c.props;e.context=d;e.updater=g;g=e.state;void 0===g&&(e.state=g=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),f.length){g=f;var u=h;f=null;h=!1;if(u&&
1===g.length)e.state=g[0];else{v=u?g[0]:e.state;var m=!0;for(u=u?1:0;u<g.length;u++){var n=g[u];n="function"===typeof n?n.call(e,v,c.props,d):n;null!=n&&(m?(m=!1,v=q({},v,n)):q(v,n))}e.state=v}}else f=null;a=e.render();V(a,k);c=void 0;if("function"===typeof e.getChildContext&&(d=k.childContextTypes,"object"===typeof d)){c=e.getChildContext();for(var r in c)r in d?void 0:A("108",T(k)||"Unknown",r)}c&&(b=q({},b,c))}for(;t.isValidElement(a);){var c=a,k=c.type;if("function"!==typeof k)break;d(c,k)}return{child:a,
context:b}}
var W=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");t.isValidElement(b)?b.type!==E?b=[b]:(b=b.props.children,b=t.isValidElement(b)?[b]:R(b)):b=R(b);this.stack=[{type:null,domNamespace:N.html,children:b,childIndex:0,context:x,footer:""}];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.providerStack=[];this.providerIndex=-1}a.prototype.pushProvider=function(a){this.providerIndex+=1;
this.providerStack[this.providerIndex]=a;a.type._context._currentValue=a.props.value};a.prototype.popProvider=function(a){this.providerStack[this.providerIndex]=null;--this.providerIndex;a=a.type._context;a._currentValue=0>this.providerIndex?a._defaultValue:this.providerStack[this.providerIndex].props.value};a.prototype.read=function(a){if(this.exhausted)return null;for(var b="";b.length<a;){if(0===this.stack.length){this.exhausted=!0;break}var c=this.stack[this.stack.length-1];if(c.childIndex>=c.children.length){var k=
c.footer;b+=k;""!==k&&(this.previousWasTextNode=!1);this.stack.pop();"select"===c.type?this.currentSelectValue=null:null!=c.type&&null!=c.type.type&&c.type.type.$$typeof===F&&this.popProvider(c.type)}else k=c.children[c.childIndex++],b+=this.render(k,c.context,c.domNamespace)}return b};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=
!0;return M(c)}d=va(a,d);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!t.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ca?A("257"):void 0;A("258",b.toString())}a=R(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case da:case fa:case E:return a=R(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),
"";case aa:case ba:A("259")}if("object"===typeof b&&null!==b)switch(b.$$typeof){case ha:return a=R(b.render(a.props,a.ref)),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case F:return b=R(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case ea:return b=R(a.props.children(a.type._currentValue)),this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""}),
""}A("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===N.html&&O(b);U.hasOwnProperty(b)||(qa.test(b)?void 0:A("65",b),U[b]=!0);var f=a.props;if("input"===b)f=q({type:void 0},f,{defaultChecked:void 0,defaultValue:void 0,value:null!=f.value?f.value:f.defaultValue,checked:null!=f.checked?f.checked:f.defaultChecked});else if("textarea"===b){var h=f.value;if(null==h){h=f.defaultValue;var l=f.children;null!=l&&(null!=h?A("92"):void 0,Array.isArray(l)&&(1>=
l.length?void 0:A("93"),l=l[0]),h=""+l);null==h&&(h="")}f=q({},f,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=f.value?f.value:f.defaultValue,f=q({},f,{value:void 0});else if("option"===b){l=this.currentSelectValue;var D=sa(f.children);if(null!=l){var B=null!=f.value?f.value+"":D;h=!1;if(Array.isArray(l))for(var g=0;g<l.length;g++){if(""+l[g]===B){h=!0;break}}else h=""+l===B;f=q({selected:void 0,children:void 0},f,{selected:h,children:D})}}if(h=f)na[b]&&(null!=h.children||
null!=h.dangerouslySetInnerHTML?A("137",b,S()):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?A("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:A("61")),null!=h.style&&"object"!==typeof h.style?A("62",S()):void 0;h=f;l=this.makeStaticMarkup;D=1===this.stack.length;B="\x3c"+a.type;for(r in h)if(h.hasOwnProperty(r)){var e=h[r];if(null!=e){if("style"===r){g=void 0;var v="",u="";for(g in e)if(e.hasOwnProperty(g)){var m=0===g.indexOf("--"),
n=e[g];null!=n&&(v+=u+ra(g)+":",u=g,m=null==n||"boolean"===typeof n||""===n?"":m||"number"!==typeof n||0===n||Q.hasOwnProperty(u)&&Q[u]?(""+n).trim():n+"px",v+=m,u=";")}e=v||null}g=null;b:if(m=b,n=h,-1===m.indexOf("-"))m="string"===typeof n.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)ua.hasOwnProperty(r)||(g=r,g=ja(g)&&null!=
e?g+"\x3d"+('"'+M(e)+'"'):"");else{m=r;g=e;e=J.hasOwnProperty(m)?J[m]:null;if(n="style"!==m)n=null!==e?0===e.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;n||la(m,g,e,!1)?g="":null!==e?(m=e.attributeName,e=e.type,g=3===e||4===e&&!0===g?m+'\x3d""':m+"\x3d"+('"'+M(g)+'"')):g=m+"\x3d"+('"'+M(g)+'"')}g&&(B+=" "+g)}}l||D&&(B+=' data-reactroot\x3d""');var r=B;h="";P.hasOwnProperty(b)?r+="/\x3e":(r+="\x3e",h="\x3c/"+a.type+"\x3e");a:{l=f.dangerouslySetInnerHTML;if(null!=l){if(null!=
l.__html){l=l.__html;break a}}else if(l=f.children,"string"===typeof l||"number"===typeof l){l=M(l);break a}l=null}null!=l?(f=[],pa[b]&&"\n"===l.charAt(0)&&(r+="\n"),r+=l):f=R(f.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?O(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:f,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return r};return a}(),X={renderToString:function(a){return(new W(a,
!1)).read(Infinity)},renderToStaticMarkup:function(a){return(new W(a,!0)).read(Infinity)},renderToNodeStream:function(){A("207")},renderToStaticNodeStream:function(){A("208")},version:"16.3.2"},Y=Object.freeze({default:X}),Z=Y&&X||Y;module.exports=Z["default"]?Z["default"]:Z;


/***/ }),

/***/ "./node_modules/react-dom/server.browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("./node_modules/react-dom/cjs/react-dom-server.browser.production.min.js");
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),

/***/ "./node_modules/react-error-boundary/dist/commonjs/ErrorBoundary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _ErrorBoundaryFallbackComponent = __webpack_require__("./node_modules/react-error-boundary/dist/commonjs/ErrorBoundaryFallbackComponent.js");

var _ErrorBoundaryFallbackComponent2 = _interopRequireDefault(_ErrorBoundaryFallbackComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorBoundary = function (_Component) {
  _inherits(ErrorBoundary, _Component);

  function ErrorBoundary(props, context) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props, context));

    _this.state = {
      error: null,
      info: null
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: 'unstable_handleError',
    value: function unstable_handleError(error, info) {
      // This method is a fallback for react <= 16.0.0-alpha.13
      this.componentDidError(error, info);
    }
  }, {
    key: 'componentDidError',
    value: function componentDidError(error, info) {
      var onError = this.props.onError;


      if (typeof onError === 'function') {
        try {
          onError(error, info ? info.componentStack : '');
        } catch (error) {}
      }

      this.setState({ error: error, info: info });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          FallbackComponent = _props.FallbackComponent;
      var _state = this.state,
          error = _state.error,
          info = _state.info;


      if (error !== null) {
        return _react2.default.createElement(FallbackComponent, { componentStack: info ? info.componentStack : '', error: error });
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(_react.Component);

ErrorBoundary.defaultProps = {
  FallbackComponent: _ErrorBoundaryFallbackComponent2.default
};
ErrorBoundary.propTypes = {
  children: __webpack_require__("./node_modules/prop-types/index.js").any,
  FallbackComponent: __webpack_require__("./node_modules/prop-types/index.js").any.isRequired,
  onError: __webpack_require__("./node_modules/prop-types/index.js").func
};
exports.default = ErrorBoundary;

/***/ }),

/***/ "./node_modules/react-error-boundary/dist/commonjs/ErrorBoundaryFallbackComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toTitle = function toTitle(error, componentStack) {
  return error.toString() + "\n\nThis is located at:" + componentStack;
};

var ErrorBoundaryFallbackComponent = function ErrorBoundaryFallbackComponent(_ref) {
  var componentStack = _ref.componentStack,
      error = _ref.error;
  return _react2.default.createElement(
    "div",
    { style: style, title: toTitle(error, componentStack) },
    _react2.default.createElement(
      "svg",
      { style: svgStyle, viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid" },
      _react2.default.createElement("path", { d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,\n        12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,\n        12M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,\n        9.5C14,8.7 14.7,8 15.5,8M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,\n        8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,14C13.75,14 15.29,14.72 16.19,\n        15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,\n        17.23L7.81,15.81C8.71,14.72 10.25,14 12,14Z" })
    )
  );
};

ErrorBoundaryFallbackComponent.propTypes = {
  componentStack: __webpack_require__("./node_modules/prop-types/index.js").string.isRequired,
  error: typeof Error === "function" ? __webpack_require__("./node_modules/prop-types/index.js").instanceOf(Error).isRequired : __webpack_require__("./node_modules/prop-types/index.js").any.isRequired
};
var style = {
  height: '100%',
  maxHeight: '100vh',
  width: '100%',
  maxWidth: '100vw',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  backgroundColor: '#C00',
  color: '#FFF',
  boxSizing: 'border-box',
  cursor: 'help'
};

var svgStyle = {
  fill: 'currentColor',
  flex: '1 1 auto'
};

exports.default = ErrorBoundaryFallbackComponent;

/***/ }),

/***/ "./node_modules/react-error-boundary/dist/commonjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundaryFallbackComponent = exports.ErrorBoundary = undefined;

var _ErrorBoundaryFallbackComponent = __webpack_require__("./node_modules/react-error-boundary/dist/commonjs/ErrorBoundaryFallbackComponent.js");

var _ErrorBoundaryFallbackComponent2 = _interopRequireDefault(_ErrorBoundaryFallbackComponent);

var _ErrorBoundary = __webpack_require__("./node_modules/react-error-boundary/dist/commonjs/ErrorBoundary.js");

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ErrorBoundary2.default;
exports.ErrorBoundary = _ErrorBoundary2.default;
exports.ErrorBoundaryFallbackComponent = _ErrorBoundaryFallbackComponent2.default;

/***/ }),

/***/ "./node_modules/react-icon-base/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconBase = function IconBase(_ref, _ref2) {
  var children = _ref.children;
  var color = _ref.color;
  var size = _ref.size;
  var style = _ref.style;
  var width = _ref.width;
  var height = _ref.height;

  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);

  var _ref2$reactIconBase = _ref2.reactIconBase;
  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;

  var computedSize = size || reactIconBase.size || '1em';
  return _react2.default.createElement('svg', _extends({
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: height || computedSize,
    width: width || computedSize
  }, reactIconBase, props, {
    style: _extends({
      verticalAlign: 'middle',
      color: color || reactIconBase.color
    }, reactIconBase.style || {}, style)
  }));
};

IconBase.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
};

IconBase.contextTypes = {
  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
};

exports.default = IconBase;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/arrow-circle-o-up.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaArrowCircleOUp = function FaArrowCircleOUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28 19.6q-0.2 0.4-0.7 0.4h-4.3v7.9q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-7.9h-4.3q-0.3 0-0.5-0.2t-0.2-0.5q0-0.3 0.2-0.5l7.1-7.2q0.3-0.2 0.5-0.2t0.6 0.2l7.1 7.2q0.3 0.3 0.2 0.8z m-7.9-11.7q-3.3 0-6.1 1.6t-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6z m17.2 12.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaArrowCircleOUp;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/chevron-circle-left.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaChevronCircleLeft = function FaChevronCircleLeft(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.3 31.1l2.3-2.2q0.4-0.5 0.4-1t-0.4-1l-6.9-6.9 6.9-6.9q0.4-0.4 0.4-1t-0.4-1l-2.3-2.2q-0.4-0.5-1-0.5t-1 0.5l-10.2 10.1q-0.4 0.4-0.4 1t0.4 1l10.2 10.1q0.4 0.5 1 0.5t1-0.5z m14-11.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaChevronCircleLeft;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/chevron-circle-right.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaChevronCircleRight = function FaChevronCircleRight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19 31.1l10.1-10.1q0.5-0.4 0.5-1t-0.5-1l-10.1-10.1q-0.4-0.5-1-0.5t-1 0.5l-2.3 2.2q-0.4 0.5-0.4 1t0.4 1l6.9 6.9-6.9 6.9q-0.4 0.4-0.4 1t0.4 1l2.3 2.2q0.4 0.5 1 0.5t1-0.5z m18.3-11.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaChevronCircleRight;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/circle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCircle = function FaCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.3 20q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaCircle;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/cloud.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCloud = function FaCloud(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.9 25.3q0 3.3-2.4 5.7t-5.6 2.3h-22.6q-3.8 0-6.6-2.7t-2.7-6.6q0-2.8 1.5-5t3.9-3.4q-0.1-0.6-0.1-0.9 0-4.4 3.1-7.5t7.5-3.1q3.3 0 6 1.8t3.9 4.8q1.4-1.3 3.4-1.3 2.2 0 3.8 1.5t1.5 3.8q0 1.5-0.8 2.8 2.7 0.7 4.4 2.8t1.8 5z' })
        )
    );
};

exports.default = FaCloud;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/copy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCopy = function FaCopy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.9 8.6q0.9 0 1.5 0.6t0.6 1.5v27.2q0 0.9-0.6 1.5t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.5v-6.5h-12.2q-0.9 0-1.5-0.6t-0.6-1.5v-15q0-0.9 0.4-2t1.1-1.7l9.1-9.1q0.6-0.6 1.7-1.1t2-0.4h9.3q0.9 0 1.5 0.6t0.6 1.5v7.4q1.5-0.9 2.9-0.9h9.3z m-12.2 4.7l-6.7 6.7h6.7v-6.7z m-14.3-8.5l-6.6 6.6h6.6v-6.6z m4.4 14.4l7.1-7.1v-9.2h-8.6v9.2q0 0.9-0.6 1.6t-1.6 0.6h-9.2v14.3h11.4v-5.7q0-0.9 0.4-2t1.1-1.7z m21.3 17.9v-25.7h-8.5v9.3q0 0.9-0.7 1.5t-1.5 0.7h-9.3v14.2h20z' })
        )
    );
};

exports.default = FaCopy;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/download.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaDownload = function FaDownload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.1 30q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m5.7 0q0-0.6-0.4-1t-1-0.4-1 0.4-0.5 1 0.5 1 1 0.4 1-0.4 0.4-1z m2.8-5v7.1q0 0.9-0.6 1.6t-1.5 0.6h-32.9q-0.8 0-1.5-0.6t-0.6-1.6v-7.1q0-0.9 0.6-1.5t1.5-0.6h10.4l3 3q1.3 1.2 3.1 1.2t3-1.2l3-3h10.4q0.9 0 1.5 0.6t0.6 1.5z m-7.2-12.7q0.4 0.9-0.3 1.6l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.7-0.7-0.3-1.6 0.3-0.9 1.3-0.9h5.7v-10q0-0.6 0.4-1t1-0.4h5.7q0.6 0 1 0.4t0.5 1v10h5.7q0.9 0 1.3 0.9z' })
        )
    );
};

exports.default = FaDownload;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/edit.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaEdit = function FaEdit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z' })
        )
    );
};

exports.default = FaEdit;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/file-pdf-o.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFilePdfO = function FaFilePdfO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-11.4-13.2q0.7 0.6 1.8 1.3 1.3-0.2 2.6-0.2 3.3 0 4 1.1 0.4 0.5 0 1.2 0 0 0 0l0 0v0.1q-0.2 0.8-1.6 0.8-1.1 0-2.6-0.4t-2.9-1.2q-4.9 0.5-8.7 1.8-3.4 5.9-5.4 5.9-0.4 0-0.7-0.2l-0.5-0.2q0-0.1-0.1-0.2-0.3-0.2-0.2-0.8 0.2-0.8 1.3-2t2.9-2.1q0.3-0.2 0.5 0.1 0.1 0 0.1 0.1 1.1-1.9 2.4-4.4 1.5-3.1 2.3-5.9-0.5-1.8-0.7-3.5t0.2-2.9q0.2-0.9 0.9-0.9h0.5q0.5 0 0.8 0.4 0.4 0.4 0.2 1.5-0.1 0.1-0.1 0.2 0 0 0 0.1v0.7q0 2.8-0.3 4.3 1.2 3.7 3.3 5.3z m-12.9 9.2q1.2-0.6 3.1-3.5-1.2 0.8-2 1.8t-1.1 1.7z m8.9-20.6q-0.4 1-0.1 3 0.1-0.2 0.2-1 0-0.1 0.1-0.9 0.1-0.1 0.1-0.2 0-0.1 0-0.1t0 0 0 0q0-0.5-0.3-0.8 0 0 0 0v0z m-2.8 14.8q3-1.2 6.4-1.8-0.1 0-0.3-0.2t-0.4-0.3q-1.7-1.5-2.8-4-0.6 2-1.9 4.4-0.7 1.3-1 1.9z m14.4-0.4q-0.5-0.5-3.1-0.5 1.7 0.6 2.8 0.6 0.3 0 0.4 0 0 0-0.1-0.1z' })
        )
    );
};

exports.default = FaFilePdfO;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/file-text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFileText = function FaFileText(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 10.6q0.3 0.3 0.6 0.8h-10.5v-10.5q0.4 0.3 0.8 0.6z m-10.7 3.7h12.2v23.6q0 0.9-0.6 1.5t-1.6 0.6h-30q-0.8 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h17.9v12.1q0 0.9 0.6 1.6t1.5 0.6z m3.6 16.4v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.4-0.2-0.6t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.6v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.2-0.5z' })
        )
    );
};

exports.default = FaFileText;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/file.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFile = function FaFile(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 11.4v-10.5q0.4 0.3 0.8 0.6l9.1 9.1q0.3 0.3 0.6 0.8h-10.5z m-2.9 0.7q0 0.9 0.6 1.6t1.5 0.6h12.2v23.6q0 0.9-0.6 1.5t-1.6 0.6h-30q-0.8 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h17.9v12.1z' })
        )
    );
};

exports.default = FaFile;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/folder-open.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFolderOpen = function FaFolderOpen(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.9 21.2q0 0.6-0.6 1.4l-7.2 8.4q-0.9 1.1-2.5 1.9t-3.1 0.7h-23.1q-0.7 0-1.3-0.3t-0.5-0.9q0-0.6 0.6-1.4l7.2-8.4q0.9-1.1 2.5-1.8t3.1-0.8h23.1q0.7 0 1.3 0.3t0.5 0.9z m-7.2-7.3v3.4h-17.7q-2 0-4.2 1t-3.5 2.5l-7.3 8.6q0-0.1 0-0.3t0-0.3v-20.4q0-1.9 1.4-3.3t3.4-1.4h6.8q1.9 0 3.3 1.4t1.4 3.3v0.7h11.6q1.9 0 3.4 1.4t1.4 3.4z' })
        )
    );
};

exports.default = FaFolderOpen;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/magic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaMagic = function FaMagic(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.6 13l6.5-6.6-2.4-2.4-6.5 6.6z m9.9-6.6q0 0.6-0.4 1l-28.7 28.7q-0.4 0.4-1 0.4t-1-0.4l-4.4-4.4q-0.4-0.4-0.4-1t0.4-1l28.7-28.7q0.4-0.4 1-0.4t1 0.4l4.4 4.4q0.4 0.4 0.4 1z m-30.1-4.2l2.2 0.7-2.2 0.6-0.7 2.2-0.7-2.2-2.1-0.6 2.1-0.7 0.7-2.2z m7.8 3.6l4.4 1.3-4.4 1.4-1.3 4.4-1.4-4.4-4.4-1.4 4.4-1.3 1.4-4.4z m20.8 10.7l2.1 0.6-2.1 0.7-0.7 2.2-0.7-2.2-2.2-0.7 2.2-0.6 0.7-2.2z m-14.3-14.3l2.2 0.7-2.2 0.6-0.7 2.2-0.7-2.2-2.2-0.6 2.2-0.7 0.7-2.2z' })
        )
    );
};

exports.default = FaMagic;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/pencil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPencil = function FaPencil(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.1 34.3l2-2-5.2-5.3-2 2v2.4h2.8v2.9h2.4z m11.7-20.7q0-0.5-0.5-0.5-0.2 0-0.4 0.1l-12.1 12.1q-0.1 0.2-0.1 0.4 0 0.5 0.4 0.5 0.3 0 0.4-0.2l12.1-12.1q0.2-0.1 0.2-0.3z m-1.2-4.3l9.3 9.3-18.6 18.5h-9.3v-9.2z m15.2 2.1q0 1.2-0.8 2l-3.7 3.7-9.3-9.2 3.7-3.7q0.8-0.9 2-0.9 1.2 0 2 0.9l5.3 5.2q0.8 0.9 0.8 2z' })
        )
    );
};

exports.default = FaPencil;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/question-circle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaQuestionCircle = function FaQuestionCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23 30.7v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-4.3q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5z m5.7-15q0-2-1.2-3.6t-3.1-2.6-3.8-0.9q-5.4 0-8.3 4.7-0.3 0.6 0.2 1l2.9 2.2q0.2 0.1 0.5 0.1 0.3 0 0.5-0.2 1.2-1.6 1.9-2.1 0.8-0.5 2-0.5 1 0 1.9 0.6t0.8 1.3q0 0.8-0.4 1.3t-1.6 1q-1.4 0.7-2.5 2t-1.2 2.8v0.8q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5q0-0.5 0.5-1.1t1.2-1.1q0.7-0.4 1.1-0.7t1-0.8 1-1 0.6-1.4 0.3-1.8z m8.6 4.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaQuestionCircle;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/refresh.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaRefresh = function FaRefresh(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.7 23.6q0 0.1 0 0.1-1.4 6-6 9.7t-10.6 3.7q-3.3 0-6.4-1.2t-5.4-3.5l-2.9 2.9q-0.4 0.4-1 0.4t-1-0.4-0.4-1v-10q0-0.6 0.4-1t1-0.4h10q0.6 0 1 0.4t0.5 1-0.5 1l-3 3q1.6 1.5 3.6 2.3t4.1 0.8q3 0 5.6-1.4t4.2-4q0.2-0.4 1.2-2.6 0.1-0.5 0.6-0.5h4.3q0.3 0 0.5 0.2t0.2 0.5z m0.6-17.9v10q0 0.6-0.4 1t-1 0.4h-10q-0.6 0-1-0.4t-0.5-1 0.5-1l3-3.1q-3.3-3-7.8-3-2.9 0-5.5 1.4t-4.2 4q-0.2 0.4-1.2 2.6-0.2 0.5-0.6 0.5h-4.5q-0.3 0-0.5-0.2t-0.2-0.5v-0.1q1.5-6 6-9.7t10.7-3.7q3.3 0 6.4 1.2t5.4 3.5l3-2.9q0.4-0.4 1-0.4t1 0.4 0.4 1z' })
        )
    );
};

exports.default = FaRefresh;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/rotate-left.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaRotateLeft = function FaRotateLeft(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.3 20q0 3.5-1.4 6.7t-3.6 5.4-5.5 3.7-6.7 1.3q-3.8 0-7.3-1.6t-5.8-4.5q-0.2-0.3-0.2-0.5t0.2-0.5l3.1-3.1q0.2-0.2 0.5-0.2 0.4 0.1 0.5 0.3 1.7 2.1 4 3.3t5 1.1q2.4 0 4.5-0.9t3.6-2.4 2.5-3.7 0.9-4.4-0.9-4.4-2.5-3.7-3.6-2.4-4.5-0.9q-2.1 0-4.2 0.8t-3.5 2.2l3 3.1q0.7 0.7 0.3 1.6-0.3 0.8-1.3 0.8h-10q-0.5 0-1-0.4t-0.4-1v-10q0-0.9 0.9-1.3 0.9-0.4 1.5 0.3l2.9 2.9q2.4-2.3 5.5-3.5t6.3-1.2q3.5 0 6.7 1.3t5.5 3.7 3.6 5.4 1.4 6.7z' })
        )
    );
};

exports.default = FaRotateLeft;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/shopping-cart.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaShoppingCart = function FaShoppingCart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.8 34.3q0 1.1-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m20 0q0 1.1-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m2.8-24.3v11.4q0 0.6-0.3 1t-0.9 0.5l-23.3 2.7q0.3 1.3 0.3 1.5 0 0.4-0.6 1.5h20.6q0.5 0 1 0.4t0.4 1-0.4 1-1 0.4h-22.9q-0.6 0-1-0.4t-0.4-1q0-0.2 0.2-0.7t0.3-0.8 0.5-0.9 0.3-0.7l-3.9-18.3h-4.6q-0.6 0-1-0.5t-0.4-1 0.4-1 1-0.4h5.7q0.4 0 0.7 0.2t0.4 0.3 0.3 0.6 0.2 0.5 0.1 0.7 0.1 0.6h26.8q0.6 0 1 0.4t0.4 1z' })
        )
    );
};

exports.default = FaShoppingCart;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/spinner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSpinner = function FaSpinner(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.7 31.1q0 1.2-0.8 2t-2 0.9q-1.2 0-2-0.9t-0.9-2q0-1.2 0.9-2t2-0.8 2 0.8 0.8 2z m11.2 4.6q0 1.2-0.9 2t-2 0.9-2-0.9-0.9-2 0.9-2 2-0.8 2 0.8 0.9 2z m-15.8-15.7q0 1.2-0.8 2t-2 0.9-2-0.9-0.9-2 0.9-2 2-0.9 2 0.9 0.8 2z m26.9 11.1q0 1.2-0.9 2t-2 0.9q-1.2 0-2-0.9t-0.8-2 0.8-2 2-0.8 2 0.8 0.9 2z m-21.5-22.2q0 1.5-1.1 2.5t-2.5 1.1-2.5-1.1-1.1-2.5 1.1-2.5 2.5-1.1 2.5 1.1 1.1 2.5z m26.1 11.1q0 1.2-0.9 2t-2 0.9-2-0.9-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m-14.3-15.7q0 1.8-1.3 3t-3 1.3-3-1.3-1.3-3 1.3-3.1 3-1.2 3 1.3 1.3 3z m11.8 4.6q0 2.1-1.5 3.5t-3.5 1.5q-2.1 0-3.5-1.5t-1.5-3.5q0-2.1 1.5-3.5t3.5-1.5q2.1 0 3.5 1.5t1.5 3.5z' })
        )
    );
};

exports.default = FaSpinner;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/trash.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaTrash = function FaTrash(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.9 30.7v-15.7q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.7 0v-15.7q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.8 0v-15.7q0-0.3-0.2-0.5t-0.6-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.4 0 0.6-0.2t0.2-0.5z m-12.2-22.1h10l-1.1-2.6q-0.1-0.2-0.3-0.3h-7.1q-0.2 0.1-0.4 0.3z m20.7 0.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-2.1v21.2q0 1.8-1.1 3.2t-2.5 1.3h-18.6q-1.4 0-2.5-1.3t-1-3.1v-21.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h6.9l1.6-3.8q0.3-0.8 1.2-1.4t1.7-0.5h7.2q0.9 0 1.8 0.5t1.2 1.4l1.5 3.8h6.9q0.3 0 0.5 0.2t0.2 0.5z' })
        )
    );
};

exports.default = FaTrash;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/components/DefaultWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function DefaultWrapper(_ref) {
    var childProps = _ref.childProps,
        children = _ref.children,
        isFailed = _ref.isFailed,
        isLoaded = _ref.isLoaded,
        props = _objectWithoutProperties(_ref, ['childProps', 'children', 'isFailed', 'isLoaded']);

    var className = 'react-lazy-wrapper' + (!isLoaded && !isFailed ? ' react-lazy-wrapper--' + (childProps ? 'loading' : 'placeholder') : '') + (isFailed ? ' react-lazy-wrapper--failed' : '') + (isLoaded ? ' react-lazy-wrapper--loaded' : '') + (props.className ? ' ' + props.className : '');

    return _react2.default.createElement(
        'div',
        _extends({}, props, { className: className }),
        children
    );
}

DefaultWrapper.propTypes = {
    children: _propTypes2.default.node,
    childProps: _propTypes2.default.object,
    className: _propTypes2.default.string,
    isFailed: _propTypes2.default.bool,
    isLoaded: _propTypes2.default.bool
};

exports.default = DefaultWrapper;

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/components/Lazy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _viewport = __webpack_require__("./node_modules/react-lazy/dist/module/lib/viewport.js");

var _wrap = __webpack_require__("./node_modules/react-lazy/dist/module/lib/wrap.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Lazy = function (_React$PureComponent) {
    _inherits(Lazy, _React$PureComponent);

    function Lazy(props) {
        _classCallCheck(this, Lazy);

        var _this = _possibleConstructorReturn(this, (Lazy.__proto__ || Object.getPrototypeOf(Lazy)).call(this, props));

        _this.state = { loadedAt: null };

        _this.getRef = _this.getRef.bind(_this);
        _this.onViewport = _this.onViewport.bind(_this);
        return _this;
    }

    _createClass(Lazy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.options = {
                callback: this.onViewport,
                cushion: this.props.cushion,
                element: this.el
            };
            (0, _viewport.addElement)(this.options);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.cushion !== this.props.cushion) {
                this.options.cushion = nextProps.cushion;
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _viewport.removeElement)(this.options);
            delete this.options;
        }
    }, {
        key: 'getRef',
        value: function getRef(el) {
            this.el = el;
        }
    }, {
        key: 'onViewport',
        value: function onViewport() {
            var _props = this.props,
                onLoad = _props.onLoad,
                onViewport = _props.onViewport,
                visible = _props.visible;


            if (!visible) {
                return false;
            }

            if (onViewport) {
                onViewport();
            }

            this.setState({ loadedAt: Date.now() }, onLoad);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                component = _props2.component,
                cushion = _props2.cushion,
                ltIE9 = _props2.ltIE9,
                visible = _props2.visible,
                onLoad = _props2.onLoad,
                onViewport = _props2.onViewport,
                rest = _objectWithoutProperties(_props2, ['children', 'component', 'cushion', 'ltIE9', 'visible', 'onLoad', 'onViewport']);

            var props = _extends({}, rest, { ref: this.getRef });

            if (visible && this.state.loadedAt) {
                return _react2.default.createElement(component, props, children);
            }

            // wrap all contents inside noscript
            return _react2.default.createElement(component, (0, _wrap.propsWithNoScriptRender)(children, ltIE9, props));
        }
    }]);

    return Lazy;
}(_react2.default.PureComponent);

Lazy.defaultProps = {
    component: 'div',
    cushion: 0,
    ltIE9: false,
    visible: true
};

Lazy.propTypes = {
    children: _propTypes2.default.node,
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
    cushion: _propTypes2.default.number,
    ltIE9: _propTypes2.default.bool,
    onLoad: _propTypes2.default.func,
    onViewport: _propTypes2.default.func,
    visible: _propTypes2.default.bool
};

exports.default = Lazy;

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/components/LazyChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LazyChild = function (_React$PureComponent) {
    _inherits(LazyChild, _React$PureComponent);

    function LazyChild(props) {
        _classCallCheck(this, LazyChild);

        var _this = _possibleConstructorReturn(this, (LazyChild.__proto__ || Object.getPrototypeOf(LazyChild)).call(this, props));

        var _ref = props.children && (props.children.props || props.children._store && props.children._store.props) || {},
            onError = _ref.onError,
            onLoad = _ref.onLoad,
            childProps = _objectWithoutProperties(_ref, ['onError', 'onLoad']);

        _this.childOnError = onError;
        _this.childOnLoad = onLoad;
        _this.childProps = childProps;

        _this.state = { isFailed: false, isLoaded: false };

        _this.onError = _this.onError.bind(_this);
        _this.onLoad = _this.onLoad.bind(_this);
        return _this;
    }

    _createClass(LazyChild, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.children === this.props.children) {
                return;
            }

            var _ref2 = nextProps.children && (nextProps.children.props || nextProps.children._store && nextProps.children._store.props) || {},
                onError = _ref2.onError,
                onLoad = _ref2.onLoad,
                childProps = _objectWithoutProperties(_ref2, ['onError', 'onLoad']);

            this.childOnError = onError;
            this.childOnLoad = onLoad;
            this.childProps = childProps;
        }
    }, {
        key: 'onError',
        value: function onError(event) {
            this.setState({ isFailed: true }, this.props.callback);

            if (this.childOnError) {
                this.childOnError(event);
            }
        }
    }, {
        key: 'onLoad',
        value: function onLoad(event) {
            this.setState({ isLoaded: true }, this.props.callback);

            if (this.childOnLoad) {
                this.childOnLoad(event);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                callback = _props.callback,
                children = _props.children,
                wrapper = _props.wrapper,
                props = _objectWithoutProperties(_props, ['callback', 'children', 'wrapper']);

            var child = _react2.default.Children.only(children);

            return _react2.default.createElement(wrapper, _extends({}, props, this.state, { childProps: this.childProps }), !this.state.isFailed && !this.state.isLoaded ? _react2.default.cloneElement(child, { onError: this.onError, onLoad: this.onLoad }) : child);
        }
    }]);

    return LazyChild;
}(_react2.default.PureComponent);

LazyChild.propTypes = {
    callback: _propTypes2.default.func,
    children: _propTypes2.default.node.isRequired,
    wrapper: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired
};

exports.default = LazyChild;

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/components/LazyGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wrap = __webpack_require__("./node_modules/react-lazy/dist/module/lib/wrap.js");

var _DefaultWrapper = __webpack_require__("./node_modules/react-lazy/dist/module/components/DefaultWrapper.js");

var _DefaultWrapper2 = _interopRequireDefault(_DefaultWrapper);

var _Lazy2 = __webpack_require__("./node_modules/react-lazy/dist/module/components/Lazy.js");

var _Lazy3 = _interopRequireDefault(_Lazy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LazyGroup = function (_Lazy) {
    _inherits(LazyGroup, _Lazy);

    function LazyGroup(props) {
        _classCallCheck(this, LazyGroup);

        var _this = _possibleConstructorReturn(this, (LazyGroup.__proto__ || Object.getPrototypeOf(LazyGroup)).call(this, props));

        _this.loadedImgTags = 0;
        _this.state = { imgTagCount: null, loadedAt: null, viewportAt: null };

        _this.onImgLoaded = _this.onImgLoaded.bind(_this);
        _this.onViewport = _this.onViewport.bind(_this);
        return _this;
    }

    _createClass(LazyGroup, [{
        key: 'onImgLoaded',
        value: function onImgLoaded() {
            this.loadedImgTags++;

            if (this.loadedImgTags === this.state.imgTagCount) {
                this.loadedImgTags = 0;
                this.setState({ imgTagCount: null, loadedAt: Date.now() }, this.props.onLoad);
            }
        }
    }, {
        key: 'onViewport',
        value: function onViewport() {
            var _props = this.props,
                children = _props.children,
                childrenToWrap = _props.childrenToWrap,
                onLoad = _props.onLoad,
                onViewport = _props.onViewport,
                visible = _props.visible;


            if (!visible) {
                return false;
            }

            var imgTagCount = (0, _wrap.countTypesTags)(childrenToWrap, children) || null;
            this.loadedImgTags = 0;
            if (onViewport) {
                onViewport();
            }
            var viewportAt = Date.now();
            this.setState({ imgTagCount: imgTagCount, loadedAt: !imgTagCount ? viewportAt : null, viewportAt: viewportAt }, !imgTagCount ? onLoad : null);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                childrenToWrap = _props2.childrenToWrap,
                childWrapper = _props2.childWrapper,
                component = _props2.component,
                cushion = _props2.cushion,
                ltIE9 = _props2.ltIE9,
                onLoad = _props2.onLoad,
                onViewport = _props2.onViewport,
                visible = _props2.visible,
                rest = _objectWithoutProperties(_props2, ['children', 'childrenToWrap', 'childWrapper', 'component', 'cushion', 'ltIE9', 'onLoad', 'onViewport', 'visible']);

            var props = _extends({}, rest, { ref: this.getRef });

            return _react2.default.createElement(component, props,
            // swap render once element is visible in viewport
            visible && this.state.viewportAt
            // replace elements with LazyChild
            ? (0, _wrap.wrapTypesToLazyChild)(childrenToWrap, children, childWrapper, this.onImgLoaded)
            // wrap given element types to noscript and the given wrapper component
            : (0, _wrap.wrapTypesToNoScript)(childrenToWrap, children, ltIE9, childWrapper));
        }
    }]);

    return LazyGroup;
}(_Lazy3.default);

LazyGroup.defaultProps = _extends({}, _Lazy3.default.defaultProps, {
    childrenToWrap: ['iframe', 'img'],
    childWrapper: _DefaultWrapper2.default
});

LazyGroup.propTypes = _extends({}, _Lazy3.default.propTypes, {
    childrenToWrap: _propTypes2.default.arrayOf(_Lazy3.default.propTypes.component),
    childWrapper: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
});

exports.default = LazyGroup;

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lazy = exports.LazyGroup = exports.LazyChild = exports.DefaultWrapper = exports.checkElementsInViewport = undefined;

var _viewport = __webpack_require__("./node_modules/react-lazy/dist/module/lib/viewport.js");

Object.defineProperty(exports, 'checkElementsInViewport', {
  enumerable: true,
  get: function get() {
    return _viewport.checkElementsInViewport;
  }
});

var _DefaultWrapper2 = __webpack_require__("./node_modules/react-lazy/dist/module/components/DefaultWrapper.js");

var _DefaultWrapper3 = _interopRequireDefault(_DefaultWrapper2);

var _LazyChild2 = __webpack_require__("./node_modules/react-lazy/dist/module/components/LazyChild.js");

var _LazyChild3 = _interopRequireDefault(_LazyChild2);

var _LazyGroup2 = __webpack_require__("./node_modules/react-lazy/dist/module/components/LazyGroup.js");

var _LazyGroup3 = _interopRequireDefault(_LazyGroup2);

var _Lazy2 = __webpack_require__("./node_modules/react-lazy/dist/module/components/Lazy.js");

var _Lazy3 = _interopRequireDefault(_Lazy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DefaultWrapper = _DefaultWrapper3.default;
exports.LazyChild = _LazyChild3.default;
exports.LazyGroup = _LazyGroup3.default;
exports.Lazy = _Lazy3.default;

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/lib/eventListener.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.bindMultipleListeners = bindMultipleListeners;
exports.getEventListenerOptions = getEventListenerOptions;
exports.isEventListenerOptionSupported = isEventListenerOptionSupported;
var options = ['capture', 'once', 'passive'];
var supports = {};

if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.addEventListener && window.removeEventListener && Object.defineProperty) {
    var check = {};

    options.forEach(function (option) {
        Object.defineProperty(check, option, function () {
            supports.optionsObject = true;
            supports[option] = true;
        });
    });

    window.addEventListener('null', null, check);
    window.removeEventListener('null', null, check);

    supports.browser = true;
}

function bindMultipleListeners(target, events, listener, options) {
    if (!supports.browser) {
        return false;
    }

    var opts = getEventListenerOptions(options);

    events.forEach(function (event) {
        target.addEventListener(event, listener, opts);
    });

    return function unbindMultipleListeners() {
        events.forEach(function (event) {
            target.removeEventListener(event, listener, opts);
        });
    };
}

function getEventListenerOptions(options) {
    if (supports.optionsObject) {
        return options;
    }

    return !!(options && options.capture);
}

function isEventListenerOptionSupported(option) {
    if (options.includes(option)) {
        return supports[option] === true;
    }

    throw new Error('Option must be exactly one of: ' + options.join(', '));
}

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/lib/viewport.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkElementsInViewport = undefined;
exports.addElement = addElement;
exports.removeElement = removeElement;

var _eventListener = __webpack_require__("./node_modules/react-lazy/dist/module/lib/eventListener.js");

var elements = [];
var removeListeners = false;

function getRectWithCushion(rect, cushion) {
    var bottom = rect.bottom + cushion;
    var left = rect.left - cushion;
    var right = rect.right + cushion;
    var top = rect.top - cushion;

    return {
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        height: bottom - top,
        width: right - left
    };
}

function getRect(element, cushion) {
    element = element && !element.nodeType ? element[0] : element;

    if (!element || element.nodeType !== 1) {
        return false;
    }

    return getRectWithCushion(element.getBoundingClientRect(), cushion);
}

function getViewportSize() {
    return {
        height: Math.max(document.documentElement.clientHeight, window.innerHeight),
        width: Math.max(document.documentElement.clientWidth, window.innerWidth)
    };
}

function inViewport(_ref, viewport) {
    var cushion = _ref.cushion,
        element = _ref.element;

    if (element.offsetParent === null) {
        return false;
    }

    var rect = getRect(element, cushion);

    return !!rect && rect.bottom >= 0 && rect.right >= 0 && rect.top < viewport.height && rect.left < viewport.width;
}

function debounce(func, wait) {
    var timeout;

    return function () {
        var call = !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(function (args) {
            timeout = null;
            func.apply(this, args);
        }.bind(this, arguments), wait);
        if (call) {
            func.apply(this, arguments);
        }
    };
}

var checkElementsInViewport = exports.checkElementsInViewport = debounce(function checkElementsInViewport() {
    if (elements.length === 0) {
        return;
    }

    var size = getViewportSize();

    for (var i = elements.length - 1; i >= 0; i--) {
        if (inViewport(elements[i], size)) {
            // callback may return false to prevent lazy loading items in viewport
            if (elements[i].callback() !== false) {
                elements.splice(i, 1);
            }
        }
    }
    checkUnbind();
}, 50);

function addElement(options) {
    // callback may return false to prevent lazy loading items in viewport
    if (inViewport(options, getViewportSize()) && options.callback() !== false) {
        return;
    }

    if (!removeListeners && elements.length === 0) {
        removeListeners = (0, _eventListener.bindMultipleListeners)(window, ['resize', 'scroll', 'touchend', 'wheel'], checkElementsInViewport, { passive: true });
    }

    elements.push(options);
}

function checkUnbind() {
    if (removeListeners && elements.length === 0) {
        removeListeners();
        removeListeners = false;
    }
}

function removeElement(options) {
    var index = elements.indexOf(options);

    if (index >= 0) {
        elements.splice(index, 1);
    }

    checkUnbind();
}

/***/ }),

/***/ "./node_modules/react-lazy/dist/module/lib/wrap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.countTypesTags = countTypesTags;
exports.propsWithNoScriptRender = propsWithNoScriptRender;
exports.wrapTypesToLazyChild = wrapTypesToLazyChild;
exports.wrapTypesToNoScript = wrapTypesToNoScript;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__("./node_modules/react-dom/server.browser.js");

var _Lazy = __webpack_require__("./node_modules/react-lazy/dist/module/components/Lazy.js");

var _Lazy2 = _interopRequireDefault(_Lazy);

var _LazyChild = __webpack_require__("./node_modules/react-lazy/dist/module/components/LazyChild.js");

var _LazyChild2 = _interopRequireDefault(_LazyChild);

var _LazyGroup = __webpack_require__("./node_modules/react-lazy/dist/module/components/LazyGroup.js");

var _LazyGroup2 = _interopRequireDefault(_LazyGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function countTypesTags(types, children) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (!children) {
        return count;
    }

    _react2.default.Children.forEach(children, function (child) {
        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
            return;
        } else if (types.includes(child.type)) {
            count++;
        } else {
            var props = child.props || child._store && child._store.props || {};
            count += countTypesTags(types, props.children);
        }
    });

    return count;
}

function propsWithNoScriptRender(children, ltIE9) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!ltIE9) {
        props.dangerouslySetInnerHTML = {
            __html: (0, _server.renderToStaticMarkup)(_react2.default.createElement('noscript', null, children))
        };
    } else {
        props.dangerouslySetInnerHTML = {
            __html: (0, _server.renderToStaticMarkup)(_react2.default.createElement('noscript', null, children)).replace('<noscript>', '<!--[if IE 9]><!--><noscript><!--<![endif]-->').replace('</noscript>', '<!--[if IE 9]><!--></noscript><!--<![endif]-->')
        };
    }

    return props;
}

function wrapTypesToLazyChild(types, children, wrapper, callback) {
    if (!children) {
        return children;
    }

    return _react2.default.Children.map(children, function (child) {
        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
            return child;
        } else if (types.includes(child.type)) {
            return _react2.default.createElement(
                _LazyChild2.default,
                { callback: callback, wrapper: wrapper },
                child
            );
        } else {
            var props = child.props || child._store && child._store.props || {};
            var _children = wrapTypesToLazyChild(types, props.children, wrapper, callback);

            if (_children !== props.children) {
                return _react2.default.cloneElement(child, null, _children);
            } else {
                return child;
            }
        }
    });
}

function wrapTypesToNoScript(types, children, ltIE9, wrapper) {
    if (!children) {
        return children;
    }

    return _react2.default.Children.map(children, function (child) {
        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
            return child;
        } else if (types.includes(child.type)) {
            return _react2.default.createElement(wrapper, propsWithNoScriptRender(child, ltIE9));
        } else {
            var props = child.props || child._store && child._store.props || {};
            var _children2 = wrapTypesToNoScript(types, props.children, ltIE9, wrapper);

            if (_children2 !== props.children) {
                return _react2.default.cloneElement(child, null, _children2);
            } else {
                return child;
            }
        }
    });
}

/***/ }),

/***/ "./node_modules/react-scroll-up/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author  Milos Janda
 * @licence MIT
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tweenFunctions = __webpack_require__("./node_modules/tween-functions/index.js");

var _tweenFunctions2 = _interopRequireDefault(_tweenFunctions);

var _detectPassiveEvents = __webpack_require__("./node_modules/detect-passive-events/lib/index.js");

var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);

var _objectAssign = __webpack_require__("./node_modules/object-assign/index.js");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollUp = function (_React$Component) {
    _inherits(ScrollUp, _React$Component);

    function ScrollUp(props) {
        _classCallCheck(this, ScrollUp);

        // set default state
        var _this = _possibleConstructorReturn(this, (ScrollUp.__proto__ || Object.getPrototypeOf(ScrollUp)).call(this, props));

        _this.state = { show: false };

        // default property `data`
        _this.data = {
            startValue: 0,
            currentTime: 0, // store current time of animation
            startTime: null,
            rafId: null
        };

        // bind
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.scrollStep = _this.scrollStep.bind(_this);
        _this.stopScrolling = _this.stopScrolling.bind(_this);
        return _this;
    }

    _createClass(ScrollUp, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.show !== this.state.show;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.handleScroll(); // initialize state

            // Add all listeners which can start scroll
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener("wheel", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
            window.addEventListener("touchstart", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Remove all listeners which was registered
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener("wheel", this.stopScrolling, false);
            window.removeEventListener("touchstart", this.stopScrolling, false);
        }

        /**
         * Evaluate show/hide this component, depend on new position
         */

    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            if (window.pageYOffset > this.props.showUnder) {
                if (!this.state.show) {
                    this.setState({ show: true });
                }
            } else {
                if (this.state.show) {
                    this.setState({ show: false });
                }
            }
        }

        /**
         * Handle click on the button
         */

    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.stopScrolling();
            this.data.startValue = window.pageYOffset;
            this.data.currentTime = 0;
            this.data.startTime = null;
            this.data.rafId = window.requestAnimationFrame(this.scrollStep);
        }

        /**
         * Calculate new position
         * and scroll screen to new position or stop scrolling
         * @param timestamp
         */

    }, {
        key: 'scrollStep',
        value: function scrollStep(timestamp) {
            if (!this.data.startTime) {
                this.data.startTime = timestamp;
            }

            this.data.currentTime = timestamp - this.data.startTime;

            var position = _tweenFunctions2.default[this.props.easing](this.data.currentTime, this.data.startValue, this.props.topPosition, this.props.duration);

            if (window.pageYOffset <= this.props.topPosition) {
                this.stopScrolling();
            } else {
                window.scrollTo(window.pageYOffset, position);
                this.data.rafId = window.requestAnimationFrame(this.scrollStep);
            }
        }

        /**
         * Stop Animation Frame
         */

    }, {
        key: 'stopScrolling',
        value: function stopScrolling() {
            window.cancelAnimationFrame(this.data.rafId);
        }

        /**
         * Render component
         */

    }, {
        key: 'render',
        value: function render() {

            var propStyle = this.props.style;
            var element = _react2.default.createElement(
                'div',
                { style: propStyle, onClick: this.handleClick },
                this.props.children
            );

            var style = (0, _objectAssign2.default)({}, ScrollUp.defaultProps.style);
            style = (0, _objectAssign2.default)(style, propStyle);
            style.opacity = this.state.show ? 1 : 0;
            style.visibility = this.state.show ? 'visible' : 'hidden';
            style.transitionProperty = 'opacity, visibility';

            return _react2.default.cloneElement(element, { style: style });
        }
    }]);

    return ScrollUp;
}(_react2.default.Component);

// Set default props


exports.default = ScrollUp;
ScrollUp.defaultProps = {
    duration: 250,
    easing: 'easeOutCubic',
    style: {
        position: 'fixed',
        bottom: 50,
        right: 30,
        cursor: 'pointer',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'linear',
        transitionDelay: '0s'
    },
    topPosition: 0
};

// Set validation property types
ScrollUp.propTypes = {
    topPosition: _propTypes2.default.number,
    showUnder: _propTypes2.default.number.isRequired, // show button under this position,
    easing: _propTypes2.default.oneOf(['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack', 'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce']),
    duration: _propTypes2.default.number, // seconds
    style: _propTypes2.default.object
};


/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/react-transition-group/node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroupChild.js");

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroupChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__("./node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("./node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__("./node_modules/dom-helpers/util/requestAnimationFrame.js");

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/react-transition-group/node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__("./node_modules/chain-function/index.js");

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/react-transition-group/node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__("./node_modules/warning/browser.js");

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var ReactPropTypesSecret = __webpack_require__("./node_modules/react-transition-group/node_modules/prop-types/lib/ReactPropTypesSecret.js");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/react-transition-group/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/react-transition-group/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/react-transition-group/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__("./node_modules/react/index.js");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/react-transition-group/node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "./node_modules/react-visibility-sensor/lib/is-visible-with-offset.js":
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value;

  // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.
  switch (offsetDir) {
  case 'top':
    return ((containmentRect.top + offsetVal) < rect.top) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right);

  case 'left':
    return ((containmentRect.left + offsetVal) < rect.left) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.right > rect.right);

  case 'bottom':
    return ((containmentRect.bottom - offsetVal) > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right) &&
      (containmentRect.top < rect.top);

  case 'right':
    return ((containmentRect.right - offsetVal) > rect.right) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.bottom > rect.bottom);
  }
}


/***/ }),

/***/ "./node_modules/react-visibility-sensor/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var ReactPropTypesSecret = __webpack_require__("./node_modules/react-visibility-sensor/node_modules/prop-types/lib/ReactPropTypesSecret.js");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/react-visibility-sensor/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/react-visibility-sensor/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/react-visibility-sensor/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/react-visibility-sensor/visibility-sensor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__("./node_modules/react/index.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");
var PropTypes = __webpack_require__("./node_modules/react-visibility-sensor/node_modules/prop-types/index.js");
var createReactClass = __webpack_require__("./node_modules/create-react-class/index.js");
var isVisibleWithOffset = __webpack_require__("./node_modules/react-visibility-sensor/lib/is-visible-with-offset.js")

var containmentPropType = PropTypes.any;

if (typeof window !== 'undefined') {
  containmentPropType = PropTypes.instanceOf(window.Element);
}

function throttle (callback, limit) {
    var wait = false;
    return function () {
        if (!wait) {
            wait = true;
            setTimeout(function () {
                callback();
                wait = false;
            }, limit);
        }
    }
}

function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

module.exports = createReactClass({
  displayName: 'VisibilitySensor',

  propTypes: {
    onChange: PropTypes.func,
    active: PropTypes.bool,
    partialVisibility: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    ]),
    delayedCall: PropTypes.bool,
    offset: PropTypes.oneOfType([
      PropTypes.shape({
        top: PropTypes.number,
        left: PropTypes.number,
        bottom: PropTypes.number,
        right: PropTypes.number
      }),
      // deprecated offset property
      PropTypes.shape({
        direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        value: PropTypes.number
      })
    ]),
    scrollCheck: PropTypes.bool,
    scrollDelay: PropTypes.number,
    scrollThrottle: PropTypes.number,
    resizeCheck: PropTypes.bool,
    resizeDelay: PropTypes.number,
    resizeThrottle: PropTypes.number,
    intervalCheck: PropTypes.bool,
    intervalDelay: PropTypes.number,
    containment: containmentPropType,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
    ]),
    minTopValue: PropTypes.number,
  },

  getDefaultProps: function () {
    return {
      active: true,
      partialVisibility: false,
      minTopValue: 0,
      scrollCheck: false,
      scrollDelay: 250,
      scrollThrottle: -1,
      resizeCheck: false,
      resizeDelay: 250,
      resizeThrottle: -1,
      intervalCheck: true,
      intervalDelay: 100,
      delayedCall: false,
      offset: {},
      containment: null,
      children: React.createElement('span')
    };
  },

  getInitialState: function () {
    return {
      isVisible: null,
      visibilityRect: {}
    };
  },

  componentDidMount: function () {
    this.node = ReactDOM.findDOMNode(this);
    if (this.props.active) {
      this.startWatching();
    }
  },

  componentWillUnmount: function () {
    this.stopWatching();
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.active && !this.props.active) {
      this.setState(this.getInitialState());
      this.startWatching();
    } else if (!nextProps.active) {
      this.stopWatching();
    }
  },

  getContainer: function () {
    return this.props.containment || window;
  },

  addEventListener: function (target, event, delay, throttle) {
    if (!this.debounceCheck) {
      this.debounceCheck = {};
    }

    var timeout;
    var func;

    var later = function () {
      timeout = null;
      this.check();
    }.bind(this);

    if (throttle > -1) {
      func = function () {
        if (!timeout) {
          timeout = setTimeout(later, throttle || 0);
        }
      };
    } else {
      func = function () {
        clearTimeout(timeout);
        timeout = setTimeout(later, delay || 0);
      };
    }

    var info = {
      target: target,
      fn: func,
      getLastTimeout: function () {
        return timeout;
      },
    };

    target.addEventListener(event, info.fn);
    this.debounceCheck[event] = info;
  },

  startWatching: function () {
    if (this.debounceCheck || this.interval) { return; }

    if (this.props.intervalCheck) {
      this.interval = setInterval(this.check, this.props.intervalDelay);
    }

    if (this.props.scrollCheck) {
      this.addEventListener(
        this.getContainer(),
        'scroll',
        this.props.scrollDelay,
        this.props.scrollThrottle
      );
    }

    if (this.props.resizeCheck) {
      this.addEventListener(
        window,
        'resize',
        this.props.resizeDelay,
        this.props.resizeThrottle
      );
    }

    // if dont need delayed call, check on load ( before the first interval fires )
    !this.props.delayedCall && this.check();
  },

  stopWatching: function () {
    if (this.debounceCheck) {
      // clean up event listeners and their debounce callers
      for (var debounceEvent in this.debounceCheck) {
        if (this.debounceCheck.hasOwnProperty(debounceEvent)) {
          var debounceInfo = this.debounceCheck[debounceEvent];

          clearTimeout(debounceInfo.getLastTimeout());
          debounceInfo.target.removeEventListener(
            debounceEvent, debounceInfo.fn
          );

          this.debounceCheck[debounceEvent] = null;
        }
      }
    }
    this.debounceCheck = null;

    if (this.interval) { this.interval = clearInterval(this.interval); }
  },

  /**
   * Check if the element is within the visible viewport
   */
  check: function () {
    var el = this.node;
    var rect;
    var containmentRect;
    // if the component has rendered to null, dont update visibility
    if (!el) {
      return this.state;
    }

    rect = el.getBoundingClientRect();

    if (this.props.containment) {
      var containmentDOMRect = this.props.containment.getBoundingClientRect();
      containmentRect = {
        top: containmentDOMRect.top,
        left: containmentDOMRect.left,
        bottom: containmentDOMRect.bottom,
        right: containmentDOMRect.right,
      }
    } else {
      containmentRect = {
        top: 0,
        left: 0,
        bottom: window.innerHeight || document.documentElement.clientHeight,
        right: window.innerWidth || document.documentElement.clientWidth
      };
    }

    // Check if visibility is wanted via offset?
    var offset = this.props.offset || {};
    var hasValidOffset = typeof offset === 'object';
    if (hasValidOffset) {
      containmentRect.top += offset.top || 0;
      containmentRect.left += offset.left || 0;
      containmentRect.bottom -= offset.bottom || 0;
      containmentRect.right -= offset.right || 0;
    }

    var visibilityRect = {
      top: rect.top >= containmentRect.top,
      left: rect.left >= containmentRect.left,
      bottom: rect.bottom <= containmentRect.bottom,
      right: rect.right <= containmentRect.right
    };

    var isVisible = (
      visibilityRect.top &&
      visibilityRect.left &&
      visibilityRect.bottom &&
      visibilityRect.right
    );

    // check for partial visibility
    if (this.props.partialVisibility) {
      var partialVisible =
          rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top &&
          rect.left <= containmentRect.right && rect.right >= containmentRect.left;

      // account for partial visibility on a single edge
      if (typeof this.props.partialVisibility === 'string') {
        partialVisible = visibilityRect[this.props.partialVisibility]
      }

      // if we have minimum top visibility set by props, lets check, if it meets the passed value
      // so if for instance element is at least 200px in viewport, then show it.
      isVisible = this.props.minTopValue
        ? partialVisible && rect.top <= (containmentRect.bottom - this.props.minTopValue)
        : partialVisible
    }

    // Deprecated options for calculating offset.
    if (typeof offset.direction === 'string' &&
        typeof offset.value === 'number') {
      console.warn('[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }', offset.direction, offset.value)

      isVisible = isVisibleWithOffset(offset, rect, containmentRect);
    }

    var state = this.state;
    // notify the parent when the value changes
    if (this.state.isVisible !== isVisible) {
      state = {
        isVisible: isVisible,
        visibilityRect: visibilityRect
      };
      this.setState(state);
      if (this.props.onChange) this.props.onChange(isVisible, visibilityRect);
    }

    return state;
  },

  render: function () {
    if (this.props.children instanceof Function) {
      return this.props.children({
        isVisible: this.state.isVisible,
        visibilityRect: this.state.visibilityRect,
      });
    }
    return React.Children.only(this.props.children);
  }
});


/***/ }),

/***/ "./node_modules/redux-logger/dist/redux-logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/redux-notifications/lib/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifSend = notifSend;
exports.notifDismiss = notifDismiss;
exports.notifClear = notifClear;
var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");

var NOTIF_SEND = exports.NOTIF_SEND = 'NOTIF_SEND';
var NOTIF_DISMISS = exports.NOTIF_DISMISS = 'NOTIF_DISMISS';
var NOTIF_CLEAR = exports.NOTIF_CLEAR = 'NOTIF_CLEAR';

/**
 * Publish a notification,
 * - if `dismissAfter` was set, the notification will be auto dismissed after the given period.
 * - if id wasn't specified, a time based id will be generated.``
 */
function notifSend(notif) {
  var payload = objectAssign({}, notif);
  if (!payload.id) {
    payload.id = new Date().getTime();
  }
  return function (dispatch) {
    dispatch({ type: NOTIF_SEND, payload: payload });

    if (payload.dismissAfter) {
      setTimeout(function () {
        dispatch({
          type: NOTIF_DISMISS,
          payload: payload.id
        });
      }, payload.dismissAfter);
    }
  };
}

/**
 * Dismiss a notification by the given id.
 */
function notifDismiss(id) {
  return { type: NOTIF_DISMISS, payload: id };
}

/**
 * Clear all notifications
 */
function notifClear() {
  return { type: NOTIF_CLEAR };
}

/***/ }),

/***/ "./node_modules/redux-notifications/lib/components/Notif.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notif = function Notif(_ref) {
  var kind = _ref.kind,
      componentClassName = _ref.componentClassName,
      actionLabel = _ref.actionLabel,
      onActionClick = _ref.onActionClick,
      id = _ref.id,
      message = _ref.message;

  var handleActionClick = function handleActionClick(ev) {
    ev.preventDefault();

    if (!onActionClick) {
      return;
    }

    onActionClick(id);
  };

  return _react2.default.createElement(
    'div',
    { className: componentClassName + ' ' + componentClassName + '--' + kind },
    _react2.default.createElement('div', { className: componentClassName + '__icon' }),
    _react2.default.createElement(
      'div',
      { className: componentClassName + '__content' },
      _react2.default.createElement(
        'span',
        { className: componentClassName + '__message' },
        message
      )
    ),
    actionLabel && _react2.default.createElement(
      'span',
      { className: componentClassName + '__action' },
      _react2.default.createElement(
        'button',
        { onClick: handleActionClick },
        actionLabel
      )
    ),
    _react2.default.createElement('div', { className: componentClassName + '__close' })
  );
};

Notif.defaultProps = {
  kind: 'info'
};

Notif.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  message: _propTypes2.default.node.isRequired,
  kind: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger']).isRequired,
  componentClassName: _propTypes2.default.string,
  onActionClick: _propTypes2.default.func,
  actionLabel: _propTypes2.default.string
};

exports.default = Notif;

/***/ }),

/***/ "./node_modules/redux-notifications/lib/components/Notifs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _CSSTransitionGroup = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroup.js");

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _Notif = __webpack_require__("./node_modules/redux-notifications/lib/components/Notif.js");

var _Notif2 = _interopRequireDefault(_Notif);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This checks to see if object is immutable and properly access it
var getter = function getter(obj, propName) {
  return obj.get ? obj.get(propName) : obj[propName];
};

var Notifs = function Notifs(props) {
  var notifications = props.notifications,
      className = props.className,
      componentClassName = props.componentClassName,
      CustomComponent = props.CustomComponent,
      transitionEnterTimeout = props.transitionEnterTimeout,
      transitionLeaveTimeout = props.transitionLeaveTimeout;


  var renderedNotifications = notifications.map(function (notification) {
    if (CustomComponent) {
      return _react2.default.createElement(CustomComponent, _extends({}, props, {
        componentClassName: componentClassName,
        key: getter(notification, 'id'),
        id: getter(notification, 'id'),
        message: getter(notification, 'message'),
        kind: getter(notification, 'kind')
      }));
    }
    return _react2.default.createElement(_Notif2.default, _extends({}, props, {
      componentClassName: componentClassName,
      key: getter(notification, 'id'),
      id: getter(notification, 'id'),
      message: getter(notification, 'message'),
      kind: getter(notification, 'kind')
    }));
  });
  var classes = [componentClassName + '__container', className].join(' ').split();

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(
      _CSSTransitionGroup2.default,
      {
        transitionName: componentClassName + '-transition',
        transitionEnterTimeout: transitionEnterTimeout,
        transitionLeaveTimeout: transitionLeaveTimeout
      },
      renderedNotifications
    )
  );
};

Notifs.defaultProps = {
  className: null,
  componentClassName: 'notif',
  CustomComponent: null,
  transitionEnterTimeout: 600,
  transitionLeaveTimeout: 600
};

Notifs.propTypes = {
  notifications: _propTypes2.default.array.isRequired,
  className: _propTypes2.default.string,
  CustomComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node, _propTypes2.default.element]),
  componentClassName: _propTypes2.default.string,
  transitionEnterTimeout: _propTypes2.default.number,
  transitionLeaveTimeout: _propTypes2.default.number
};

function mapStateToProps(state) {
  return { notifications: state.get ? state.get('notifs') : state.notifs };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Notifs);

/***/ }),

/***/ "./node_modules/redux-notifications/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.reducer = exports.actions = exports.Notifs = undefined;

var _reducer = __webpack_require__("./node_modules/redux-notifications/lib/reducer.js");

var _reducer2 = _interopRequireDefault(_reducer);

var _actions = __webpack_require__("./node_modules/redux-notifications/lib/actions.js");

var actions = _interopRequireWildcard(_actions);

var _Notifs = __webpack_require__("./node_modules/redux-notifications/lib/components/Notifs.js");

var _Notifs2 = _interopRequireDefault(_Notifs);

var _styles = __webpack_require__("./node_modules/redux-notifications/lib/styles.css");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Notifs = _Notifs2.default;
exports.actions = actions;
exports.reducer = _reducer2.default;
exports.styles = _styles2.default;

/***/ }),

/***/ "./node_modules/redux-notifications/lib/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notifs;

var _actions = __webpack_require__("./node_modules/redux-notifications/lib/actions.js");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function notifs() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  if (!action || !action.type) return domain;

  switch (action.type) {
    case _actions.NOTIF_SEND:
      return [action.payload].concat(_toConsumableArray(domain.filter(function (_ref) {
        var id = _ref.id;
        return id !== action.payload.id;
      })));
    case _actions.NOTIF_DISMISS:
      return domain.filter(function (notif) {
        return notif.id !== action.payload;
      });
    case _actions.NOTIF_CLEAR:
      return [];
    default:
      return domain;
  }
}

/***/ }),

/***/ "./node_modules/redux-notifications/lib/styles.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/rollbar/dist/rollbar.umd.min.js":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.rollbar=e():t.rollbar=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){t.exports=n(1)},function(t,e,n){"use strict";var r=n(2),o="undefined"!=typeof window&&window._rollbarConfig,i=o&&o.globalAlias||"Rollbar",a="undefined"!=typeof window&&window[i]&&"function"==typeof window[i].shimId&&void 0!==window[i].shimId();if("undefined"==typeof window||window._rollbarStartTime||(window._rollbarStartTime=(new Date).getTime()),!a&&o){var s=new r(o);window[i]=s}else"undefined"!=typeof window?(window.rollbar=r,window._rollbarDidLoad=!0):"undefined"!=typeof self&&(self.rollbar=r,self._rollbarDidLoad=!0);t.exports=r},function(t,e,n){"use strict";function r(t,e){this.options=c.extend(!0,x,t);var n=new l(this.options,h,d);this.client=e||new u(this.options,n,p,"browser");var r="undefined"!=typeof window&&window||"undefined"!=typeof self&&self,o="undefined"!=typeof document&&document;i(this.client.notifier),a(this.client.queue),(this.options.captureUncaught||this.options.handleUncaughtExceptions)&&(f.captureUncaughtExceptions(r,this),f.wrapGlobals(r,this)),(this.options.captureUnhandledRejections||this.options.handleUnhandledRejections)&&f.captureUnhandledRejections(r,this),this.instrumenter=new w(this.options,this.client.telemeter,this,r,o),this.instrumenter.instrument()}function o(t){var e="Rollbar is not initialized";p.error(e),t&&t(new Error(e))}function i(t){t.addTransform(m.handleItemWithError).addTransform(m.ensureItemHasSomethingToSay).addTransform(m.addBaseInfo).addTransform(m.addRequestInfo(window)).addTransform(m.addClientInfo(window)).addTransform(m.addPluginInfo(window)).addTransform(m.addBody).addTransform(g.addMessageWithError).addTransform(g.addTelemetryData).addTransform(g.addConfigToPayload).addTransform(m.scrubPayload).addTransform(g.userTransform(p)).addTransform(g.itemToPayload)}function a(t){t.addPredicate(y.checkLevel).addPredicate(v.checkIgnore).addPredicate(y.userCheckIgnore(p)).addPredicate(y.urlIsNotBlacklisted(p)).addPredicate(y.urlIsWhitelisted(p)).addPredicate(y.messageIsIgnored(p))}function s(t){for(var e=0,n=t.length;e<n;++e)if(c.isFunction(t[e]))return t[e]}var u=n(3),c=n(6),l=n(11),p=n(13),f=n(16),h=n(17),d=n(18),m=n(19),g=n(23),v=n(24),y=n(25),b=n(20),w=n(26),_=null;r.init=function(t,e){return _?_.global(t).configure(t):_=new r(t,e)},r.prototype.global=function(t){return this.client.global(t),this},r.global=function(t){return _?_.global(t):void o()},r.prototype.configure=function(t,e){var n=this.options,r={};return e&&(r={payload:e}),this.options=c.extend(!0,{},n,t,r),this.client.configure(t,e),this.instrumenter.configure(t),this},r.configure=function(t,e){return _?_.configure(t,e):void o()},r.prototype.lastError=function(){return this.client.lastError},r.lastError=function(){return _?_.lastError():void o()},r.prototype.log=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.log(t),{uuid:e}},r.log=function(){if(_)return _.log.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.debug=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.debug(t),{uuid:e}},r.debug=function(){if(_)return _.debug.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.info=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.info(t),{uuid:e}},r.info=function(){if(_)return _.info.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.warn=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warn(t),{uuid:e}},r.warn=function(){if(_)return _.warn.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.warning=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warning(t),{uuid:e}},r.warning=function(){if(_)return _.warning.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.error=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.error(t),{uuid:e}},r.error=function(){if(_)return _.error.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.critical=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.critical(t),{uuid:e}},r.critical=function(){if(_)return _.critical.apply(_,arguments);var t=s(arguments);o(t)},r.prototype.handleUncaughtException=function(t,e,n,r,o,i){var a,s=c.makeUnhandledStackInfo(t,e,n,r,o,"onerror","uncaught exception",b);c.isError(o)?(a=this._createItem([t,o,i]),a._unhandledStackInfo=s):c.isError(e)?(a=this._createItem([t,e,i]),a._unhandledStackInfo=s):(a=this._createItem([t,i]),a.stackInfo=s),a.level=this.options.uncaughtErrorLevel,a._isUncaught=!0,this.client.log(a)},r.prototype.handleUnhandledRejection=function(t,e){var n="unhandled rejection was null or undefined!";n=t?t.message||String(t):n;var r,o=t&&t._rollbarContext||e&&e._rollbarContext;c.isError(t)?r=this._createItem([n,t,o]):(r=this._createItem([n,t,o]),r.stackInfo=c.makeUnhandledStackInfo(n,"",0,0,null,"unhandledrejection","",b)),r.level=this.options.uncaughtErrorLevel,r._isUncaught=!0,r._originalArgs=r._originalArgs||[],r._originalArgs.push(e),this.client.log(r)},r.prototype.wrap=function(t,e,n){try{var r;if(r=c.isFunction(e)?e:function(){return e||{}},!c.isFunction(t))return t;if(t._isWrap)return t;if(!t._rollbar_wrapped&&(t._rollbar_wrapped=function(){n&&c.isFunction(n)&&n.apply(this,arguments);try{return t.apply(this,arguments)}catch(n){var e=n;throw c.isType(e,"string")&&(e=new String(e)),e._rollbarContext=r()||{},e._rollbarContext._wrappedSource=t.toString(),window._rollbarWrappedError=e,e}},t._rollbar_wrapped._isWrap=!0,t.hasOwnProperty))for(var o in t)t.hasOwnProperty(o)&&(t._rollbar_wrapped[o]=t[o]);return t._rollbar_wrapped}catch(e){return t}},r.wrap=function(t,e){return _?_.wrap(t,e):void o()},r.prototype.captureEvent=function(t,e){return this.client.captureEvent(t,e)},r.captureEvent=function(t,e){return _?_.captureEvent(t,e):void o()},r.prototype.captureDomContentLoaded=function(t,e){return e||(e=new Date),this.client.captureDomContentLoaded(e)},r.prototype.captureLoad=function(t,e){return e||(e=new Date),this.client.captureLoad(e)},r.prototype._createItem=function(t){return c.createItem(t,p,this)};var x={version:"2.3.9",scrubFields:["pw","pass","passwd","password","secret","confirm_password","confirmPassword","password_confirmation","passwordConfirmation","access_token","accessToken","secret_key","secretKey","secretToken"],logLevel:"debug",reportLevel:"debug",uncaughtErrorLevel:"error",endpoint:"api.rollbar.com/api/1/item/",verbose:!1,enabled:!0,sendConfig:!1,includeItemsInTelemetry:!0};t.exports=r},function(t,e,n){"use strict";function r(t,e,n,o){this.options=u.extend(!0,{},t),this.logger=n,r.rateLimiter.configureGlobal(this.options),r.rateLimiter.setPlatformOptions(o,this.options),this.queue=new i(r.rateLimiter,e,n,this.options),this.notifier=new a(this.queue,this.options),this.telemeter=new s(this.options),this.lastError=null}var o=n(4),i=n(5),a=n(9),s=n(10),u=n(6),c={maxItems:0,itemsPerMinute:60};r.rateLimiter=new o(c),r.prototype.global=function(t){return r.rateLimiter.configureGlobal(t),this},r.prototype.configure=function(t,e){this.notifier&&this.notifier.configure(t),this.telemeter&&this.telemeter.configure(t);var n=this.options,r={};return e&&(r={payload:e}),this.options=u.extend(!0,{},n,t,r),this.global(this.options),this},r.prototype.log=function(t){var e=this._defaultLogLevel();return this._log(e,t)},r.prototype.debug=function(t){this._log("debug",t)},r.prototype.info=function(t){this._log("info",t)},r.prototype.warn=function(t){this._log("warning",t)},r.prototype.warning=function(t){this._log("warning",t)},r.prototype.error=function(t){this._log("error",t)},r.prototype.critical=function(t){this._log("critical",t)},r.prototype.wait=function(t){this.queue.wait(t)},r.prototype.captureEvent=function(t,e){return this.telemeter.captureEvent(t,e)},r.prototype.captureDomContentLoaded=function(t){return this.telemeter.captureDomContentLoaded(t)},r.prototype.captureLoad=function(t){return this.telemeter.captureLoad(t)},r.prototype._log=function(t,e){if(this._sameAsLastError(e))return void(e.callback&&e.callback());try{var n=null;e.callback&&(n=e.callback,delete e.callback),e.level=e.level||t,this.telemeter._captureRollbarItem(e),e.telemetryEvents=this.telemeter.copyEvents(),this.notifier.log(e,n)}catch(t){this.logger.error(t)}},r.prototype._defaultLogLevel=function(){return this.options.logLevel||"debug"},r.prototype._sameAsLastError=function(t){return!(!this.lastError||this.lastError!==t.err)||(this.lastError=t.err,!1)},t.exports=r},function(t,e){"use strict";function n(t){this.startTime=(new Date).getTime(),this.counter=0,this.perMinCounter=0,this.platform=null,this.platformOptions={},this.configureGlobal(t)}function r(t,e,n){return!t.ignoreRateLimit&&e>=1&&n>e}function o(t,e,n,r,o,a,s){var u=null;return n&&(n=new Error(n)),n||r||(u=i(t,e,o,a,s)),{error:n,shouldSend:r,payload:u}}function i(t,e,n,r,o){var i,a=e.environment||e.payload&&e.payload.environment;i=o?"item per minute limit reached, ignoring errors until timeout":"maxItems has been hit, ignoring errors until reset.";var s={body:{message:{body:i,extra:{maxItems:n,itemsPerMinute:r}}},language:"javascript",environment:a,notifier:{version:e.notifier&&e.notifier.version||e.version}};return"browser"===t?(s.platform="browser",s.framework="browser-js",s.notifier.name="rollbar-browser-js"):"server"===t?(s.framework=e.framework||"node-js",s.notifier.name=e.notifier.name):"react-native"===t&&(s.framework=e.framework||"react-native",s.notifier.name=e.notifier.name),s}n.globalSettings={startTime:(new Date).getTime(),maxItems:void 0,itemsPerMinute:void 0},n.prototype.configureGlobal=function(t){void 0!==t.startTime&&(n.globalSettings.startTime=t.startTime),void 0!==t.maxItems&&(n.globalSettings.maxItems=t.maxItems),void 0!==t.itemsPerMinute&&(n.globalSettings.itemsPerMinute=t.itemsPerMinute)},n.prototype.shouldSend=function(t,e){e=e||(new Date).getTime(),e-this.startTime>=6e4&&(this.startTime=e,this.perMinCounter=0);var i=n.globalSettings.maxItems,a=n.globalSettings.itemsPerMinute;if(r(t,i,this.counter))return o(this.platform,this.platformOptions,i+" max items reached",!1);if(r(t,a,this.perMinCounter))return o(this.platform,this.platformOptions,a+" items per minute reached",!1);this.counter++,this.perMinCounter++;var s=!r(t,i,this.counter),u=s;return s=s&&!r(t,a,this.perMinCounter),o(this.platform,this.platformOptions,null,s,i,a,u)},n.prototype.setPlatformOptions=function(t,e){this.platform=t,this.platformOptions=e},t.exports=n},function(t,e,n){"use strict";function r(t,e,n,r){this.rateLimiter=t,this.api=e,this.logger=n,this.options=r,this.predicates=[],this.pendingItems=[],this.pendingRequests=[],this.retryQueue=[],this.retryHandle=null,this.waitCallback=null,this.waitIntervalID=null}var o=n(6);r.prototype.configure=function(t){this.api&&this.api.configure(t);var e=this.options;return this.options=o.extend(!0,{},e,t),this},r.prototype.addPredicate=function(t){return o.isFunction(t)&&this.predicates.push(t),this},r.prototype.addPendingItem=function(t){this.pendingItems.push(t)},r.prototype.removePendingItem=function(t){var e=this.pendingItems.indexOf(t);e!==-1&&this.pendingItems.splice(e,1)},r.prototype.addItem=function(t,e,n,r){e&&o.isFunction(e)||(e=function(){});var i=this._applyPredicates(t);if(i.stop)return this.removePendingItem(r),void e(i.err);this._maybeLog(t,n),this.removePendingItem(r),this.pendingRequests.push(t);try{this._makeApiRequest(t,function(n,r){this._dequeuePendingRequest(t),e(n,r)}.bind(this))}catch(n){this._dequeuePendingRequest(t),e(n)}},r.prototype.wait=function(t){o.isFunction(t)&&(this.waitCallback=t,this._maybeCallWait()||(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitIntervalID=setInterval(function(){this._maybeCallWait()}.bind(this),500)))},r.prototype._applyPredicates=function(t){for(var e=null,n=0,r=this.predicates.length;n<r;n++)if(e=this.predicates[n](t,this.options),!e||void 0!==e.err)return{stop:!0,err:e.err};return{stop:!1,err:null}},r.prototype._makeApiRequest=function(t,e){var n=this.rateLimiter.shouldSend(t);n.shouldSend?this.api.postItem(t,function(n,r){n?this._maybeRetry(n,t,e):e(n,r)}.bind(this)):n.error?e(n.error):this.api.postItem(n.payload,e)};var i=["ECONNRESET","ENOTFOUND","ESOCKETTIMEDOUT","ETIMEDOUT","ECONNREFUSED","EHOSTUNREACH","EPIPE","EAI_AGAIN"];r.prototype._maybeRetry=function(t,e,n){var r=!1;if(this.options.retryInterval)for(var o=0,a=i.length;o<a;o++)if(t.code===i[o]){r=!0;break}r?this._retryApiRequest(e,n):n(t)},r.prototype._retryApiRequest=function(t,e){this.retryQueue.push({item:t,callback:e}),this.retryHandle||(this.retryHandle=setInterval(function(){for(;this.retryQueue.length;){var t=this.retryQueue.shift();this._makeApiRequest(t.item,t.callback)}}.bind(this),this.options.retryInterval))},r.prototype._dequeuePendingRequest=function(t){var e=this.pendingRequests.indexOf(t);e!==-1&&(this.pendingRequests.splice(e,1),this._maybeCallWait())},r.prototype._maybeLog=function(t,e){if(this.logger&&this.options.verbose){var n=e;if(n=n||o.get(t,"body.trace.exception.message"),n=n||o.get(t,"body.trace_chain.0.exception.message"))return void this.logger.error(n);n=o.get(t,"body.message.body"),n&&this.logger.log(n)}},r.prototype._maybeCallWait=function(){return!(!o.isFunction(this.waitCallback)||0!==this.pendingItems.length||0!==this.pendingRequests.length)&&(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitCallback(),!0)},t.exports=r},function(t,e,n){"use strict";function r(){if(!R&&(R=!0,c(JSON)&&(s(JSON.stringify)&&(j.stringify=JSON.stringify),s(JSON.parse)&&(j.parse=JSON.parse)),!a(j.stringify)||!a(j.parse))){var t=n(8);t(j)}}function o(t,e){return e===i(t)}function i(t){var e=typeof t;return"object"!==e?e:t?t instanceof Error?"error":{}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase():"null"}function a(t){return o(t,"function")}function s(t){var e=/[\\^$.*+?()[\]{}|]/g,n=Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(e,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?"),r=RegExp("^"+n+"$");return u(t)&&r.test(t)}function u(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}function c(t){return!o(t,"undefined")}function l(t){var e=i(t);return"object"===e||"array"===e}function p(t){return o(t,"error")}function f(t,e,n){var r,i,a,s=o(t,"object"),u=o(t,"array"),c=[];if(s&&n.indexOf(t)!==-1)return t;if(n.push(t),s)for(r in t)Object.prototype.hasOwnProperty.call(t,r)&&c.push(r);else if(u)for(a=0;a<t.length;++a)c.push(a);var l=s?{}:[];for(a=0;a<c.length;++a)r=c[a],i=t[r],l[r]=e(r,i,n);return 0!=c.length?l:t}function h(){return"********"}function d(){var t=N(),e="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var n=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"===e?n:7&n|8).toString(16)});return e}function m(t){var e=g(t);return""===e.anchor&&(e.source=e.source.replace("#","")),t=e.source.replace("?"+e.query,"")}function g(t){if(!o(t,"string"))throw new Error("received invalid input");for(var e=q,n=e.parser[e.strictMode?"strict":"loose"].exec(t),r={},i=e.key.length;i--;)r[e.key[i]]=n[i]||"";return r[e.q.name]={},r[e.key[12]].replace(e.q.parser,function(t,n,o){n&&(r[e.q.name][n]=o)}),r}function v(t,e,n){n=n||{},n.access_token=t;var r,o=[];for(r in n)Object.prototype.hasOwnProperty.call(n,r)&&o.push([r,n[r]].join("="));var i="?"+o.sort().join("&");e=e||{},e.path=e.path||"";var a,s=e.path.indexOf("?"),u=e.path.indexOf("#");s!==-1&&(u===-1||u>s)?(a=e.path,e.path=a.substring(0,s)+i+"&"+a.substring(s+1)):u!==-1?(a=e.path,e.path=a.substring(0,u)+i+a.substring(u)):e.path=e.path+i}function y(t,e){if(e=e||t.protocol,!e&&t.port&&(80===t.port?e="http:":443===t.port&&(e="https:")),e=e||"https:",!t.hostname)return null;var n=e+"//"+t.hostname;return t.port&&(n=n+":"+t.port),t.path&&(n+=t.path),n}function b(t,e){var n,r;try{n=j.stringify(t)}catch(o){if(e&&a(e))try{n=e(t)}catch(t){r=t}else r=o}return{error:r,value:n}}function w(t){var e,n;try{e=j.parse(t)}catch(t){n=t}return{error:n,value:e}}function _(t,e,n,r,o,i,a,s){var u={url:e||"",line:n,column:r};u.func=s.guessFunctionName(u.url,u.line),u.context=s.gatherContext(u.url,u.line);var c=document&&document.location&&document.location.href,l=window&&window.navigator&&window.navigator.userAgent;return{mode:i,message:o?String(o):t||a,url:c,stack:[u],useragent:l}}function x(t,e){return function(n,r){try{e(n,r)}catch(e){t.error(e)}}}function k(t,e,n,r,o){for(var a,s,u,c,l,p,f=[],h=0,m=t.length;h<m;++h){p=t[h];var g=i(p);switch(g){case"undefined":break;case"string":a?f.push(p):a=p;break;case"function":c=x(e,p);break;case"date":f.push(p);break;case"error":case"domexception":s?f.push(p):s=p;break;case"object":case"array":if(p instanceof Error||"undefined"!=typeof DOMException&&p instanceof DOMException){s?f.push(p):s=p;break}if(r&&"object"===g&&!l){for(var v=0,y=r.length;v<y;++v)if(void 0!==p[r[v]]){l=p;break}if(l)break}u?f.push(p):u=p;break;default:if(p instanceof Error||"undefined"!=typeof DOMException&&p instanceof DOMException){s?f.push(p):s=p;break}f.push(p)}}f.length>0&&(u=C(!0,{},u),u.extraArgs=f);var b={message:a,err:s,custom:u,timestamp:N(),callback:c,uuid:d()};return u&&void 0!==u.level&&(b.level=u.level,delete u.level),r&&l&&(b.request=l),o&&(b.lambdaContext=o),b._originalArgs=t,b}function E(t,e){if(t){var n=e.split("."),r=t;try{for(var o=0,i=n.length;o<i;++o)r=r[n[o]]}catch(t){r=void 0}return r}}function I(t,e,n){if(t){var r=e.split("."),o=r.length;if(!(o<1)){if(1===o)return void(t[r[0]]=n);try{for(var i=t[r[0]]||{},a=i,s=1;s<o-1;s++)i[r[s]]=i[r[s]]||{},i=i[r[s]];i[r[o-1]]=n,t[r[0]]=a}catch(t){return}}}}function T(t,e){function n(t,e,n,r,o,i){return e+h(i)}function r(t){var e;if(o(t,"string"))for(e=0;e<u.length;++e)t=t.replace(u[e],n);return t}function i(t,e){var n;for(n=0;n<s.length;++n)if(s[n].test(t)){e=h(e);break}return e}function a(t,e,n){var s=i(t,e);return s===e?o(e,"object")||o(e,"array")?f(e,a,n):r(s):s}e=e||[];var s=S(e),u=O(e);return f(t,a,[])}function S(t){for(var e,n=[],r=0;r<t.length;++r)e="^\\[?(%5[bB])?"+t[r]+"\\[?(%5[bB])?\\]?(%5[dD])?$",n.push(new RegExp(e,"i"));return n}function O(t){for(var e,n=[],r=0;r<t.length;++r)e="\\[?(%5[bB])?"+t[r]+"\\[?(%5[bB])?\\]?(%5[dD])?",n.push(new RegExp("("+e+"=)([^&\\n]+)","igm"));return n}function L(t){var e,n,r,o=[];for(e=0,n=t.length;e<n;e++)r=t[e],"object"==typeof r?(r=b(r),r=r.error||r.value,r.length>500&&(r=r.substr(0,500)+"...")):"undefined"==typeof r&&(r="undefined"),o.push(r);return o.join(" ")}function N(){return Date.now?+Date.now():+new Date}var C=n(7),j={},R=!1;r();var A={debug:0,info:1,warning:2,error:3,critical:4},q={strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}};t.exports={isType:o,typeName:i,isFunction:a,isNativeFunction:s,isIterable:l,isError:p,extend:C,traverse:f,redact:h,uuid4:d,LEVELS:A,sanitizeUrl:m,addParamsAndAccessTokenToPath:v,formatUrl:y,stringify:b,jsonParse:w,makeUnhandledStackInfo:_,createItem:k,get:E,set:I,scrub:T,formatArgsAsString:L,now:N}},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r=Object.prototype.toString,o=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===r.call(t)},i=function(t){if(!t||"[object Object]"!==r.call(t))return!1;var e=n.call(t,"constructor"),o=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!o)return!1;var i;for(i in t);return"undefined"==typeof i||n.call(t,i)};t.exports=function t(){var e,n,r,a,s,u,c=arguments[0],l=1,p=arguments.length,f=!1;for("boolean"==typeof c?(f=c,c=arguments[1]||{},l=2):("object"!=typeof c&&"function"!=typeof c||null==c)&&(c={});l<p;++l)if(e=arguments[l],null!=e)for(n in e)r=c[n],a=e[n],c!==a&&(f&&a&&(i(a)||(s=o(a)))?(s?(s=!1,u=r&&o(r)?r:[]):u=r&&i(r)?r:{},c[n]=t(f,u,a)):"undefined"!=typeof a&&(c[n]=a));return c}},function(t,e){var n=function(t){function e(t){return t<10?"0"+t:t}function n(){return this.valueOf()}function r(t){return i.lastIndex=0,i.test(t)?'"'+t.replace(i,function(t){var e=u[t];return"string"==typeof e?e:"\\u"+("0000"+t.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+t+'"'}function o(t,e){var n,i,u,l,p,f=a,h=e[t];switch(h&&"object"==typeof h&&"function"==typeof h.toJSON&&(h=h.toJSON(t)),"function"==typeof c&&(h=c.call(e,t,h)),typeof h){case"string":return r(h);case"number":return isFinite(h)?String(h):"null";case"boolean":case"null":return String(h);case"object":if(!h)return"null";if(a+=s,p=[],"[object Array]"===Object.prototype.toString.apply(h)){for(l=h.length,n=0;n<l;n+=1)p[n]=o(n,h)||"null";return u=0===p.length?"[]":a?"[\n"+a+p.join(",\n"+a)+"\n"+f+"]":"["+p.join(",")+"]",a=f,u}if(c&&"object"==typeof c)for(l=c.length,n=0;n<l;n+=1)"string"==typeof c[n]&&(i=c[n],u=o(i,h),u&&p.push(r(i)+(a?": ":":")+u));else for(i in h)Object.prototype.hasOwnProperty.call(h,i)&&(u=o(i,h),u&&p.push(r(i)+(a?": ":":")+u));return u=0===p.length?"{}":a?"{\n"+a+p.join(",\n"+a)+"\n"+f+"}":"{"+p.join(",")+"}",a=f,u}}var i=/[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+e(this.getUTCMonth()+1)+"-"+e(this.getUTCDate())+"T"+e(this.getUTCHours())+":"+e(this.getUTCMinutes())+":"+e(this.getUTCSeconds())+"Z":null},Boolean.prototype.toJSON=n,Number.prototype.toJSON=n,String.prototype.toJSON=n);var a,s,u,c;"function"!=typeof t.stringify&&(u={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},t.stringify=function(t,e,n){var r;if(a="",s="","number"==typeof n)for(r=0;r<n;r+=1)s+=" ";else"string"==typeof n&&(s=n);if(c=e,e&&"function"!=typeof e&&("object"!=typeof e||"number"!=typeof e.length))throw new Error("JSON.stringify");return o("",{"":t})}),"function"!=typeof t.parse&&(t.parse=function(){function t(t){return t.replace(/\\(?:u(.{4})|([^u]))/g,function(t,e,n){return e?String.fromCharCode(parseInt(e,16)):a[n]})}var e,n,r,o,i,a={"\\":"\\",'"':'"',"/":"/",t:"\t",n:"\n",r:"\r",f:"\f",b:"\b"},s={go:function(){e="ok"},firstokey:function(){o=i,e="colon"},okey:function(){o=i,e="colon"},ovalue:function(){e="ocomma"},firstavalue:function(){e="acomma"},avalue:function(){e="acomma"}},u={go:function(){e="ok"},ovalue:function(){e="ocomma"},firstavalue:function(){e="acomma"},avalue:function(){e="acomma"}},c={"{":{go:function(){n.push({state:"ok"}),r={},e="firstokey"},ovalue:function(){n.push({container:r,state:"ocomma",key:o}),r={},e="firstokey"},firstavalue:function(){n.push({container:r,state:"acomma"}),r={},e="firstokey"},avalue:function(){n.push({container:r,state:"acomma"}),r={},e="firstokey"}},"}":{firstokey:function(){var t=n.pop();i=r,r=t.container,o=t.key,e=t.state},ocomma:function(){var t=n.pop();r[o]=i,i=r,r=t.container,o=t.key,e=t.state}},"[":{go:function(){n.push({state:"ok"}),r=[],e="firstavalue"},ovalue:function(){n.push({container:r,state:"ocomma",key:o}),r=[],e="firstavalue"},firstavalue:function(){n.push({container:r,state:"acomma"}),r=[],e="firstavalue"},avalue:function(){n.push({container:r,state:"acomma"}),r=[],e="firstavalue"}},"]":{firstavalue:function(){var t=n.pop();i=r,r=t.container,o=t.key,e=t.state},acomma:function(){var t=n.pop();r.push(i),i=r,r=t.container,o=t.key,e=t.state}},":":{colon:function(){if(Object.hasOwnProperty.call(r,o))throw new SyntaxError("Duplicate key '"+o+'"');e="ovalue"}},",":{ocomma:function(){r[o]=i,e="okey"},acomma:function(){r.push(i),e="avalue"}},true:{go:function(){i=!0,e="ok"},ovalue:function(){i=!0,e="ocomma"},firstavalue:function(){i=!0,e="acomma"},avalue:function(){i=!0,e="acomma"}},false:{go:function(){i=!1,e="ok"},ovalue:function(){i=!1,e="ocomma"},firstavalue:function(){i=!1,e="acomma"},avalue:function(){i=!1,e="acomma"}},null:{go:function(){i=null,e="ok"},ovalue:function(){i=null,e="ocomma"},firstavalue:function(){i=null,e="acomma"},avalue:function(){i=null,e="acomma"}}};return function(r,o){var a,l=/^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;e="go",n=[];try{for(;;){if(a=l.exec(r),!a)break;a[1]?c[a[1]][e]():a[2]?(i=+a[2],u[e]()):(i=t(a[3]),s[e]()),r=r.slice(a[0].length)}}catch(t){e=t}if("ok"!==e||/[^\u0020\t\n\r]/.test(r))throw e instanceof SyntaxError?e:new SyntaxError("JSON");return"function"==typeof o?function t(e,n){var r,a,s=e[n];if(s&&"object"==typeof s)for(r in i)Object.prototype.hasOwnProperty.call(s,r)&&(a=t(s,r),void 0!==a?s[r]=a:delete s[r]);return o.call(e,n,s)}({"":i},""):i}}())};t.exports=n},function(t,e,n){"use strict";function r(t,e){this.queue=t,this.options=e,this.transforms=[]}var o=n(6);r.prototype.configure=function(t){this.queue&&this.queue.configure(t);var e=this.options;return this.options=o.extend(!0,{},e,t),this},r.prototype.addTransform=function(t){return o.isFunction(t)&&this.transforms.push(t),this},r.prototype.log=function(t,e){if(e&&o.isFunction(e)||(e=function(){}),!this.options.enabled)return e(new Error("Rollbar is not enabled"));this.queue.addPendingItem(t);var n=t.err;this._applyTransforms(t,function(r,o){return r?(this.queue.removePendingItem(t),e(r,null)):void this.queue.addItem(o,e,n,t)}.bind(this))},r.prototype._applyTransforms=function(t,e){var n=-1,r=this.transforms.length,o=this.transforms,i=this.options,a=function(t,s){return t?void e(t,null):(n++,n===r?void e(null,s):void o[n](s,i,a))};a(null,t)},t.exports=r},function(t,e,n){"use strict";function r(t){this.queue=[],this.options=i.extend(!0,{},t);var e=this.options.maxTelemetryEvents||a;this.maxQueueSize=Math.max(0,Math.min(e,a))}function o(t,e){if(e)return e;var n={error:"error",manual:"info"};return n[t]||"info"}var i=n(6),a=100;r.prototype.configure=function(t){var e=this.options;this.options=i.extend(!0,{},e,t);var n=this.options.maxTelemetryEvents||a,r=Math.max(0,Math.min(n,a)),o=0;this.maxQueueSize>r&&(o=this.maxQueueSize-r),this.maxQueueSize=r,this.queue.splice(0,o)},r.prototype.copyEvents=function(){return Array.prototype.slice.call(this.queue,0)},r.prototype.capture=function(t,e,n,r,a){var s={level:o(t,n),type:t,timestamp_ms:a||i.now(),body:e,source:"client"};r&&(s.uuid=r);try{if(i.isFunction(this.options.filterTelemetry)&&this.options.filterTelemetry(s))return!1}catch(t){this.options.filterTelemetry=null}return this.push(s),s},r.prototype.captureEvent=function(t,e,n){return this.capture("manual",t,e,n)},r.prototype.captureError=function(t,e,n,r){var o={message:t.message||String(t)};return t.stack&&(o.stack=t.stack),this.capture("error",o,e,n,r)},r.prototype.captureLog=function(t,e,n,r){return this.capture("log",{message:t},e,n,r)},r.prototype.captureNetwork=function(t,e,n,r){e=e||"xhr",t.subtype=t.subtype||e,r&&(t.request=r);var o=this.levelFromStatus(t.status_code);return this.capture("network",t,o,n)},r.prototype.levelFromStatus=function(t){return t>=200&&t<400?"info":0===t||t>=400?"error":"info"},r.prototype.captureDom=function(t,e,n,r,o){var i={subtype:t,element:e};return void 0!==n&&(i.value=n),void 0!==r&&(i.checked=r),this.capture("dom",i,"info",o)},r.prototype.captureNavigation=function(t,e,n){return this.capture("navigation",{from:t,to:e},"info",n)},r.prototype.captureDomContentLoaded=function(t){return this.capture("navigation",{subtype:"DOMContentLoaded"},"info",void 0,t&&t.getTime())},r.prototype.captureLoad=function(t){return this.capture("navigation",{subtype:"load"},"info",void 0,t&&t.getTime())},r.prototype.captureConnectivityChange=function(t,e){return this.captureNetwork({change:t},"connectivity",e)},r.prototype._captureRollbarItem=function(t){if(this.options.includeItemsInTelemetry)return t.err?this.captureError(t.err,t.level,t.uuid,t.timestamp):t.message?this.captureLog(t.message,t.level,t.uuid,t.timestamp):t.custom?this.capture("log",t.custom,t.level,t.uuid,t.timestamp):void 0},r.prototype.push=function(t){this.queue.push(t),this.queue.length>this.maxQueueSize&&this.queue.shift()},t.exports=r},function(t,e,n){"use strict";function r(t,e,n,r){this.options=t,this.transport=e,this.url=n,this.jsonBackup=r,this.accessToken=t.accessToken,this.transportOptions=o(t,n)}function o(t,e){return a.getTransportFromOptions(t,s,e)}var i=n(6),a=n(12),s={hostname:"api.rollbar.com",path:"/api/1/item/",search:null,version:"1",protocol:"https:",port:443};r.prototype.postItem=function(t,e){var n=a.transportOptions(this.transportOptions,"POST"),r=a.buildPayload(this.accessToken,t,this.jsonBackup);this.transport.post(this.accessToken,n,r,e)},r.prototype.configure=function(t){var e=this.oldOptions;return this.options=i.extend(!0,{},e,t),this.transportOptions=o(this.options,this.url),void 0!==this.options.accessToken&&(this.accessToken=this.options.accessToken),this},t.exports=r},function(t,e,n){"use strict";function r(t,e,n){if(!s.isType(e.context,"string")){var r=s.stringify(e.context,n);r.error?e.context="Error: could not serialize 'context'":e.context=r.value||"",e.context.length>255&&(e.context=e.context.substr(0,255))}return{access_token:t,data:e}}function o(t,e,n){var r=e.hostname,o=e.protocol,i=e.port,a=e.path,s=e.search,u=t.proxy;if(t.endpoint){var c=n.parse(t.endpoint);r=c.hostname,o=c.protocol,i=c.port,a=c.pathname,s=c.search}return{hostname:r,protocol:o,port:i,path:a,search:s,proxy:u}}function i(t,e){var n=t.protocol||"https:",r=t.port||("http:"===n?80:"https:"===n?443:void 0),o=t.hostname,i=t.path;return t.search&&(i+=t.search),t.proxy&&(i=n+"//"+o+i,o=t.proxy.host||t.proxy.hostname,r=t.proxy.port,n=t.proxy.protocol||n),{protocol:n,hostname:o,path:i,port:r,method:e}}function a(t,e){var n=/\/$/.test(t),r=/^\//.test(e);return n&&r?e=e.substring(1):n||r||(e="/"+e),t+e}var s=n(6);t.exports={buildPayload:r,getTransportFromOptions:o,transportOptions:i,appendPathToPath:a}},function(t,e,n){"use strict";function r(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.error(s.formatArgsAsString(t)):console.error.apply(console,t)}function o(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.info(s.formatArgsAsString(t)):console.info.apply(console,t)}function i(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.log(s.formatArgsAsString(t)):console.log.apply(console,t)}n(14);var a=n(15),s=n(6);t.exports={error:r,info:o,log:i}},function(t,e){!function(t){"use strict";t.console||(t.console={});for(var e,n,r=t.console,o=function(){},i=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=i.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=o)}("undefined"==typeof window?this:window)},function(t,e){"use strict";function n(){var t;if(!document)return t;for(var e=3,n=document.createElement("div"),r=n.getElementsByTagName("i");n.innerHTML="<!--[if gt IE "+ ++e+"]><i></i><![endif]-->",r[0];);return e>4?e:t}var r={ieVersion:n};t.exports=r},function(t,e){"use strict";function n(t,e,n){if(t){var o;"function"==typeof e._rollbarOldOnError?o=e._rollbarOldOnError:t.onerror&&!t.onerror.belongsToShim&&(o=t.onerror,
e._rollbarOldOnError=o);var i=function(){var n=Array.prototype.slice.call(arguments,0);r(t,e,o,n)};i.belongsToShim=n,t.onerror=i}}function r(t,e,n,r){t._rollbarWrappedError&&(r[4]||(r[4]=t._rollbarWrappedError),r[5]||(r[5]=t._rollbarWrappedError._rollbarContext),t._rollbarWrappedError=null),e.handleUncaughtException.apply(e,r),n&&n.apply(t,r)}function o(t,e,n){if(t){"function"==typeof t._rollbarURH&&t._rollbarURH.belongsToShim&&t.removeEventListener("unhandledrejection",t._rollbarURH);var r=function(t){var n,r,o;try{n=t.reason}catch(t){n=void 0}try{r=t.promise}catch(t){r="[unhandledrejection] error getting `promise` from event"}try{o=t.detail,!n&&o&&(n=o.reason,r=o.promise)}catch(t){o="[unhandledrejection] error getting `detail` from event"}n||(n="[unhandledrejection] error getting `reason` from event"),e&&e.handleUnhandledRejection&&e.handleUnhandledRejection(n,r)};r.belongsToShim=n,t._rollbarURH=r,t.addEventListener("unhandledrejection",r)}}function i(t,e,n){if(t){var r,o,i="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(r=0;r<i.length;++r)o=i[r],t[o]&&t[o].prototype&&a(e,t[o].prototype,n)}}function a(t,e,n){if(e.hasOwnProperty&&e.hasOwnProperty("addEventListener")){for(var r=e.addEventListener;r._rollbarOldAdd&&r.belongsToShim;)r=r._rollbarOldAdd;var o=function(e,n,o){r.call(this,e,t.wrap(n),o)};o._rollbarOldAdd=r,o.belongsToShim=n,e.addEventListener=o;for(var i=e.removeEventListener;i._rollbarOldRemove&&i.belongsToShim;)i=i._rollbarOldRemove;var a=function(t,e,n){i.call(this,t,e&&e._rollbar_wrapped||e,n)};a._rollbarOldRemove=i,a.belongsToShim=n,e.removeEventListener=a}}t.exports={captureUncaughtExceptions:n,captureUnhandledRejections:o,wrapGlobals:i}},function(t,e,n){"use strict";function r(t,e,n,r,o){r&&l.isFunction(r)||(r=function(){}),l.addParamsAndAccessTokenToPath(t,e,n);var a="GET",s=l.formatUrl(e);i(t,s,a,null,r,o)}function o(t,e,n,r,o){if(r&&l.isFunction(r)||(r=function(){}),!n)return r(new Error("Cannot send empty request"));var a=l.stringify(n);if(a.error)return r(a.error);var s=a.value,u="POST",c=l.formatUrl(e);i(t,c,u,s,r,o)}function i(t,e,n,r,o,i){var f;if(f=i?i():a(),!f)return o(new Error("No way to send a request"));try{try{var h=function(){try{if(h&&4===f.readyState){h=void 0;var t=l.jsonParse(f.responseText);if(s(f))return void o(t.error,t.value);if(u(f)){if(403===f.status){var e=t.value&&t.value.message;p.error(e)}o(new Error(String(f.status)))}else{var n="XHR response had no status code (likely connection failure)";o(c(n))}}}catch(t){var r;r=t&&t.stack?t:new Error(t),o(r)}};f.open(n,e,!0),f.setRequestHeader&&(f.setRequestHeader("Content-Type","application/json"),f.setRequestHeader("X-Rollbar-Access-Token",t)),f.onreadystatechange=h,f.send(r)}catch(t){if("undefined"!=typeof XDomainRequest){if(!window||!window.location)return o(new Error("No window available during request, unknown environment"));"http:"===window.location.href.substring(0,5)&&"https"===e.substring(0,5)&&(e="http"+e.substring(5));var d=new XDomainRequest;d.onprogress=function(){},d.ontimeout=function(){var t="Request timed out",e="ETIMEDOUT";o(c(t,e))},d.onerror=function(){o(new Error("Error during request"))},d.onload=function(){var t=l.jsonParse(d.responseText);o(t.error,t.value)},d.open(n,e,!0),d.send(r)}else o(new Error("Cannot find a method to transport a request"))}}catch(t){o(t)}}function a(){var t,e,n=[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],r=n.length;for(e=0;e<r;e++)try{t=n[e]();break}catch(t){}return t}function s(t){return t&&t.status&&200===t.status}function u(t){return t&&l.isType(t.status,"number")&&t.status>=400&&t.status<600}function c(t,e){var n=new Error(t);return n.code=e||"ENOTFOUND",n}var l=n(6),p=n(13);t.exports={get:r,post:o}},function(t,e){"use strict";function n(t){var e,n,r={protocol:null,auth:null,host:null,path:null,hash:null,href:t,hostname:null,port:null,pathname:null,search:null,query:null};if(e=t.indexOf("//"),e!==-1?(r.protocol=t.substring(0,e),n=e+2):n=0,e=t.indexOf("@",n),e!==-1&&(r.auth=t.substring(n,e),n=e+1),e=t.indexOf("/",n),e===-1){if(e=t.indexOf("?",n),e===-1)return e=t.indexOf("#",n),e===-1?r.host=t.substring(n):(r.host=t.substring(n,e),r.hash=t.substring(e)),r.hostname=r.host.split(":")[0],r.port=r.host.split(":")[1],r.port&&(r.port=parseInt(r.port,10)),r;r.host=t.substring(n,e),r.hostname=r.host.split(":")[0],r.port=r.host.split(":")[1],r.port&&(r.port=parseInt(r.port,10)),n=e}else r.host=t.substring(n,e),r.hostname=r.host.split(":")[0],r.port=r.host.split(":")[1],r.port&&(r.port=parseInt(r.port,10)),n=e;if(e=t.indexOf("#",n),e===-1?r.path=t.substring(n):(r.path=t.substring(n,e),r.hash=t.substring(e)),r.path){var o=r.path.split("?");r.pathname=o[0],r.query=o[1],r.search=r.query?"?"+r.query:null}return r}t.exports={parse:n}},function(t,e,n){"use strict";function r(t,e,n){if(t.data=t.data||{},t.err)try{t.stackInfo=t.err._savedStackTrace||d.parse(t.err)}catch(e){m.error("Error while parsing the error object.",e),t.message=t.err.message||t.err.description||t.message||String(t.err),delete t.err}n(null,t)}function o(t,e,n){t.message||t.stackInfo||t.custom||n(new Error("No message, stack info, or custom data"),null),n(null,t)}function i(t,e,n){var r=e.payload&&e.payload.environment||e.environment;t.data=h.extend(!0,{},t.data,{environment:r,level:t.level,endpoint:e.endpoint,platform:"browser",framework:"browser-js",language:"javascript",server:{},uuid:t.uuid,notifier:{name:"rollbar-browser-js",version:e.version}}),n(null,t)}function a(t){return function(e,n,r){return t&&t.location?(h.set(e,"data.request",{url:t.location.href,query_string:t.location.search,user_ip:"$remote_ip"}),void r(null,e)):r(null,e)}}function s(t){return function(e,n,r){if(!t)return r(null,e);var o=t.navigator||{},i=t.screen||{};h.set(e,"data.client",{runtime_ms:e.timestamp-t._rollbarStartTime,timestamp:Math.round(e.timestamp/1e3),javascript:{browser:o.userAgent,language:o.language,cookie_enabled:o.cookieEnabled,screen:{width:i.width,height:i.height}}}),r(null,e)}}function u(t){return function(e,n,r){if(!t||!t.navigator)return r(null,e);for(var o,i=[],a=t.navigator.plugins||[],s=0,u=a.length;s<u;++s)o=a[s],i.push({name:o.name,description:o.description});h.set(e,"data.client.javascript.plugins",i),r(null,e)}}function c(t,e,n){t.stackInfo?p(t,e,n):l(t,e,n)}function l(t,e,n){var r=t.message,o=t.custom;if(!r)if(o){var i=e.scrubFields,a=h.stringify(h.scrub(o,i));r=a.error||a.value||""}else r="";var s={body:r};o&&(s.extra=h.extend(!0,{},o)),h.set(t,"data.body",{message:s}),n(null,t)}function p(t,e,n){var r=t.data.description,o=t.stackInfo,i=t.custom,a=d.guessErrorClass(o.message),s=o.name||a[0],u=a[1],c={exception:{class:s,message:u}};r&&(c.exception.description=r);var p=o.stack;if(p&&0===p.length&&t._unhandledStackInfo&&t._unhandledStackInfo.stack&&(p=t._unhandledStackInfo.stack),p){0===p.length&&(c.exception.stack=o.rawStack,c.exception.raw=String(o.rawException));var f,m,g,v,y,b,w,_;for(c.frames=[],w=0;w<p.length;++w)f=p[w],m={filename:f.url?h.sanitizeUrl(f.url):"(unknown)",lineno:f.line||null,method:f.func&&"?"!==f.func?f.func:"[anonymous]",colno:f.column},m.method&&m.method.endsWith&&m.method.endsWith("_rollbar_wrapped")||(g=v=y=null,b=f.context?f.context.length:0,b&&(_=Math.floor(b/2),v=f.context.slice(0,_),g=f.context[_],y=f.context.slice(_)),g&&(m.code=g),(v||y)&&(m.context={},v&&v.length&&(m.context.pre=v),y&&y.length&&(m.context.post=y)),f.args&&(m.args=f.args),c.frames.push(m));c.frames.reverse(),i&&(c.extra=h.extend(!0,{},i)),h.set(t,"data.body",{trace:c}),n(null,t)}else t.message=s+": "+u,l(t,e,n)}function f(t,e,n){var r=e.scrubFields;t.data=h.scrub(t.data,r),n(null,t)}var h=n(6),d=n(20),m=n(13);t.exports={handleItemWithError:r,ensureItemHasSomethingToSay:o,addBaseInfo:i,addRequestInfo:a,addClientInfo:s,addPluginInfo:u,addBody:c,scrubPayload:f}},function(t,e,n){"use strict";function r(){return l}function o(){return null}function i(t){var e={};return e._stackFrame=t,e.url=t.fileName,e.line=t.lineNumber,e.func=t.functionName,e.column=t.columnNumber,e.args=t.args,e.context=o(e.url,e.line),e}function a(t){function e(){var e,n=[];if(t.stack)e=t;else try{throw t}catch(t){e=t}try{n=c.parse(e)}catch(t){n=[]}for(var r=[],o=0;o<n.length;o++)r.push(new i(n[o]));return r}return{stack:e(),message:t.message,name:t.name,rawStack:t.stack,rawException:t}}function s(t){return new a(t)}function u(t){if(!t||!t.match)return["Unknown error. There was no error message to display.",""];var e=t.match(p),n="(unknown)";return e&&(n=e[e.length-1],t=t.replace((e[e.length-2]||"")+n+":",""),t=t.replace(/(^[\s]+|[\s]+$)/g,"")),[n,t]}var c=n(21),l="?",p=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");t.exports={guessFunctionName:r,guessErrorClass:u,gatherContext:o,parse:s,Stack:a,Frame:i}},function(t,e,n){var r,o,i;!function(a,s){"use strict";o=[n(22)],r=s,i="function"==typeof r?r.apply(e,o):r,!(void 0!==i&&(t.exports=i))}(this,function(t){"use strict";function e(t,e,n){if("function"==typeof Array.prototype.map)return t.map(e,n);for(var r=new Array(t.length),o=0;o<t.length;o++)r[o]=e.call(n,t[o]);return r}function n(t,e,n){if("function"==typeof Array.prototype.filter)return t.filter(e,n);for(var r=[],o=0;o<t.length;o++)e.call(n,t[o])&&r.push(t[o]);return r}var r=/(^|@)\S+\:\d+/,o=/^\s*at .*(\S+\:\d+|\(native\))/m,i=/^(eval@)?(\[native code\])?$/;return{parse:function(t){if("undefined"!=typeof t.stacktrace||"undefined"!=typeof t["opera#sourceloc"])return this.parseOpera(t);if(t.stack&&t.stack.match(o))return this.parseV8OrIE(t);if(t.stack)return this.parseFFOrSafari(t);throw new Error("Cannot parse given Error object")},extractLocation:function(t){if(t.indexOf(":")===-1)return[t];var e=t.replace(/[\(\)\s]/g,"").split(":"),n=e.pop(),r=e[e.length-1];if(!isNaN(parseFloat(r))&&isFinite(r)){var o=e.pop();return[e.join(":"),o,n]}return[e.join(":"),n,void 0]},parseV8OrIE:function(r){var i=n(r.stack.split("\n"),function(t){return!!t.match(o)},this);return e(i,function(e){e.indexOf("(eval ")>-1&&(e=e.replace(/eval code/g,"eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g,""));var n=e.replace(/^\s+/,"").replace(/\(eval code/g,"(").split(/\s+/).slice(1),r=this.extractLocation(n.pop()),o=n.join(" ")||void 0,i="eval"===r[0]?void 0:r[0];return new t(o,void 0,i,r[1],r[2],e)},this)},parseFFOrSafari:function(r){var o=n(r.stack.split("\n"),function(t){return!t.match(i)},this);return e(o,function(e){if(e.indexOf(" > eval")>-1&&(e=e.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g,":$1")),e.indexOf("@")===-1&&e.indexOf(":")===-1)return new t(e);var n=e.split("@"),r=this.extractLocation(n.pop()),o=n.shift()||void 0;return new t(o,void 0,r[0],r[1],r[2],e)},this)},parseOpera:function(t){return!t.stacktrace||t.message.indexOf("\n")>-1&&t.message.split("\n").length>t.stacktrace.split("\n").length?this.parseOpera9(t):t.stack?this.parseOpera11(t):this.parseOpera10(t)},parseOpera9:function(e){for(var n=/Line (\d+).*script (?:in )?(\S+)/i,r=e.message.split("\n"),o=[],i=2,a=r.length;i<a;i+=2){var s=n.exec(r[i]);s&&o.push(new t(void 0,void 0,s[2],s[1],void 0,r[i]))}return o},parseOpera10:function(e){for(var n=/Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,r=e.stacktrace.split("\n"),o=[],i=0,a=r.length;i<a;i+=2){var s=n.exec(r[i]);s&&o.push(new t(s[3]||void 0,void 0,s[2],s[1],void 0,r[i]))}return o},parseOpera11:function(o){var i=n(o.stack.split("\n"),function(t){return!!t.match(r)&&!t.match(/^Error created at/)},this);return e(i,function(e){var n,r=e.split("@"),o=this.extractLocation(r.pop()),i=r.shift()||"",a=i.replace(/<anonymous function(: (\w+))?>/,"$2").replace(/\([^\)]*\)/g,"")||void 0;i.match(/\(([^\)]*)\)/)&&(n=i.replace(/^[^\(]+\(([^\)]*)\)$/,"$1"));var s=void 0===n||"[arguments not available]"===n?void 0:n.split(",");return new t(a,s,o[0],o[1],o[2],e)},this)}}})},function(t,e,n){var r,o,i;!function(n,a){"use strict";o=[],r=a,i="function"==typeof r?r.apply(e,o):r,!(void 0!==i&&(t.exports=i))}(this,function(){"use strict";function t(t){return!isNaN(parseFloat(t))&&isFinite(t)}function e(t,e,n,r,o,i){void 0!==t&&this.setFunctionName(t),void 0!==e&&this.setArgs(e),void 0!==n&&this.setFileName(n),void 0!==r&&this.setLineNumber(r),void 0!==o&&this.setColumnNumber(o),void 0!==i&&this.setSource(i)}return e.prototype={getFunctionName:function(){return this.functionName},setFunctionName:function(t){this.functionName=String(t)},getArgs:function(){return this.args},setArgs:function(t){if("[object Array]"!==Object.prototype.toString.call(t))throw new TypeError("Args must be an Array");this.args=t},getFileName:function(){return this.fileName},setFileName:function(t){this.fileName=String(t)},getLineNumber:function(){return this.lineNumber},setLineNumber:function(e){if(!t(e))throw new TypeError("Line Number must be a Number");this.lineNumber=Number(e)},getColumnNumber:function(){return this.columnNumber},setColumnNumber:function(e){if(!t(e))throw new TypeError("Column Number must be a Number");this.columnNumber=Number(e)},getSource:function(){return this.source},setSource:function(t){this.source=String(t)},toString:function(){var e=this.getFunctionName()||"{anonymous}",n="("+(this.getArgs()||[]).join(",")+")",r=this.getFileName()?"@"+this.getFileName():"",o=t(this.getLineNumber())?":"+this.getLineNumber():"",i=t(this.getColumnNumber())?":"+this.getColumnNumber():"";return e+n+r+o+i}},e})},function(t,e,n){"use strict";function r(t,e,n){var r=e.payload||{};r.body&&delete r.body;var o=u.extend(!0,{},t.data,r);t._isUncaught&&(o._isUncaught=!0),t._originalArgs&&(o._originalArgs=t._originalArgs),n(null,o)}function o(t,e,n){t.telemetryEvents&&u.set(t,"data.body.telemetry",t.telemetryEvents),n(null,t)}function i(t,e,n){if(!t.message)return void n(null,t);var r="data.body.trace_chain.0",o=u.get(t,r);if(o||(r="data.body.trace",o=u.get(t,r)),o){if(!o.exception||!o.exception.description)return u.set(t,r+".exception.description",t.message),void n(null,t);var i=u.get(t,r+".extra")||{},a=u.extend(!0,{},i,{message:t.message});u.set(t,r+".extra",a)}n(null,t)}function a(t){return function(e,n,r){var o=u.extend(!0,{},e);try{u.isFunction(n.transform)&&n.transform(o.data)}catch(o){return n.transform=null,t.error("Error while calling custom transform() function. Removing custom transform().",o),void r(null,e)}r(null,o)}}function s(t,e,n){if(!e.sendConfig)return n(null,t);var r="_rollbarConfig",o=u.get(t,"data.custom")||{};o[r]=e,t.data.custom=o,n(null,t)}var u=n(6);t.exports={itemToPayload:r,addTelemetryData:o,addMessageWithError:i,userTransform:a,addConfigToPayload:s}},function(t,e,n){"use strict";function r(t,e){return!o.get(e,"plugins.jquery.ignoreAjaxErrors")||!o.get(t,"body.message.extra.isAjax")}var o=n(6);t.exports={checkIgnore:r}},function(t,e,n){"use strict";function r(t,e){var n=t.level,r=c.LEVELS[n]||0,o=e.reportLevel,i=c.LEVELS[o]||0;return!(r<i)}function o(t){return function(e,n){var r=!!e._isUncaught;delete e._isUncaught;var o=e._originalArgs;delete e._originalArgs;try{c.isFunction(n.onSendCallback)&&n.onSendCallback(r,o,e)}catch(e){n.onSendCallback=null,t.error("Error while calling onSendCallback, removing",e)}try{if(c.isFunction(n.checkIgnore)&&n.checkIgnore(r,o,e))return!1}catch(e){n.checkIgnore=null,t.error("Error while calling custom checkIgnore(), removing",e)}return!0}}function i(t){return function(e,n){return!s(e,n,"blacklist",t)}}function a(t){return function(e,n){return s(e,n,"whitelist",t)}}function s(t,e,n,r){var o=!1;"blacklist"===n&&(o=!0);var i,a,s,u,l,p,f,h,d,m;try{if(i=o?e.hostBlackList:e.hostWhiteList,f=i&&i.length,a=c.get(t,"body.trace"),!i||0===f)return!o;if(!a||!a.frames||0===a.frames.length)return!o;for(l=a.frames.length,d=0;d<l;d++){if(s=a.frames[d],u=s.filename,!c.isType(u,"string"))return!o;for(m=0;m<f;m++)if(p=i[m],h=new RegExp(p),h.test(u))return!0}}catch(t){o?e.hostBlackList=null:e.hostWhiteList=null;var g=o?"hostBlackList":"hostWhiteList";return r.error("Error while reading your configuration's "+g+" option. Removing custom "+g+".",t),!o}return!1}function u(t){return function(e,n){var r,o,i,a,s,u,l,p,f;try{if(s=!1,i=n.ignoredMessages,!i||0===i.length)return!0;if(l=e.body,p=c.get(l,"trace.exception.message"),f=c.get(l,"message.body"),r=p||f,!r)return!0;for(a=i.length,o=0;o<a&&(u=new RegExp(i[o],"gi"),!(s=u.test(r)));o++);}catch(e){n.ignoredMessages=null,t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return!s}}var c=n(6);t.exports={checkLevel:r,userCheckIgnore:o,urlIsNotBlacklisted:i,urlIsWhitelisted:a,messageIsIgnored:u}},function(t,e,n){"use strict";function r(t,e,n,r,o){var i=t[e];t[e]=n(i),r&&r[o].push([t,e,i])}function o(t,e){for(var n;t[e].length;)n=t[e].shift(),n[0][n[1]]=n[2]}function i(t,e,n,r,o){var i=t.autoInstrument;t.enabled===!1||i===!1?this.autoInstrument={}:(a.isType(i,"object")||(i=c),this.autoInstrument=a.extend(!0,{},c,i)),this.scrubTelemetryInputs=!!t.scrubTelemetryInputs,this.telemetryScrubber=t.telemetryScrubber,this.telemeter=e,this.rollbar=n,this._window=r||{},this._document=o||{},this.replacements={network:[],log:[],navigation:[],connectivity:[]},this.eventRemovers={dom:[],connectivity:[]},this._location=this._window.location,this._lastHref=this._location&&this._location.href}var a=n(6),s=n(18),u=n(27),c={network:!0,networkResponseHeaders:!1,networkResponseBody:!1,networkRequestBody:!1,log:!0,dom:!0,navigation:!0,connectivity:!0};i.prototype.configure=function(t){var e=t.autoInstrument,n=a.extend(!0,{},this.autoInstrument);t.enabled===!1||e===!1?this.autoInstrument={}:(a.isType(e,"object")||(e=c),this.autoInstrument=a.extend(!0,{},c,e)),this.instrument(n),void 0!==t.scrubTelemetryInputs&&(this.scrubTelemetryInputs=!!t.scrubTelemetryInputs),void 0!==t.telemetryScrubber&&(this.telemetryScrubber=t.telemetryScrubber)},i.prototype.instrument=function(t){!this.autoInstrument.network||t&&t.network?!this.autoInstrument.network&&t&&t.network&&this.deinstrumentNetwork():this.instrumentNetwork(),!this.autoInstrument.log||t&&t.log?!this.autoInstrument.log&&t&&t.log&&this.deinstrumentConsole():this.instrumentConsole(),!this.autoInstrument.dom||t&&t.dom?!this.autoInstrument.dom&&t&&t.dom&&this.deinstrumentDom():this.instrumentDom(),!this.autoInstrument.navigation||t&&t.navigation?!this.autoInstrument.navigation&&t&&t.navigation&&this.deinstrumentNavigation():this.instrumentNavigation(),!this.autoInstrument.connectivity||t&&t.connectivity?!this.autoInstrument.connectivity&&t&&t.connectivity&&this.deinstrumentConnectivity():this.instrumentConnectivity()},i.prototype.deinstrumentNetwork=function(){o(this.replacements,"network")},i.prototype.instrumentNetwork=function(){function t(t,n){t in n&&a.isFunction(n[t])&&r(n,t,function(t){return e.rollbar.wrap(t)})}var e=this;if("XMLHttpRequest"in this._window){var n=this._window.XMLHttpRequest.prototype;r(n,"open",function(t){return function(e,n){return a.isType(n,"string")&&(this.__rollbar_xhr={method:e,url:n,status_code:null,start_time_ms:a.now(),end_time_ms:null}),t.apply(this,arguments)}},this.replacements,"network"),r(n,"send",function(n){return function(o){function i(){if(s.__rollbar_xhr&&(1===s.readyState||4===s.readyState)){if(null===s.__rollbar_xhr.status_code){s.__rollbar_xhr.status_code=0;var t=null;e.autoInstrument.networkRequestBody&&(t=o),s.__rollbar_event=e.telemeter.captureNetwork(s.__rollbar_xhr,"xhr",void 0,t)}if(1===s.readyState)s.__rollbar_xhr.start_time_ms=a.now();else{s.__rollbar_xhr.end_time_ms=a.now();var n=null;if(e.autoInstrument.networkResponseHeaders){var r=e.autoInstrument.networkResponseHeaders;n={};try{var i,u;if(r===!0){var c=s.getAllResponseHeaders();if(c){var l,p,f=c.trim().split(/[\r\n]+/);for(u=0;u<f.length;u++)l=f[u].split(": "),i=l.shift(),p=l.join(": "),n[i]=p}}else for(u=0;u<r.length;u++)i=r[u],n[i]=s.getResponseHeader(i)}catch(t){}}var h=null;if(e.autoInstrument.networkResponseBody)try{h=s.responseText}catch(t){}var d=null;(h||n)&&(d={},h&&(d.body=h),n&&(d.headers=n)),d&&(s.__rollbar_xhr.response=d)}try{var m=s.status;m=1223===m?204:m,s.__rollbar_xhr.status_code=m,s.__rollbar_event.level=e.telemeter.levelFromStatus(m)}catch(t){}}}var s=this;return t("onload",s),t("onerror",s),t("onprogress",s),"onreadystatechange"in s&&a.isFunction(s.onreadystatechange)?r(s,"onreadystatechange",function(t){return e.rollbar.wrap(t,void 0,i)}):s.onreadystatechange=i,n.apply(this,arguments)}},this.replacements,"network")}"fetch"in this._window&&r(this._window,"fetch",function(t){return function(n,r){for(var o=new Array(arguments.length),i=0,s=o.length;i<s;i++)o[i]=arguments[i];var u,c=o[0],l="GET";a.isType(c,"string")?u=c:c&&(u=c.url,c.method&&(l=c.method)),o[1]&&o[1].method&&(l=o[1].method);var p={method:l,url:u,status_code:null,start_time_ms:a.now(),end_time_ms:null},f=null;return e.autoInstrument.networkRequestBody&&(o[1]&&o[1].body?f=o[1].body:o[0]&&!a.isType(o[0],"string")&&o[0].body&&(f=o[0].body)),e.telemeter.captureNetwork(p,"fetch",void 0,f),t.apply(this,o).then(function(t){p.end_time_ms=a.now(),p.status_code=t.status;var n=null;if(e.autoInstrument.networkResponseHeaders){var r=e.autoInstrument.networkResponseHeaders;n={};try{if(r===!0);else for(var o=0;o<r.length;o++){var i=r[o];n[i]=t.headers.get(i)}}catch(t){}}var s=null;return n&&(s={headers:n}),s&&(p.response=s),t})}},this.replacements,"network")},i.prototype.deinstrumentConsole=function(){if("console"in this._window&&this._window.console.log)for(var t;this.replacements.log.length;)t=this.replacements.log.shift(),this._window.console[t[0]]=t[1]},i.prototype.instrumentConsole=function(){function t(t){var r=n[t],o=n,i="warn"===t?"warning":t;n[t]=function(){var t=Array.prototype.slice.call(arguments),n=a.formatArgsAsString(t);e.telemeter.captureLog(n,i),r&&Function.prototype.apply.call(r,o,t)},e.replacements.log.push([t,r])}if("console"in this._window&&this._window.console.log)for(var e=this,n=this._window.console,r=["debug","info","warn","error","log"],o=0,i=r.length;o<i;o++)t(r[o])},i.prototype.deinstrumentDom=function(){("addEventListener"in this._window||"attachEvent"in this._window)&&this.removeListeners("dom")},i.prototype.instrumentDom=function(){if("addEventListener"in this._window||"attachEvent"in this._window){var t=this.handleClick.bind(this),e=this.handleBlur.bind(this);this.addListener("dom",this._window,"click","onclick",t,!0),this.addListener("dom",this._window,"blur","onfocusout",e,!0)}},i.prototype.handleClick=function(t){try{var e=u.getElementFromEvent(t,this._document),n=e&&e.tagName,r=u.isDescribedElement(e,"a")||u.isDescribedElement(e,"button");n&&(r||u.isDescribedElement(e,"input",["button","submit"]))?this.captureDomEvent("click",e):u.isDescribedElement(e,"input",["checkbox","radio"])&&this.captureDomEvent("input",e,e.value,e.checked)}catch(t){}},i.prototype.handleBlur=function(t){try{var e=u.getElementFromEvent(t,this._document);e&&e.tagName&&(u.isDescribedElement(e,"textarea")?this.captureDomEvent("input",e,e.value):u.isDescribedElement(e,"select")&&e.options&&e.options.length?this.handleSelectInputChanged(e):u.isDescribedElement(e,"input")&&!u.isDescribedElement(e,"input",["button","submit","hidden","checkbox","radio"])&&this.captureDomEvent("input",e,e.value))}catch(t){}},i.prototype.handleSelectInputChanged=function(t){if(t.multiple)for(var e=0;e<t.options.length;e++)t.options[e].selected&&this.captureDomEvent("input",t,t.options[e].value);else t.selectedIndex>=0&&t.options[t.selectedIndex]&&this.captureDomEvent("input",t,t.options[t.selectedIndex].value)},i.prototype.captureDomEvent=function(t,e,n,r){if(void 0!==n)if(this.scrubTelemetryInputs||"password"===u.getElementType(e))n="[scrubbed]";else if(this.telemetryScrubber){var o=u.describeElement(e);this.telemetryScrubber(o)&&(n="[scrubbed]")}var i=u.elementArrayToString(u.treeToArray(e));this.telemeter.captureDom(t,i,n,r)},i.prototype.deinstrumentNavigation=function(){var t=this._window.chrome,e=t&&t.app&&t.app.runtime,n=!e&&this._window.history&&this._window.history.pushState;n&&o(this.replacements,"navigation")},i.prototype.instrumentNavigation=function(){var t=this._window.chrome,e=t&&t.app&&t.app.runtime,n=!e&&this._window.history&&this._window.history.pushState;if(n){var o=this;r(this._window,"onpopstate",function(t){return function(){var e=o._location.href;o.handleUrlChange(o._lastHref,e),t&&t.apply(this,arguments)}},this.replacements,"navigation"),r(this._window.history,"pushState",function(t){return function(){var e=arguments.length>2?arguments[2]:void 0;return e&&o.handleUrlChange(o._lastHref,e+""),t.apply(this,arguments)}},this.replacements,"navigation")}},i.prototype.handleUrlChange=function(t,e){var n=s.parse(this._location.href),r=s.parse(e),o=s.parse(t);this._lastHref=e,n.protocol===r.protocol&&n.host===r.host&&(e=r.path+(r.hash||"")),n.protocol===o.protocol&&n.host===o.host&&(t=o.path+(o.hash||"")),this.telemeter.captureNavigation(t,e)},i.prototype.deinstrumentConnectivity=function(){("addEventListener"in this._window||"body"in this._document)&&(this._window.addEventListener?this.removeListeners("connectivity"):o(this.replacements,"connectivity"))},i.prototype.instrumentConnectivity=function(){if("addEventListener"in this._window||"body"in this._document)if(this._window.addEventListener)this.addListener("connectivity",this._window,"online",void 0,function(){this.telemeter.captureConnectivityChange("online")}.bind(this),!0),this.addListener("connectivity",this._window,"offline",void 0,function(){this.telemeter.captureConnectivityChange("offline")}.bind(this),!0);else{var t=this;r(this._document.body,"ononline",function(e){return function(){t.telemeter.captureConnectivityChange("online"),e&&e.apply(this,arguments)}},this.replacements,"connectivity"),r(this._document.body,"onoffline",function(e){return function(){t.telemeter.captureConnectivityChange("offline"),e&&e.apply(this,arguments)}},this.replacements,"connectivity")}},i.prototype.addListener=function(t,e,n,r,o,i){e.addEventListener?(e.addEventListener(n,o,i),this.eventRemovers[t].push(function(){e.removeEventListener(n,o,i)})):r&&(e.attachEvent(r,o),this.eventRemovers[t].push(function(){e.detachEvent(r,o)}))},i.prototype.removeListeners=function(t){for(var e;this.eventRemovers[t].length;)(e=this.eventRemovers[t].shift())()},t.exports=i},function(t,e){"use strict";function n(t){return(t.getAttribute("type")||"").toLowerCase()}function r(t,e,r){if(t.tagName.toLowerCase()!==e.toLowerCase())return!1;if(!r)return!0;t=n(t);for(var o=0;o<r.length;o++)if(r[o]===t)return!0;return!1}function o(t,e){return t.target?t.target:e&&e.elementFromPoint?e.elementFromPoint(t.clientX,t.clientY):void 0}function i(t){for(var e,n=5,r=[],o=0;t&&o<n&&(e=u(t),"html"!==e.tagName);o++)r.unshift(e),t=t.parentNode;return r}function a(t){for(var e,n,r=80,o=" > ",i=o.length,a=[],u=0,c=t.length-1;c>=0;c--){if(e=s(t[c]),n=u+a.length*i+e.length,c<t.length-1&&n>=r+3){a.unshift("...");break}a.unshift(e),u+=e.length}return a.join(o)}function s(t){if(!t||!t.tagName)return"";var e=[t.tagName];t.id&&e.push("#"+t.id),t.classes&&e.push("."+t.classes.join("."));for(var n=0;n<t.attributes.length;n++)e.push("["+t.attributes[n].key+'="'+t.attributes[n].value+'"]');return e.join("")}function u(t){if(!t||!t.tagName)return null;var e,n,r,o,i={};i.tagName=t.tagName.toLowerCase(),t.id&&(i.id=t.id),e=t.className,e&&"string"==typeof e&&(i.classes=e.split(/\s+/));var a=["type","name","title","alt"];for(i.attributes=[],o=0;o<a.length;o++)n=a[o],r=t.getAttribute(n),r&&i.attributes.push({key:n,value:r});return i}t.exports={describeElement:u,descriptionToString:s,elementArrayToString:a,treeToArray:i,getElementFromEvent:o,isDescribedElement:r,getElementType:n}}])});
//# sourceMappingURL=rollbar.umd.min.js.map

/***/ }),

/***/ "./node_modules/tween-functions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// t: current time, b: beginning value, _c: final value, d: total duration
var tweenFunctions = {
  linear: function(t, b, _c, d) {
    var c = _c - b;
    return c * t / d + b;
  },
  easeInQuad: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t + b;
  },
  easeOutQuad: function(t, b, _c, d) {
    var c = _c - b;
    return -c * (t /= d) * (t - 2) + b;
  },
  easeInOutQuad: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t + b;
    } else {
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    }
  },
  easeInCubic: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function(t, b, _c, d) {
    var c = _c - b;
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t + b;
    } else {
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
  },
  easeInQuart: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t * t * t + b;
  },
  easeOutQuart: function(t, b, _c, d) {
    var c = _c - b;
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeInOutQuart: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t * t + b;
    } else {
      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
  },
  easeInQuint: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t * t * t * t + b;
  },
  easeOutQuint: function(t, b, _c, d) {
    var c = _c - b;
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  easeInOutQuint: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t * t * t + b;
    } else {
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
  },
  easeInSine: function(t, b, _c, d) {
    var c = _c - b;
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  },
  easeOutSine: function(t, b, _c, d) {
    var c = _c - b;
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  },
  easeInOutSine: function(t, b, _c, d) {
    var c = _c - b;
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  },
  easeInExpo: function(t, b, _c, d) {
    var c = _c - b;
    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
  },
  easeOutExpo: function(t, b, _c, d) {
    var c = _c - b;
    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
  },
  easeInOutExpo: function(t, b, _c, d) {
    var c = _c - b;
    if (t === 0) {
      return b;
    }
    if (t === d) {
      return b + c;
    }
    if ((t /= d / 2) < 1) {
      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    } else {
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  },
  easeInCirc: function(t, b, _c, d) {
    var c = _c - b;
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  },
  easeOutCirc: function(t, b, _c, d) {
    var c = _c - b;
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  },
  easeInOutCirc: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    } else {
      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
  },
  easeInElastic: function(t, b, _c, d) {
    var c = _c - b;
    var a, p, s;
    s = 1.70158;
    p = 0;
    a = c;
    if (t === 0) {
      return b;
    } else if ((t /= d) === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
  },
  easeOutElastic: function(t, b, _c, d) {
    var c = _c - b;
    var a, p, s;
    s = 1.70158;
    p = 0;
    a = c;
    if (t === 0) {
      return b;
    } else if ((t /= d) === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
  },
  easeInOutElastic: function(t, b, _c, d) {
    var c = _c - b;
    var a, p, s;
    s = 1.70158;
    p = 0;
    a = c;
    if (t === 0) {
      return b;
    } else if ((t /= d / 2) === 2) {
      return b + c;
    }
    if (!p) {
      p = d * (0.3 * 1.5);
    }
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    if (t < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    } else {
      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    }
  },
  easeInBack: function(t, b, _c, d, s) {
    var c = _c - b;
    if (s === void 0) {
      s = 1.70158;
    }
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  easeOutBack: function(t, b, _c, d, s) {
    var c = _c - b;
    if (s === void 0) {
      s = 1.70158;
    }
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  easeInOutBack: function(t, b, _c, d, s) {
    var c = _c - b;
    if (s === void 0) {
      s = 1.70158;
    }
    if ((t /= d / 2) < 1) {
      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    } else {
      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
  },
  easeInBounce: function(t, b, _c, d) {
    var c = _c - b;
    var v;
    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
    return c - v + b;
  },
  easeOutBounce: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
  },
  easeInOutBounce: function(t, b, _c, d) {
    var c = _c - b;
    var v;
    if (t < d / 2) {
      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
      return v * 0.5 + b;
    } else {
      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
      return v * 0.5 + c * 0.5 + b;
    }
  }
};

module.exports = tweenFunctions;


/***/ }),

/***/ "./node_modules/underscore.string.fp/camelize.js":
/***/ (function(module, exports, __webpack_require__) {

var _camelize = __webpack_require__("./node_modules/underscore.string/camelize.js");
var _curry = __webpack_require__("./node_modules/chickencurry/index.js");

module.exports = _curry(function camelize(str) {
  return _camelize(str, true);
});


/***/ }),

/***/ "./node_modules/underscore.string/camelize.js":
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__("./node_modules/underscore.string/trim.js");
var decap = __webpack_require__("./node_modules/underscore.string/decapitalize.js");

module.exports = function camelize(str, decapitalize) {
  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
    return c ? c.toUpperCase() : "";
  });

  if (decapitalize === true) {
    return decap(str);
  } else {
    return str;
  }
};


/***/ }),

/***/ "./node_modules/underscore.string/decapitalize.js":
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__("./node_modules/underscore.string/helper/makeString.js");

module.exports = function decapitalize(str) {
  str = makeString(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
};


/***/ }),

/***/ "./node_modules/underscore.string/helper/defaultToWhiteSpace.js":
/***/ (function(module, exports, __webpack_require__) {

var escapeRegExp = __webpack_require__("./node_modules/underscore.string/helper/escapeRegExp.js");

module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return '\\s';
  else if (characters.source)
    return characters.source;
  else
    return '[' + escapeRegExp(characters) + ']';
};


/***/ }),

/***/ "./node_modules/underscore.string/helper/escapeRegExp.js":
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__("./node_modules/underscore.string/helper/makeString.js");

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};


/***/ }),

/***/ "./node_modules/underscore.string/helper/makeString.js":
/***/ (function(module, exports) {

/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};


/***/ }),

/***/ "./node_modules/underscore.string/trim.js":
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__("./node_modules/underscore.string/helper/makeString.js");
var defaultToWhiteSpace = __webpack_require__("./node_modules/underscore.string/helper/defaultToWhiteSpace.js");
var nativeTrim = String.prototype.trim;

module.exports = function trim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrim) return nativeTrim.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
};


/***/ }),

/***/ "./node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "./src/App.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepWrapper__ = __webpack_require__("./src/components/StepWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExportReportWrapper__ = __webpack_require__("./src/components/ExportReportWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AnalysisWrapper__ = __webpack_require__("./src/components/AnalysisWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BomWrapper__ = __webpack_require__("./src/components/BomWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SchematicWrapper__ = __webpack_require__("./src/components/SchematicWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc_withLoader__ = __webpack_require__("./src/hoc/withLoader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hoc_withErrorHandler__ = __webpack_require__("./src/hoc/withErrorHandler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_constants__ = __webpack_require__("./src/utils/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_stepHelpers__ = __webpack_require__("./src/utils/stepHelpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_errors__ = __webpack_require__("./src/selectors/errors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__App_scss__ = __webpack_require__("./src/App.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// const debug = require('debug')('app:');
var App=function(_React$PureComponent){_inherits(App,_React$PureComponent);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){var currentStep=this.props.currentStep;var stepData=Object(__WEBPACK_IMPORTED_MODULE_11__utils_stepHelpers__["e" /* getStepDataByKey */])(currentStep);switch(currentStep){case __WEBPACK_IMPORTED_MODULE_10__utils_constants__["b" /* Steps */].STEP_ANALYSIS:{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_14__App_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_AnalysisWrapper__["a" /* default */],null));}case __WEBPACK_IMPORTED_MODULE_10__utils_constants__["b" /* Steps */].REPORT:{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_14__App_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ExportReportWrapper__["a" /* default */],null));}case __WEBPACK_IMPORTED_MODULE_10__utils_constants__["b" /* Steps */].BOM:{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_14__App_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_BomWrapper__["a" /* default */],null));}case __WEBPACK_IMPORTED_MODULE_10__utils_constants__["b" /* Steps */].SCHEMATIC:{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_14__App_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SchematicWrapper__["a" /* default */],null));}default:{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_14__App_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_StepWrapper__["a" /* default */],{data:stepData}));}}}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_design__["l" /* isLoading */])(state),hasError:Object(__WEBPACK_IMPORTED_MODULE_13__selectors_errors__["b" /* hasError */])(state),currentStep:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_design__["b" /* getCurrentStep */])(state)};}var connector=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps);var enhancer=Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["compose"])(connector,__WEBPACK_IMPORTED_MODULE_9__hoc_withErrorHandler__["a" /* default */],__WEBPACK_IMPORTED_MODULE_8__hoc_withLoader__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (enhancer(App));

/***/ }),

/***/ "./src/App.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"App__wrapper"};

/***/ }),

/***/ "./src/actions/design.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return revertField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal__ = __webpack_require__("./src/actions/modal.js");
/**
 * 
 * @format
 */// import { downloadSVGImage } from '../utils';
// import { getNextFieldsByStep, getStepByField, downloadBlob, downloadSVGImage } from '../utils';
// Constants
var constants={STEP_FORWARD:'Design/STEP_FORWARD',STEP_BACKWARD:'Design/STEP_BACKWARD',STEP_RESET:'Design/STEP_RESET',AUTO_COMPLETE:'Design/AUTO_COMPLETE',RENAME_DESIGN:'Design/RENAME_DESIGN',NEW_DESIGN:'Design/NEW_DESIGN',ERROR:'Design/ERROR',API_ERROR:'Design/API_ERROR',EVALUATE_ERROR:'Design/EVALULATE_ERROR',UPDATE:'Design/UPDATE',EVALUATE:'Design/EVALUATE',CHANGE_VALUE:'Design/CHANGE_VALUE',REVERT_FIELD:'Design/REVERT_FIELD',PENDING:'Design/PENDING',VALIDATION_ERROR:'Design/VALIDATION_ERROR',DOWNLOAD_PDF:'Design/DOWNLOAD_PDF',REQUEST_PDF:'Design/REQUEST_PDF',CANCEL_PDF:'Design/CANCEL_PDF',RECEIVE_PDF:'Design/RECEIVE_PDF',DOWNLOAD_SCHEMATIC:'Design/DOWNLOAD_SCHEMATIC',CHECK_FET_CONFIG:'Design/CHECK_FET_CONFIG',RECEIVE_FET_CONFIG:'Design/RECEIVE_FET_CONFIG',EXPORT_BOM_EXCEL:'Design/EXPORT_BOM_EXCEL',SAVE_DESIGN:'Design/SAVE_DESIGN',OPEN_DESIGN:'Design/OPEN_DESIGN',// FETCH_DESIGNS: 'Design/FETCH_DESIGNS',
// RECEIVE_DESIGNS: 'Design/RECEIVE_DESIGNS',
// FETCH_DESIGN: 'Design/FETCH_DESIGN',
// RECEIVE_DESIGN: 'Design/RECEIVE_DESIGN',
REQUEST_USER:'Design/REQUEST_USER',RECEIVE_USER:'Design/RECEIVE_USER',REQUEST_PARTS:'Design/REQUEST_PARTS',RECEIVE_PARTS:'Design/RECEIVE_PARTS'};var revertField=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(constants.REVERT_FIELD,function(_ref){var id=_ref.id;return{field:id};},function(_ref2){var isSelect=_ref2.isSelect;return{isSelect:isSelect};});// Action Creators
var actions={revertField:revertField,stepForward:function stepForward(){return{type:constants.STEP_FORWARD,payload:null};},stepBackward:function stepBackward(){return{type:constants.STEP_BACKWARD,payload:null};},stepReset:function stepReset(){return{type:constants.STEP_RESET,payload:null};},autoComplete:function autoComplete(){return{type:constants.AUTO_COMPLETE,payload:null};},pendingAction:function pendingAction(){return{type:constants.PENDING,payload:null};},renameDesign:function renameDesign(payload){return{type:constants.RENAME_DESIGN,data:payload};},newDesign:function newDesign(){var silent=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return{type:constants.NEW_DESIGN,payload:silent};},error:function error(payload){return{type:constants.ERROR,payload:payload};},apiError:function apiError(payload){return{type:constants.API_ERROR,payload:payload};},evaluateError:function evaluateError(payload){return{type:constants.EVALUATE_ERROR,payload:payload};},receiveData:function receiveData(payload){return{type:constants.UPDATE,payload:payload};},evaluateData:function evaluateData(payload){return{type:constants.EVALUATE,payload:payload};},validationError:function validationError(payload){return{type:constants.VALIDATION_ERROR,payload:payload};},changeValue:function changeValue(payload){return{type:constants.CHANGE_VALUE,payload:payload};},// downloadPDF: () => ({ type: constants.DOWNLOAD_PDF }),
requestPDF:function requestPDF(){return{type:constants.REQUEST_PDF};},cancelPDF:function cancelPDF(){return{type:constants.CANCEL_PDF};},receivePDF:function receivePDF(payload,filename){return{type:constants.RECEIVE_PDF,payload:payload,filename:filename};},requestUser:function requestUser(){return{type:constants.REQUEST_USER};},receiveUser:function receiveUser(payload){return{type:constants.RECEIVE_USER,payload:payload};},downloadSchematic:function downloadSchematic(){return{type:constants.DOWNLOAD_SCHEMATIC};},// saveSchematicImage: (data: string, filename: string) => downloadSVGImage(data, filename),
checkFETConfig:function checkFETConfig(){return{type:constants.CHECK_FET_CONFIG};},receiveFETConfig:function receiveFETConfig(payload){return{type:constants.RECEIVE_FET_CONFIG,payload:payload};},exportBOMToExcel:function exportBOMToExcel(){return{type:constants.EXPORT_BOM_EXCEL};},saveDesign:function saveDesign(payload){return{type:constants.SAVE_DESIGN,payload:payload};},openDesign:function openDesign(){return{type:constants.OPEN_DESIGN};},// fetchDesign: (payload: number) => ({ type: constants.FETCH_DESIGN, payload }),
// receiveDesign: (payload: Object) => ({
//   type: constants.RECEIVE_DESIGN,
//   payload,
// }),
// fetchDesigns: () => ({ type: constants.FETCH_DESIGNS }),
receiveDesigns:function receiveDesigns(data){return __WEBPACK_IMPORTED_MODULE_1__modal__["a" /* actions */].showModal({modalType:__WEBPACK_IMPORTED_MODULE_1__modal__["b" /* constants */].MODAL_OPEN_DESIGN,modalProps:{data:data// onOpenDesign: (id: number) => dispatch(actions.fetchDesign(id)),
}});},requestParts:function requestParts(){return{type:constants.REQUEST_PARTS};},receiveParts:function receiveParts(payload){return{type:constants.RECEIVE_PARTS,payload:payload};}};/* unused harmony default export */ var _unused_webpack_default_export = ({constants:constants,actions:actions});

/***/ }),

/***/ "./src/actions/errors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/**
 * 
 * @format
 */var constants={API_ERROR:'Errors/API_ERROR'};var actions={apiError:function apiError(payload){return{type:constants.API_ERROR,payload:payload};}};/* unused harmony default export */ var _unused_webpack_default_export = ({constants:constants,actions:actions});

/***/ }),

/***/ "./src/actions/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/**
 * 
 * @format
 */var constants={SHOW_MODAL:'SHOW_MODAL',HIDE_MODAL:'HIDE_MODAL',MODAL_SAVE_DESIGN:'MODAL_SAVE_DESIGN',MODAL_OPEN_DESIGN:'MODAL_OPEN_DESIGN',MODAL_FILE_MANAGE:'MODAL_FILE_MANAGE'};var actions={showModal:function showModal(data){return{type:constants.SHOW_MODAL,data:data};},hideModal:function hideModal(data){return{type:constants.HIDE_MODAL,data:data};}};/* unused harmony default export */ var _unused_webpack_default_export = ({constants:constants,actions:actions});

/***/ }),

/***/ "./src/components/AnalysisWrapper/AnalysisWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnalysisWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__("./node_modules/lodash/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_slice__ = __webpack_require__("./node_modules/lodash/slice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ChartLineGraph__ = __webpack_require__("./src/components/ChartLineGraph/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PieChart__ = __webpack_require__("./src/components/PieChart/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss__ = __webpack_require__("./src/components/AnalysisWrapper/AnalysisWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable react/no-array-index-key */// import type { ChartType } from '~/reducers/global';
// import ReportInputParams from '../ReportInputParams';
// import ReportOutputParams from '../ReportOutputParams';
function replaceTableText(str){var obj={// min: 'Minimum',
// nom: 'Nominal',
// max: 'Maximim',
Vin:'V<sub>IN</sub>'// eslint-disable-line no-useless-escape
};return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* createHTMLMarkup */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["q" /* replaceAll */])(str,obj));}var AnalysisWrapper=function(_React$PureComponent){_inherits(AnalysisWrapper,_React$PureComponent);function AnalysisWrapper(){_classCallCheck(this,AnalysisWrapper);return _possibleConstructorReturn(this,(AnalysisWrapper.__proto__||Object.getPrototypeOf(AnalysisWrapper)).apply(this,arguments));}_createClass(AnalysisWrapper,[{key:'render',// eslint-disable-line react/sort-comp
// componentDidMount() {
// Adjust the graphs and legends after the components have been generated.
// There might be an easier way to do this?
// const groups = d3.selectAll('.graph');
// groups.each(function each() {
//   let viewBox: string = this.getAttribute('viewBox');
//   const legend = d3
//     .select(this)
//     .select('.legend')
//     .select('g');
//   const legendGroup: Element = legend.node();
//   const width = Math.round(legendGroup.getBoundingClientRect().width + 5);
//   // legendGroup.previousElementSibling.setAttribute('width', width);
//   // IE11: parentElement is undefined for SVG elements, use parentNode.
//   const wrapper = legendGroup.parentNode;
//   if (wrapper instanceof Element) {
//     wrapper.setAttribute(
//       'transform',
//       `translate(-${40 + 10 + 10 + width}, 5)`,
//     );
//     // Move the viewbox
//     viewBox = viewBox.replace('0', `-${width / 2}`);
//     this.setAttribute('viewBox', viewBox);
//   }
// });
// }
value:function render(){var _this2=this;var pieCharts=__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(this.props.charts,10);// const pieCharts = [];
var lossCharts=__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(this.props.charts,0,10);// const lossCharts = _.slice(this.props.charts, 0, 1);
// console.log(charts);
var graphs=__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(lossCharts,function(d,k){var title=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{style:{textAlign:'center'},className:__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardSubHeader},replaceTableText(d.name));return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{sm:12,md:12,lg:6,key:k,className:'pb-0'},title,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'px-xl-5'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'p-sm-1 p-md-2 p-lg-3 px-xl-5 py-xl-3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'mx-auto',style:{maxWidth:'700px'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ChartLineGraph__["a" /* default */],{graphNum:k+1,chartInfo:d.labels,chartData:d.data,legend:'horizontal',viewBox:{x:0,y:0,width:550,height:325}})))));});var pieGraphs=__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(pieCharts,function(d){var omitFields=_this2.props.hasSnubber?['totalpowerloss']:['totalpowerloss','snubber'];var data=__WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(d.data,omitFields);var title=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{style:{textAlign:'center'},className:__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardSubHeader},replaceTableText(d.name));return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{xs:4,key:d.name,className:'pb-5'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'pb-3'},title,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PieChart__["a" /* default */],{data:data,totalLoss:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(d,['data','totalpowerloss'],0),width:'100%',height:230,radius:100,viewBox:{x:0,y:0,width:325,height:250}})));});var effRows=this.props.effSummary.map(function(d){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',{key:d.vin},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,replaceTableText(d.vin)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,d.load100p),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,d.load75p),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,d.load50p),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',null,d.load25p));});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:Object(__WEBPACK_IMPORTED_MODULE_7_classcat__["default"])(['col col-sm-12',__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardHeader])},'Loss Review'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Card"],{body:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Row"],{noGutters:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardSubHeader},'6a: MOSFET & Diode Loss Breakdown')),__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(graphs,0,6)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Row"],{noGutters:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardSubHeader},'6b: Powertrain Component Loss Summary')),pieGraphs),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Row"],{noGutters:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h4',{className:__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardSubHeader},'6c: Loss & Efficiency vs. V',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('sub',null,'in'),' & Load')),__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(graphs,6)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{sm:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:Object(__WEBPACK_IMPORTED_MODULE_7_classcat__["default"])(['text-center',__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.cardSubHeader])},'Powertrain Efficiency Summary')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{style:{display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('table',{className:Object(__WEBPACK_IMPORTED_MODULE_7_classcat__["default"])(['table table-sm table-bordered',__WEBPACK_IMPORTED_MODULE_12__AnalysisWrapper_scss___default.a.summaryTable])},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('thead',{className:'thead-inverse'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'100% Load'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'75% Load'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'50% Load'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',null,'25% Load'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tbody',null,effRows)))))));}}]);return AnalysisWrapper;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);AnalysisWrapper.defaultProps={effSummary:[],charts:{},hasSnubber:false};function mapStateToProps(state){var hasSnubber=Object(__WEBPACK_IMPORTED_MODULE_9__selectors_design__["j" /* getSnubberStatus */])(state);return Object.assign({},state.global.chartData.data,{hasSnubber:hasSnubber});}var connector=Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(AnalysisWrapper));

/***/ }),

/***/ "./src/components/AnalysisWrapper/AnalysisWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AnalysisWrapper__wrapper","cardHeader":"AnalysisWrapper__cardHeader","cardSubHeader":"AnalysisWrapper__cardSubHeader","summaryTable":"AnalysisWrapper__summaryTable"};

/***/ }),

/***/ "./src/components/AnalysisWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalysisWrapper__ = __webpack_require__("./src/components/AnalysisWrapper/AnalysisWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__AnalysisWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/BomWrapper/BomWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BomWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__("./node_modules/lodash/isEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_every__ = __webpack_require__("./node_modules/lodash/every.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_tail__ = __webpack_require__("./node_modules/lodash/tail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_tail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_tail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_first__ = __webpack_require__("./node_modules/lodash/first.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_noop__ = __webpack_require__("./node_modules/lodash/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_shopping_cart__ = __webpack_require__("./node_modules/react-icons/lib/fa/shopping-cart.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_shopping_cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_shopping_cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_download__ = __webpack_require__("./node_modules/react-icons/lib/fa/download.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BomWrapper_scss__ = __webpack_require__("./src/components/BomWrapper/BomWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BomWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__BomWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var hashId=new __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* HashId */]();function replaceText(text){if(!text)return text;return text.replace(/>=/g,'≥').replace(/<=/g,'≤');}function generateLink(data,part){if(['ON Semiconductor','Fairchild'].includes(data[3])){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:'/PowerSolutions/product.do?id='+part,rel:'noopener noreferrer',target:'_blank'},part);}return part;}var BomWrapper=function(_React$PureComponent){_inherits(BomWrapper,_React$PureComponent);function BomWrapper(){_classCallCheck(this,BomWrapper);return _possibleConstructorReturn(this,(BomWrapper.__proto__||Object.getPrototypeOf(BomWrapper)).apply(this,arguments));}_createClass(BomWrapper,[{key:'render',value:function render(){var _props=this.props,parts=_props.parts,data=_props.data;if(data.length===0){return null;}var head=__WEBPACK_IMPORTED_MODULE_4_lodash_first___default()(data);var pkgIndex=head.indexOf('Part Number');var qtyIndex=head.indexOf('Qty');var manIndex=head.indexOf('Manufacturer');var desIndex=head.indexOf('Description');var headers=head.map(function(s){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('th',{key:s},s);});var rows=__WEBPACK_IMPORTED_MODULE_3_lodash_tail___default()(this.props.data).map(function(r){if(__WEBPACK_IMPORTED_MODULE_2_lodash_every___default()(r,__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default.a))return null;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('tr',{key:hashId.nextId()},r.map(function(s,j,arr){if(j===pkgIndex){var partData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(parts,s);if(!partData)return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:s},generateLink(arr,s));return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:s},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:partData.productPageUrl,rel:'noopener noreferrer',target:'_blank'},s),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'pull-xs-right'},partData.sampleUrl?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:partData.sampleUrl,rel:'noopener noreferrer',target:'_blank',className:'btn btn-primary btn-sm'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_shopping_cart___default.a,null),' Sample'):null,' ',partData.buyUrl?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:partData.buyUrl,rel:'noopener noreferrer',target:'_blank',className:'btn btn-primary btn-sm'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_shopping_cart___default.a,null),' Buy'):null));}else if(j===qtyIndex){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:hashId.nextId()},parseInt(s,10));}else if(j===manIndex){switch(s){case'Fairchild':return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:hashId.nextId()},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:'https://fairchildsemi.com',rel:'noopener noreferrer',target:'_blank'},s));case'ON Semiconductor':return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:hashId.nextId()},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{href:'https://onsemi.com',rel:'noopener noreferrer',target:'_blank'},s));default:return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:hashId.nextId()},s);}}else if(j===desIndex){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:hashId.nextId()},replaceText(s));}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('td',{key:hashId.nextId()},s);}));});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',{className:Object(__WEBPACK_IMPORTED_MODULE_9_classcat__["default"])(['col col-sm-12',__WEBPACK_IMPORTED_MODULE_14__BomWrapper_scss___default.a.cardHeader])},'Powertrain Bill of Materials',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Button"],{className:'ml-3',size:'sm',onClick:this.props.onExportBOM},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_download___default.a,null),' Export BOM')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Card"],{body:true,style:{border:0}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["Table"],{size:'sm',hover:true,striped:true,className:Object(__WEBPACK_IMPORTED_MODULE_9_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_14__BomWrapper_scss___default.a.tableHeader])},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('thead',{className:Object(__WEBPACK_IMPORTED_MODULE_9_classcat__["default"])(['thead-inverse'])},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('tr',null,headers)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('tbody',null,rows)))))));}}]);return BomWrapper;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.PureComponent);BomWrapper.defaultProps={data:[],parts:{},onExportBOM:__WEBPACK_IMPORTED_MODULE_5_lodash_noop___default.a};function mapStateToProps(state){return{data:state.global.BOMTable};}function mapDispatchToProps(dispatch){return{onExportBOM:function onExportBOM(){return dispatch(__WEBPACK_IMPORTED_MODULE_12__actions_design__["a" /* actions */].exportBOMToExcel());}};}var connector=Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps,mapDispatchToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(BomWrapper));

/***/ }),

/***/ "./src/components/BomWrapper/BomWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"BomWrapper__wrapper","cardHeader":"BomWrapper__cardHeader","tableHeader":"BomWrapper__tableHeader"};

/***/ }),

/***/ "./src/components/BomWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BomWrapper__ = __webpack_require__("./src/components/BomWrapper/BomWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BomWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/ChartLineGraph/ChartLineGraph.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChartLineGraph */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__("./node_modules/lodash/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MultiLineGraph__ = __webpack_require__("./src/components/MultiLineGraph/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LineGraph__ = __webpack_require__("./src/components/LineGraph/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChartLineGraph_scss__ = __webpack_require__("./src/components/ChartLineGraph/ChartLineGraph.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChartLineGraph_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ChartLineGraph_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// eslint-disable-next-line react/prefer-stateless-function
var ChartLineGraph=function(_React$Component){_inherits(ChartLineGraph,_React$Component);function ChartLineGraph(){_classCallCheck(this,ChartLineGraph);return _possibleConstructorReturn(this,(ChartLineGraph.__proto__||Object.getPrototypeOf(ChartLineGraph)).apply(this,arguments));}_createClass(ChartLineGraph,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){// Set up our props for later
var props={area:this.props.chartArea,data:this.props.chartData,labels:this.props.chartInfo,markers:this.props.chartMarker,width:this.props.width,height:this.props.height,viewBox:this.props.viewBox,aspectRatio:this.props.aspectRatio,legend:this.props.legend};var multiLine=Object.keys(this.props.chartData).length>3||(this.props.chartData['Critical Load']!==undefined&&this.props.chartData['Max Load'])!==undefined;var Graph=multiLine?__WEBPACK_IMPORTED_MODULE_5__MultiLineGraph__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_6__LineGraph__["a" /* default */];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7__ChartLineGraph_scss___default.a.graphWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Graph,props)),Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* branch */])(__WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(this.props.chartInfo.Detail),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_7__ChartLineGraph_scss___default.a.chartDetails,'px-5 pb-5 pt-0 d-flex'])},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'w-75'},this.props.chartInfo.Detail))));}}]);return ChartLineGraph;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ChartLineGraph.defaultProps={aspectRatio:'xMidYMid meet',chartArea:[],chartData:{},chartInfo:{},chartMarker:{},graphNum:'#',height:null,legend:'vertical',viewBox:{x:0,y:0,width:475,height:200},width:null,resize:false};/* harmony default export */ __webpack_exports__["a"] = (ChartLineGraph);

/***/ }),

/***/ "./src/components/ChartLineGraph/ChartLineGraph.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chartDetails":"ChartLineGraph__chartDetails","graphWrapper":"ChartLineGraph__graphWrapper"};

/***/ }),

/***/ "./src/components/ChartLineGraph/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChartLineGraph__ = __webpack_require__("./src/components/ChartLineGraph/ChartLineGraph.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ChartLineGraph__["a" /* default */]);

/***/ }),

/***/ "./src/components/Circle/Circle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Circle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import classes from './Circle.scss';
var Circle=function(_React$PureComponent){_inherits(Circle,_React$PureComponent);function Circle(){_classCallCheck(this,Circle);return _possibleConstructorReturn(this,(Circle.__proto__||Object.getPrototypeOf(Circle)).apply(this,arguments));}_createClass(Circle,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',this.props);}}]);return Circle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);Circle.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (Circle);

/***/ }),

/***/ "./src/components/Circle/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Circle__ = __webpack_require__("./src/components/Circle/Circle.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Circle__["a" /* default */]);

/***/ }),

/***/ "./src/components/DesignToolBar/DesignToolBar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DesignToolBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit__ = __webpack_require__("./node_modules/lodash/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routines_design__ = __webpack_require__("./src/routines/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_modal__ = __webpack_require__("./src/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_global__ = __webpack_require__("./src/selectors/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_progress__ = __webpack_require__("./src/selectors/progress.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RightToolBar__ = __webpack_require__("./src/components/RightToolBar/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LeftToolBar__ = __webpack_require__("./src/components/LeftToolBar/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DesignToolBar_scss__ = __webpack_require__("./src/components/DesignToolBar/DesignToolBar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DesignToolBar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__DesignToolBar_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import cc from 'classcat';
// import type { Connector } from 'react-redux';
var DesignToolBar=function(_React$PureComponent){_inherits(DesignToolBar,_React$PureComponent);function DesignToolBar(){_classCallCheck(this,DesignToolBar);return _possibleConstructorReturn(this,(DesignToolBar.__proto__||Object.getPrototypeOf(DesignToolBar)).apply(this,arguments));}_createClass(DesignToolBar,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{className:__WEBPACK_IMPORTED_MODULE_12__DesignToolBar_scss___default.a.navWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-lg-flex justify-content-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LeftToolBar__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(this.props,['disableReset','disableAutoComplete'])),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RightToolBar__["a" /* default */],this.props)));}}]);return DesignToolBar;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);function mapStateToProps(state,ownProps){var designName=Object(__WEBPACK_IMPORTED_MODULE_8__selectors_global__["c" /* getDesignName */])(state);var id=Object(__WEBPACK_IMPORTED_MODULE_8__selectors_global__["b" /* getCurrentRecordId */])(state);var isSavedDesign=id!==null;return Object.assign({},ownProps,{disableOpen:false,disableSave:false,disableNext:!__WEBPACK_IMPORTED_MODULE_9__selectors_progress__["g" /* getNextEnabled */](state),disableBack:!__WEBPACK_IMPORTED_MODULE_9__selectors_progress__["c" /* getBackEnabled */](state),disableReset:!__WEBPACK_IMPORTED_MODULE_9__selectors_progress__["h" /* getResetEnabled */](state),disableRename:false,disableAutoComplete:!__WEBPACK_IMPORTED_MODULE_9__selectors_progress__["b" /* getAutocompleteEnabled */](state),designName:designName,isSavedDesign:isSavedDesign,id:id});}// PropsType & { dispatch: Dispatch }
var enhancer=Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps),// TODO: ___ FIX THIS ___ use title updater for contenteditable.
Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["withState"])('designTitle','setTitle',function(props){return props.designName;}),Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["withHandlers"])({onChangeDesignName:function onChangeDesignName(_ref){var setTitle=_ref.setTitle;return function(){return setTitle(function(s){return s;});};},onAutoComplete:function onAutoComplete(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_design__["a" /* actions */].autoComplete());};},onNewDesign:function onNewDesign(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_design__["a" /* actions */].newDesign());};},onOpen:function onOpen(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_design__["a" /* actions */].openDesign());};},// onRedo: (props: HType) => () => props.dispatch(designActions.())),
onSave:function onSave(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_7__actions_modal__["a" /* actions */].showModal({modalType:__WEBPACK_IMPORTED_MODULE_7__actions_modal__["b" /* constants */].MODAL_SAVE_DESIGN,modalProps:{onSubmit:function onSubmit(data){return props.dispatch(__WEBPACK_IMPORTED_MODULE_6__routines_design__["a" /* default */].saveDesignRecord(data));}// onUpdate: (data: string) =>
//   props.dispatch(designRoutines.updateDesignRecord(data)),
}}));};},// onManage: (props: HType) => () =>
//   props.dispatch(
//     modalActions.showModal({
//       modalType: modalConstants.MODAL_FILE_MANAGE,
//       modalProps: {
//         onDelete: (id: number) => console.log('deleting: ', id),
//         onRename: (id: number, newName: string) =>
//           console.log('renaming', id, 'to', newName),
//       },
//     }),
//   ),
onStepBackward:function onStepBackward(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_design__["a" /* actions */].stepBackward());};},onStepForward:function onStepForward(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_design__["a" /* actions */].stepForward());};},onStepReset:function onStepReset(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_design__["a" /* actions */].stepReset());};},// onUndo: (props: HType) => () => props.actions.()),
onDuplicateDesign:function onDuplicateDesign(props){return function(id){return props.dispatch(__WEBPACK_IMPORTED_MODULE_6__routines_design__["a" /* default */].copyDesign({id:id,name:props.designName+'-'+new Date().toISOString()}));};},onUpdateDesign:function onUpdateDesign(props){return function(){return props.dispatch(__WEBPACK_IMPORTED_MODULE_6__routines_design__["a" /* default */].updateDesign({id:props.id}));};}}));/* harmony default export */ __webpack_exports__["a"] = (enhancer(DesignToolBar));

/***/ }),

/***/ "./src/components/DesignToolBar/DesignToolBar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navWrapper":"DesignToolBar__navWrapper"};

/***/ }),

/***/ "./src/components/DesignToolBar/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DesignToolBar__ = __webpack_require__("./src/components/DesignToolBar/DesignToolBar.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DesignToolBar__["a" /* default */]);

/***/ }),

/***/ "./src/components/ErrorComponent/ErrorComponent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_errors__ = __webpack_require__("./src/selectors/errors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorComponent_scss__ = __webpack_require__("./src/components/ErrorComponent/ErrorComponent.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorComponent_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ErrorComponent_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// eslint-disable-next-line react/prefer-stateless-function
var ErrorComponent=function(_React$Component){_inherits(ErrorComponent,_React$Component);function ErrorComponent(){_classCallCheck(this,ErrorComponent);return _possibleConstructorReturn(this,(ErrorComponent.__proto__||Object.getPrototypeOf(ErrorComponent)).apply(this,arguments));}_createClass(ErrorComponent,[{key:'render',value:function render(){var errors=this.props.errors.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:e.data.timestamp},e.data.message);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],{className:__WEBPACK_IMPORTED_MODULE_5__ErrorComponent_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],{className:'pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Card"],{body:true,className:'bg-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5__ErrorComponent_scss___default.a.errorWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Error: ',errors)))));}}]);return ErrorComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ErrorComponent.defaultProps={errors:[]};function mapStateToProps(state){return{errors:Object(__WEBPACK_IMPORTED_MODULE_4__selectors_errors__["a" /* getErrors */])(state)};}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps),__WEBPACK_IMPORTED_MODULE_2_recompose__["pure"]);/* harmony default export */ __webpack_exports__["a"] = (enhancer(ErrorComponent));

/***/ }),

/***/ "./src/components/ErrorComponent/ErrorComponent.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ErrorComponent__wrapper","errorWrapper":"ErrorComponent__errorWrapper"};

/***/ }),

/***/ "./src/components/ErrorComponent/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorComponent__ = __webpack_require__("./src/components/ErrorComponent/ErrorComponent.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ErrorComponent__["a" /* default */]);

/***/ }),

/***/ "./src/components/ExportReportWrapper/ExportReportWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExportReportWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_pdf_o__ = __webpack_require__("./node_modules/react-icons/lib/fa/file-pdf-o.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_pdf_o___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_pdf_o__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_spinner__ = __webpack_require__("./node_modules/react-icons/lib/fa/spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ExportReportWrapper_scss__ = __webpack_require__("./src/components/ExportReportWrapper/ExportReportWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ExportReportWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ExportReportWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import debug from '~/utils/macros/debug.macro';
// eslint-disable-next-line react/prefer-stateless-function
var ExportReportWrapper=function(_React$Component){_inherits(ExportReportWrapper,_React$Component);function ExportReportWrapper(){_classCallCheck(this,ExportReportWrapper);return _possibleConstructorReturn(this,(ExportReportWrapper.__proto__||Object.getPrototypeOf(ExportReportWrapper)).apply(this,arguments));}_createClass(ExportReportWrapper,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:Object(__WEBPACK_IMPORTED_MODULE_4_classcat__["default"])(['col col-sm-12',__WEBPACK_IMPORTED_MODULE_10__ExportReportWrapper_scss___default.a.cardHeader])},'Export Report'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Card"],{body:true,className:'p-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],{style:{height:'150px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],{sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Your report is ready to be generated. Click the button below to download the PDF.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{size:'md',disabled:this.props.loading,onClick:this.props.onDownloadPDF},Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* branch */])(this.props.loading,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_spinner___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_pdf_o___default.a,null)),'   ',Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* branch */])(this.props.loading,'Fetching Report','Generate Report'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Note: this may take some time to complete.'))))));}}]);return ExportReportWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ExportReportWrapper.defaultProps={};var mapStateToProps=function mapStateToProps(state){var reportData=Object(__WEBPACK_IMPORTED_MODULE_8__selectors_design__["h" /* getReportPDF */])(state);return{loading:reportData.loading};};function mapDispatchToProps(dispatch){return{onDownloadPDF:function onDownloadPDF(){return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions_design__["a" /* actions */].requestPDF());}};}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_2_recompose__["pure"]);/* harmony default export */ __webpack_exports__["a"] = (enhancer(ExportReportWrapper));

/***/ }),

/***/ "./src/components/ExportReportWrapper/ExportReportWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ExportReportWrapper__wrapper","cardHeader":"ExportReportWrapper__cardHeader"};

/***/ }),

/***/ "./src/components/ExportReportWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExportReportWrapper__ = __webpack_require__("./src/components/ExportReportWrapper/ExportReportWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ExportReportWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/FieldDropdown/FieldDropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set__ = __webpack_require__("./node_modules/lodash/set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__("./node_modules/debug/src/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RevertInput__ = __webpack_require__("./src/components/RevertInput/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}const _uid2=__WEBPACK_IMPORTED_MODULE_2_debug___default()('app:FieldDropdown');/**
 * 
 * @format
 */// import classes from './FieldDropdown.scss';
var FieldDropdown=function(_React$Component){_inherits(FieldDropdown,_React$Component);function FieldDropdown(props){_classCallCheck(this,FieldDropdown);// We need a better change handler to take care of multiple
var _this=_possibleConstructorReturn(this,(FieldDropdown.__proto__||Object.getPrototypeOf(FieldDropdown)).call(this,props));_this.onChangeHandler=function(e){// We need handle mutliple selects differently
// https://stackoverflow.com/a/1177618
if(!props.multiple){_this.props.changeInput(e);return;}// e.target.options[0].selected = false;
var values=[].concat(_toConsumableArray(e.target.options)).filter(function(o){return o.selected&&o.value!=='All';}).map(function(o){return o.value;});// If 'All' is selected only send that value
// selectedIndex is first selected in list
var index=e.target.options.selectedIndex;if(index===-1){// Nothing was selcted - send All
values=['All'];}else if(index===0&&values.length===0){// Only all was added to the selection
_uid2('all added to more selected');values=['All'];}else{_uid2('other',index,values.length);}_uid2(index,'props',props.value,'selected',values);//   // hackkkkkk
var o=__WEBPACK_IMPORTED_MODULE_1_lodash_set___default()({},'target.value',values);props.changeInput(o);};return _this;}// eslint-disable-line react/sort-comp
_createClass(FieldDropdown,[{key:'render',value:function render(){var options=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,'options',[]);var canRevert=this.props.changed||Object(__WEBPACK_IMPORTED_MODULE_5__utils__["g" /* deepDiffer */])(this.props.value,this.props.defaultVal);// debug(this.props.value, this.props.defaultVal);
var recommendedDiv=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RevertInput__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default.a.inputGroupDefault,value:this.props.defaultVal,enable:canRevert,onClick:this.props.revertInput});var _props=this.props,multiple=_props.multiple,value=_props.value;var nullFixVal=multiple&&value==null?[]:value;return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* branch */])(this.props.error.length===0,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:"7"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},this.props.fieldName)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},this.props.tooltip?this.props.tooltip:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["FormGroup"],{className:'mb-0',style:{flex:'1 1 auto'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Input"],{type:'select',name:'selectMulti',onChange:this.onChangeHandler,value:nullFixVal,multiple:multiple},options&&options.map(function(i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('option',{key:i,value:i},i);})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default.a.inputGroupColumn,style:{justifyContent:'flex-end'}},recommendedDiv),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,this.props.warning))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},this.props.fieldName,this.props.tooltip),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p',null,this.props.error),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'btn btn-link p-0',onClick:this.props.revertInput},'Clear previously selected package.')));}}]);return FieldDropdown;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);FieldDropdown.defaultProps={options:[],error:[],warning:[],fieldName:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null),multiple:false};/* harmony default export */ __webpack_exports__["a"] = (FieldDropdown);

/***/ }),

/***/ "./src/components/FieldDropdown/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldDropdown__ = __webpack_require__("./src/components/FieldDropdown/FieldDropdown.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FieldDropdown__["a" /* default */]);

/***/ }),

/***/ "./src/components/FieldMessage/FieldMessage.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import classes from './FieldMessage.scss';
var FieldMessage=function(_React$Component){_inherits(FieldMessage,_React$Component);function FieldMessage(){_classCallCheck(this,FieldMessage);return _possibleConstructorReturn(this,(FieldMessage.__proto__||Object.getPrototypeOf(FieldMessage)).apply(this,arguments));}_createClass(FieldMessage,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()([this.props.error,this.props.currentValue],[nextProps.error,nextProps.currentValue]);}},{key:'render',value:function render(){var _cc;var hasError=this.props.error.length>0;var content=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Card"],{className:Object(__WEBPACK_IMPORTED_MODULE_5_classcat__["default"])((_cc={},_defineProperty(_cc,__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default.a.card,true),_defineProperty(_cc,__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default.a.error,hasError),_defineProperty(_cc,__WEBPACK_IMPORTED_MODULE_8__FieldWrapper_FieldWrapper_scss___default.a.warning,typeof this.props.currentValue==='string'),_cc)),style:this.props.style},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],null,Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* branch */])(hasError,this.props.error,this.props.currentValue))));var message=this.props.currentValue||'';return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* branch */])(hasError||message.length>0,content);}}]);return FieldMessage;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);FieldMessage.defaultProps={currentValue:'',style:{},error:[]};function mapStateToProps(state,ownProps){var values=Object(__WEBPACK_IMPORTED_MODULE_7__selectors_design__["f" /* getFieldValues */])(state);var fieldErrors=Object(__WEBPACK_IMPORTED_MODULE_7__selectors_design__["e" /* getFieldErrors */])(state);var data=values[ownProps.id];var error=fieldErrors[ownProps.id];return Object.assign({},ownProps,{currentValue:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(data,['currentValue']),error:error});}var connector=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(FieldMessage));

/***/ }),

/***/ "./src/components/FieldMessage/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldMessage__ = __webpack_require__("./src/components/FieldMessage/FieldMessage.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FieldMessage__["a" /* default */]);

/***/ }),

/***/ "./src/components/FieldRadioGroup/FieldRadioGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldRadioGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_toString__ = __webpack_require__("./node_modules/lodash/toString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_toString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_toString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RevertInput__ = __webpack_require__("./src/components/RevertInput/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldRadioGroup_scss__ = __webpack_require__("./src/components/FieldRadioGroup/FieldRadioGroup.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldRadioGroup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FieldRadioGroup_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable react/no-multi-comp */var FormGroupInput=function(_React$PureComponent){_inherits(FormGroupInput,_React$PureComponent);function FormGroupInput(){_classCallCheck(this,FormGroupInput);return _possibleConstructorReturn(this,(FormGroupInput.__proto__||Object.getPrototypeOf(FormGroupInput)).apply(this,arguments));}_createClass(FormGroupInput,[{key:'render',// shouldComponentUpdate(nextProps: FGPropsType) {
//   console.log(nextProps);
// }
value:function render(){var _props=this.props,value=_props.value,checked=_props.checked,onChange=_props.onChange,name=_props.name;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],{check:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{check:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'radio',value:value,checked:checked,onChange:onChange}),' ',Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* createHTMLMarkup */])(name)));}}]);return FormGroupInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);var FieldRadioGroup=function(_React$PureComponent2){_inherits(FieldRadioGroup,_React$PureComponent2);function FieldRadioGroup(){_classCallCheck(this,FieldRadioGroup);return _possibleConstructorReturn(this,(FieldRadioGroup.__proto__||Object.getPrototypeOf(FieldRadioGroup)).apply(this,arguments));}_createClass(FieldRadioGroup,[{key:'render',value:function render(){var _this3=this;var hasError=this.props.error.length>0;var ref=this;var options=this.props.options.map(function(opt){var checked=__WEBPACK_IMPORTED_MODULE_0_lodash_toString___default()(opt.key)===__WEBPACK_IMPORTED_MODULE_0_lodash_toString___default()(ref.props.value);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FormGroupInput,{key:opt.key,value:opt.key,checked:checked,onChange:ref.props.changeInput,name:opt.name||opt.display});});var canRevert=this.props.changed||this.props.value!==this.props.defaultVal;var getRevertNameFromValue=function getRevertNameFromValue(){var val=_this3.props.defaultVal;var opt=_this3.props.options.find(function(i){return i.key===val;});if(!opt)return val;return opt.display||opt.name||val;};var recommendedDiv=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RevertInput__["a" /* default */],{className:__WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss___default.a.inputGroupDefault,value:getRevertNameFromValue(),enable:canRevert,onClick:this.props.revertInput});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{sm:"7"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex'},this.props.fieldName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss___default.a.infoIconWrapper},this.props.tooltip),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],{tag:'fieldset',className:__WEBPACK_IMPORTED_MODULE_6__FieldRadioGroup_scss___default.a.formGroup},options,Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* branch */])(hasError,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss___default.a.errorBlock},'Error: ',this.props.error)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7__FieldWrapper_FieldWrapper_scss___default.a.inputGroupColumn},recommendedDiv))));}}]);return FieldRadioGroup;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);FieldRadioGroup.defaultProps={options:[],error:[],tooltip:null};/* harmony default export */ __webpack_exports__["a"] = (FieldRadioGroup);

/***/ }),

/***/ "./src/components/FieldRadioGroup/FieldRadioGroup.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"formGroup":"FieldRadioGroup__formGroup"};

/***/ }),

/***/ "./src/components/FieldRadioGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldRadioGroup__ = __webpack_require__("./src/components/FieldRadioGroup/FieldRadioGroup.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FieldRadioGroup__["a" /* default */]);

/***/ }),

/***/ "./src/components/FieldStacked/FieldStacked.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldStacked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputField__ = __webpack_require__("./src/components/InputField/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldStacked_scss__ = __webpack_require__("./src/components/FieldStacked/FieldStacked.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldStacked_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FieldStacked_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';
// import debug from '~/utils/macros/debug.macro';
var FieldStacked=function(_React$Component){_inherits(FieldStacked,_React$Component);function FieldStacked(){_classCallCheck(this,FieldStacked);return _possibleConstructorReturn(this,(FieldStacked.__proto__||Object.getPrototypeOf(FieldStacked)).apply(this,arguments));}_createClass(FieldStacked,[{key:'shouldComponentUpdate',// eslint-disable-line react/sort-comp
value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(this.props.value,nextProps.value);}},{key:'render',value:function render(){var _this2=this;// debug(this.props);
var style={height:'2rem',display:'flex'};// <div className={fieldWrapperClasses.infoIconWrapper}>
//   {this.props.tooltip}
// </div>
var fieldNames=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(this.props.value,function(f,i){var stackTip=_this2.props.tooltip&&Array.isArray(_this2.props.tooltip)&&_this2.props.tooltip[i]?_this2.props.tooltip[i]:null;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h5',{key:f[0],style:style},Object(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* createHTMLMarkup */])(f[0]),stackTip);});var fieldInputs=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(this.props.value,function(f){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InputField__["a" /* default */],{className:Object(__WEBPACK_IMPORTED_MODULE_4_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_8__FieldStacked_scss___default.a.inputGroup]),key:f[0],value:f[1],readOnly:true,type:'text',unit:f[2]});});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],{sm:"7",className:__WEBPACK_IMPORTED_MODULE_8__FieldStacked_scss___default.a.subHeader},fieldNames),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8__FieldStacked_scss___default.a.flexCol},fieldInputs)));}}]);return FieldStacked;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);FieldStacked.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (FieldStacked);

/***/ }),

/***/ "./src/components/FieldStacked/FieldStacked.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flexCol":"FieldStacked__flexCol","inputGroup":"FieldStacked__inputGroup","subHeader":"FieldStacked__subHeader"};

/***/ }),

/***/ "./src/components/FieldStacked/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldStacked__ = __webpack_require__("./src/components/FieldStacked/FieldStacked.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FieldStacked__["a" /* default */]);

/***/ }),

/***/ "./src/components/FieldTypeInput/FieldTypeInput.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldTypeInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_isNumber__ = __webpack_require__("./node_modules/lodash/fp/isNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_every__ = __webpack_require__("./node_modules/lodash/fp/every.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit__ = __webpack_require__("./node_modules/lodash/fp/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RevertInput__ = __webpack_require__("./src/components/RevertInput/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputField__ = __webpack_require__("./src/components/InputField/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import classes from './FieldTypeInput.scss';
var SIZE=12-+"7";// eslint-disable-next-line react/prefer-stateless-function
var FieldTypeInput=function(_React$Component){_inherits(FieldTypeInput,_React$Component);function FieldTypeInput(){_classCallCheck(this,FieldTypeInput);return _possibleConstructorReturn(this,(FieldTypeInput.__proto__||Object.getPrototypeOf(FieldTypeInput)).apply(this,arguments));}_createClass(FieldTypeInput,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var subProps=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_omit___default()(['tooltip']);return!Object(__WEBPACK_IMPORTED_MODULE_6__utils__["s" /* shallowEqual */])(subProps(this.props),subProps(nextProps));}},{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var _props=this.props,error=_props.error,defaultVal=_props.defaultVal,value=_props.value,changed=_props.changed,range=_props.range,type=_props.type,calculated=_props.calculated,unit=_props.unit,step=_props.step,revertInput=_props.revertInput,changeInput=_props.changeInput;var canRevert=changed||value!==defaultVal;var rangeDiv=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{disabled:true,className:Object(__WEBPACK_IMPORTED_MODULE_4_classcat__["default"])(['btn','btn-link','btn-sm','disabled']),style:{cursor:'inherit'}},'Range: ['+range[0]+', '+range[1]+']');var recommendedDiv=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RevertInput__["a" /* default */],{value:defaultVal,enable:canRevert,onClick:revertInput});var errorDiv=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.errorBlock},'Error: ',error);// const differs = defaultValue !== currentValue;
var hasError=error.length>0;var areAllNumbers=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_every___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_isNumber___default.a);var hasRange=areAllNumbers(range)&&!calculated;// Input DateTime
// https://stackoverflow.com/a/19012837
// min=0 : only positive numbers
// step any allows any number of decimal places
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{sm:SIZE},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.infoIconWrapper},this.props.tooltip),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__InputField__["a" /* default */],{value:value,readOnly:calculated,type:type,step:step,onChange:changeInput,unit:unit})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.inputGroupColumn},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.inputGroupStyle},Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* branch */])(hasRange,rangeDiv)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.inputGroupStyle},Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* branch */])(!calculated,recommendedDiv))),Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* branch */])(hasError,errorDiv));}}]);return FieldTypeInput;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);FieldTypeInput.defaultProps={range:[1,2],error:[],tooltip:null};/* harmony default export */ __webpack_exports__["a"] = (FieldTypeInput);

/***/ }),

/***/ "./src/components/FieldTypeInput/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldTypeInput__ = __webpack_require__("./src/components/FieldTypeInput/FieldTypeInput.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FieldTypeInput__["a" /* default */]);

/***/ }),

/***/ "./src/components/FieldWrapper/FieldWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__("./node_modules/lodash/fp/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_every__ = __webpack_require__("./node_modules/lodash/every.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_tail__ = __webpack_require__("./node_modules/lodash/tail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_tail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_tail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString__ = __webpack_require__("./node_modules/lodash/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_camelCase__ = __webpack_require__("./node_modules/lodash/camelCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_error_boundary__ = __webpack_require__("./node_modules/react-error-boundary/dist/commonjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_error_boundary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_error_boundary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_question_circle__ = __webpack_require__("./node_modules/react-icons/lib/fa/question-circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_question_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_question_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HoverTooltip__ = __webpack_require__("./src/components/HoverTooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FieldTypeInput__ = __webpack_require__("./src/components/FieldTypeInput/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FieldRadioGroup__ = __webpack_require__("./src/components/FieldRadioGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__FieldStacked__ = __webpack_require__("./src/components/FieldStacked/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TableSelectionGroup__ = __webpack_require__("./src/components/TableSelectionGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TableGroup_PowerSemiLossSummary__ = __webpack_require__("./src/components/TableGroup/PowerSemiLossSummary.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TableGroup__ = __webpack_require__("./src/components/TableGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LargeTable__ = __webpack_require__("./src/components/LargeTable/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StackedGroup__ = __webpack_require__("./src/components/StackedGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FieldDropdown__ = __webpack_require__("./src/components/FieldDropdown/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__GraphGroup__ = __webpack_require__("./src/components/GraphGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var FieldWrapper=function(_React$Component){_inherits(FieldWrapper,_React$Component);_createClass(FieldWrapper,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var subProps=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['currentValue','defaultValue','dirty','error','isChanged','isEvaluating','rangeMax','rangeMin','shouldRender','warning','options']);return!__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default()(subProps(this.props),subProps(nextProps));}// eslint-disable-next-line react/sort-comp
}]);function FieldWrapper(props){_classCallCheck(this,FieldWrapper);var _this=_possibleConstructorReturn(this,(FieldWrapper.__proto__||Object.getPrototypeOf(FieldWrapper)).call(this,props));_this.onChange=props.onChangeHandler(props.id);_this.onRevert=function(){props.onRevertHandler(props.id);};return _this;}_createClass(FieldWrapper,[{key:'render',value:function render(){var _this2=this,_cardClasses;var _props=this.props,currentValue=_props.currentValue,defaultValue=_props.defaultValue,isChanged=_props.isChanged,isEvaluating=_props.isEvaluating,lastValue=_props.lastValue,rangeMin=_props.rangeMin,rangeMax=_props.rangeMax,dirty=_props.dirty,error=_props.error,warning=_props.warning;var data=this.props.data;// Break this render early if the deps aren't met.
if(!this.props.shouldRender){return null;}var type=data.type?data.type:'number';var step=data.step?data.step:'any';// const isLoading = (isEvaluating && errors.length === 0);
var isLoading=false;var isDirty=dirty!==undefined;var isCalculated=data.calculated;var isModified=isChanged&&!isDirty&&!isCalculated;var isTable=type==='table';var isSelectTable=type==='selecttable';// const differs = defaultValue !== currentValue;
var hasError=error.length>0;var hasWarning=warning.length>0;var markupName=Object(__WEBPACK_IMPORTED_MODULE_14__utils__["e" /* createHTMLMarkup */])(data.name);var fieldName=data.name?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h5',null,markupName):'';// debug(changed, dirty, isModified, differs);
var tooltip=null;if(Array.isArray(data.tooltip)){tooltip=data.tooltip.map(function(t,i){if(!t)return null;var title=__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(_this2.props,['currentValue',''+(i+1),'0'],'');return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__HoverTooltip__["a" /* default */],{key:_this2.props.id+'-'+__WEBPACK_IMPORTED_MODULE_4_lodash_camelCase___default()(title),id:_this2.props.id+'-'+__WEBPACK_IMPORTED_MODULE_4_lodash_camelCase___default()(title),title:Object(__WEBPACK_IMPORTED_MODULE_14__utils__["e" /* createHTMLMarkup */])(title)// text={createHTMLMarkup(data.tooltip[i])}
,text:Object(__WEBPACK_IMPORTED_MODULE_14__utils__["e" /* createHTMLMarkup */])(t)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_question_circle___default.a,{className:__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.infoIcon,size:24}));});}else{tooltip=Object(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* branch */])(__WEBPACK_IMPORTED_MODULE_3_lodash_isString___default()(data.tooltip),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__HoverTooltip__["a" /* default */],{id:this.props.id,title:markupName,text:Object(__WEBPACK_IMPORTED_MODULE_14__utils__["e" /* createHTMLMarkup */])(data.tooltip)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_question_circle___default.a,{className:__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.infoIcon,size:24})),null);}var width=this.props.id==='SemiconLossSummaryTable'?6:"7";var leftCol=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["Col"],{sm:width,className:'d-flex'},fieldName,Object(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* branch */])(!['number','text','stack'].includes(type),tooltip));var isATable=isSelectTable||isTable;var cardClasses=(_cardClasses={},_defineProperty(_cardClasses,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.error,hasError),_defineProperty(_cardClasses,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.warning,hasWarning),_defineProperty(_cardClasses,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.changed,isDirty||isLoading),_cardClasses);if(!isATable){var _Object$assign;cardClasses=Object.assign({},cardClasses,(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.calculated,isCalculated),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.success,isModified&&!isLoading),_Object$assign));}// hack
if(type==='largetable'){var _Object$assign2;cardClasses=Object.assign({},cardClasses,(_Object$assign2={},_defineProperty(_Object$assign2,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.error,hasError||hasWarning),_defineProperty(_Object$assign2,__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.warning,null),_Object$assign2));}var isSummaryTable=this.props.id==='SemiconLossSummaryTable';var hasLeftCol=!isSummaryTable&&!isATable&&!['dropdown','graph','fieldstack','stack','radio','largetable'].includes(type);var padClass=isSelectTable||type==='largetable'||isSummaryTable?'p-0':'';var borderHackFix=type==='graph'||isSummaryTable?'border-0':'';// if (hasError) console.log(dirty, currentValue, this.props.lastValue);
// Sometimes an error field doesn't show a new value (shows 0) so
// we have to keep track of the last value we recieved.
var displayValue=hasError?lastValue:currentValue;var rightCol=function rightCol(){if(type==='number'||type==='text'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__FieldTypeInput__["a" /* default */],{id:_this2.props.id,value:displayValue,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,range:[rangeMin,rangeMax],calculated:isCalculated||false,unit:data.unit,step:step,revertInput:_this2.onRevert,changeInput:_this2.onChange,type:type,tooltip:tooltip});}if(type==='stack'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__StackedGroup__["a" /* default */],{calculated:isCalculated||false,value:displayValue,tooltip:tooltip,fieldName:fieldName});}if(type==='graph'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__GraphGroup__["a" /* default */],{id:_this2.props.id,chartName:data.name});}if(type==='radio'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__FieldRadioGroup__["a" /* default */],{value:displayValue,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,fieldName:fieldName,revertInput:_this2.onRevert,changeInput:_this2.onChange,options:_this2.props.data.options,tooltip:tooltip});}if(type==='dropdown'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FieldDropdown__["a" /* default */],{value:displayValue,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,revertInput:_this2.onRevert,changeInput:_this2.onChange,options:_this2.props.options,fieldName:fieldName,tooltip:tooltip,multiple:_this2.props.data.multiple});}if(isSelectTable){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TableSelectionGroup__["a" /* default */],{id:_this2.props.id,name:fieldName,tooltip:tooltip,value:displayValue,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,dataTarget:data.data,revertInput:_this2.onRevert,changeInput:_this2.onChange,options:data.options});}if(_this2.props.id==='SemiconLossSummaryTable'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TableGroup_PowerSemiLossSummary__["a" /* default */],{id:_this2.props.id,value:displayValue,fieldName:fieldName,tooltip:tooltip,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,dataTarget:data.data,revertInput:_this2.onRevert,changeInput:_this2.onChange,options:data.options});}if(type==='fieldstack'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__FieldStacked__["a" /* default */],{id:_this2.props.id// $FlowFixMe
,value:__WEBPACK_IMPORTED_MODULE_2_lodash_tail___default()(displayValue),unit:data.unit,fieldName:fieldName,type:type,tooltip:tooltip,readOnly:isCalculated||false});}if(isTable){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TableGroup__["a" /* default */],{id:_this2.props.id,value:displayValue,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,dataTarget:data.data,revertInput:_this2.onRevert,changeInput:_this2.onChange,options:data.options});}if(type==='largetable'){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__LargeTable__["a" /* default */],{id:_this2.props.id,value:displayValue,defaultVal:defaultValue,changed:isChanged,evaluating:isEvaluating,error:error,warning:warning,revertInput:_this2.onRevert,changeInput:_this2.onChange,options:_this2.props.options,fieldName:fieldName,tooltip:tooltip});}return null;};return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_error_boundary___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["Card"],{id:this.props.id,className:Object(__WEBPACK_IMPORTED_MODULE_11_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_27__FieldWrapper_scss___default.a.card,cardClasses,padClass,borderHackFix]),style:this.props.style},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["Row"],null,Object(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* branch */])(hasLeftCol,leftCol),rightCol())));}}]);return FieldWrapper;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);FieldWrapper.defaultProps={error:[],warning:[],data:{type:'',step:'',calculated:false},onChangeHandler:function onChangeHandler(){},onRevertHandler:function onRevertHandler(){},style:{}};function mapStateToProps(state,ownProps){var values=__WEBPACK_IMPORTED_MODULE_15__selectors_design__["f" /* getFieldValues */](state);var changedValues=__WEBPACK_IMPORTED_MODULE_15__selectors_design__["a" /* getChangedFields */](state);var dirtyValues=__WEBPACK_IMPORTED_MODULE_15__selectors_design__["c" /* getDirtyFields */](state);var fieldErrors=__WEBPACK_IMPORTED_MODULE_15__selectors_design__["e" /* getFieldErrors */](state);var fieldEvaulating=__WEBPACK_IMPORTED_MODULE_15__selectors_design__["d" /* getEvaluatingFields */](state);var fieldWarnings=__WEBPACK_IMPORTED_MODULE_15__selectors_design__["g" /* getFieldWarnings */](state);var data=values[ownProps.id];var dirty=dirtyValues[ownProps.id];var isEvaluating=Boolean(fieldEvaulating[ownProps.id]);var isChanged=Boolean(changedValues[ownProps.id]);var error=fieldErrors[ownProps.id];var warning=fieldWarnings[ownProps.id];// catch any radio buttons depending on other lists
// TODO: hacky - should prob fix this at some point? maybe in reducer?
var currentValue=__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(data,['currentValue']);var defaultValue=__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(data,['defaultValue']);var options=ownProps.data.options;var target=ownProps.data.dataTarget;if(target){options=currentValue;// eslint-disable-next-line prefer-destructuring
currentValue=values[target].currentValue;// eslint-disable-next-line prefer-destructuring
defaultValue=values[target].defaultValue;// be sure and catch any dataTarget messages and show them!
if(fieldWarnings[target]){warning=fieldWarnings[target];}if(fieldErrors[target]){error=fieldErrors[target];}/*
     * ONS#1034241
     * Edge case for Losscom_FET table - needs error instead of warning here.
     */if(target==='PN_sel_fet'){error=fieldWarnings[ownProps.id]||fieldErrors[ownProps.id];warning=[];}}if(ownProps.data.type==='stack'){// Handle adding quantity to the FET count
var quantity=values.Num_pll_fet.currentValue;var fields=__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(ownProps,['data','fields'],[]);// $FlowIgnore
currentValue=fields.map(function(_ref){var id=_ref.id,unit=_ref.unit,name=_ref.name;var val=values[id].currentValue;if(id==='SelectedMOSFET'){val=val+'\tQty = '+quantity;}return[id,val,unit,name];});}// check any field dependancies
var shouldRender=true;var deps=__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(ownProps,['data','dependancies']);if(deps){shouldRender=__WEBPACK_IMPORTED_MODULE_1_lodash_every___default()(deps,function(value,key){var fieldValue=__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(values,[key,'currentValue']);return fieldValue===value;});}return Object.assign({},ownProps,{rangeMin:__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(data,['rangeValue','min']),rangeMax:__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(data,['rangeValue','max']),options:options,dirty:dirty,isEvaluating:isEvaluating,isChanged:isChanged,error:error,warning:warning,shouldRender:shouldRender,currentValue:currentValue,defaultValue:defaultValue,lastValue:__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(state.design.lastValues[ownProps.id],['currentValue'])});}var connector=Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(Object(__WEBPACK_IMPORTED_MODULE_9_recompose__["pure"])(FieldWrapper)));

/***/ }),

/***/ "./src/components/FieldWrapper/FieldWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"FieldWrapper__card","inputGroupColumn":"FieldWrapper__inputGroupColumn","inputGroupDefault":"FieldWrapper__inputGroupDefault","inputGroupStyle":"FieldWrapper__inputGroupStyle","calculated":"FieldWrapper__calculated","changed":"FieldWrapper__changed","success":"FieldWrapper__success","error":"FieldWrapper__error","warning":"FieldWrapper__warning","errorBlock":"FieldWrapper__errorBlock","infoIconWrapper":"FieldWrapper__infoIconWrapper","infoIcon":"FieldWrapper__infoIcon"};

/***/ }),

/***/ "./src/components/FieldWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldWrapper__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FieldWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/FileManagement/FileManagement.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileManagement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_edit__ = __webpack_require__("./node_modules/react-icons/lib/fa/edit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_copy__ = __webpack_require__("./node_modules/react-icons/lib/fa/copy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_trash__ = __webpack_require__("./node_modules/react-icons/lib/fa/trash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/prefer-stateless-function */// $FlowIgnore
// import debug from '~/utils/macros/debug.macro';
// import classes from './FileManagement.scss';
var FileManagement=function(_React$PureComponent){_inherits(FileManagement,_React$PureComponent);function FileManagement(){_classCallCheck(this,FileManagement);return _possibleConstructorReturn(this,(FileManagement.__proto__||Object.getPrototypeOf(FileManagement)).apply(this,arguments));}_createClass(FileManagement,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var _this2=this;var listGroups=Array.from(this.props.data).map(function(_ref,i){var _ref2=_slicedToArray(_ref,2),id=_ref2[0],record=_ref2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'link',style:{cursor:'pointer'},tabIndex:i,onClick:function onClick(){return _this2.props.onHandleClick(id);}},record.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'small',style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(record.timestamp,'MMM DD, YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["ButtonGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Button"],{size:'sm',title:'Rename design',color:'warning',onClick:function onClick(){return _this2.props.onHandleRename(id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_edit___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Button"],{size:'sm',title:'Copy design',color:'info',onClick:function onClick(){return _this2.props.onHandleCopy(id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_copy___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Button"],{size:'sm',title:'Delete design',color:'danger',onClick:function onClick(){return _this2.props.onHandleDelete(id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_trash___default.a,null)))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Table"],{className:'small',striped:true,responsive:true,hover:true,size:'sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,listGroups));}}]);return FileManagement;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);// function mapStateToProps(state) {
//   const error = state.global.records.error || '';
//   const { loading, current, data } = state.global.records;
//   return {
//     loading,
//     error,
//     currentId: current,
//     data,
//   };
// }
/* unused harmony default export */ var _unused_webpack_default_export = (FileManagement);

/***/ }),

/***/ "./src/components/Footer/Footer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Footer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__("./node_modules/react-ga/dist/react-ga.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_scss__ = __webpack_require__("./src/components/Footer/Footer.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable max-len */var env="production";var commit="865943b97b";var Footer=function(_React$Component){_inherits(Footer,_React$Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return false;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{className:__WEBPACK_IMPORTED_MODULE_3__Footer_scss___default.a.footer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mb-0'},"Boost Powertrain"+' v'+"1.3.5"+' ('+env+'#'+commit+')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA9 '+"2017"+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_ga__["OutboundLink"],{eventLabel:'homepage',to:''+"https://onsemi.com",style:{color:'inherit',textDecoration:'underline'}},''+"ON Semiconductor")));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ "./src/components/Footer/Footer.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer"};

/***/ }),

/***/ "./src/components/Footer/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__("./src/components/Footer/Footer.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]);

/***/ }),

/***/ "./src/components/GraphGroup/GraphGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GraphGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit__ = __webpack_require__("./node_modules/lodash/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__ = __webpack_require__("./node_modules/lodash/pickBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase__ = __webpack_require__("./node_modules/lodash/startCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_mapKeys__ = __webpack_require__("./node_modules/lodash/mapKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_mapValues__ = __webpack_require__("./node_modules/lodash/mapValues.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChartLineGraph__ = __webpack_require__("./src/components/ChartLineGraph/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import cc from 'classcat';
// import classes from './GraphGroup.scss';
var area=[{name:'CCM',inside:true,style:{fill:'lightyellow'}},{name:'DCM',inside:false,style:{fill:'aquamarine'}}];var GraphGroup=function(_React$Component){_inherits(GraphGroup,_React$Component);function GraphGroup(){_classCallCheck(this,GraphGroup);return _possibleConstructorReturn(this,(GraphGroup.__proto__||Object.getPrototypeOf(GraphGroup)).apply(this,arguments));}_createClass(GraphGroup,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* deepDiffer */])(this.props,nextProps);}},{key:'render',value:function render(){// Handle null data condition
if(!this.props.data)return null;var _props=this.props,_props$data=_props.data,chartInfo=_props$data.chartInfo,chartMarker=_props$data.chartMarker,chartName=_props.chartName;var chartData=this.props.data.chartData;// trim any negaive indexes
var critLoad=chartData['critical load']||[];var negativeIndex=critLoad.findIndex(function(i){return i<0;});if(negativeIndex){chartData=__WEBPACK_IMPORTED_MODULE_4_lodash_mapValues___default()(chartData,function(a){return a.slice(0,negativeIndex);});}var info={y1:'Current (A)','y1.legend':chartInfo.y,x:chartInfo.x};var data=__WEBPACK_IMPORTED_MODULE_3_lodash_mapKeys___default()(chartData,function(v,k){return __WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default()(k);});data['Max Load']=Array(data.Unit.length).fill(chartMarker['max load']);var marker=__WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default()(chartMarker,function(v){return v!==0;});marker=__WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(marker,'max load');return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ChartLineGraph__["a" /* default */],{className:'svg-content',aspectRatio:'xMaxYMax',chartData:data,chartInfo:info,chartMarker:marker,height:null,width:null,chartArea:area,viewBox:{x:0,y:0,width:550,height:325},resize:true,legend:'horizontal'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('strong',null,chartName)));}}]);return GraphGroup;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);GraphGroup.defaultProps={chartName:'Untitled Graph',data:{chartData:{Unit:[],'Critical Load':[]},chartInfo:{},chartMarker:{}}};function mapStateToProps(state,ownProps){return Object.assign({},ownProps,{data:state.global.critChart});}var connector=Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(GraphGroup));

/***/ }),

/***/ "./src/components/GraphGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphGroup__ = __webpack_require__("./src/components/GraphGroup/GraphGroup.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__GraphGroup__["a" /* default */]);

/***/ }),

/***/ "./src/components/GraphRowPaderator/GraphRowPaderator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GraphRowPaderator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("./node_modules/lodash/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("./src/utils/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable class-methods-use-this */// import debug from '~/utils/macros/debug.macro';
// import classes from './GraphRowPaderator.scss';
var GraphRowPaderator=function(_React$Component){_inherits(GraphRowPaderator,_React$Component);_createClass(GraphRowPaderator,[{key:'onResizeOrScroll',value:function onResizeOrScroll(){window.requestAnimationFrame(this.calculatePadding);}},{key:'calculatePadding',value:function calculatePadding(){var target=document.getElementById(this.props.target);var graphTarget=document.getElementById(this.props.graphTarget);if(!target||!graphTarget)return;var targetOffset=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["j" /* getPosition */])(target);var graphOffset=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["j" /* getPosition */])(graphTarget);var offset=graphOffset.y-targetOffset.y-target.clientHeight;// $FlowIgnore
this.node.style.paddingTop=offset+'px';}}]);function GraphRowPaderator(){_classCallCheck(this,GraphRowPaderator);var _this=_possibleConstructorReturn(this,(GraphRowPaderator.__proto__||Object.getPrototypeOf(GraphRowPaderator)).call(this));_this.node=null;_this.timerHandle=null;_this.onResizeOrScroll=_this.onResizeOrScroll.bind(_this);_this.calculatePadding=_this.calculatePadding.bind(_this);_this.onResizeOrScroll=__WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(_this.onResizeOrScroll,100);return _this;}_createClass(GraphRowPaderator,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timerHandle=setTimeout(function(){_this2.calculatePadding();if(typeof window!=='undefined'){window.addEventListener('resize',_this2.onResizeOrScroll);window.addEventListener('scroll',_this2.onResizeOrScroll);}},250);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.calculatePadding();}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.timerHandle!==null)clearTimeout(this.timerHandle);window.removeEventListener('resize',this.onResizeOrScroll);window.removeEventListener('scroll',this.onResizeOrScroll);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-none d-lg-block',ref:function ref(c){if(!c)return;_this3.node=c;}})));}}]);return GraphRowPaderator;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);GraphRowPaderator.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (GraphRowPaderator);

/***/ }),

/***/ "./src/components/GraphRowPaderator/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphRowPaderator__ = __webpack_require__("./src/components/GraphRowPaderator/GraphRowPaderator.js");
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__GraphRowPaderator__["a" /* default */]);

/***/ }),

/***/ "./src/components/Header/Header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__("./node_modules/react-ga/dist/react-ga.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_onsemifcslogo_svg__ = __webpack_require__("./src/images/onsemifcslogo.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_onsemifcslogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_onsemifcslogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_pswlogo_svg__ = __webpack_require__("./src/images/pswlogo.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_pswlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_pswlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StepProgressBar__ = __webpack_require__("./src/components/StepProgressBar/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DesignToolBar__ = __webpack_require__("./src/components/DesignToolBar/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header_scss__ = __webpack_require__("./src/components/Header/Header.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Header_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var Header=function(_PureComponent){_inherits(Header,_PureComponent);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:'render',value:function render(){var _props=this.props,title=_props.title,showMenu=_props.showMenu,toggle=_props.toggle;var userName=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,['currentUser','username']);var userNameLink=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavLink"],{style:{color:'lightgray'}},userName));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_10__Header_scss___default.a.navSticky},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Navbar"],{color:'dark',expand:'md',dark:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavbarBrand"],{href:'/',className:__WEBPACK_IMPORTED_MODULE_10__Header_scss___default.a.brand},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'d-none d-lg-inline-flex',alt:'ON Semi',height:40,width:120,src:__WEBPACK_IMPORTED_MODULE_6__images_onsemifcslogo_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'d-none d-lg-inline-flex',alt:'PS WebDesigner',height:40,width:220,src:__WEBPACK_IMPORTED_MODULE_7__images_pswlogo_svg___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavbarBrand"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-text inverse',style:{color:'lightgray'}},title)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavbarToggler"],{onClick:toggle}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Collapse"],{isOpen:showMenu,navbar:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Nav"],{className:'ml-auto',navbar:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_ga__["OutboundLink"],{to:"/design/boost-api/feedback.html",target:'_blank',rel:'noopener noreferrer',eventLabel:'feedback',className:'nav-link',style:{color:'lightyellow'}},'Feedback')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_ga__["OutboundLink"],{eventLabel:'legal',to:"/PowerSolutions/content.do?id=1108",className:'nav-link',style:{color:'lightgray'}},'Legal')),Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* branch */])(userName.length>0,userNameLink),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_ga__["OutboundLink"],{eventLabel:'logout',to:"/PowerSolutions/myon/logout.do",className:'nav-link',style:{color:'lightgray'}},'Logout'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DesignToolBar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StepProgressBar__["a" /* default */],null));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);// const mapStateToProps = (/* state: AppStateType*/) => ({});
// const connector = connect(mapStateToProps);
Header.defaultProps={title:'Base Design Tool',currentUser:{username:''},showMenu:false};var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withState"])('showMenu','setMenu',false),// connector,
Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withHandlers"])({toggle:function toggle(_ref){var setMenu=_ref.setMenu,showMenu=_ref.showMenu;return function(){return setMenu(!showMenu);};}}),__WEBPACK_IMPORTED_MODULE_2_recompose__["pure"]);/* harmony default export */ __webpack_exports__["a"] = (enhancer(Header));

/***/ }),

/***/ "./src/components/Header/Header.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navSticky":"Header__navSticky","brand":"Header__brand"};

/***/ }),

/***/ "./src/components/Header/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__("./src/components/Header/Header.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Header__["a" /* default */]);

/***/ }),

/***/ "./src/components/HoverTooltip/HoverTooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HoverTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HoverTooltip_scss__ = __webpack_require__("./src/components/HoverTooltip/HoverTooltip.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HoverTooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HoverTooltip_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var HoverTooltip=function(_React$Component){_inherits(HoverTooltip,_React$Component);function HoverTooltip(){_classCallCheck(this,HoverTooltip);return _possibleConstructorReturn(this,(HoverTooltip.__proto__||Object.getPrototypeOf(HoverTooltip)).apply(this,arguments));}_createClass(HoverTooltip,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return this.props.showTooltip!==nextProps.showTooltip;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-flex ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'popover-'+this.props.id,onMouseEnter:this.props.showTip,onMouseLeave:this.props.hideTip},this.props.children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Popover"],{placement:'right',isOpen:this.props.showTooltip,target:'popover-'+this.props.id,toggle:this.props.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PopoverHeader"],{className:__WEBPACK_IMPORTED_MODULE_3__HoverTooltip_scss___default.a.header},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PopoverBody"],{className:__WEBPACK_IMPORTED_MODULE_3__HoverTooltip_scss___default.a.body},this.props.text)));}}]);return HoverTooltip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);HoverTooltip.defaultProps={children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)};var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withStateHandlers"])({showTooltip:false},{toggle:function toggle(_ref){var showTooltip=_ref.showTooltip;return function(){return{showTooltip:!showTooltip};};},showTip:function showTip(){return function(){return{showTooltip:true};};},hideTip:function hideTip(){return function(){return{showTooltip:false};};}}));/* harmony default export */ __webpack_exports__["a"] = (enhancer(HoverTooltip));

/***/ }),

/***/ "./src/components/HoverTooltip/HoverTooltip.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"HoverTooltip__header"};

/***/ }),

/***/ "./src/components/HoverTooltip/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HoverTooltip__ = __webpack_require__("./src/components/HoverTooltip/HoverTooltip.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__HoverTooltip__["a" /* default */]);

/***/ }),

/***/ "./src/components/InputField/InputField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__("./node_modules/lodash/isNil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("./node_modules/lodash/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("./src/utils/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import cc from 'classcat';
// import classes from './InputField.scss';
// import debug from '~/utils/macros/debug.macro';
var InputField=function(_React$PureComponent){_inherits(InputField,_React$PureComponent);function InputField(){_classCallCheck(this,InputField);return _possibleConstructorReturn(this,(InputField.__proto__||Object.getPrototypeOf(InputField)).apply(this,arguments));}_createClass(InputField,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var _props=this.props,value=_props.value,readOnly=_props.readOnly,type=_props.type,step=_props.step,onChange=_props.onChange,unit=_props.unit,style=_props.style,className=_props.className;var renderUnit=function renderUnit(){return __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(unit)?Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* createHTMLMarkup */])(unit):unit;};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["InputGroup"],{style:style,className:className},Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* branch */])(value==='N/A',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Input"],{type:'text',value:value,disabled:readOnly}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Input"],{type:type,step:step||'any',min:0,value:value,disabled:readOnly,onChange:onChange})),Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* branch */])(!__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(unit),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["InputGroupAddon"],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'input-group-text'},renderUnit()))));}}]);return InputField;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);InputField.defaultProps={className:null,onChange:function onChange(){},readOnly:false,step:'any',type:'text',style:{}};/* harmony default export */ __webpack_exports__["a"] = (InputField);

/***/ }),

/***/ "./src/components/InputField/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputField__ = __webpack_require__("./src/components/InputField/InputField.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InputField__["a" /* default */]);

/***/ }),

/***/ "./src/components/LargeTable/LargeTable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LargeTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_tail__ = __webpack_require__("./node_modules/lodash/fp/tail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_tail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_tail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_head__ = __webpack_require__("./node_modules/lodash/fp/head.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_text__ = __webpack_require__("./node_modules/react-icons/lib/fa/file-text.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LargeTable_scss__ = __webpack_require__("./src/components/LargeTable/LargeTable.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LargeTable_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LargeTable_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import { connect } from 'react-redux';
// import { getFieldValues } from '~/selectors/design';
// import type { Connector } from 'react-redux';
// import debug from '~/utils/macros/debug.macro';
// type ReduxType = {
//   rowData: string[][],
//   rowHeader: string[],
// };
// type PropsType = ReduxType & OwnPropsType;
var hashId=new __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* HashId */]();function generateDataSheetLink(part){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/PowerSolutions/supportDoc.do?type=Datasheets&part='+part,rel:'noopener noreferrer',target:'_blank'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_file_text___default.a,{style:{color:'black'}}));}function generateLink(part){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'/PowerSolutions/product.do?id='+part,rel:'noopener noreferrer',target:'_blank',style:{flex:1}},part),generateDataSheetLink(part));}var getHeader=function getHeader(str){switch(str){case'Configuration':return'Cfg';default:return str;}};var LargeTable=function(_React$Component){_inherits(LargeTable,_React$Component);function LargeTable(){_classCallCheck(this,LargeTable);return _possibleConstructorReturn(this,(LargeTable.__proto__||Object.getPrototypeOf(LargeTable)).apply(this,arguments));}_createClass(LargeTable,[{key:'render',// shouldComponentUpdate(nextProps: PropsType) {
//   const subProps = _.pick([
//     'changed',
//     'defaultVal',
//     'dirty',
//     'error',
//     'evaluating',
//     'rowData',
//     'warning',
//   ]);
//   return deepDiffer(subProps(this.props), subProps(nextProps));
// }
value:function render(){var _this2=this;var hasError=this.props.error.length>0;var hasWarning=this.props.warning.length>0;var errorOrWarning=function errorOrWarning(text){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'pt-2 pl-2 pr-2 d-flex'},_this2.props.fieldName,_this2.props.tooltip),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'pt-3 pb-3 pl-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,text)));};// Handle any errors for this field
if(hasError){return errorOrWarning(this.props.error);}if(hasWarning){return errorOrWarning(this.props.warning);}var rowHeader=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_head___default()(this.props.value);var rowData=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_tail___default()(this.props.value);if(!rowHeader)return null;var tHeader=rowHeader.map(function(s){var title=getHeader(s);if(title){title=title.replace(/\s@\s/g,'<br/>@&nbsp;');title=title.replace(/\)\smax/g,')<br/>max');// title = title.replace(/RDS/g, 'RDS<br />');
title=title.replace(/ID\scont/g,'ID&nbsp;cont');var index=title.lastIndexOf(' ');title=index===-1?title:title.slice(0,index)+'</br>'+title.slice(index+1);}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{className:'sticky-top',key:hashId.nextId()},Object(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* createHTMLMarkup */])(title)||__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'\xA0'));});var tRows=rowData.map(function(r,k){var id=hashId.nextId();return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',{key:id,className:Object(__WEBPACK_IMPORTED_MODULE_3_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_7__LargeTable_scss___default.a.partRow])},r.map(function(d,l){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',{key:hashId.encode(''+k+l)},l===0?generateLink(d):d);}));});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'pt-2 pl-2 pr-2 d-flex'},this.props.fieldName,this.props.tooltip),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7__LargeTable_scss___default.a.scrollable},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('table',{className:__WEBPACK_IMPORTED_MODULE_7__LargeTable_scss___default.a.tableFixed},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('thead',{className:'thead-inverse'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,tHeader)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tbody',null,tRows))));}}]);return LargeTable;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);// function mapStateToProps(
//   state: AppStateType,
//   ownProps: OwnPropsType,
// ): PropsType {
//   const values = getFieldValues(state);
//   const data: { currentValue: any } = values[ownProps.id];
//   const tableData: string[][] = data.currentValue || [[]];
//   return {
//     ...ownProps,
//     rowData: _.tail(tableData),
//     rowHeader: _.head(tableData),
//   };
// }
// const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);
LargeTable.defaultProps={rowHeader:[],rowData:[],error:[],warning:[]};/* harmony default export */ __webpack_exports__["a"] = (LargeTable);

/***/ }),

/***/ "./src/components/LargeTable/LargeTable.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tableFixed":"LargeTable__tableFixed","scrollable":"LargeTable__scrollable"};

/***/ }),

/***/ "./src/components/LargeTable/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LargeTable__ = __webpack_require__("./src/components/LargeTable/LargeTable.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LargeTable__["a" /* default */]);

/***/ }),

/***/ "./src/components/LazyImage/LazyImage.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LazyImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_every__ = __webpack_require__("./node_modules/lodash/every.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lazy__ = __webpack_require__("./node_modules/react-lazy/dist/module/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_lazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("./src/utils/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import classes from './LazyImage.scss';
// type StateType = {};
var LazyImage=function(_React$PureComponent){_inherits(LazyImage,_React$PureComponent);function LazyImage(){_classCallCheck(this,LazyImage);return _possibleConstructorReturn(this,(LazyImage.__proto__||Object.getPrototypeOf(LazyImage)).apply(this,arguments));}_createClass(LazyImage,[{key:'render',// eslint-disable-line react/sort-comp
/*
  constructor(props: PropsType) {
    super(props);
  }
  */value:function render(){return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* branch */])(this.props.shouldRender,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_lazy__["Lazy"],{key:this.props.file},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{className:'img-fluid',alt:'SubStep',src:"."+'/images/'+this.props.file})));}// state: StateType; // eslint-disable-line react/sort-comp
}]);return LazyImage;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);LazyImage.defaultProps={condition:{}};function mapStateToProps(state,ownProps){var values=Object(__WEBPACK_IMPORTED_MODULE_5__selectors_design__["f" /* getFieldValues */])(state);// check any field dependancies
var shouldRender=true;var deps=ownProps.condition;if(deps){shouldRender=__WEBPACK_IMPORTED_MODULE_1_lodash_every___default()(deps,function(value,key){var fieldValue=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(values,[key,'currentValue']);return fieldValue===value;});}return Object.assign({},ownProps,{shouldRender:shouldRender});}var connector=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(LazyImage));

/***/ }),

/***/ "./src/components/LazyImage/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyImage__ = __webpack_require__("./src/components/LazyImage/LazyImage.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LazyImage__["a" /* default */]);

/***/ }),

/***/ "./src/components/LeftToolBar/LeftToolBar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LeftToolBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__("./node_modules/lodash/fp/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_file__ = __webpack_require__("./node_modules/react-icons/lib/fa/file.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_pencil__ = __webpack_require__("./node_modules/react-icons/lib/fa/pencil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_pencil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_pencil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_cloud__ = __webpack_require__("./node_modules/react-icons/lib/fa/cloud.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_cloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_copy__ = __webpack_require__("./node_modules/react-icons/lib/fa/copy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_folder_open__ = __webpack_require__("./node_modules/react-icons/lib/fa/folder-open.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_folder_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_folder_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_file_text__ = __webpack_require__("./node_modules/react-icons/lib/fa/file-text.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_file_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_file_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("./src/utils/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import ContentEditable from 'react-simple-contenteditable';
// import classes from './LeftToolBar.scss';
var LeftToolBar=function(_React$Component){_inherits(LeftToolBar,_React$Component);function LeftToolBar(){_classCallCheck(this,LeftToolBar);return _possibleConstructorReturn(this,(LeftToolBar.__proto__||Object.getPrototypeOf(LeftToolBar)).apply(this,arguments));}_createClass(LeftToolBar,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var subProps=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['designName','disableOpen','disableRedo','disableSave']);return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* deepDiffer */])(subProps(this.props),subProps(nextProps));}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{title:'New Design',size:'sm',onClick:this.props.onNewDesign},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_file___default.a,null),' New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{title:'Manage Your Designs',size:'sm',onClick:this.props.onOpen,disabled:this.props.disableOpen},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_folder_open___default.a,null),' My Designs')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item'},Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* branch */])(this.props.isSavedDesign,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["ButtonGroup"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{size:'sm',title:'Save Design Changes',onClick:this.props.onUpdateDesign,disabled:this.props.disableUpdate},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_pencil___default.a,null),' Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{size:'sm',title:'Duplicate Current Design',onClick:function onClick(){return _this2.props.onDuplicateDesign(_this2.props.id);},disabled:this.props.disableSave},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_copy___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{size:'sm',title:'Save Current Design',onClick:this.props.onSave,disabled:this.props.disableSave},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_cloud___default.a,null),' Save As'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item align-self-center d-inline-flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_file_text___default.a,{style:{margin:'0 0.25rem 0.25rem 1rem'}}),this.props.designName||"Untitled Design"));}}]);return LeftToolBar;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);LeftToolBar.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (LeftToolBar);

/***/ }),

/***/ "./src/components/LeftToolBar/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeftToolBar__ = __webpack_require__("./src/components/LeftToolBar/LeftToolBar.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LeftToolBar__["a" /* default */]);

/***/ }),

/***/ "./src/components/LineGraph/LineGraph.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/LineGraph/LineGraph.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LineGraph */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__("./node_modules/lodash/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__("./node_modules/lodash/forEach.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values__ = __webpack_require__("./node_modules/lodash/values.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_noop__ = __webpack_require__("./node_modules/lodash/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flatten__ = __webpack_require__("./node_modules/lodash/flatten.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_size__ = __webpack_require__("./node_modules/lodash/size.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_omit__ = __webpack_require__("./node_modules/lodash/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__("./node_modules/debug/src/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3__ = __webpack_require__("./node_modules/d3/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_faux_dom__ = __webpack_require__("./node_modules/react-faux-dom/lib/ReactFauxDOM.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_faux_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_faux_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LineGraph_css__ = __webpack_require__("./src/components/LineGraph/LineGraph.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LineGraph_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__LineGraph_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}const _uid2=__WEBPACK_IMPORTED_MODULE_9_debug___default()('app:LineGraph');/**
 * 
 * @format
 */var FIELD_DOMAIN=['FWD Loss (W)','Hi-Side Modulation Signal','FWD Tj (°C)','Hi-Side IGBT/MOSFET Current (A)','Total Module Loss (W)','Thermal Resistance Limited by Ths (°C/W)','Max Allowable Case Temperature (°C)','IGBT/MOSFET Tj (°C)','Thermal Resistance Limited by Tj (°C/W)','IGBT/MOSFET Loss (W)','IGBT ΔTj-c','FWD ΔTj-c','IGBT/MOSFET Loss (W)','IGBT/MOSFET Tj (°C)'];var maxMarkerFields=['MaxTjDh','Max Tj','MaxTjigbt','Max Tj-D'];var meanMarkerFields=['MeanTjDh','Mean Tj','MeanTjigbt','Mean Tj-D'];// calculate the width of the text
var calculateTextWidth=function calculateTextWidth(keys){var textSize=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var canvas=document.createElement('canvas');var ctx=canvas.getContext('2d');if(ctx){ctx.font=textSize+'px Arial';if(typeof keys==='string'){return ctx.measureText(keys).width;}return keys.reduce(function(ret,str){var len=ctx.measureText(str).width;if(len>ret)return len;return ret;},0);}return 0;};var LineGraph=function(_React$Component){_inherits(LineGraph,_React$Component);_createClass(LineGraph,[{key:'onResize',value:function onResize(){this.forceUpdate();}// eslint-disable-line react/sort-comp
}]);function LineGraph(){_classCallCheck(this,LineGraph);var _this=_possibleConstructorReturn(this,(LineGraph.__proto__||Object.getPrototypeOf(LineGraph)).call(this));_this.onResize=_this.onResize.bind(_this);return _this;}_createClass(LineGraph,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.onResize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize);}},{key:'render',value:function render(){var _props=this.props,orgData=_props.data,viewBox=_props.viewBox,width=_props.width,height=_props.height,labels=_props.labels,aspectRatio=_props.aspectRatio;var markers=this.props.markers;var data=__WEBPACK_IMPORTED_MODULE_8_lodash_omit___default()(orgData,'Unit');if(!__WEBPACK_IMPORTED_MODULE_7_lodash_size___default()(data))return null;var xAxisData=orgData.Unit;var y1AxisData=data[labels.y1];var y2AxisData=data[labels.y2];var thisData=__WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(data,function(values,key){var vals=values;// this is dumb.. some data is not the same length.
if(xAxisData.length<values.length){vals=values.slice(0,xAxisData.length);}return vals.map(function(value,index){return{id:key,key:xAxisData[index],val:value};});});// Fatten the [][]
var flatData=__WEBPACK_IMPORTED_MODULE_5_lodash_flatten___default()(thisData);// Set up the base SVG
var svg=__WEBPACK_IMPORTED_MODULE_12_react_faux_dom___default.a.createElement('svg');var svgWrapper=__WEBPACK_IMPORTED_MODULE_11_d3__["select"](svg).attr('class','graph').attr('viewBox',viewBox.x+' '+viewBox.y+' '+viewBox.width+' '+(viewBox.height+50)).attr('width',width).attr('height',height)// .attr('data', null)
// .append('g');
.attr('preserveAspectRatio',aspectRatio).attr('transform','translate(0, 0)');var el=svgWrapper.append('g').attr('class','groupWrapper');// set a container with margins
var group=el.append('g').attr('transform','translate(0, 5)');var x=__WEBPACK_IMPORTED_MODULE_11_d3__["scaleLinear"]().range([0,viewBox.width]).domain(__WEBPACK_IMPORTED_MODULE_11_d3__["extent"](flatData,function(d){return d.key;})).clamp(true);// .nice();
var y1=null;var yUpper=markers['Y-axis upper range'];var xUpper=__WEBPACK_IMPORTED_MODULE_11_d3__["max"](flatData,function(v){return v.key;});markers=__WEBPACK_IMPORTED_MODULE_8_lodash_omit___default()(markers,'Y-axis upper range');if(!yUpper){y1=__WEBPACK_IMPORTED_MODULE_11_d3__["scaleLinear"]().range([viewBox.height,__WEBPACK_IMPORTED_MODULE_11_d3__["max"](flatData,function(v){return v.val;})]).domain(__WEBPACK_IMPORTED_MODULE_11_d3__["extent"](y1AxisData)).clamp(true).nice();}else{y1=__WEBPACK_IMPORTED_MODULE_11_d3__["scaleLinear"]().range([viewBox.height,0])// .range([viewBox.height, d3.max(flatData, v => v.val)])
.domain([0,yUpper]).clamp(true);}var y2=null;if(y2AxisData){y2=__WEBPACK_IMPORTED_MODULE_11_d3__["scaleLinear"]().range([viewBox.height,__WEBPACK_IMPORTED_MODULE_11_d3__["min"](flatData,function(v){return v.val;})])// .domain(d3.extent(flatData, d => d.val))
.domain(__WEBPACK_IMPORTED_MODULE_11_d3__["extent"](y2AxisData)).clamp(true).nice();}var color=__WEBPACK_IMPORTED_MODULE_11_d3__["scaleOrdinal"](__WEBPACK_IMPORTED_MODULE_11_d3__["schemeCategory20"]).domain(FIELD_DOMAIN);var getColor=function getColor(key){// debug(FIELD_DOMAIN.includes(key) ? 'key' : 'missing', key);
if(['Hi-Side IGBT/MOSFET Current (A)','Thermal Resistance Limited by Ths (°C/W)'].includes(key)){return'blue';}if(['Hi-Side Modulation Signal','Thermal Resistance Limited by Tj (°C/W)'].includes(key)){return'green';}return color(key);};var y1Line=__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().curve(__WEBPACK_IMPORTED_MODULE_11_d3__["curveMonotoneX"]).x(function(d){return x(d.key);}).y(function(d){return y1&&y1(d.val);});var y2Line=__WEBPACK_IMPORTED_MODULE_4_lodash_noop___default.a;if(y2!==null){y2Line=__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().curve(__WEBPACK_IMPORTED_MODULE_11_d3__["curveMonotoneX"]).x(function(d){return x(d.key);}).y(function(d){return y2&&y2(d.val);});}var getMarkerLines=function getMarkerLines(obj){var lines=[];if(!obj)return{lines:lines};if(obj['min Vin']&&obj['max Vin']&&obj['max load']){// hack - crit graph
var horzMarkers=__WEBPACK_IMPORTED_MODULE_8_lodash_omit___default()(obj,['max load','Y-axis upper range']);// const vertMarkers = _.pick(obj, 'max load');
var vertMarkers={};return[{x:__WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(horzMarkers,function(h){return x(h);}),y:__WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(vertMarkers,function(v){if(y1){return y1(v);}return-1;})}];}var lineMarkers=__WEBPACK_IMPORTED_MODULE_3_lodash_values___default()(obj);if(lineMarkers[0]&&lineMarkers[1]&&y2){lines=[__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().x(function(d){return x(d.key);}).y(function(){return y2&&y2(lineMarkers[1]);}),__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().x(function(d){return x(d.key);}).y(function(){return y2&&y2(lineMarkers[0]);})];}var totalModuleLoss=obj['Total Module Loss'];if(totalModuleLoss){lines=[__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().x(function(d){return x(d.key);}).y(function(){return y1&&y1(totalModuleLoss);})];}var iOverload=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(obj,['I-Overload']);var iRated=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(obj,['I-rated']);if(iOverload&&iRated){var niceX=x.nice();lines=[__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().x(function(){return niceX(iOverload);}).y(function(d){return y2&&y2(d.val);}),__WEBPACK_IMPORTED_MODULE_11_d3__["line"]().x(function(){return niceX(iRated);}).y(function(d){return y2&&y2(d.val);})];}return{lines:lines};};var markerLines=getMarkerLines(markers);_uid2(markerLines);// Create axis
var xAxis=__WEBPACK_IMPORTED_MODULE_11_d3__["axisBottom"](x);var yAxis=__WEBPACK_IMPORTED_MODULE_11_d3__["axisLeft"](y1);var y1Axis=null;if(y2){y1Axis=__WEBPACK_IMPORTED_MODULE_11_d3__["axisRight"](y2);}// Create x-axis
group.append('g').attr('class','axis').attr('transform','translate(0, '+viewBox.height+')').call(xAxis);// Add x-axis label
group.append('g').attr('transform','translate('+viewBox.width/2+', '+(viewBox.height+35)+')').append('text').attr('class','x label').style('font-size','12px').style('font-weight','bold').attr('text-anchor','middle').text(labels.x);// Create y-axis
group.append('g').attr('class','axis').call(yAxis);if(y1Axis){group.append('g').attr('class','axis').attr('transform','translate('+viewBox.width+', 0)').call(y1Axis);}// Add y-axis label
group.append('g').attr('transform','translate('+-40+', '+viewBox.height/2+')').append('text').attr('class','y label').style('font-size','12px').style('font-weight','bold').attr('text-anchor','middle').attr('transform','rotate(-90)').text(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(labels,['y1.legend'],labels.y1));group.append('g').attr('transform','translate('+(viewBox.width+40)+', '+viewBox.height/2+')').append('text').attr('class','y label').style('font-size','12px').style('font-weight','bold').attr('text-anchor','middle').attr('transform','rotate(90)').text(labels.y2);// Create the grid
group.append('g').attr('class','grid').attr('transform','translate(0, '+viewBox.height+')').call(xAxis.tickSize(-viewBox.height,0,0).tickFormat(''));group.append('g').attr('class','grid').attr('transform','translate(0, 0)').call(yAxis.tickSize(-viewBox.width,0,0).tickFormat(''));// Add legend
var legendSize=12;var legendSpacing=5;var textSize=12;var legend=el.append('g').attr('class','legend').attr('transform','translate(0, 0)');// make the legend more box like
legend.append('rect').attr('class','legendBackground').style('stroke','black').style('stroke-width',0.5);var legendRow=legend.append('g').attr('transform','translate('+legendSpacing+', '+legendSpacing+')');// Append all of our lines and legend text
var count=0;var pathGroup=group.append('g');__WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(thisData,function(value){var legendKey=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(value[0],['id'],'unknown');var row=legendRow.append('g').attr('class','legendRow');// Legend rectangle
row.append('rect').attr('width',legendSize).attr('height',legendSize).attr('x',0).attr('y',count*(legendSize+legendSpacing)).style('fill',getColor(legendKey));// Legend text
var legendText=row.append('text').attr('x',legendSize+legendSpacing).attr('y',count*(legendSize+legendSpacing)).attr('dy',legendSize).style('fill','black').attr('font-size',textSize).attr('transform','translate(0, -2)');count+=1;if(legendKey===labels.y1){pathGroup.append('path').data([value]).attr('class','line').attr('d',y1Line).style('stroke',getColor(legendKey));legendText.text(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(labels,['y1'],legendKey));}else{if(y2Line){pathGroup.append('path').data([value]).attr('class','line').attr('d',y2Line).style('stroke',getColor(legendKey));}legendText.text(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(labels,['y2.legned'],legendKey));}if(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(markerLines)){var xlines=markerLines[0].x;var ylines=markerLines[0].y;__WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(xlines,function(lineX,index){return pathGroup.append('line').attr('class','line').attr('x1',lineX).attr('y1',y1&&y1(0)).attr('x2',lineX).attr('y2',y1&&y1(yUpper)).style('stroke','black').style('stroke-dasharray',index===0?'0, 0':'3, 5').style('stroke-width',1);});// horizontal lines
__WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(ylines,function(lineY){return pathGroup.append('line').attr('class','line').attr('x1',x(0)).attr('y1',lineY).attr('x2',x(xUpper)).attr('y2',lineY).style('stroke','blue')// .style('stroke-dasharray', '3, 5')
.style('stroke-width',1.5);});}else{var _lines=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(markerLines,'lines',[]);__WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(_lines,function(line){return pathGroup.append('path').data([value]).attr('class','line').attr('d',line).style('stroke','black').style('stroke-dasharray','3, 5').style('stroke-width',0.75);});}});var markerCount=0;__WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(markers,function(val,key){if(key==='fs')return;if(['Total Module Loss'].concat(maxMarkerFields,meanMarkerFields).includes(key)){group.append('text').attr('x',viewBox.width-20).attr('y',key==='Total Module Loss'?y1&&y1(val):y2&&y2(val)).style('fill','black').style('font-size','12px').attr('text-anchor','right').attr('transform','translate(-'+calculateTextWidth(key)+', 12)').text(key);// } else if (key === 'max load') {
}else if(key==='max load'){// horizontal line
// group.append('text')
//   .attr('y', y1 && y1(val))
//   .attr('x', 0)
//   .style('fill', 'black')
//   .style('font-size', '12px')
//   .attr('text-anchor', 'left')
//   .attr('transform', 'translate(6, -6)')
//   .text(key);
}else{var even=markerCount%2===0;group.append('text').attr('y',-x(val)).attr('x',y1&&y1(+yUpper/2)).style('fill','black').style('font-size','12px').attr('text-anchor','middle').attr('transform','translate('+(even?'-12':'6')+', 0) rotate(90)').text(key);}markerCount+=1;});// reattach for zindex order
legend.raise();// const textWidth = calculateTextWidth(Object.keys(data), textSize);
legend.select('.legendBackground').attr('height',legendSpacing+count*(legendSize+legendSpacing)).attr('fill','white');// .attr('width', ((textWidth) + (legendSize + (legendSpacing * 3))));
// Convert the d3 node to a React node
return svgWrapper.node().toReact();}}]);return LineGraph;}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (LineGraph);

/***/ }),

/***/ "./src/components/LineGraph/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineGraph__ = __webpack_require__("./src/components/LineGraph/LineGraph.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LineGraph__["a" /* default */]);

/***/ }),

/***/ "./src/components/Loading/Loading.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_better_react_spinkit_dist_CubeGrid_index__ = __webpack_require__("./node_modules/better-react-spinkit/dist/CubeGrid/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_better_react_spinkit_dist_CubeGrid_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_better_react_spinkit_dist_CubeGrid_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loading_scss__ = __webpack_require__("./src/components/Loading/Loading.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loading_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Loading_scss__);
/**
 * 
 * @format
 */var Loading=function Loading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_4__Loading_scss___default.a.wrapper,'p-5'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_better_react_spinkit_dist_CubeGrid_index___default.a,{col:props.col,color:props.color,row:props.row,size:props.size,style:props.loaderStyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:props.textStyle},props.text));};var withDefaults=Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["defaultProps"])({col:3,row:3,size:72,color:'',loaderStyle:{},text:'Loading Data',textStyle:{paddingTop:'1.5rem',paddingBottom:'0'}});/* harmony default export */ __webpack_exports__["a"] = (withDefaults(Loading));

/***/ }),

/***/ "./src/components/Loading/Loading.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Loading__wrapper"};

/***/ }),

/***/ "./src/components/Loading/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading__ = __webpack_require__("./src/components/Loading/Loading.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Loading__["a" /* default */]);

/***/ }),

/***/ "./src/components/ModalWrapper/ModalWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_modal__ = __webpack_require__("./src/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SaveDesignModal__ = __webpack_require__("./src/components/SaveDesignModal/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OpenDesignModal__ = __webpack_require__("./src/components/OpenDesignModal/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _MODAL_COMPONENTS;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * 
 * @format
 */// import { FileManagementModal } from '../FileManagement/FileManagementModal';
// import classes from './ModalWrapper.scss';
var MODAL_COMPONENTS=(_MODAL_COMPONENTS={},_defineProperty(_MODAL_COMPONENTS,__WEBPACK_IMPORTED_MODULE_4__actions_modal__["b" /* constants */].MODAL_SAVE_DESIGN,__WEBPACK_IMPORTED_MODULE_5__SaveDesignModal__["a" /* default */]),_defineProperty(_MODAL_COMPONENTS,__WEBPACK_IMPORTED_MODULE_4__actions_modal__["b" /* constants */].MODAL_OPEN_DESIGN,__WEBPACK_IMPORTED_MODULE_6__OpenDesignModal__["a" /* default */]),_MODAL_COMPONENTS);// eslint-disable-next-line react/prefer-stateless-function
var ModalWrapper=function(_React$Component){_inherits(ModalWrapper,_React$Component);function ModalWrapper(){_classCallCheck(this,ModalWrapper);return _possibleConstructorReturn(this,(ModalWrapper.__proto__||Object.getPrototypeOf(ModalWrapper)).apply(this,arguments));}_createClass(ModalWrapper,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){if(!this.props.modalType)return null;var BaseModal=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(MODAL_COMPONENTS,[this.props.modalType]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseModal,Object.assign({show:true},this.props));}// state: StateType; // eslint-disable-line react/sort-comp
}]);return ModalWrapper;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ModalWrapper.defaultProps={};function mapStateToProps(state,props){return Object.assign({},props,state.modals.modalProps,{modalType:state.modals.modalType});}function mapDispatchToProps(dispatch){return{onHide:function onHide(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_modal__["a" /* actions */].hideModal(payload));}};}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_3_recompose__["pure"]);/* harmony default export */ __webpack_exports__["a"] = (enhancer(ModalWrapper));

/***/ }),

/***/ "./src/components/ModalWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalWrapper__ = __webpack_require__("./src/components/ModalWrapper/ModalWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ModalWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/MultiLineGraph/MultiLineGraph.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MultiLineGraph */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__("./node_modules/lodash/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__("./node_modules/lodash/forEach.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("./node_modules/lodash/flatten.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_size__ = __webpack_require__("./node_modules/lodash/size.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit__ = __webpack_require__("./node_modules/lodash/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_startCase__ = __webpack_require__("./node_modules/lodash/startCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3__ = __webpack_require__("./node_modules/d3/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_faux_dom__ = __webpack_require__("./node_modules/react-faux-dom/lib/ReactFauxDOM.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_faux_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_faux_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("./src/utils/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */function getTextWidth(text,fontSize){var fontFace=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var a=document.createElement('canvas');var b=a.getContext('2d');b.font=fontSize+'px '+fontFace;return b.measureText(text).width;}// calculate the width of the text
var calculateTextWidth=function calculateTextWidth(keys){var textSize=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var canvas=document.createElement('canvas');var ctx=canvas.getContext('2d');if(ctx){ctx.font=textSize+'px Arial';if(typeof keys==='string'){return ctx.measureText(keys).width;}return keys.reduce(function(ret,str){var len=ctx.measureText(str).width;if(len>ret)return len;return ret;},0);}return 0;};function replaceLegendText(str){return''+__WEBPACK_IMPORTED_MODULE_7_lodash_startCase___default()(str[0])+str.slice(1);}var getColor=function getColor(key){var color=__WEBPACK_IMPORTED_MODULE_9_d3__["scaleOrdinal"](__WEBPACK_IMPORTED_MODULE_9_d3__["schemeCategory20b"]).domain(['Total FET(s)','Total diode','50% load','Switching','Coss','6','Max Vin','Rg','100% load','3','Conduction','25% load','Nom Vin','Rev. recov.','Min Vin','2','4','75% load','Max Load','Leakage']);if(['Hi-Side IGBT/MOSFET Current(amps)','Thermal Resistance Limited by Ths(°C)'].includes(key)){return'blue';}if(['Hi-Side Modulation Signal','Thermal Resistance Limited by Tj(°C)'].includes(key)){return'green';}return color(key);};var MultiLineGraph=function(_React$PureComponent){_inherits(MultiLineGraph,_React$PureComponent);function MultiLineGraph(){_classCallCheck(this,MultiLineGraph);return _possibleConstructorReturn(this,(MultiLineGraph.__proto__||Object.getPrototypeOf(MultiLineGraph)).apply(this,arguments));}_createClass(MultiLineGraph,[{key:'render',value:function render(){var _props=this.props,orgData=_props.data,viewBox=_props.viewBox,width=_props.width,height=_props.height,labels=_props.labels,aspectRatio=_props.aspectRatio,legendPos=_props.legend;var markers=this.props.markers;var data=__WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(orgData,'Unit');// const data = _.pick(orgData, 'total FET(s)');
var xAxisData=orgData.Unit;// const y1AxisData = data[labels.y1];
// const y2AxisData = data[labels.y2];
// No data? Gitoutta here.
if(!__WEBPACK_IMPORTED_MODULE_5_lodash_size___default()(data))return null;// Remap the data into a format that is easier to consume with d3
var thisXData=__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(data,function(values,key){var vals=values;// this is dumb.. some data is not the same length.
if(xAxisData.length<values.length){vals=values.slice(0,xAxisData.length);}return vals.map(function(value,index){return{id:key,key:xAxisData[index],val:value};});});// vs. only vs Load should have %
var showVin=data['100% load'];// Remap the Y data to a format that is easier to consume with d3: [][]
var thisYData=__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(data,function(values,key){var vals=values;return vals.map(function(value,index){return{id:key,key:showVin?xAxisData[index]:index,val:value};});});// Fatten the [][]
var flatData=__WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(thisXData);var flatYData=__WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(thisYData);// Set up the base SVG
var svg=__WEBPACK_IMPORTED_MODULE_10_react_faux_dom___default.a.createElement('svg');var svgWrapper=__WEBPACK_IMPORTED_MODULE_9_d3__["select"](svg).attr('class','graph').attr('viewBox',viewBox?viewBox.x+' '+viewBox.y+' '+viewBox.width+' '+(viewBox.height+50):null).attr('width',width).attr('height',height)// .attr('data', null)
// .append('g');
.attr('preserveAspectRatio',aspectRatio);var el=svgWrapper.append('g').attr('class','groupWrapper').attr('transform','scale(0.9) translate(50)');if(!viewBox){el.attr('transform','translate(150, 0)');}// set a container with margins
var group=el.append('g').attr('transform','translate(0, 20)');var vbWidth=viewBox?viewBox.width:400;var vbHeight=viewBox?viewBox.height:400;var x=__WEBPACK_IMPORTED_MODULE_9_d3__["scalePow"]().range([0,vbWidth]).domain(__WEBPACK_IMPORTED_MODULE_9_d3__["extent"](flatYData,function(d){return d.key;})).clamp(true).nice();var y1=__WEBPACK_IMPORTED_MODULE_9_d3__["scaleLinear"]().range([vbHeight,0]).domain(__WEBPACK_IMPORTED_MODULE_9_d3__["extent"](flatYData,function(d){return d.val;})).clamp(true).nice();var yUpper=markers['Y-axis upper range']||false;var xUpper=__WEBPACK_IMPORTED_MODULE_9_d3__["max"](flatData,function(v){return v.key;});markers=__WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(markers,'Y-axis upper range');if(yUpper){y1=__WEBPACK_IMPORTED_MODULE_9_d3__["scaleLinear"]().range([vbHeight,0])// .domain(d3.extent(flatData, d => d.val))
.domain([0,yUpper]).clamp(true);x=__WEBPACK_IMPORTED_MODULE_9_d3__["scaleLinear"]().range([0,vbWidth]).domain(__WEBPACK_IMPORTED_MODULE_9_d3__["extent"](flatData,function(d){return d.key;})).clamp(true);}// const y2 = d3.scaleLinear()
//   .range([viewBox.height, d3.min(flatData, v => v.val)])
//   // .domain(d3.extent(flatData, d => d.val))
//   .domain(d3.extent(y2AxisData))
//   .clamp(true)
//   .nice();
var y1Line=__WEBPACK_IMPORTED_MODULE_9_d3__["line"]().curve(__WEBPACK_IMPORTED_MODULE_9_d3__["curveMonotoneX"]).x(function(d){return x(d.key);}).y(function(d){return y1(d.val);});// Area
// let area1 = null;
// if (this.props.area.length > 0) {
//   area1 = d3.area()
//     .x(d => x(d.key))
//     // .y0(viewBox.height)
//     .y(d => y1 && y1(d.val));
// }
var getMarkerLines=function getMarkerLines(obj){var lines=[];if(!obj)return{lines:lines};if(obj['min Vin']&&obj['max Vin']){// hack - crit graph
var horzMarkers=__WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(obj,['max load','Y-axis upper range']);// const vertMarkers = _.pick(obj, 'max load');
var vertMarkers={};return[{x:__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(horzMarkers,function(h){return x(h);}),y:__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(vertMarkers,function(v){if(y1){return y1(v);}return-1;})}];}var iOverload=obj['I-Overload'];var iRated=obj['I-rated'];if(iOverload&&iRated){var niceX=x.nice();lines=[__WEBPACK_IMPORTED_MODULE_9_d3__["line"]().x(function(){return niceX(iOverload);}).y(function(d){return y1&&y1(d.val);}),__WEBPACK_IMPORTED_MODULE_9_d3__["line"]().x(function(){return niceX(iRated);}).y(function(d){return y1&&y1(d.val);})];}return{lines:lines};};var markerLines=getMarkerLines(markers);// Create axis
var xAxis=__WEBPACK_IMPORTED_MODULE_9_d3__["axisBottom"](x);var yAxis=__WEBPACK_IMPORTED_MODULE_9_d3__["axisLeft"](y1);// Create x-axis
group.append('g').attr('class','axis').attr('transform','translate(0, '+vbHeight+')').call(xAxis);var textSpan=function textSpan(k){if(!k)return k;if(k.includes('Vin')){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('tspan',{key:k},k.replace(/in$/,''),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('tspan',{fontSize:'7',baselineShift:'sub'},'IN'));}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('tspan',{key:k},k);};// Add x-axis label
group.append('g').attr('transform','translate('+vbWidth/2+', '+(vbHeight+35)+')').append('text').attr('class','x label').style('font-size','12px').style('font-weight','bold').attr('text-anchor','middle').text(textSpan(__WEBPACK_IMPORTED_MODULE_11__utils__["u" /* toTitleCase */](labels.x)));// Create y-axis
group.append('g').attr('class','axis').call(yAxis);// Add y-axis label
group.append('g').attr('transform','translate('+-40+', '+vbHeight/2+')').append('text').attr('class','y label').style('font-size','12px').style('font-weight','bold').attr('text-anchor','middle').attr('transform','rotate(-90)').text(textSpan(__WEBPACK_IMPORTED_MODULE_11__utils__["u" /* toTitleCase */](labels.y1)));// Add y-axis 2 label if necessary
group.append('g').attr('transform','translate('+(vbWidth+40)+', '+vbHeight/2+')').append('text').attr('class','y label').style('font-size','12px').style('font-weight','bold').attr('text-anchor','middle').attr('transform','rotate(90)').text(__WEBPACK_IMPORTED_MODULE_11__utils__["u" /* toTitleCase */](labels.y2));// Create the grid
group.append('g').attr('class','grid').attr('transform','translate(0, '+vbHeight+')').call(xAxis.tickSize(-vbHeight,0,0).tickFormat(''));group.append('g').attr('class','grid').attr('transform','translate(0, 0)').call(yAxis.tickSize(-vbWidth,0,0).tickFormat(''));// Add legend
var legendRectSize=11;var legendPad=2;var textSize=12;var legend=el.append('g').attr('class','legend').attr('transform','translate(5, 0)');// make the legend more box like
var legendRow=legend.append('g');legendRow.append('rect').attr('class','legendBackground')// .style('stroke', 'black')
// .attr('transform', `translate(${legendPad}, ${legendPad})`)
.style('stroke-width',0.5);// Append all of our lines and legend text
var count=0;var runningWidth=0;var theData=yUpper?thisXData:thisYData;var pathGroup=group.append('g');__WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(theData,function(value){var legendKey=replaceLegendText(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(value[0],['id'],'unknown'));var row=legendRow.append('g').attr('class','legendRow');var textLen=getTextWidth(legendKey,textSize);// Legend text
if(legendPos==='vertical'){row.append('rect').attr('width',legendRectSize).attr('height',legendRectSize).attr('x',0).attr('y',count*(legendRectSize+legendPad)).style('fill',getColor(legendKey));row.append('text').attr('x',legendRectSize+legendPad).attr('y',count*(legendRectSize+legendPad)).attr('dy',legendRectSize).style('fill','black').attr('font-size',textSize).attr('transform','translate(0, -2)').text(textSpan(legendKey));}else{var legendTextSpan=textSpan(legendKey);var defSpacing=legendRectSize+legendPad;row.append('rect').attr('width',legendRectSize).attr('height',legendRectSize).attr('x',runningWidth+count*legendRectSize).attr('y',0).style('fill',getColor(legendKey));row.append('text').attr('x',runningWidth+count*defSpacing).attr('dx',defSpacing)// spacing after the square
.attr('y',0).attr('dy',legendRectSize).style('fill','black').attr('font-size',textSize).attr('transform','translate(0, 0)').text(legendTextSpan);runningWidth+=textLen+legendRectSize+legendPad*4;}count+=1;pathGroup.append('path').data([value]).attr('class','line').attr('d',y1Line).style('stroke',getColor(legendKey));if(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(markerLines)){var xlines=markerLines[0].x;var ylines=markerLines[0].y;__WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(xlines,function(lineX,index){return pathGroup.append('line').attr('class','line').attr('x1',lineX).attr('y1',y1&&y1(0)).attr('x2',lineX).attr('y2',y1&&y1(yUpper)).style('stroke','black')// IE11 doesn't handle '0, 0' for dasharrays.
.style('stroke-dasharray',[0,1].includes(index)?'0':'3, 5').style('stroke-width',1);});// horizontal lines
__WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(ylines,function(lineY){return pathGroup.append('line').attr('class','line').attr('x1',x(0)).attr('y1',lineY).attr('x2',x(xUpper)).attr('y2',lineY).style('stroke','blue')// .style('stroke-dasharray', '3, 5')
.style('stroke-width',1.6);});}else{var _lines=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(markerLines,'lines',[]);__WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(_lines,function(line){return pathGroup.append('path').data([value]).attr('class','line').attr('d',line).style('stroke','black').style('stroke-dasharray','3, 5').style('stroke-width',0.85);});}});var index=0;__WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(markers,function(val,key){if(key==='fs')return;var anchor=function anchor(){if(Object.keys(markers).length===2)return'center';return key.includes('mode')?'start':'end';};group.append('text').attr('y',-x(val)).attr('x',0).style('fill','black').style('font-size','14px').attr('text-anchor',anchor).attr('transform','translate('+(index%2?'-14':'8')+', 55) rotate(90)').text(textSpan(key));index+=1;});// if (this.props.area.length) {
//   // Append the area
//   const values = thisXData[0]; // critical load
//   pathGroup.append('path')
//     .attr('class', 'area')
//     .data([values])
//     .attr('d', area1);
// }
// reattach for zindex order
legend.raise();var textWidth=calculateTextWidth(Object.keys(data),textSize);if(legendPos==='vertical'){legend.select('.legendBackground').attr('height',legendPad+count*(legendRectSize+legendPad)).attr('fill','white').attr('opacity','0.65').attr('width',textWidth+10+(legendRectSize+legendPad*3));}else{legend.select('.legendBackground').attr('height',legendPad*2+legendRectSize).attr('fill','white').attr('opacity','0.65').attr('width',runningWidth);}// Convert the d3 node to a React node
return svgWrapper.node().toReact();}// componentWillMount() {
//   const { data: orgData, viewBox, width, height, labels } = this.props;
//   const data = _.omit(orgData, 'Unit');
//   // Mouse over effects
//   const svgWrapper = d3.select('.groupWrapper');
//   const mouseG = svgWrapper.append('g')
//     .attr('class', 'mouse-over-effects');
//   mouseG.append('path') // this is the black vertical line to follow mouse
//     .attr('class', 'mouse-line')
//     .style('stroke', 'black')
//     .style('stroke-width', '1px')
//     .style('opacity', '0');
//   const lines = document.getElementsByClassName('line');
//   console.log(svgWrapper.node(), data);
//   const mousePerLine = mouseG.selectAll('.mouse-per-line')
//     .data(data)
//     .enter()
//     .append('g')
//     .attr('class', 'mouse-per-line');
//   mousePerLine.append('circle')
//     .attr('r', 7)
//     .style('stroke', d => getColor(d.id))
//     .style('fill', 'none')
//     .style('stroke-width', '1px')
//     .style('opacity', '0');
//   mousePerLine.append('text')
//     .attr('transform', 'translate(10,3)');
//   /* eslint-disable indent */
//   mouseG.append('svg:rect') // append a rect to catch mouse movements on canvas
//     .attr('width', width) // can't catch mouse events on a g element
//     .attr('height', height)
//     .attr('fill', 'none')
//     .attr('pointer-events', 'all')
//     .on('mouseout', () => { // on mouse out hide line, circles and text
//       d3.select('.mouse-line')
//         .style('opacity', '0');
//       d3.selectAll('.mouse-per-line circle')
//         .style('opacity', '0');
//       d3.selectAll('.mouse-per-line text')
//         .style('opacity', '0');
//     })
//     .on('mouseover', () => { // on mouse in show line, circles and text
//       d3.select('.mouse-line')
//         .style('opacity', '1');
//       d3.selectAll('.mouse-per-line circle')
//         .style('opacity', '1');
//       d3.selectAll('.mouse-per-line text')
//         .style('opacity', '1');
//     })
//     .on('mousemove', () => { // mouse moving over canvas
//       const mouse = d3.mouse(this);
//       console.log('mmove');
//       d3.select('.mouse-line')
//         .attr('d', () => `M${mouse[0]},${height} ${mouse[0]}, 0`);
//       // var d = 'M' + mouse[0] + ',' + height;
//       // d += ' ' + mouse[0] + ',' + 0;
//       // return d;
//     });
//       // d3.selectAll('.mouse-per-line')
//       //   .attr('transform', (d, i) => {
//       //     console.log(width / mouse[0]);
//       //     const xDate = x.invert(mouse[0]);
//       //     const bisect = d3.bisector(f => f.date).right;
//       //     const idx = bisect(d.values, xDate);
//       //     let beginning = 0;
//       //     let end = lines[i].getTotalLength();
//       //     let target = null;
//       //     let pos = {};
//       //     while (true) {
//       //       target = Math.floor((beginning + end) / 2);
//       //       pos = lines[i].getPointAtLength(target);
//       //       if ((target === end || target === beginning) && pos.x !== mouse[0]) {
//       //         break;
//       //       }
//       //       if (pos.x > mouse[0]) end = target;
//       //       else if (pos.x < mouse[0]) beginning = target;
//       //       else break; // position found
//       //     }
//       //     d3.select(this).select('text')
//       //       .text(y1.invert(pos.y).toFixed(2));
//       //     return `translate(${mouse[0]},${pos.y})`;
//       //   });
//     // });
// }
}]);return MultiLineGraph;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.PureComponent);MultiLineGraph.defaultProps={area:[]};/* harmony default export */ __webpack_exports__["a"] = (MultiLineGraph);

/***/ }),

/***/ "./src/components/MultiLineGraph/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiLineGraph__ = __webpack_require__("./src/components/MultiLineGraph/MultiLineGraph.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MultiLineGraph__["a" /* default */]);

/***/ }),

/***/ "./src/components/OpenDesignModal/OpenDesignModal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OpenDesignModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routines_design__ = __webpack_require__("./src/routines/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FileManagement_FileManagement__ = __webpack_require__("./src/components/FileManagement/FileManagement.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OpenDesignModal_scss__ = __webpack_require__("./src/components/OpenDesignModal/OpenDesignModal.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OpenDesignModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OpenDesignModal_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var OpenDesignModal=function(_React$PureComponent){_inherits(OpenDesignModal,_React$PureComponent);function OpenDesignModal(){_classCallCheck(this,OpenDesignModal);return _possibleConstructorReturn(this,(OpenDesignModal.__proto__||Object.getPrototypeOf(OpenDesignModal)).apply(this,arguments));}_createClass(OpenDesignModal,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var _this2=this;var toggle=this.props.onHide;var handleOnOpen=function handleOnOpen(id){_this2.props.onHide();_this2.props.onOpenDesign(id);};var handleRename=function handleRename(id){var record=_this2.props.data.get(id);if(!record)return;var name=prompt('New design name',record.name||'Unititled');if(name===null)return;var nameExists=name&&Array.from(_this2.props.data).some(function(_ref){var _ref2=_slicedToArray(_ref,2),r=_ref2[1];return r.name.toUpperCase()===name.trim().toUpperCase();});if(nameExists){alert('Name already exists.');return;}_this2.props.onRenameDesign({id:id,name:name});};var handleDelete=function handleDelete(id){var record=_this2.props.data.get(id);if(!record)return;if(confirm('Are you sure you want to delete the design "'+record.name+'"?')){_this2.props.onDeleteDesign(id);}};var handleCopy=function handleCopy(id){var record=_this2.props.data.get(id);if(!record)return;var newRecordName=record.name+'-'+new Date().toISOString();var nameExists=Array.from(_this2.props.data).some(function(_ref3){var _ref4=_slicedToArray(_ref3,2),r=_ref4[1];return r.name.toUpperCase()===newRecordName.toUpperCase();});if(nameExists){alert('Name already exists.');return;}_this2.props.onCopyDesign({id:id,name:newRecordName});};var loadingOrContent=function loadingOrContent(){if(_this2.props.loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Loading...');if(_this2.props.data.size===0)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'There were no previously saved designs found.');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileManagement_FileManagement__["a" /* FileManagement */],{data:_this2.props.data,onHandleClick:handleOnOpen,onHandleRename:handleRename,onHandleDelete:handleDelete,onHandleCopy:handleCopy});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Modal"],{isOpen:this.props.show,toggle:toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ModalHeader"],{toggle:toggle},'My Designs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ModalBody"],{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],{sm:12,className:__WEBPACK_IMPORTED_MODULE_6__OpenDesignModal_scss___default.a.scrollable},loadingOrContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'secondary',onClick:toggle},'Close')));}}]);return OpenDesignModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);OpenDesignModal.defaultProps={};function mapStateToProps(state){return{loading:state.global.records.loading,data:state.global.records.data};}function mapDispatchToProps(dispatch){return{onOpenDesign:function onOpenDesign(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].fetchRecord(id));},onRenameDesign:function onRenameDesign(id,name){return dispatch(__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].updateRecordName(id,name));},onCopyDesign:function onCopyDesign(id,name){return dispatch(__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].copyDesign(id,name));},onDeleteDesign:function onDeleteDesign(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].deleteDesign(id));}};}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps));/* harmony default export */ __webpack_exports__["a"] = (enhancer(OpenDesignModal));

/***/ }),

/***/ "./src/components/OpenDesignModal/OpenDesignModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"scrollable":"OpenDesignModal__scrollable"};

/***/ }),

/***/ "./src/components/OpenDesignModal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OpenDesignModal__ = __webpack_require__("./src/components/OpenDesignModal/OpenDesignModal.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__OpenDesignModal__["a" /* default */]);

/***/ }),

/***/ "./src/components/PieChart/PieChart.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_startCase__ = __webpack_require__("./node_modules/lodash/startCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3__ = __webpack_require__("./node_modules/d3/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_circle__ = __webpack_require__("./node_modules/react-icons/lib/fa/circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PieChart_scss__ = __webpack_require__("./src/components/PieChart/PieChart.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PieChart_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PieChart_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import debug from '~/utils/macros/debug.macro';
var SCALER=12;var PieChart=function(_React$PureComponent){_inherits(PieChart,_React$PureComponent);function PieChart(){_classCallCheck(this,PieChart);return _possibleConstructorReturn(this,(PieChart.__proto__||Object.getPrototypeOf(PieChart)).apply(this,arguments));}_createClass(PieChart,[{key:'render',value:function render(){var _props=this.props,data=_props.data,radius=_props.radius,viewBox=_props.viewBox,totalLoss=_props.totalLoss,rest=_objectWithoutProperties(_props,['data','radius','viewBox','totalLoss']);var mappedData=__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(data,function(v,k){return{val:v,key:k};});var arcs=__WEBPACK_IMPORTED_MODULE_4_d3__["pie"]().value(function(d){return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* placeRound */])(d.val);}).sort(null)(mappedData);var arcGen=__WEBPACK_IMPORTED_MODULE_4_d3__["arc"]().innerRadius(0).outerRadius(radius*0.8);var outerArc=__WEBPACK_IMPORTED_MODULE_4_d3__["arc"]().innerRadius(radius*0.6).outerRadius(radius*0.7);var color=__WEBPACK_IMPORTED_MODULE_4_d3__["scaleOrdinal"](__WEBPACK_IMPORTED_MODULE_4_d3__["schemeCategory10"]);var pieArcs=arcs.map(function(a,i){var ratio=Math.abs(a.startAngle-a.endAngle)/2/Math.PI;var mid=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["n" /* midAngle */])(a.startAngle,a.endAngle);var posModifier=mid<Math.PI?1:-1;var center=outerArc.centroid(a);var pos=[radius*posModifier,center[1]];var percentCalc=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* placeRound */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["t" /* toPercent */])(a.data.val,totalLoss),1);var label=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('text',{className:__WEBPACK_IMPORTED_MODULE_7__PieChart_scss___default.a.percentText,transform:'translate('+pos[0]+', '+(pos[1]-i*SCALER)+')',textAnchor:pos[0]<0?'end':'start',dy:'0.35em',fill:'black'},percentCalc,'%');var fillColor=color(ratio);return{data:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('g',{key:'arc'+a.value,className:'slice'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path',{fill:fillColor,stroke:'black',d:arcGen(a)}),percentCalc>=0.5?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('g',null,label,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('polyline',{points:[arcGen.centroid(a),[center[0],center[1]-i*SCALER],[radius*0.95*posModifier,center[1]-i*SCALER]],fill:'none',stroke:'black',style:{opacity:0.3,strokeWidth:'2px'}})):null),legend:{name:__WEBPACK_IMPORTED_MODULE_0_lodash_startCase___default()(a.data.key),color:fillColor,value:Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* placeRound */])(a.data.val,3),percent:percentCalc}};});var legendRows=pieArcs.map(function(d){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:d.legend.name},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_circle___default.a,{color:d.legend.color}),' ',d.legend.name,': ',d.legend.value,' ','(',d.legend.percent,'%)');});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg',Object.assign({},rest,{viewBox:viewBox.x+' '+viewBox.y+' '+viewBox.width+' '+viewBox.height}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('g',{transform:'translate('+viewBox.width/2+', '+viewBox.height/2+')'},pieArcs.map(function(i){return i.data;}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:Object(__WEBPACK_IMPORTED_MODULE_3_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_7__PieChart_scss___default.a.legend,'list-unstyled']),style:{textAlign:'left',transform:'translateX(-50%)',width:'50%',marginLeft:'50%'}},legendRows,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',null,'Total Power Loss (W): ',Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* placeRound */])(totalLoss,3))));}}]);return PieChart;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);PieChart.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (PieChart);

/***/ }),

/***/ "./src/components/PieChart/PieChart.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"percentText":"PieChart__percentText","legend":"PieChart__legend"};

/***/ }),

/***/ "./src/components/PieChart/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PieChart__ = __webpack_require__("./src/components/PieChart/PieChart.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PieChart__["a" /* default */]);

/***/ }),

/***/ "./src/components/RevertInput/RevertInput.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RevertInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__("./node_modules/lodash/fp/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_rotate_left__ = __webpack_require__("./node_modules/react-icons/lib/fa/rotate-left.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_rotate_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_rotate_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("./src/utils/index.js");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import classes from './RevertInput.scss';
var RevertInput=function(_React$Component){_inherits(RevertInput,_React$Component);function RevertInput(){_classCallCheck(this,RevertInput);return _possibleConstructorReturn(this,(RevertInput.__proto__||Object.getPrototypeOf(RevertInput)).apply(this,arguments));}_createClass(RevertInput,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var subProps=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['enable','value']);return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* deepDiffer */])(subProps(this.props),subProps(nextProps));}// eslint-disable-line react/sort-comp
},{key:'render',value:function render(){var text=this.props.value===null?'N/A':this.props.value;// const text = this.props.value;
var string=Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* createHTMLMarkup */])('Recommended: [<span>'+text+'</span>]');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{className:this.props.className,color:'link',size:'sm',disabled:!this.props.enable,onClick:this.props.onClick},string,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_rotate_left___default.a,null));}}]);return RevertInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);RevertInput.defaultProps={className:null};/* harmony default export */ __webpack_exports__["a"] = (RevertInput);

/***/ }),

/***/ "./src/components/RevertInput/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RevertInput__ = __webpack_require__("./src/components/RevertInput/RevertInput.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RevertInput__["a" /* default */]);

/***/ }),

/***/ "./src/components/RightToolBar/RightToolBar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RightToolBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_magic__ = __webpack_require__("./node_modules/react-icons/lib/fa/magic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_magic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_magic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_chevron_circle_left__ = __webpack_require__("./node_modules/react-icons/lib/fa/chevron-circle-left.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_chevron_circle_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_chevron_circle_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_chevron_circle_right__ = __webpack_require__("./node_modules/react-icons/lib/fa/chevron-circle-right.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_chevron_circle_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_chevron_circle_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_refresh__ = __webpack_require__("./node_modules/react-icons/lib/fa/refresh.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_refresh__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import FaRotateLeft from 'react-icons/lib/fa/rotate-left';
// import FaRepeat from 'react-icons/lib/fa/repeat';
// import classes from './RightToolBar.scss';
var RightToolBar=function(_React$PureComponent){_inherits(RightToolBar,_React$PureComponent);function RightToolBar(){_classCallCheck(this,RightToolBar);return _possibleConstructorReturn(this,(RightToolBar.__proto__||Object.getPrototypeOf(RightToolBar)).apply(this,arguments));}_createClass(RightToolBar,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var _props=this.props,disableAutoComplete=_props.disableAutoComplete,onAutoComplete=_props.onAutoComplete,disableReset=_props.disableReset,onStepReset=_props.onStepReset,disableBack=_props.disableBack,onStepBackward=_props.onStepBackward,disableNext=_props.disableNext,onStepForward=_props.onStepForward;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',size:'sm',disabled:disableAutoComplete,onClick:onAutoComplete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_magic___default.a,{style:{color:'#0EADF8'}}),' Auto-Complete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',size:'sm',disabled:disableReset,onClick:onStepReset},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_refresh___default.a,{style:{color:'#FA9300'}}),' Reset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',size:'sm',disabled:disableBack,onClick:onStepBackward},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_chevron_circle_left___default.a,null),' Back')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',size:'sm',disabled:disableNext,onClick:onStepForward},'Next ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_chevron_circle_right___default.a,null))));}}]);return RightToolBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);RightToolBar.defaultProps={onUndo:function onUndo(){},onRedo:function onRedo(){}};/* harmony default export */ __webpack_exports__["a"] = (RightToolBar);

/***/ }),

/***/ "./src/components/RightToolBar/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RightToolBar__ = __webpack_require__("./src/components/RightToolBar/RightToolBar.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RightToolBar__["a" /* default */]);

/***/ }),

/***/ "./src/components/SaveDesignModal/SaveDesignModal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SaveDesignModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_global__ = __webpack_require__("./src/selectors/global.js");
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NAME_LENGTHS=[1,30];// eslint-disable-next-line react/prefer-stateless-function
var SaveDesignModal=function(_React$Component){_inherits(SaveDesignModal,_React$Component);function SaveDesignModal(props){_classCallCheck(this,SaveDesignModal);var _this=_possibleConstructorReturn(this,(SaveDesignModal.__proto__||Object.getPrototypeOf(SaveDesignModal)).call(this,props));_this.state={name:'',error:'',dirty:false,lastError:''};_this.state={name:props.initialName||'',error:props.error,lastError:props.error,dirty:false};return _this;}// eslint-disable-line react/sort-comp
_createClass(SaveDesignModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,onHide=_props.onHide,onSubmit=_props.onSubmit,loading=_props.loading,_props$initialName=_props.initialName,initialName=_props$initialName===undefined?'':_props$initialName;var _state=this.state,name=_state.name,error=_state.error;var isValidLength=name.length>NAME_LENGTHS[0]&&name.length<NAME_LENGTHS[1];var isValid=isValidLength;var isUpdatingDesign=initialName.length>0;// const isSameDesignName = isUpdatingDesign && initialName === name;
var hasError=error.length>0;var isErrorNameExists=error.startsWith('Design name');var isErrorNameExistsEqual=isErrorNameExists&&error.match(RegExp('\''+name+'\''))!==null;var submitHandler=function submitHandler(e){e.preventDefault();// if (isUpdatingDesign || e.target.name === 'overwrite') {
//   onUpdate(`${this.props.designId}/${name}`);
//   return;
// }
onSubmit(name);};var handleOnChange=function handleOnChange(e){var value=e.target.value;_this2.setState(function(_ref){var lastError=_ref.lastError;// Check if the user tries to use the same  name after an error
var val=value.replace(/[^\w-]+/g,'-');if(lastError.match(RegExp('\''+val+'\''))){return{name:val,dirty:true,error:lastError};}// Changed the name - clear any errors
return{name:val,error:'',dirty:true};});};var getFeedbackText=function getFeedbackText(){if(!isValidLength)return'Name length must be between '+NAME_LENGTHS[0]+' and '+NAME_LENGTHS[1]+' characters.';if(error){if(!isErrorNameExists||!isUpdatingDesign)return error;if(isUpdatingDesign&&isErrorNameExistsEqual&&!loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex',style:{alightItems:'baseline',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,error));}// return '\u00A0';
return'';};//     const getAlert = () => (
//       <Alert className="w-100" color={isSameDesignName ? 'warning' : 'info'}>
//         {isSameDesignName
//           ? `Warning: Using the same name will overwrite the saved design with the current parameters.\
// This action cannot be undone.`
//           : 'Note: You are saving a copy of the current design.'}
//       </Alert>
//     );
var feedback=getFeedbackText();var hasFeedback=(typeof feedback==='undefined'?'undefined':_typeof(feedback))==='object'||feedback.length>0;var inputValue=this.state.dirty?name:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Modal"],{isOpen:this.props.show,toggle:onHide},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ModalHeader"],{toggle:onHide},'Save Design'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ModalBody"],{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Form"],{onSubmit:submitHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Label"],{'for':'designName'},'Design Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Input"],{type:'text',bsSize:'lg',invalid:!isValid||hasError&&!loading,placeholder:"Untitled Design",onChange:handleOnChange,value:inputValue,disabled:loading}),hasFeedback&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["FormFeedback"],null,feedback),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["FormText"],null,'Saving...'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'primary',id:'submit',type:'submit',onClick:submitHandler,disabled:!isValid||loading||isErrorNameExistsEqual},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'secondary',onClick:onHide},'Cancel')));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,prevState){// console.log('gDSFP', nextProps, prevState);
// console.log('dirty', prevState.dirty, prevState.name, nextProps.name);
return Object.assign({},prevState,{name:prevState.name,error:nextProps.error,lastError:nextProps.error});}}]);return SaveDesignModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SaveDesignModal.defaultProps={show:false,error:'',warning:'',name:''};function mapStateToProps(state){var error=state.global.records.error||'';var initialName=Object(__WEBPACK_IMPORTED_MODULE_4__selectors_global__["c" /* getDesignName */])(state)||'';// const designId = getDesignName(state) || '';
var _state$global$records=state.global.records,loading=_state$global$records.loading,designId=_state$global$records.current;return{loading:loading,error:error,initialName:initialName,designId:designId};}// $FlowIgnore
var withRedux=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps);var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(withRedux);/* harmony default export */ __webpack_exports__["a"] = (enhancer(SaveDesignModal));

/***/ }),

/***/ "./src/components/SaveDesignModal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SaveDesignModal__ = __webpack_require__("./src/components/SaveDesignModal/SaveDesignModal.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SaveDesignModal__["a" /* default */]);

/***/ }),

/***/ "./src/components/SchematicWrapper/SchematicWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SchematicWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__("./node_modules/lodash/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_download__ = __webpack_require__("./node_modules/react-icons/lib/fa/download.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SchematicWrapper_scss__ = __webpack_require__("./src/components/SchematicWrapper/SchematicWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SchematicWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SchematicWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// import debug from '~/utils/macros/debug.macro';
// eslint-disable-next-line react/prefer-stateless-function
var SchematicWrapper=function(_React$Component){_inherits(SchematicWrapper,_React$Component);function SchematicWrapper(){_classCallCheck(this,SchematicWrapper);return _possibleConstructorReturn(this,(SchematicWrapper.__proto__||Object.getPrototypeOf(SchematicWrapper)).apply(this,arguments));}_createClass(SchematicWrapper,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:Object(__WEBPACK_IMPORTED_MODULE_4_classcat__["default"])(['col col-sm-12',__WEBPACK_IMPORTED_MODULE_10__SchematicWrapper_scss___default.a.cardHeader])},'Schematic',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{className:'ml-3',size:'sm',onClick:this.props.onDownloadSchematic},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_download___default.a,null),' Save Image')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Card"],{body:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],{sm:12,className:'pb-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pl-5 pr-5'},Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* branch */])(this.props.data.length>0,Object(__WEBPACK_IMPORTED_MODULE_7__utils__["f" /* createSVGMarkup */])(this.props.data,'div','style="width: 100%; height: 500px"'))))))));}}]);return SchematicWrapper;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);SchematicWrapper.defaultProps={data:'',onDownloadSchematic:__WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a};function mapStateToProps(state){var _getSchematic=Object(__WEBPACK_IMPORTED_MODULE_6__selectors_design__["i" /* getSchematic */])(state),data=_getSchematic.data;return{data:data};}function mapDispatchToProps(dispatch){return{onDownloadSchematic:function onDownloadSchematic(){return dispatch(__WEBPACK_IMPORTED_MODULE_8__actions_design__["a" /* actions */].downloadSchematic());}};}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps);/* harmony default export */ __webpack_exports__["a"] = (enhancer(SchematicWrapper));

/***/ }),

/***/ "./src/components/SchematicWrapper/SchematicWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SchematicWrapper__wrapper","cardHeader":"SchematicWrapper__cardHeader"};

/***/ }),

/***/ "./src/components/SchematicWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SchematicWrapper__ = __webpack_require__("./src/components/SchematicWrapper/SchematicWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SchematicWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/StackedGroup/StackedGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StackedGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__("./node_modules/lodash/some.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputField__ = __webpack_require__("./src/components/InputField/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss__ = __webpack_require__("./src/components/StackedGroup/StackedGroup.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss__ = __webpack_require__("./src/components/FieldWrapper/FieldWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */// eslint-disable-next-line react/prefer-stateless-function
var StackedGroup=function(_React$Component){_inherits(StackedGroup,_React$Component);function StackedGroup(){_classCallCheck(this,StackedGroup);return _possibleConstructorReturn(this,(StackedGroup.__proto__||Object.getPrototypeOf(StackedGroup)).apply(this,arguments));}_createClass(StackedGroup,[{key:'shouldComponentUpdate',// eslint-disable-line react/sort-comp
value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default()(this.props.value,nextProps.value);}},{key:'render',value:function render(){var hasTitle=this.props.fieldName;var hasFieldNames=__WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(this.props.value,function(v){return v[3];});var fieldNames=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(this.props.value,function(f){return hasTitle?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h6',{key:f[0]},f[3]):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h5',{key:f[0]},f[3]);});var rows=this.props.value.map(function(_ref){var _ref2=_slicedToArray(_ref,3),id=_ref2[0],val=_ref2[1],unit=_ref2[2];return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InputField__["a" /* default */],{key:id,className:Object(__WEBPACK_IMPORTED_MODULE_4_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.inputGroup]),id:id,value:val===null?'null':val,readOnly:true,unit:unit});});if(hasTitle){if(!hasFieldNames){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{sm:"7",className:__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.subHeader},this.props.fieldName),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.infoIconWrapper},this.props.tooltip),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.formGroup},rows))));}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{sm:12,style:{paddingBottom:'1rem',display:'flex'}},this.props.fieldName,this.props.tooltip),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{sm:"7",className:__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.subHeader},fieldNames),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.formGroup},rows))));}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{sm:"7",className:__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.subHeader},fieldNames),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__FieldWrapper_FieldWrapper_scss___default.a.infoIconWrapper},this.props.tooltip),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8__StackedGroup_scss___default.a.formGroup},rows))));}}]);return StackedGroup;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);StackedGroup.defaultProps={value:[]};/* harmony default export */ __webpack_exports__["a"] = (StackedGroup);

/***/ }),

/***/ "./src/components/StackedGroup/StackedGroup.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"formGroup":"StackedGroup__formGroup","inputGroup":"StackedGroup__inputGroup","subHeader":"StackedGroup__subHeader"};

/***/ }),

/***/ "./src/components/StackedGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StackedGroup__ = __webpack_require__("./src/components/StackedGroup/StackedGroup.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__StackedGroup__["a" /* default */]);

/***/ }),

/***/ "./src/components/StepGroup/StepGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StepGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__("./node_modules/lodash/noop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constants__ = __webpack_require__("./src/utils/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_stepHelpers__ = __webpack_require__("./src/utils/stepHelpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Circle__ = __webpack_require__("./src/components/Circle/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepGroup_scss__ = __webpack_require__("./src/components/StepGroup/StepGroup.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 *
 * @format
 */var StepGroup=function(_React$PureComponent){_inherits(StepGroup,_React$PureComponent);// eslint-disable-next-line react/sort-comp
// eslint-disable-line react/sort-comp
function StepGroup(props){_classCallCheck(this,StepGroup);var _this=_possibleConstructorReturn(this,(StepGroup.__proto__||Object.getPrototypeOf(StepGroup)).call(this,props));_this.state={offset:props.calcOffset(props.id),index:props.getIndex(props.id),data:Object(__WEBPACK_IMPORTED_MODULE_5__utils_stepHelpers__["e" /* getStepDataByKey */])(props.id)};_this.onClick=function(){return props.onClickHandler(props.id);};return _this;}// eslint-disable-line react/sort-comp
_createClass(StepGroup,[{key:'render',value:function render(){var _cc,_cc2,_cc3;var _props=this.props,config=_props.config,active=_props.active,status=_props.status;var _state$data=this.state.data,id=_state$data.id,name=_state$data.name,icon=_state$data.icon;var isComplete=status===__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* StepState */].COMPLETE;var isDisabled=status===__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* StepState */].DISABLED;var hasError=status===__WEBPACK_IMPORTED_MODULE_3__utils_constants__["a" /* StepState */].ERROR;var clickHandler=isDisabled?__WEBPACK_IMPORTED_MODULE_0_lodash_noop___default()():this.onClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{key:id,className:__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.svg,x:this.state.offset+0.5+'%',width:'70',onClick:clickHandler},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{style:{cursor:isDisabled?'not-allowed':'pointer'// transform: `translate(-${this.state.offset}%, 0, 0)`,
},transform:'translate(-35, 0)'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Circle__["a" /* default */],{cx:config.BASE_HEIGHT/2,cy:config.BASE_HEIGHT/2,r:(config.BASE_HEIGHT-2)/2,className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])((_cc={},_defineProperty(_cc,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.largeCircle,true),_defineProperty(_cc,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.completeRing,isComplete&&!hasError),_defineProperty(_cc,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.errorRing,hasError),_cc))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Circle__["a" /* default */],{cx:config.BASE_HEIGHT/2,cy:config.BASE_HEIGHT/2,r:(config.BASE_HEIGHT-2)/2.5,className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])((_cc2={},_defineProperty(_cc2,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.smallCircle,true),_defineProperty(_cc2,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.error,hasError),_defineProperty(_cc2,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.active,active&&!hasError),_defineProperty(_cc2,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.complete,isComplete&&!hasError),_defineProperty(_cc2,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.disabled,isDisabled&&!hasError),_cc2))}),icon&&icon.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.svgIcon,transform:'translate('+(config.BASE_HEIGHT/2-8)+', '+(config.BASE_HEIGHT/2-8)+')'},Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* createSVGMarkup */])(icon)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{textAnchor:'middle',y:config.BASE_HEIGHT/2+(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* isBrowserIE */])()?5:0),x:config.BASE_HEIGHT/2,color:'black',alignmentBaseline:'central',dominantBaseline:'central'},this.state.index),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])((_cc3={},_defineProperty(_cc3,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.nameText,true),_defineProperty(_cc3,__WEBPACK_IMPORTED_MODULE_7__StepGroup_scss___default.a.activeText,active),_cc3)),textAnchor:'middle',y:config.BASE_HEIGHT+config.TEXT_HEIGHT/2,x:config.BASE_HEIGHT/2,alignmentBaseline:'central',dominantBaseline:'central'},name)));}}]);return StepGroup;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);StepGroup.defaultProps={offset:0,calcOffset:function calcOffset(){return 0;},getIndex:function getIndex(){return 0;},config:{BASE_HEIGHT:0,RECT_HEIGHT:0,TEXT_HEIGHT:0},status:'',id:'STEP_ONE'};/* harmony default export */ __webpack_exports__["a"] = (StepGroup);

/***/ }),

/***/ "./src/components/StepGroup/StepGroup.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"svg":"StepGroup__svg","largeCircle":"StepGroup__largeCircle","smallCircle":"StepGroup__smallCircle","active":"StepGroup__active","activeRing":"StepGroup__activeRing","completeRing":"StepGroup__completeRing","pending":"StepGroup__pending","disabled":"StepGroup__disabled","complete":"StepGroup__complete","error":"StepGroup__error","errorRing":"StepGroup__errorRing","nameText":"StepGroup__nameText","activeText":"StepGroup__activeText"};

/***/ }),

/***/ "./src/components/StepGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepGroup__ = __webpack_require__("./src/components/StepGroup/StepGroup.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__StepGroup__["a" /* default */]);

/***/ }),

/***/ "./src/components/StepProgressBar/StepProgressBar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StepProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__("./node_modules/lodash/fp/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size__ = __webpack_require__("./node_modules/lodash/size.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routines_global__ = __webpack_require__("./src/routines/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_progress__ = __webpack_require__("./src/selectors/progress.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepGroup__ = __webpack_require__("./src/components/StepGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss__ = __webpack_require__("./src/components/StepProgressBar/StepProgressBar.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var defaultProps={};var config={SVG_WIDTH:100,BASE_HEIGHT:50,TEXT_HEIGHT:20,get RECT_HEIGHT(){return this.BASE_HEIGHT/2.5;},get SVG_OFFSET(){return 100-this.SVG_WIDTH;}};var StepProgressBar=function(_React$Component){_inherits(StepProgressBar,_React$Component);function StepProgressBar(){_classCallCheck(this,StepProgressBar);return _possibleConstructorReturn(this,(StepProgressBar.__proto__||Object.getPrototypeOf(StepProgressBar)).apply(this,arguments));}_createClass(StepProgressBar,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var subProps=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['stepGroupStatus','loading','hasError','active']);return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* deepDiffer */])(subProps(this.props),subProps(nextProps));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,hasError=_props.hasError,successWidth=_props.successWidth,stepList=_props.stepList,stepGroupStatus=_props.stepGroupStatus;var stepGroups=__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(stepList,function(step){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StepGroup__["a" /* default */],{key:step,id:step,config:config,onClickHandler:_this2.props.onStepGroupClick,calcOffset:_this2.props.calculateGroupOffset,getIndex:_this2.props.getGroupIndex,active:_this2.props.active===step,status:stepGroupStatus[step]});});var errorRail=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect',{className:Object(__WEBPACK_IMPORTED_MODULE_7_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.rail,__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.errorRail]),y:config.BASE_HEIGHT/2-config.RECT_HEIGHT/2+1,rx:config.RECT_HEIGHT/2,ry:config.RECT_HEIGHT/2,height:config.RECT_HEIGHT,width:'100%'});return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Row"],{noGutters:true,className:__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.navWrapper},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["Col"],{sm:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('svg',{className:__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.rootSvg,height:''+(config.BASE_HEIGHT+config.TEXT_HEIGHT),width:'100%',id:'svgProgressNav'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('pattern',{id:'pattern-stripe',width:'50',height:'4',patternUnits:'userSpaceOnUse',patternTransform:'rotate(45)'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect',{width:'25',height:'4',transform:'translate(0,0)',fill:'rgba(255, 0, 0, 80)'})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('mask',{id:'mask-stripe'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect',{x:'0',y:'0',width:'100%',height:'100%',fill:'url(#pattern-stripe)'}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect',{className:Object(__WEBPACK_IMPORTED_MODULE_7_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.rail,__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.backgroundRail]),x:'0',y:config.BASE_HEIGHT/2-config.RECT_HEIGHT/2+1,rx:config.RECT_HEIGHT/2,ry:config.RECT_HEIGHT/2,height:config.RECT_HEIGHT,width:'100%'}),Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* branch */])(hasError,errorRail),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect',{className:Object(__WEBPACK_IMPORTED_MODULE_7_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.rail,__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.widthTransition,__WEBPACK_IMPORTED_MODULE_12__StepProgressBar_scss___default.a.completeRail]),x:'0',y:config.BASE_HEIGHT/2-config.RECT_HEIGHT/2+1,rx:config.RECT_HEIGHT/2,ry:config.RECT_HEIGHT/2,height:config.RECT_HEIGHT,width:successWidth+'%'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect',{x:'0',y:config.BASE_HEIGHT/2-config.RECT_HEIGHT/2+1,rx:config.RECT_HEIGHT/2,ry:config.RECT_HEIGHT/2,height:config.RECT_HEIGHT,width:'100%',fill:'black',style:{mask:'url(#mask-stripe)'}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('g',null,stepGroups))));}}]);return StepProgressBar;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);StepProgressBar.defaultProps=defaultProps;function mapStateToProps(state,ownProps){// const stepStatus = getStatus(state);
var stepList=Object(__WEBPACK_IMPORTED_MODULE_10__selectors_progress__["j" /* getStepList */])(state);var active=Object(__WEBPACK_IMPORTED_MODULE_10__selectors_progress__["a" /* getActive */])(state);var loading=Object(__WEBPACK_IMPORTED_MODULE_10__selectors_progress__["e" /* getDesignLoading */])(state);var errors=Object(__WEBPACK_IMPORTED_MODULE_10__selectors_progress__["f" /* getErrors */])(state);var completeCount=Object(__WEBPACK_IMPORTED_MODULE_10__selectors_progress__["d" /* getCompleteCount */])(state);var stepGroupStatus=Object(__WEBPACK_IMPORTED_MODULE_10__selectors_progress__["i" /* getStatus */])(state);var len=__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(stepList)+1;var adjustedCount=completeCount+1;var calcSuccessWidth=function calcSuccessWidth(){if(adjustedCount===len-1)return 100;return 100/len*adjustedCount;};return Object.assign({},ownProps,{active:active,loading:loading,stepList:stepList,stepGroupStatus:stepGroupStatus,successWidth:calcSuccessWidth(),hasError:__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(errors)>0});}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["withHandlers"])({onJumpStep:function onJumpStep(props){return function(payload){// props.dispatch(actions.jumpStep(payload));
props.dispatch(__WEBPACK_IMPORTED_MODULE_8__routines_global__["a" /* default */].jumpToStep(payload,{skipAnalytics:true}));};},onStepGroupClick:function onStepGroupClick(props){return function(id){if(props.active!==id){props.dispatch(__WEBPACK_IMPORTED_MODULE_8__routines_global__["a" /* default */].jumpToStep(id));}};},getGroupIndex:function getGroupIndex(props){return function(id){return props.stepList.findIndex(function(i){return i===id;})+1;};},calculateGroupOffset:function calculateGroupOffset(props){return function(id){var index=props.stepList.findIndex(function(i){return i===id;});return 100/(__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(props.stepList)+1)*(index+1);};}}));/* harmony default export */ __webpack_exports__["a"] = (enhancer(StepProgressBar));

/***/ }),

/***/ "./src/components/StepProgressBar/StepProgressBar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navWrapper":"StepProgressBar__navWrapper","svg":"StepProgressBar__svg","rootSvg":"StepProgressBar__rootSvg","widthTransition":"StepProgressBar__widthTransition","rail":"StepProgressBar__rail","backgroundRail":"StepProgressBar__backgroundRail","errorRail":"StepProgressBar__errorRail","completeRail":"StepProgressBar__completeRail"};

/***/ }),

/***/ "./src/components/StepProgressBar/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepProgressBar__ = __webpack_require__("./src/components/StepProgressBar/StepProgressBar.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__StepProgressBar__["a" /* default */]);

/***/ }),

/***/ "./src/components/StepWrapper/StepWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StepWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__("./node_modules/lodash/reduce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick__ = __webpack_require__("./node_modules/lodash/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LazyImage__ = __webpack_require__("./src/components/LazyImage/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldWrapper__ = __webpack_require__("./src/components/FieldWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SubStepWrapper__ = __webpack_require__("./src/components/SubStepWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GraphRowPaderator__ = __webpack_require__("./src/components/GraphRowPaderator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss__ = __webpack_require__("./src/components/StepWrapper/StepWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable no-unused-vars */var INPUT_WIDTH=+"7";var OFFSET=+"0";var StepWrapper=function(_React$PureComponent){_inherits(StepWrapper,_React$PureComponent);function StepWrapper(){_classCallCheck(this,StepWrapper);return _possibleConstructorReturn(this,(StepWrapper.__proto__||Object.getPrototypeOf(StepWrapper)).apply(this,arguments));}_createClass(StepWrapper,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var data=this.props.data;var span=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data,'image-span',[]);var mergeSteps=span.length>0?__WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(data.steps,span.split(', ')):[];var mergedSection=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(mergeSteps,function(a,s){return[].concat(a,__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(s.images,function(img){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LazyImage__["a" /* default */],Object.assign({key:img.file},img));}));},[]);var steps=data.steps||[];var rightPane=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(steps,function(a,step,i){if(span.length>0){// merges can only be in a row - include the merged section here
if(span[0]===i){return[].concat(a,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Row"],{key:span},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{className:__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default.a.imageCol},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Card"],{body:true,className:__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default.a.imageCard},mergedSection))));}// Ignore other sections since they are already merged
if(span.includes(i))return a;}var graphs=step.graphs&&__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(step.graphs,function(graph,key){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Row"],{key:key,id:key},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{className:__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default.a.imageCol},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FieldWrapper__["a" /* default */],{id:key,data:{type:'graph',name:graph.name},style:{border:'0 !important'},onChangeHandler:function onChangeHandler(){},onRevertHandler:function onRevertHandler(){}})));});var images=step.images&&step.images.length>0&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Row"],{key:i+'-images',id:'step-images'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{className:__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default.a.imageCol},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Card"],{body:true,className:__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default.a.imageCard},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(step.images,function(img){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Row"],{key:img.file},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LazyImage__["a" /* default */],img)));}))));var padding=graphs&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__GraphRowPaderator__["a" /* default */],{key:step.name+'-padding',target:'step-images',graphTarget:'inductor-performance-summary'});return[].concat(a,images,padding,graphs);},[]);var width=INPUT_WIDTH-OFFSET*2;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Row"],{className:__WEBPACK_IMPORTED_MODULE_12__StepWrapper_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{lg:{size:width,offset:OFFSET},md:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data.steps,function(val,key){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SubStepWrapper__["a" /* default */],{key:key,data:val});})),Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* branch */])(rightPane.length>0,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["Col"],{lg:{size:12-width,offset:OFFSET},md:12,sm:12},rightPane)));}}]);return StepWrapper;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);/*
        <Col sm={12 - INPUT_WIDTH} className={classes.imageCol}>
          <Card body className={classes.imageCard}>
            {graphPane}
          </Card>
        </Col>
        */StepWrapper.defaultProps={data:{}};/* harmony default export */ __webpack_exports__["a"] = (StepWrapper);

/***/ }),

/***/ "./src/components/StepWrapper/StepWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"StepWrapper__wrapper","imageCol":"StepWrapper__imageCol","imageCard":"StepWrapper__imageCard"};

/***/ }),

/***/ "./src/components/StepWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepWrapper__ = __webpack_require__("./src/components/StepWrapper/StepWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__StepWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/SubStepWrapper/SubStepWrapper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubStepWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase__ = __webpack_require__("./node_modules/lodash/kebabCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor__ = __webpack_require__("./node_modules/react-visibility-sensor/visibility-sensor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_question_circle__ = __webpack_require__("./node_modules/react-icons/lib/fa/question-circle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_question_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_question_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FieldWrapper__ = __webpack_require__("./src/components/FieldWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldMessage__ = __webpack_require__("./src/components/FieldMessage/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HoverTooltip__ = __webpack_require__("./src/components/HoverTooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SubStepWrapper_scss__ = __webpack_require__("./src/components/SubStepWrapper/SubStepWrapper.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SubStepWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SubStepWrapper_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 */var SubStepWrapper=function(_React$PureComponent){_inherits(SubStepWrapper,_React$PureComponent);function SubStepWrapper(){_classCallCheck(this,SubStepWrapper);return _possibleConstructorReturn(this,(SubStepWrapper.__proto__||Object.getPrototypeOf(SubStepWrapper)).apply(this,arguments));}_createClass(SubStepWrapper,[{key:'render',value:function render(){var _props=this.props,data=_props.data,onChange=_props.onChange,onRevert=_props.onRevert;var badge=data.badge?data.badge.toString()+': ':'';var renderFields=function renderFields(){return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(data.fields,function(fieldData,key){var getField=function getField(){switch(fieldData.type){case'message':{return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__FieldMessage__["a" /* default */],{data:fieldData,style:key==='DtyCy_message'?{backgroundColor:'mistyrose'}:{},id:key});}default:{return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FieldWrapper__["a" /* default */],{onChangeHandler:onChange,onRevertHandler:onRevert,id:key,data:fieldData});}}};return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_visibility_sensor___default.a,{offset:{top:10,bottom:10},scrollCheck:true,delayedCall:true,key:key},getField());});};var blockTitle=''+badge+data.name;var tooltipDiv=data.description?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__HoverTooltip__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default()(blockTitle),title:Object(__WEBPACK_IMPORTED_MODULE_11__utils__["e" /* createHTMLMarkup */])(blockTitle),text:Object(__WEBPACK_IMPORTED_MODULE_11__utils__["e" /* createHTMLMarkup */])(data.description)},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_question_circle___default.a,{className:__WEBPACK_IMPORTED_MODULE_15__SubStepWrapper_scss___default.a.infoIcon,size:24})):null;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:Object(__WEBPACK_IMPORTED_MODULE_6_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_15__SubStepWrapper_scss___default.a.cardHeader]),id:__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default()(blockTitle)},blockTitle,tooltipDiv),renderFields());}}]);return SubStepWrapper;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);SubStepWrapper.defaultProps={data:{badge:'',fields:{},images:[]}};function mapStateToProps(state,ownProps){return Object.assign({},ownProps);}var enhancer=Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps),Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["withHandlers"])({onChange:function onChange(props){return function(id){return function(e){// This should prob be moved somewhere else (config maybe?)
var fieldData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(props,['data','fields',id],{});var dataTarget=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(fieldData,'dataTarget',id);var isSelection=['dropdown','radio','selecttable'].includes(fieldData.type);var value=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(e.target,'value');// return props.dispatch(actions.changeValue({
//   field: fieldId, value, isSelection,
// }));
return props.dispatch(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].changeValue({field:dataTarget,value:value,isSelection:isSelection,fieldId:id}));};};},onRevert:function onRevert(props){return function(id){var fieldData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(props,['data','fields',id],{});var fieldId=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(fieldData,['dataTarget'],id);var isSelect=['dropdown','radio','selecttable'].includes(fieldData.type);// Extra field needed to handle part reset cases (see ref#122)
var revertFieldId=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(fieldData,['revertTarget']);return props.dispatch(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].revertField({id:revertFieldId||fieldId,isSelect:isSelect}));};}}));/* harmony default export */ __webpack_exports__["a"] = (enhancer(SubStepWrapper));

/***/ }),

/***/ "./src/components/SubStepWrapper/SubStepWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SubStepWrapper__wrapper","card":"SubStepWrapper__card","imageCol":"SubStepWrapper__imageCol","imageCard":"SubStepWrapper__imageCard","cardHeader":"SubStepWrapper__cardHeader"};

/***/ }),

/***/ "./src/components/SubStepWrapper/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubStepWrapper__ = __webpack_require__("./src/components/SubStepWrapper/SubStepWrapper.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SubStepWrapper__["a" /* default */]);

/***/ }),

/***/ "./src/components/TableGroup/PowerSemiLossSummary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PowerSemiLossSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_slice__ = __webpack_require__("./node_modules/lodash/slice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss__ = __webpack_require__("./src/components/TableGroup/PowerSemiLossSummary.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable jsx-a11y/no-static-element-interactions */var hashId=new __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* HashId */]();// eslint-disable-next-line react/prefer-stateless-function
var PowerSemiLossSummary=function(_React$Component){_inherits(PowerSemiLossSummary,_React$Component);function PowerSemiLossSummary(){_classCallCheck(this,PowerSemiLossSummary);return _possibleConstructorReturn(this,(PowerSemiLossSummary.__proto__||Object.getPrototypeOf(PowerSemiLossSummary)).apply(this,arguments));}_createClass(PowerSemiLossSummary,[{key:'render',// shouldComponentUpdate(nextProps: PropsType) {
//   const subProps = pick([
//     'changed',
//     'defaultVal',
//     'error',
//     'evaluating',
//     'pos',
//     'rowData',
//     'value',
//     'warning',
//   ]);
// //   return deepDiffer(subProps(this.props), subProps(nextProps));
// }
value:function render(){var rowData=__WEBPACK_IMPORTED_MODULE_0_lodash_slice___default()(this.props.value,2);var tRows=rowData.map(function(r,k){var _rowClass;var id=r[0];if(id.includes('Rthja')){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:id,className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.partRow])},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,r[0]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{colSpan:2,className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.lightBlue},r[1]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{colSpan:2},r[3]));}var rowClass=(_rowClass={},_defineProperty(_rowClass,__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.partRow,true),_defineProperty(_rowClass,__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.totalRow,id.includes('Total')),_defineProperty(_rowClass,__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.maxRow,id.includes('max')),_rowClass);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:id,className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])([rowClass])},r.map(function(d,l){var _c;var c=(_c={},_defineProperty(_c,__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.emptyRow,l>2&&!d.length),_defineProperty(_c,__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.lightBlue,l>0&&l<3),_c);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{key:hashId.encode(''+k+l),className:Object(__WEBPACK_IMPORTED_MODULE_2_classcat__["default"])([c])},d);}));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pt-2 pl-2 pr-2 d-flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,this.props.fieldName),this.props.tooltip),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Table"],{responsive:true,size:'sm',bordered:true,className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.table},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',{className:'thead-inverse'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.emptyRow}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{colSpan:2,className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.blueHeader},'MOSFET'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{colSpan:2,className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.lightBlueHeader},'Diode')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.emptyRow}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.blueHeader},'V',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sub',null,'IN'),' min'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.blueHeader},'V',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sub',null,'IN'),' max'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.lightBlueHeader},'V',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sub',null,'IN'),' min'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:__WEBPACK_IMPORTED_MODULE_5__PowerSemiLossSummary_scss___default.a.lightBlueHeader},'V',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sub',null,'IN'),' max'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,tRows)));}}]);return PowerSemiLossSummary;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);// function mapStateToProps(
//   state: AppStateType,
//   ownProps: OwnPropsType,
// ): PropsType {
//   const values = getFieldValues(state);
//   const data = values[ownProps.id];
//   // log(data);
//   const tableData: string[][] = _.get(data, ['currentValue'], []);
//   const rowData: string[][] = _.slice(tableData, 2);
//   return {
//     ...ownProps,
//     rowData,
//   };
// }
// const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);
PowerSemiLossSummary.defaultProps={rowHeader:[],rowData:[]};/* harmony default export */ __webpack_exports__["a"] = (PowerSemiLossSummary);

/***/ }),

/***/ "./src/components/TableGroup/PowerSemiLossSummary.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"PowerSemiLossSummary__table","totalRow":"PowerSemiLossSummary__totalRow","maxRow":"PowerSemiLossSummary__maxRow","emptyRow":"PowerSemiLossSummary__emptyRow","lightBlue":"PowerSemiLossSummary__lightBlue","lightBlueHeader":"PowerSemiLossSummary__lightBlueHeader","blueHeader":"PowerSemiLossSummary__blueHeader"};

/***/ }),

/***/ "./src/components/TableGroup/TableGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TableGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_tail__ = __webpack_require__("./node_modules/lodash/tail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_tail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_tail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_every__ = __webpack_require__("./node_modules/lodash/every.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_head__ = __webpack_require__("./node_modules/lodash/head.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableGroup_scss__ = __webpack_require__("./src/components/TableGroup/TableGroup.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableGroup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__TableGroup_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable jsx-a11y/no-static-element-interactions */// import log from '~/utils/macros/debug.macro';
var hashId=new __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* HashId */]();// eslint-disable-next-line react/prefer-stateless-function
var TableGroup=function(_React$Component){_inherits(TableGroup,_React$Component);function TableGroup(){_classCallCheck(this,TableGroup);return _possibleConstructorReturn(this,(TableGroup.__proto__||Object.getPrototypeOf(TableGroup)).apply(this,arguments));}_createClass(TableGroup,[{key:'render',// eslint-disable-line react/sort-comp
value:function render(){var tHeader=this.props.rowHeader.map(function(s){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('th',{key:hashId.nextId()},s||__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',null,'\xA0'));});var tRows=this.props.rowData.map(function(r,k){var id=r[0];return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',{key:id,className:Object(__WEBPACK_IMPORTED_MODULE_6_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_10__TableGroup_scss___default.a.partRow])},r.map(function(d,l){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('td',{key:hashId.encode(''+k+l)},d);}));});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Table"],{responsive:true,size:'sm',className:__WEBPACK_IMPORTED_MODULE_10__TableGroup_scss___default.a.table},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('thead',{className:'thead-inverse'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tr',null,tHeader)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('tbody',null,tRows)));}}]);return TableGroup;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);TableGroup.defaultProps={rowHeader:[],rowData:[]};function mapStateToProps(state,ownProps){var values=Object(__WEBPACK_IMPORTED_MODULE_8__selectors_design__["f" /* getFieldValues */])(state);var data=values[ownProps.id];// log(data);
var tableData=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data,['currentValue'],[]);var headData=__WEBPACK_IMPORTED_MODULE_2_lodash_head___default()(tableData);if(__WEBPACK_IMPORTED_MODULE_1_lodash_every___default()(headData,function(s){return s.length===0;})){headData=[];}return Object.assign({},ownProps,{rowData:__WEBPACK_IMPORTED_MODULE_0_lodash_tail___default()(tableData),rowHeader:headData});}var connector=Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(TableGroup));

/***/ }),

/***/ "./src/components/TableGroup/TableGroup.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TableGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableGroup__ = __webpack_require__("./src/components/TableGroup/TableGroup.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TableGroup__["a" /* default */]);

/***/ }),

/***/ "./src/components/TableSelectionGroup/TableSelectionGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TableSelectionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__("./node_modules/lodash/fp/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head__ = __webpack_require__("./node_modules/lodash/head.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__("./node_modules/lodash/findIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_tail__ = __webpack_require__("./node_modules/lodash/tail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_tail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_tail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isArray__ = __webpack_require__("./node_modules/lodash/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classcat__ = __webpack_require__("./node_modules/classcat/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RevertInput__ = __webpack_require__("./src/components/RevertInput/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss__ = __webpack_require__("./src/components/TableSelectionGroup/TableSelectionGroup.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 
 * @format
 *//* eslint-disable jsx-a11y/no-static-element-interactions */// import log from '~/utils/macros/debug.macro';
// import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';
var hashId=new __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* HashId */]();function generateLink(part){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{href:'/PowerSolutions/product.do?id='+part,rel:'noopener noreferrer',target:'_blank'},part);}// eslint-disable-next-line react/prefer-stateless-function
var TableSelectionGroup=function(_React$Component){_inherits(TableSelectionGroup,_React$Component);function TableSelectionGroup(){_classCallCheck(this,TableSelectionGroup);return _possibleConstructorReturn(this,(TableSelectionGroup.__proto__||Object.getPrototypeOf(TableSelectionGroup)).apply(this,arguments));}_createClass(TableSelectionGroup,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var subProps=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['changed','defaultVal','dirtyVal','error','evaluating','pos','value','warning','rowData']);return!__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default()(subProps(this.props),subProps(nextProps));}},{key:'render',value:function render(){var _this2=this;if(!__WEBPACK_IMPORTED_MODULE_5_lodash_isArray___default()(this.props.rowHeader))return null;var hasError=this.props.error.length>0;var hasWarning=this.props.warning.length>0;var tHeader=this.props.rowHeader.map(function(s){var spaceIndex=s.lastIndexOf(' ');var title=spaceIndex===-1?s:s.slice(0,spaceIndex)+'</br>'+s.slice(spaceIndex+1);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('th',{className:'sticky-top',key:s},Object(__WEBPACK_IMPORTED_MODULE_12__utils__["e" /* createHTMLMarkup */])(title));});// Quick fix for #853616
var linkOrNot=function linkOrNot(str){if(_this2.props.id!=='SuitableInductors'){return generateLink(str);}return str;};var tRows=this.props.rowData.map(function(r,k){var _ref;var id=r[0];var onChange=function onChange(){return _this2.props.changeInput({target:{value:id}});};var isSelected=k===_this2.props.pos;var isDirty=id===_this2.props.dirtyVal;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('tr',{key:id,className:Object(__WEBPACK_IMPORTED_MODULE_9_classcat__["default"])([(_ref={},_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default.a.success,isSelected),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default.a.selected,isDirty),_ref),__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default.a.partRow]),onClick:onChange},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input',{type:'radio',checked:isSelected||isDirty,onChange:onChange})),r.map(function(d,l){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('td',{key:hashId.encode(''+k+l)},l===0?linkOrNot(d):d);}));});var hasData=this.props.rowData.length>0;var isEstLoss=['Losscomp_diode','Losscomp_FET'].includes(this.props.id);var getClearButton=function getClearButton(){if(_this2.props.showClear){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button',{className:'btn btn-link btn-sm',onClick:_this2.props.revertInput},'Clear previously selected part');}return null;};var getContents=function getContents(){if(hasError){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'p-2'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',null,'Error: ',_this2.props.error),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',null,getClearButton()));}if(hasWarning){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'p-2'},_this2.props.warning);}var colSpan=tHeader.length-1;// One of the th is added below
return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_9_classcat__["default"])([__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default.a.scrollable])},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('table',{className:Object(__WEBPACK_IMPORTED_MODULE_9_classcat__["default"])(['table',__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default.a.tableFixed])},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('thead',null,Object(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* branch */])(hasData&&isEstLoss,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('th',{colSpan:'2',style:{border:0,backgroundColor:'white'}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('th',{colSpan:colSpan,style:{border:0,textAlign:'center'}},'V',__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('sub',null,'in'),' = V',__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('sub',null,'in'),' MIN'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('th',{className:'sticky-top'}),tHeader)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('tbody',null,tRows)));};var canRevert=this.props.changed||this.props.value!==this.props.defaultVal;var recommendedDiv=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RevertInput__["a" /* default */]// className={fieldWrapperClasses.inputGroupDefault}
,{value:this.props.defaultVal,enable:canRevert,onClick:this.props.revertInput});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'pt-2 pl-2 pr-2 d-flex'},this.props.name,this.props.tooltip),Object(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* branch */])(isEstLoss&&!hasError,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'pb-2 pl-2'},'Please select part below')),getContents(),Object(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* branch */])(!hasError,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_14__TableSelectionGroup_scss___default.a.recommended},recommendedDiv)));}}]);return TableSelectionGroup;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);TableSelectionGroup.defaultProps={rowHeader:[],rowData:[],error:[],warning:[]};function mapStateToProps(state,ownProps){var values=Object(__WEBPACK_IMPORTED_MODULE_11__selectors_design__["f" /* getFieldValues */])(state);var dirtyValues=Object(__WEBPACK_IMPORTED_MODULE_11__selectors_design__["c" /* getDirtyFields */])(state);var id=ownProps.dataTarget||ownProps.id;var data=values[id];var dirty=dirtyValues[id];var tableData=__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data,['currentValue'],[]);var rowData=__WEBPACK_IMPORTED_MODULE_3_lodash_tail___default()(tableData);var pos=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(rowData,function(o){return o[0]===ownProps.value;});// Check if this is a clear part condition
var showClear=true;if(dirtyValues.Sel_fet_pkg===undefined&&dirtyValues.Sel_diode_pkg===undefined){showClear=false;}return Object.assign({},ownProps,{rowData:rowData,rowHeader:__WEBPACK_IMPORTED_MODULE_1_lodash_head___default()(tableData),dirtyVal:dirty,showClear:showClear,pos:pos});}var connector=Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps);/* harmony default export */ __webpack_exports__["a"] = (connector(TableSelectionGroup));

/***/ }),

/***/ "./src/components/TableSelectionGroup/TableSelectionGroup.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"TableSelectionGroup__row","selected":"TableSelectionGroup__selected","success":"TableSelectionGroup__success","tableFixed":"TableSelectionGroup__tableFixed","partRow":"TableSelectionGroup__partRow","scrollable":"TableSelectionGroup__scrollable","recommended":"TableSelectionGroup__recommended"};

/***/ }),

/***/ "./src/components/TableSelectionGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableSelectionGroup__ = __webpack_require__("./src/components/TableSelectionGroup/TableSelectionGroup.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TableSelectionGroup__["a" /* default */]);

/***/ }),

/***/ "./src/configureStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__("./node_modules/redux-saga/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__("./node_modules/redux-logger/dist/redux-logger.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middleware__ = __webpack_require__("./src/middleware/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__("./src/reducers/index.js");
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* global __DEV__ */function configureStore(){var preloadedState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// Setup middleware
var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["default"])();// $FlowIgnore
var middleware=[__WEBPACK_IMPORTED_MODULE_3__middleware__["a" /* messageForHandler */],__WEBPACK_IMPORTED_MODULE_3__middleware__["b" /* modalOpenHelper */],__WEBPACK_IMPORTED_MODULE_3__middleware__["c" /* scrollMiddleware */],sagaMiddleware];if(false){// Debug for dev if not set
if(!window.localStorage.getItem('debug')){window.localStorage.setItem('debug',process.env.REACT_APP_DEBUG);}// eslint-disable-next-line global-require
window.DUMP_RESPONSE=require('./utils/dumpResponse').default;// Logging in dev only
var logger=createLogger({diff:process.env.REACT_APP_LOGGER_DIFF,diffPredicate:function diffPredicate(getState,action){return!['Design/UPDATE'].includes(action.type);},duration:true,collapsed:function collapsed(getState,action,logEntry){return!logEntry.error;}});middleware.push(logger);// Redux state invarent check
// eslint-disable-next-line global-require
middleware.push(require('redux-immutable-state-invariant').default());// Monkey patch react to help us figure out render issues
// eslint-disable-next-line global-require
// const { whyDidYouUpdate } = require('why-did-you-update');
// whyDidYouUpdate(React);
}/* eslint-disable */var composeSetup= false?window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__:__WEBPACK_IMPORTED_MODULE_0_redux__["compose"];/* eslint-enable */var applyedMiddleware=__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined,middleware);var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */],preloadedState,composeSetup(applyedMiddleware)// allows redux devtools to watch sagas
);// $FlowIgnore
store.run=sagaMiddleware.run;return store;}/* harmony default export */ __webpack_exports__["a"] = (configureStore);

/***/ }),

/***/ "./src/extra/canvg/StackBlur.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*

StackBlur - a fast almost Gaussian Blur For Canvas

Version: 	0.5
Author:		Mario Klingemann
Contact: 	mario@quasimondo.com
Website:	http://www.quasimondo.com/StackBlurForCanvas
Twitter:	@quasimondo

In case you find this class useful - especially in commercial projects -
I am not totally unhappy for a small donation to my PayPal account
mario@quasimondo.de

Or support me on flattr:
https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

Copyright (c) 2010 Mario Klingemann

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.
*//* eslint-disable */(function(global){var mul_table=[512,512,456,512,328,456,335,512,405,328,271,456,388,335,292,512,454,405,364,328,298,271,496,456,420,388,360,335,312,292,273,512,482,454,428,405,383,364,345,328,312,298,284,271,259,496,475,456,437,420,404,388,374,360,347,335,323,312,302,292,282,273,265,512,497,482,468,454,441,428,417,405,394,383,373,364,354,345,337,328,320,312,305,298,291,284,278,271,265,259,507,496,485,475,465,456,446,437,428,420,412,404,396,388,381,374,367,360,354,347,341,335,329,323,318,312,307,302,297,292,287,282,278,273,269,265,261,512,505,497,489,482,475,468,461,454,447,441,435,428,422,417,411,405,399,394,389,383,378,373,368,364,359,354,350,345,341,337,332,328,324,320,316,312,309,305,301,298,294,291,287,284,281,278,274,271,268,265,262,259,257,507,501,496,491,485,480,475,470,465,460,456,451,446,442,437,433,428,424,420,416,412,408,404,400,396,392,388,385,381,377,374,370,367,363,360,357,354,350,347,344,341,338,335,332,329,326,323,320,318,315,312,310,307,304,302,299,297,294,292,289,287,285,282,280,278,275,273,271,269,267,265,263,261,259];var shg_table=[9,11,12,13,13,14,14,15,15,15,15,16,16,16,16,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24];function premultiplyAlpha(imageData){var pixels=imageData.data;var size=imageData.width*imageData.height*4;for(var i=0;i<size;i+=4){var a=pixels[i+3]/255;pixels[i]*=a;pixels[i+1]*=a;pixels[i+2]*=a;}}function unpremultiplyAlpha(imageData){var pixels=imageData.data;var size=imageData.width*imageData.height*4;for(var i=0;i<size;i+=4){var a=pixels[i+3];if(a!=0){a=255/a;pixels[i]*=a;pixels[i+1]*=a;pixels[i+2]*=a;}}}function stackBlurImage(imageID,canvasID,radius,blurAlphaChannel){var img=document.getElementById(imageID);var w=img.naturalWidth;var h=img.naturalHeight;var canvas=document.getElementById(canvasID);canvas.style.width=w+"px";canvas.style.height=h+"px";canvas.width=w;canvas.height=h;var context=canvas.getContext("2d");context.clearRect(0,0,w,h);context.drawImage(img,0,0);if(isNaN(radius)||radius<1)return;if(blurAlphaChannel)stackBlurCanvasRGBA(canvasID,0,0,w,h,radius);else stackBlurCanvasRGB(canvasID,0,0,w,h,radius);}function stackBlurCanvasRGBA(id,top_x,top_y,width,height,radius){if(isNaN(radius)||radius<1)return;radius|=0;var canvas=document.getElementById(id);var context=canvas.getContext("2d");var imageData;try{try{imageData=context.getImageData(top_x,top_y,width,height);}catch(e){// NOTE: this part is supposedly only needed if you want to work with local files
// so it might be okay to remove the whole try/catch block and just use
// imageData = context.getImageData( top_x, top_y, width, height );
try{netscape.security.PrivilegeManager.enablePrivilege("UniversalBrowserRead");imageData=context.getImageData(top_x,top_y,width,height);}catch(e){alert("Cannot access local image");throw new Error("unable to access local image data: "+e);return;}}}catch(e){alert("Cannot access image");throw new Error("unable to access image data: "+e);}premultiplyAlpha(imageData);var pixels=imageData.data;var x,y,i,p,yp,yi,yw,r_sum,g_sum,b_sum,a_sum,r_out_sum,g_out_sum,b_out_sum,a_out_sum,r_in_sum,g_in_sum,b_in_sum,a_in_sum,pr,pg,pb,pa,rbs;var div=radius+radius+1;var w4=width<<2;var widthMinus1=width-1;var heightMinus1=height-1;var radiusPlus1=radius+1;var sumFactor=radiusPlus1*(radiusPlus1+1)/2;var stackStart=new BlurStack();var stack=stackStart;for(i=1;i<div;i++){stack=stack.next=new BlurStack();if(i==radiusPlus1)var stackEnd=stack;}stack.next=stackStart;var stackIn=null;var stackOut=null;yw=yi=0;var mul_sum=mul_table[radius];var shg_sum=shg_table[radius];for(y=0;y<height;y++){r_in_sum=g_in_sum=b_in_sum=a_in_sum=r_sum=g_sum=b_sum=a_sum=0;r_out_sum=radiusPlus1*(pr=pixels[yi]);g_out_sum=radiusPlus1*(pg=pixels[yi+1]);b_out_sum=radiusPlus1*(pb=pixels[yi+2]);a_out_sum=radiusPlus1*(pa=pixels[yi+3]);r_sum+=sumFactor*pr;g_sum+=sumFactor*pg;b_sum+=sumFactor*pb;a_sum+=sumFactor*pa;stack=stackStart;for(i=0;i<radiusPlus1;i++){stack.r=pr;stack.g=pg;stack.b=pb;stack.a=pa;stack=stack.next;}for(i=1;i<radiusPlus1;i++){p=yi+((widthMinus1<i?widthMinus1:i)<<2);r_sum+=(stack.r=pr=pixels[p])*(rbs=radiusPlus1-i);g_sum+=(stack.g=pg=pixels[p+1])*rbs;b_sum+=(stack.b=pb=pixels[p+2])*rbs;a_sum+=(stack.a=pa=pixels[p+3])*rbs;r_in_sum+=pr;g_in_sum+=pg;b_in_sum+=pb;a_in_sum+=pa;stack=stack.next;}stackIn=stackStart;stackOut=stackEnd;for(x=0;x<width;x++){pixels[yi]=r_sum*mul_sum>>shg_sum;pixels[yi+1]=g_sum*mul_sum>>shg_sum;pixels[yi+2]=b_sum*mul_sum>>shg_sum;pixels[yi+3]=a_sum*mul_sum>>shg_sum;r_sum-=r_out_sum;g_sum-=g_out_sum;b_sum-=b_out_sum;a_sum-=a_out_sum;r_out_sum-=stackIn.r;g_out_sum-=stackIn.g;b_out_sum-=stackIn.b;a_out_sum-=stackIn.a;p=yw+((p=x+radius+1)<widthMinus1?p:widthMinus1)<<2;r_in_sum+=stackIn.r=pixels[p];g_in_sum+=stackIn.g=pixels[p+1];b_in_sum+=stackIn.b=pixels[p+2];a_in_sum+=stackIn.a=pixels[p+3];r_sum+=r_in_sum;g_sum+=g_in_sum;b_sum+=b_in_sum;a_sum+=a_in_sum;stackIn=stackIn.next;r_out_sum+=pr=stackOut.r;g_out_sum+=pg=stackOut.g;b_out_sum+=pb=stackOut.b;a_out_sum+=pa=stackOut.a;r_in_sum-=pr;g_in_sum-=pg;b_in_sum-=pb;a_in_sum-=pa;stackOut=stackOut.next;yi+=4;}yw+=width;}for(x=0;x<width;x++){g_in_sum=b_in_sum=a_in_sum=r_in_sum=g_sum=b_sum=a_sum=r_sum=0;yi=x<<2;r_out_sum=radiusPlus1*(pr=pixels[yi]);g_out_sum=radiusPlus1*(pg=pixels[yi+1]);b_out_sum=radiusPlus1*(pb=pixels[yi+2]);a_out_sum=radiusPlus1*(pa=pixels[yi+3]);r_sum+=sumFactor*pr;g_sum+=sumFactor*pg;b_sum+=sumFactor*pb;a_sum+=sumFactor*pa;stack=stackStart;for(i=0;i<radiusPlus1;i++){stack.r=pr;stack.g=pg;stack.b=pb;stack.a=pa;stack=stack.next;}yp=width;for(i=1;i<=radius;i++){yi=yp+x<<2;r_sum+=(stack.r=pr=pixels[yi])*(rbs=radiusPlus1-i);g_sum+=(stack.g=pg=pixels[yi+1])*rbs;b_sum+=(stack.b=pb=pixels[yi+2])*rbs;a_sum+=(stack.a=pa=pixels[yi+3])*rbs;r_in_sum+=pr;g_in_sum+=pg;b_in_sum+=pb;a_in_sum+=pa;stack=stack.next;if(i<heightMinus1){yp+=width;}}yi=x;stackIn=stackStart;stackOut=stackEnd;for(y=0;y<height;y++){p=yi<<2;pixels[p]=r_sum*mul_sum>>shg_sum;pixels[p+1]=g_sum*mul_sum>>shg_sum;pixels[p+2]=b_sum*mul_sum>>shg_sum;pixels[p+3]=a_sum*mul_sum>>shg_sum;r_sum-=r_out_sum;g_sum-=g_out_sum;b_sum-=b_out_sum;a_sum-=a_out_sum;r_out_sum-=stackIn.r;g_out_sum-=stackIn.g;b_out_sum-=stackIn.b;a_out_sum-=stackIn.a;p=x+((p=y+radiusPlus1)<heightMinus1?p:heightMinus1)*width<<2;r_sum+=r_in_sum+=stackIn.r=pixels[p];g_sum+=g_in_sum+=stackIn.g=pixels[p+1];b_sum+=b_in_sum+=stackIn.b=pixels[p+2];a_sum+=a_in_sum+=stackIn.a=pixels[p+3];stackIn=stackIn.next;r_out_sum+=pr=stackOut.r;g_out_sum+=pg=stackOut.g;b_out_sum+=pb=stackOut.b;a_out_sum+=pa=stackOut.a;r_in_sum-=pr;g_in_sum-=pg;b_in_sum-=pb;a_in_sum-=pa;stackOut=stackOut.next;yi+=width;}}unpremultiplyAlpha(imageData);context.putImageData(imageData,top_x,top_y);}function stackBlurCanvasRGB(id,top_x,top_y,width,height,radius){if(isNaN(radius)||radius<1)return;radius|=0;var canvas=document.getElementById(id);var context=canvas.getContext("2d");var imageData;try{try{imageData=context.getImageData(top_x,top_y,width,height);}catch(e){// NOTE: this part is supposedly only needed if you want to work with local files
// so it might be okay to remove the whole try/catch block and just use
// imageData = context.getImageData( top_x, top_y, width, height );
try{netscape.security.PrivilegeManager.enablePrivilege("UniversalBrowserRead");imageData=context.getImageData(top_x,top_y,width,height);}catch(e){alert("Cannot access local image");throw new Error("unable to access local image data: "+e);return;}}}catch(e){alert("Cannot access image");throw new Error("unable to access image data: "+e);}var pixels=imageData.data;var x,y,i,p,yp,yi,yw,r_sum,g_sum,b_sum,r_out_sum,g_out_sum,b_out_sum,r_in_sum,g_in_sum,b_in_sum,pr,pg,pb,rbs;var div=radius+radius+1;var w4=width<<2;var widthMinus1=width-1;var heightMinus1=height-1;var radiusPlus1=radius+1;var sumFactor=radiusPlus1*(radiusPlus1+1)/2;var stackStart=new BlurStack();var stack=stackStart;for(i=1;i<div;i++){stack=stack.next=new BlurStack();if(i==radiusPlus1)var stackEnd=stack;}stack.next=stackStart;var stackIn=null;var stackOut=null;yw=yi=0;var mul_sum=mul_table[radius];var shg_sum=shg_table[radius];for(y=0;y<height;y++){r_in_sum=g_in_sum=b_in_sum=r_sum=g_sum=b_sum=0;r_out_sum=radiusPlus1*(pr=pixels[yi]);g_out_sum=radiusPlus1*(pg=pixels[yi+1]);b_out_sum=radiusPlus1*(pb=pixels[yi+2]);r_sum+=sumFactor*pr;g_sum+=sumFactor*pg;b_sum+=sumFactor*pb;stack=stackStart;for(i=0;i<radiusPlus1;i++){stack.r=pr;stack.g=pg;stack.b=pb;stack=stack.next;}for(i=1;i<radiusPlus1;i++){p=yi+((widthMinus1<i?widthMinus1:i)<<2);r_sum+=(stack.r=pr=pixels[p])*(rbs=radiusPlus1-i);g_sum+=(stack.g=pg=pixels[p+1])*rbs;b_sum+=(stack.b=pb=pixels[p+2])*rbs;r_in_sum+=pr;g_in_sum+=pg;b_in_sum+=pb;stack=stack.next;}stackIn=stackStart;stackOut=stackEnd;for(x=0;x<width;x++){pixels[yi]=r_sum*mul_sum>>shg_sum;pixels[yi+1]=g_sum*mul_sum>>shg_sum;pixels[yi+2]=b_sum*mul_sum>>shg_sum;r_sum-=r_out_sum;g_sum-=g_out_sum;b_sum-=b_out_sum;r_out_sum-=stackIn.r;g_out_sum-=stackIn.g;b_out_sum-=stackIn.b;p=yw+((p=x+radius+1)<widthMinus1?p:widthMinus1)<<2;r_in_sum+=stackIn.r=pixels[p];g_in_sum+=stackIn.g=pixels[p+1];b_in_sum+=stackIn.b=pixels[p+2];r_sum+=r_in_sum;g_sum+=g_in_sum;b_sum+=b_in_sum;stackIn=stackIn.next;r_out_sum+=pr=stackOut.r;g_out_sum+=pg=stackOut.g;b_out_sum+=pb=stackOut.b;r_in_sum-=pr;g_in_sum-=pg;b_in_sum-=pb;stackOut=stackOut.next;yi+=4;}yw+=width;}for(x=0;x<width;x++){g_in_sum=b_in_sum=r_in_sum=g_sum=b_sum=r_sum=0;yi=x<<2;r_out_sum=radiusPlus1*(pr=pixels[yi]);g_out_sum=radiusPlus1*(pg=pixels[yi+1]);b_out_sum=radiusPlus1*(pb=pixels[yi+2]);r_sum+=sumFactor*pr;g_sum+=sumFactor*pg;b_sum+=sumFactor*pb;stack=stackStart;for(i=0;i<radiusPlus1;i++){stack.r=pr;stack.g=pg;stack.b=pb;stack=stack.next;}yp=width;for(i=1;i<=radius;i++){yi=yp+x<<2;r_sum+=(stack.r=pr=pixels[yi])*(rbs=radiusPlus1-i);g_sum+=(stack.g=pg=pixels[yi+1])*rbs;b_sum+=(stack.b=pb=pixels[yi+2])*rbs;r_in_sum+=pr;g_in_sum+=pg;b_in_sum+=pb;stack=stack.next;if(i<heightMinus1){yp+=width;}}yi=x;stackIn=stackStart;stackOut=stackEnd;for(y=0;y<height;y++){p=yi<<2;pixels[p]=r_sum*mul_sum>>shg_sum;pixels[p+1]=g_sum*mul_sum>>shg_sum;pixels[p+2]=b_sum*mul_sum>>shg_sum;r_sum-=r_out_sum;g_sum-=g_out_sum;b_sum-=b_out_sum;r_out_sum-=stackIn.r;g_out_sum-=stackIn.g;b_out_sum-=stackIn.b;p=x+((p=y+radiusPlus1)<heightMinus1?p:heightMinus1)*width<<2;r_sum+=r_in_sum+=stackIn.r=pixels[p];g_sum+=g_in_sum+=stackIn.g=pixels[p+1];b_sum+=b_in_sum+=stackIn.b=pixels[p+2];stackIn=stackIn.next;r_out_sum+=pr=stackOut.r;g_out_sum+=pg=stackOut.g;b_out_sum+=pb=stackOut.b;r_in_sum-=pr;g_in_sum-=pg;b_in_sum-=pb;stackOut=stackOut.next;yi+=width;}}context.putImageData(imageData,top_x,top_y);}function BlurStack(){this.r=0;this.g=0;this.b=0;this.a=0;this.next=null;}var stackBlur={image:stackBlurImage,canvasRGBA:stackBlurCanvasRGBA,canvasRGB:stackBlurCanvasRGB};// export as AMD...
if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return stackBlur;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// ...or as browserify
else if(typeof module!=='undefined'&&module.exports){module.exports=stackBlur;}global.stackBlur=stackBlur;})(typeof window!=='undefined'?window:this);

/***/ }),

/***/ "./src/extra/canvg/canvg.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * canvg.js - Javascript SVG parser and renderer on Canvas
 * MIT Licensed
 * Gabe Lerner (gabelerner@gmail.com)
 * http://code.google.com/p/canvg/
 *
 * Requires: rgbcolor.js - http://www.phpied.com/rgb-color-parser-in-javascript/
 *//* eslint-disable */(function(global,factory){'use strict';// export as AMD...
if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./src/extra/canvg/rgbcolor.js"),__webpack_require__("./src/extra/canvg/StackBlur.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// ...or as browserify
else if(typeof module!=='undefined'&&module.exports){module.exports=factory(require('./rgbcolor'),require('./StackBlur'));}global.canvg=factory(global.RGBColor,global.stackBlur);})(typeof window!=='undefined'?window:this,function(RGBColor,stackBlur){// canvg(target, s)
// empty parameters: replace all 'svg' elements on page with 'canvas' elements
// target: canvas element or the id of a canvas element
// s: svg string, url to svg file, or xml document
// opts: optional hash of options
//		 ignoreMouse: true => ignore mouse events
//		 ignoreAnimation: true => ignore animations
//		 ignoreDimensions: true => does not try to resize canvas
//		 ignoreClear: true => does not clear canvas
//		 offsetX: int => draws at a x offset
//		 offsetY: int => draws at a y offset
//		 scaleWidth: int => scales horizontally to width
//		 scaleHeight: int => scales vertically to height
//		 renderCallback: function => will call the function after the first render is completed
//		 forceRedraw: function => will call the function on every frame, if it returns true, will redraw
var canvg=function canvg(target,s,opts){// no parameters
if(target==null&&s==null&&opts==null){var svgTags=document.querySelectorAll('svg');for(var i=0;i<svgTags.length;i++){var svgTag=svgTags[i];var c=document.createElement('canvas');c.width=svgTag.clientWidth;c.height=svgTag.clientHeight;svgTag.parentNode.insertBefore(c,svgTag);svgTag.parentNode.removeChild(svgTag);var div=document.createElement('div');div.appendChild(svgTag);canvg(c,div.innerHTML);}return;}if(typeof target=='string'){target=document.getElementById(target);}// store class on canvas
if(target.svg!=null)target.svg.stop();var svg=build(opts||{});// on i.e. 8 for flash canvas, we can't assign the property so check for it
if(!(target.childNodes.length==1&&target.childNodes[0].nodeName=='OBJECT'))target.svg=svg;var ctx=target.getContext('2d');if(typeof s.documentElement!='undefined'){// load from xml doc
svg.loadXmlDoc(ctx,s);}else if(s.substr(0,1)=='<'){// load from xml string
svg.loadXml(ctx,s);}else{// load from url
svg.load(ctx,s);}};// see https://developer.mozilla.org/en-US/docs/Web/API/Element.matches
var matchesSelector;if(typeof Element.prototype.matches!='undefined'){matchesSelector=function matchesSelector(node,selector){return node.matches(selector);};}else if(typeof Element.prototype.webkitMatchesSelector!='undefined'){matchesSelector=function matchesSelector(node,selector){return node.webkitMatchesSelector(selector);};}else if(typeof Element.prototype.mozMatchesSelector!='undefined'){matchesSelector=function matchesSelector(node,selector){return node.mozMatchesSelector(selector);};}else if(typeof Element.prototype.msMatchesSelector!='undefined'){matchesSelector=function matchesSelector(node,selector){return node.msMatchesSelector(selector);};}else if(typeof Element.prototype.oMatchesSelector!='undefined'){matchesSelector=function matchesSelector(node,selector){return node.oMatchesSelector(selector);};}else{// requires Sizzle: https://github.com/jquery/sizzle/wiki/Sizzle-Documentation
// or jQuery: http://jquery.com/download/
// or Zepto: http://zeptojs.com/#
// without it, this is a ReferenceError
if(typeof jQuery==='function'||typeof Zepto==='function'){matchesSelector=function matchesSelector(node,selector){return $(node).is(selector);};}if(typeof matchesSelector==='undefined'){matchesSelector=Sizzle.matchesSelector;}}// slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
var attributeRegex=/(\[[^\]]+\])/g;var idRegex=/(#[^\s\+>~\.\[:]+)/g;var classRegex=/(\.[^\s\+>~\.\[:]+)/g;var pseudoElementRegex=/(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi;var pseudoClassWithBracketsRegex=/(:[\w-]+\([^\)]*\))/gi;var pseudoClassRegex=/(:[^\s\+>~\.\[:]+)/g;var elementRegex=/([^\s\+>~\.\[:]+)/g;function getSelectorSpecificity(selector){var typeCount=[0,0,0];var findMatch=function findMatch(regex,type){var matches=selector.match(regex);if(matches==null){return;}typeCount[type]+=matches.length;selector=selector.replace(regex,' ');};selector=selector.replace(/:not\(([^\)]*)\)/g,'     $1 ');selector=selector.replace(/{[\s\S]*/gm,' ');findMatch(attributeRegex,1);findMatch(idRegex,0);findMatch(classRegex,1);findMatch(pseudoElementRegex,2);findMatch(pseudoClassWithBracketsRegex,1);findMatch(pseudoClassRegex,1);selector=selector.replace(/[\*\s\+>~]/g,' ');selector=selector.replace(/[#\.]/g,' ');findMatch(elementRegex,2);return typeCount.join('');}function build(opts){var svg={opts:opts};svg.FRAMERATE=30;svg.MAX_VIRTUAL_PIXELS=30000;svg.log=function(msg){};if(svg.opts['log']==true&&typeof console!='undefined'){svg.log=function(msg){console.log(msg);};};// globals
svg.init=function(ctx){var uniqueId=0;svg.UniqueId=function(){uniqueId++;return'canvg'+uniqueId;};svg.Definitions={};svg.Styles={};svg.StylesSpecificity={};svg.Animations=[];svg.Images=[];svg.ctx=ctx;svg.ViewPort=new function(){this.viewPorts=[];this.Clear=function(){this.viewPorts=[];};this.SetCurrent=function(width,height){this.viewPorts.push({width:width,height:height});};this.RemoveCurrent=function(){this.viewPorts.pop();};this.Current=function(){return this.viewPorts[this.viewPorts.length-1];};this.width=function(){return this.Current().width;};this.height=function(){return this.Current().height;};this.ComputeSize=function(d){if(d!=null&&typeof d=='number')return d;if(d=='x')return this.width();if(d=='y')return this.height();return Math.sqrt(Math.pow(this.width(),2)+Math.pow(this.height(),2))/Math.sqrt(2);};}();};svg.init();// images loaded
svg.ImagesLoaded=function(){for(var i=0;i<svg.Images.length;i++){if(!svg.Images[i].loaded)return false;}return true;};// trim
svg.trim=function(s){return s.replace(/^\s+|\s+$/g,'');};// compress spaces
svg.compressSpaces=function(s){return s.replace(/[\s\r\t\n]+/gm,' ');};// ajax
svg.ajax=function(url){var AJAX;if(window.XMLHttpRequest){AJAX=new XMLHttpRequest();}else{AJAX=new ActiveXObject('Microsoft.XMLHTTP');}if(AJAX){AJAX.open('GET',url,false);AJAX.send(null);return AJAX.responseText;}return null;};// parse xml
svg.parseXml=function(xml){if(typeof Windows!='undefined'&&typeof Windows.Data!='undefined'&&typeof Windows.Data.Xml!='undefined'){var xmlDoc=new Windows.Data.Xml.Dom.XmlDocument();var settings=new Windows.Data.Xml.Dom.XmlLoadSettings();settings.prohibitDtd=false;xmlDoc.loadXml(xml,settings);return xmlDoc;}else if(window.DOMParser){try{var parser=new DOMParser();return parser.parseFromString(xml,'image/svg+xml');}catch(e){parser=new DOMParser();return parser.parseFromString(xml,'text/xml');}}else{xml=xml.replace(/<!DOCTYPE svg[^>]*>/,'');var xmlDoc=new ActiveXObject('Microsoft.XMLDOM');xmlDoc.async='false';xmlDoc.loadXML(xml);return xmlDoc;}};svg.Property=function(name,value){this.name=name;this.value=value;};svg.Property.prototype.getValue=function(){return this.value;};svg.Property.prototype.hasValue=function(){return this.value!=null&&this.value!=='';};// return the numerical value of the property
svg.Property.prototype.numValue=function(){if(!this.hasValue())return 0;var n=parseFloat(this.value);if((this.value+'').match(/%$/)){n=n/100.0;}return n;};svg.Property.prototype.valueOrDefault=function(def){if(this.hasValue())return this.value;return def;};svg.Property.prototype.numValueOrDefault=function(def){if(this.hasValue())return this.numValue();return def;};// color extensions
// augment the current color value with the opacity
svg.Property.prototype.addOpacity=function(opacityProp){var newValue=this.value;if(opacityProp.value!=null&&opacityProp.value!=''&&typeof this.value=='string'){// can only add opacity to colors, not patterns
var color=new RGBColor(this.value);if(color.ok){newValue='rgba('+color.r+', '+color.g+', '+color.b+', '+opacityProp.numValue()+')';}}return new svg.Property(this.name,newValue);};// definition extensions
// get the definition from the definitions table
svg.Property.prototype.getDefinition=function(){var name=this.value.match(/#([^\)'"]+)/);if(name){name=name[1];}if(!name){name=this.value;}return svg.Definitions[name];};svg.Property.prototype.isUrlDefinition=function(){return this.value.indexOf('url(')==0;};svg.Property.prototype.getFillStyleDefinition=function(e,opacityProp){var def=this.getDefinition();// gradient
if(def!=null&&def.createGradient){return def.createGradient(svg.ctx,e,opacityProp);}// pattern
if(def!=null&&def.createPattern){if(def.getHrefAttribute().hasValue()){var pt=def.attribute('patternTransform');def=def.getHrefAttribute().getDefinition();if(pt.hasValue()){def.attribute('patternTransform',true).value=pt.value;}}return def.createPattern(svg.ctx,e);}return null;};// length extensions
svg.Property.prototype.getDPI=function(viewPort){return 96.0;// TODO: compute?
};svg.Property.prototype.getEM=function(viewPort){var em=12;var fontSize=new svg.Property('fontSize',svg.Font.Parse(svg.ctx.font).fontSize);if(fontSize.hasValue())em=fontSize.toPixels(viewPort);return em;};svg.Property.prototype.getUnits=function(){var s=this.value+'';return s.replace(/[0-9\.\-]/g,'');};// get the length as pixels
svg.Property.prototype.toPixels=function(viewPort,processPercent){if(!this.hasValue())return 0;var s=this.value+'';if(s.match(/em$/))return this.numValue()*this.getEM(viewPort);if(s.match(/ex$/))return this.numValue()*this.getEM(viewPort)/2.0;if(s.match(/px$/))return this.numValue();if(s.match(/pt$/))return this.numValue()*this.getDPI(viewPort)*(1.0/72.0);if(s.match(/pc$/))return this.numValue()*15;if(s.match(/cm$/))return this.numValue()*this.getDPI(viewPort)/2.54;if(s.match(/mm$/))return this.numValue()*this.getDPI(viewPort)/25.4;if(s.match(/in$/))return this.numValue()*this.getDPI(viewPort);if(s.match(/%$/))return this.numValue()*svg.ViewPort.ComputeSize(viewPort);var n=this.numValue();if(processPercent&&n<1.0)return n*svg.ViewPort.ComputeSize(viewPort);return n;};// time extensions
// get the time as milliseconds
svg.Property.prototype.toMilliseconds=function(){if(!this.hasValue())return 0;var s=this.value+'';if(s.match(/s$/))return this.numValue()*1000;if(s.match(/ms$/))return this.numValue();return this.numValue();};// angle extensions
// get the angle as radians
svg.Property.prototype.toRadians=function(){if(!this.hasValue())return 0;var s=this.value+'';if(s.match(/deg$/))return this.numValue()*(Math.PI/180.0);if(s.match(/grad$/))return this.numValue()*(Math.PI/200.0);if(s.match(/rad$/))return this.numValue();return this.numValue()*(Math.PI/180.0);};// text extensions
// get the text baseline
var textBaselineMapping={'baseline':'alphabetic','before-edge':'top','text-before-edge':'top','middle':'middle','central':'middle','after-edge':'bottom','text-after-edge':'bottom','ideographic':'ideographic','alphabetic':'alphabetic','hanging':'hanging','mathematical':'alphabetic'};svg.Property.prototype.toTextBaseline=function(){if(!this.hasValue())return null;return textBaselineMapping[this.value];};// fonts
svg.Font=new function(){this.Styles='normal|italic|oblique|inherit';this.Variants='normal|small-caps|inherit';this.Weights='normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';this.CreateFont=function(fontStyle,fontVariant,fontWeight,fontSize,fontFamily,inherit){var f=inherit!=null?this.Parse(inherit):this.CreateFont('','','','','',svg.ctx.font);return{fontFamily:fontFamily||f.fontFamily,fontSize:fontSize||f.fontSize,fontStyle:fontStyle||f.fontStyle,fontWeight:fontWeight||f.fontWeight,fontVariant:fontVariant||f.fontVariant,toString:function toString(){return[this.fontStyle,this.fontVariant,this.fontWeight,this.fontSize,this.fontFamily].join(' ');}};};var that=this;this.Parse=function(s){var f={};var d=svg.trim(svg.compressSpaces(s||'')).split(' ');var set={fontSize:false,fontStyle:false,fontWeight:false,fontVariant:false};var ff='';for(var i=0;i<d.length;i++){if(!set.fontStyle&&that.Styles.indexOf(d[i])!=-1){if(d[i]!='inherit')f.fontStyle=d[i];set.fontStyle=true;}else if(!set.fontVariant&&that.Variants.indexOf(d[i])!=-1){if(d[i]!='inherit')f.fontVariant=d[i];set.fontStyle=set.fontVariant=true;}else if(!set.fontWeight&&that.Weights.indexOf(d[i])!=-1){if(d[i]!='inherit')f.fontWeight=d[i];set.fontStyle=set.fontVariant=set.fontWeight=true;}else if(!set.fontSize){if(d[i]!='inherit')f.fontSize=d[i].split('/')[0];set.fontStyle=set.fontVariant=set.fontWeight=set.fontSize=true;}else{if(d[i]!='inherit')ff+=d[i];}}if(ff!='')f.fontFamily=ff;return f;};}();// points and paths
svg.ToNumberArray=function(s){var a=svg.trim(svg.compressSpaces((s||'').replace(/,/g,' '))).split(' ');for(var i=0;i<a.length;i++){a[i]=parseFloat(a[i]);}return a;};svg.Point=function(x,y){this.x=x;this.y=y;};svg.Point.prototype.angleTo=function(p){return Math.atan2(p.y-this.y,p.x-this.x);};svg.Point.prototype.applyTransform=function(v){var xp=this.x*v[0]+this.y*v[2]+v[4];var yp=this.x*v[1]+this.y*v[3]+v[5];this.x=xp;this.y=yp;};svg.CreatePoint=function(s){var a=svg.ToNumberArray(s);return new svg.Point(a[0],a[1]);};svg.CreatePath=function(s){var a=svg.ToNumberArray(s);var path=[];for(var i=0;i<a.length;i+=2){path.push(new svg.Point(a[i],a[i+1]));}return path;};// bounding box
svg.BoundingBox=function(x1,y1,x2,y2){// pass in initial points if you want
this.x1=Number.NaN;this.y1=Number.NaN;this.x2=Number.NaN;this.y2=Number.NaN;this.x=function(){return this.x1;};this.y=function(){return this.y1;};this.width=function(){return this.x2-this.x1;};this.height=function(){return this.y2-this.y1;};this.addPoint=function(x,y){if(x!=null){if(isNaN(this.x1)||isNaN(this.x2)){this.x1=x;this.x2=x;}if(x<this.x1)this.x1=x;if(x>this.x2)this.x2=x;}if(y!=null){if(isNaN(this.y1)||isNaN(this.y2)){this.y1=y;this.y2=y;}if(y<this.y1)this.y1=y;if(y>this.y2)this.y2=y;}};this.addX=function(x){this.addPoint(x,null);};this.addY=function(y){this.addPoint(null,y);};this.addBoundingBox=function(bb){this.addPoint(bb.x1,bb.y1);this.addPoint(bb.x2,bb.y2);};this.addQuadraticCurve=function(p0x,p0y,p1x,p1y,p2x,p2y){var cp1x=p0x+2/3*(p1x-p0x);// CP1 = QP0 + 2/3 *(QP1-QP0)
var cp1y=p0y+2/3*(p1y-p0y);// CP1 = QP0 + 2/3 *(QP1-QP0)
var cp2x=cp1x+1/3*(p2x-p0x);// CP2 = CP1 + 1/3 *(QP2-QP0)
var cp2y=cp1y+1/3*(p2y-p0y);// CP2 = CP1 + 1/3 *(QP2-QP0)
this.addBezierCurve(p0x,p0y,cp1x,cp2x,cp1y,cp2y,p2x,p2y);};this.addBezierCurve=function(p0x,p0y,p1x,p1y,p2x,p2y,p3x,p3y){// from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
var p0=[p0x,p0y],p1=[p1x,p1y],p2=[p2x,p2y],p3=[p3x,p3y];this.addPoint(p0[0],p0[1]);this.addPoint(p3[0],p3[1]);for(i=0;i<=1;i++){var f=function f(t){return Math.pow(1-t,3)*p0[i]+3*Math.pow(1-t,2)*t*p1[i]+3*(1-t)*Math.pow(t,2)*p2[i]+Math.pow(t,3)*p3[i];};var b=6*p0[i]-12*p1[i]+6*p2[i];var a=-3*p0[i]+9*p1[i]-9*p2[i]+3*p3[i];var c=3*p1[i]-3*p0[i];if(a==0){if(b==0)continue;var t=-c/b;if(0<t&&t<1){if(i==0)this.addX(f(t));if(i==1)this.addY(f(t));}continue;}var b2ac=Math.pow(b,2)-4*c*a;if(b2ac<0)continue;var t1=(-b+Math.sqrt(b2ac))/(2*a);if(0<t1&&t1<1){if(i==0)this.addX(f(t1));if(i==1)this.addY(f(t1));}var t2=(-b-Math.sqrt(b2ac))/(2*a);if(0<t2&&t2<1){if(i==0)this.addX(f(t2));if(i==1)this.addY(f(t2));}}};this.isPointInBox=function(x,y){return this.x1<=x&&x<=this.x2&&this.y1<=y&&y<=this.y2;};this.addPoint(x1,y1);this.addPoint(x2,y2);};// transforms
svg.Transform=function(v){var that=this;this.Type={};// translate
this.Type.translate=function(s){this.p=svg.CreatePoint(s);this.apply=function(ctx){ctx.translate(this.p.x||0.0,this.p.y||0.0);};this.unapply=function(ctx){ctx.translate(-1.0*this.p.x||0.0,-1.0*this.p.y||0.0);};this.applyToPoint=function(p){p.applyTransform([1,0,0,1,this.p.x||0.0,this.p.y||0.0]);};};// rotate
this.Type.rotate=function(s){var a=svg.ToNumberArray(s);this.angle=new svg.Property('angle',a[0]);this.cx=a[1]||0;this.cy=a[2]||0;this.apply=function(ctx){ctx.translate(this.cx,this.cy);ctx.rotate(this.angle.toRadians());ctx.translate(-this.cx,-this.cy);};this.unapply=function(ctx){ctx.translate(this.cx,this.cy);ctx.rotate(-1.0*this.angle.toRadians());ctx.translate(-this.cx,-this.cy);};this.applyToPoint=function(p){var a=this.angle.toRadians();p.applyTransform([1,0,0,1,this.p.x||0.0,this.p.y||0.0]);p.applyTransform([Math.cos(a),Math.sin(a),-Math.sin(a),Math.cos(a),0,0]);p.applyTransform([1,0,0,1,-this.p.x||0.0,-this.p.y||0.0]);};};this.Type.scale=function(s){this.p=svg.CreatePoint(s);this.apply=function(ctx){ctx.scale(this.p.x||1.0,this.p.y||this.p.x||1.0);};this.unapply=function(ctx){ctx.scale(1.0/this.p.x||1.0,1.0/this.p.y||this.p.x||1.0);};this.applyToPoint=function(p){p.applyTransform([this.p.x||0.0,0,0,this.p.y||0.0,0,0]);};};this.Type.matrix=function(s){this.m=svg.ToNumberArray(s);this.apply=function(ctx){ctx.transform(this.m[0],this.m[1],this.m[2],this.m[3],this.m[4],this.m[5]);};this.unapply=function(ctx){var a=this.m[0];var b=this.m[2];var c=this.m[4];var d=this.m[1];var e=this.m[3];var f=this.m[5];var g=0.0;var h=0.0;var i=1.0;var det=1/(a*(e*i-f*h)-b*(d*i-f*g)+c*(d*h-e*g));ctx.transform(det*(e*i-f*h),det*(f*g-d*i),det*(c*h-b*i),det*(a*i-c*g),det*(b*f-c*e),det*(c*d-a*f));};this.applyToPoint=function(p){p.applyTransform(this.m);};};this.Type.SkewBase=function(s){this.base=that.Type.matrix;this.base(s);this.angle=new svg.Property('angle',s);};this.Type.SkewBase.prototype=new this.Type.matrix();this.Type.skewX=function(s){this.base=that.Type.SkewBase;this.base(s);this.m=[1,0,Math.tan(this.angle.toRadians()),1,0,0];};this.Type.skewX.prototype=new this.Type.SkewBase();this.Type.skewY=function(s){this.base=that.Type.SkewBase;this.base(s);this.m=[1,Math.tan(this.angle.toRadians()),0,1,0,0];};this.Type.skewY.prototype=new this.Type.SkewBase();this.transforms=[];this.apply=function(ctx){for(var i=0;i<this.transforms.length;i++){this.transforms[i].apply(ctx);}};this.unapply=function(ctx){for(var i=this.transforms.length-1;i>=0;i--){this.transforms[i].unapply(ctx);}};this.applyToPoint=function(p){for(var i=0;i<this.transforms.length;i++){this.transforms[i].applyToPoint(p);}};var data=svg.trim(svg.compressSpaces(v)).replace(/\)([a-zA-Z])/g,') $1').replace(/\)(\s?,\s?)/g,') ').split(/\s(?=[a-z])/);for(var i=0;i<data.length;i++){var type=svg.trim(data[i].split('(')[0]);var s=data[i].split('(')[1].replace(')','');var transformType=this.Type[type];if(typeof transformType!='undefined'){var transform=new transformType(s);transform.type=type;this.transforms.push(transform);}}};// aspect ratio
svg.AspectRatio=function(ctx,aspectRatio,width,desiredWidth,height,desiredHeight,minX,minY,refX,refY){// aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
aspectRatio=svg.compressSpaces(aspectRatio);aspectRatio=aspectRatio.replace(/^defer\s/,'');// ignore defer
var align=aspectRatio.split(' ')[0]||'xMidYMid';var meetOrSlice=aspectRatio.split(' ')[1]||'meet';// calculate scale
var scaleX=width/desiredWidth;var scaleY=height/desiredHeight;var scaleMin=Math.min(scaleX,scaleY);var scaleMax=Math.max(scaleX,scaleY);if(meetOrSlice=='meet'){desiredWidth*=scaleMin;desiredHeight*=scaleMin;}if(meetOrSlice=='slice'){desiredWidth*=scaleMax;desiredHeight*=scaleMax;}refX=new svg.Property('refX',refX);refY=new svg.Property('refY',refY);if(refX.hasValue()&&refY.hasValue()){ctx.translate(-scaleMin*refX.toPixels('x'),-scaleMin*refY.toPixels('y'));}else{// align
if(align.match(/^xMid/)&&(meetOrSlice=='meet'&&scaleMin==scaleY||meetOrSlice=='slice'&&scaleMax==scaleY))ctx.translate(width/2.0-desiredWidth/2.0,0);if(align.match(/YMid$/)&&(meetOrSlice=='meet'&&scaleMin==scaleX||meetOrSlice=='slice'&&scaleMax==scaleX))ctx.translate(0,height/2.0-desiredHeight/2.0);if(align.match(/^xMax/)&&(meetOrSlice=='meet'&&scaleMin==scaleY||meetOrSlice=='slice'&&scaleMax==scaleY))ctx.translate(width-desiredWidth,0);if(align.match(/YMax$/)&&(meetOrSlice=='meet'&&scaleMin==scaleX||meetOrSlice=='slice'&&scaleMax==scaleX))ctx.translate(0,height-desiredHeight);}// scale
if(align=='none')ctx.scale(scaleX,scaleY);else if(meetOrSlice=='meet')ctx.scale(scaleMin,scaleMin);else if(meetOrSlice=='slice')ctx.scale(scaleMax,scaleMax);// translate
ctx.translate(minX==null?0:-minX,minY==null?0:-minY);};// elements
svg.Element={};svg.EmptyProperty=new svg.Property('EMPTY','');svg.Element.ElementBase=function(node){this.attributes={};this.styles={};this.stylesSpecificity={};this.children=[];// get or create attribute
this.attribute=function(name,createIfNotExists){var a=this.attributes[name];if(a!=null)return a;if(createIfNotExists==true){a=new svg.Property(name,'');this.attributes[name]=a;}return a||svg.EmptyProperty;};this.getHrefAttribute=function(){for(var a in this.attributes){if(a=='href'||a.match(/:href$/)){return this.attributes[a];}}return svg.EmptyProperty;};// get or create style, crawls up node tree
this.style=function(name,createIfNotExists,skipAncestors){var s=this.styles[name];if(s!=null)return s;var a=this.attribute(name);if(a!=null&&a.hasValue()){this.styles[name]=a;// move up to me to cache
return a;}if(skipAncestors!=true){var p=this.parent;if(p!=null){var ps=p.style(name);if(ps!=null&&ps.hasValue()){return ps;}}}if(createIfNotExists==true){s=new svg.Property(name,'');this.styles[name]=s;}return s||svg.EmptyProperty;};// base render
this.render=function(ctx){// don't render display=none
if(this.style('display').value=='none')return;// don't render visibility=hidden
if(this.style('visibility').value=='hidden')return;ctx.save();if(this.style('mask').hasValue()){// mask
var mask=this.style('mask').getDefinition();if(mask!=null)mask.apply(ctx,this);}else if(this.style('filter').hasValue()){// filter
var filter=this.style('filter').getDefinition();if(filter!=null)filter.apply(ctx,this);}else{this.setContext(ctx);this.renderChildren(ctx);this.clearContext(ctx);}ctx.restore();};// base set context
this.setContext=function(ctx){}// OVERRIDE ME!
// base clear context
;this.clearContext=function(ctx){}// OVERRIDE ME!
// base render children
;this.renderChildren=function(ctx){for(var i=0;i<this.children.length;i++){this.children[i].render(ctx);}};this.addChild=function(childNode,create){var child=childNode;if(create)child=svg.CreateElement(childNode);child.parent=this;if(child.type!='title'){this.children.push(child);}};this.addStylesFromStyleDefinition=function(){// add styles
for(var selector in svg.Styles){if(selector[0]!='@'&&matchesSelector(node,selector)){var styles=svg.Styles[selector];var specificity=svg.StylesSpecificity[selector];if(styles!=null){for(var name in styles){var existingSpecificity=this.stylesSpecificity[name];if(typeof existingSpecificity=='undefined'){existingSpecificity='000';}if(specificity>existingSpecificity){this.styles[name]=styles[name];this.stylesSpecificity[name]=specificity;}}}}}};// Microsoft Edge fix
var allUppercase=new RegExp("^[A-Z\-]+$");var normalizeAttributeName=function normalizeAttributeName(name){if(allUppercase.test(name)){return name.toLowerCase();}return name;};if(node!=null&&node.nodeType==1){//ELEMENT_NODE
// add attributes
for(var i=0;i<node.attributes.length;i++){var attribute=node.attributes[i];var nodeName=normalizeAttributeName(attribute.nodeName);this.attributes[nodeName]=new svg.Property(nodeName,attribute.value);}this.addStylesFromStyleDefinition();// add inline styles
if(this.attribute('style').hasValue()){var styles=this.attribute('style').value.split(';');for(var i=0;i<styles.length;i++){if(svg.trim(styles[i])!=''){var style=styles[i].split(':');var name=svg.trim(style[0]);var value=svg.trim(style[1]);this.styles[name]=new svg.Property(name,value);}}}// add id
if(this.attribute('id').hasValue()){if(svg.Definitions[this.attribute('id').value]==null){svg.Definitions[this.attribute('id').value]=this;}}// add children
for(var i=0;i<node.childNodes.length;i++){var childNode=node.childNodes[i];if(childNode.nodeType==1)this.addChild(childNode,true);//ELEMENT_NODE
if(this.captureTextNodes&&(childNode.nodeType==3||childNode.nodeType==4)){var text=childNode.value||childNode.text||childNode.textContent||'';if(svg.compressSpaces(text)!=''){this.addChild(new svg.Element.tspan(childNode),false);// TEXT_NODE
}}}}};svg.Element.RenderedElementBase=function(node){this.base=svg.Element.ElementBase;this.base(node);this.setContext=function(ctx){// fill
if(this.style('fill').isUrlDefinition()){var fs=this.style('fill').getFillStyleDefinition(this,this.style('fill-opacity'));if(fs!=null)ctx.fillStyle=fs;}else if(this.style('fill').hasValue()){var fillStyle=this.style('fill');if(fillStyle.value=='currentColor')fillStyle.value=this.style('color').value;if(fillStyle.value!='inherit')ctx.fillStyle=fillStyle.value=='none'?'rgba(0,0,0,0)':fillStyle.value;}if(this.style('fill-opacity').hasValue()){var fillStyle=new svg.Property('fill',ctx.fillStyle);fillStyle=fillStyle.addOpacity(this.style('fill-opacity'));ctx.fillStyle=fillStyle.value;}// stroke
if(this.style('stroke').isUrlDefinition()){var fs=this.style('stroke').getFillStyleDefinition(this,this.style('stroke-opacity'));if(fs!=null)ctx.strokeStyle=fs;}else if(this.style('stroke').hasValue()){var strokeStyle=this.style('stroke');if(strokeStyle.value=='currentColor')strokeStyle.value=this.style('color').value;if(strokeStyle.value!='inherit')ctx.strokeStyle=strokeStyle.value=='none'?'rgba(0,0,0,0)':strokeStyle.value;}if(this.style('stroke-opacity').hasValue()){var strokeStyle=new svg.Property('stroke',ctx.strokeStyle);strokeStyle=strokeStyle.addOpacity(this.style('stroke-opacity'));ctx.strokeStyle=strokeStyle.value;}if(this.style('stroke-width').hasValue()){var newLineWidth=this.style('stroke-width').toPixels();ctx.lineWidth=newLineWidth==0?0.001:newLineWidth;// browsers don't respect 0
}if(this.style('stroke-linecap').hasValue())ctx.lineCap=this.style('stroke-linecap').value;if(this.style('stroke-linejoin').hasValue())ctx.lineJoin=this.style('stroke-linejoin').value;if(this.style('stroke-miterlimit').hasValue())ctx.miterLimit=this.style('stroke-miterlimit').value;if(this.style('stroke-dasharray').hasValue()&&this.style('stroke-dasharray').value!='none'){var gaps=svg.ToNumberArray(this.style('stroke-dasharray').value);if(typeof ctx.setLineDash!='undefined'){ctx.setLineDash(gaps);}else if(typeof ctx.webkitLineDash!='undefined'){ctx.webkitLineDash=gaps;}else if(typeof ctx.mozDash!='undefined'&&!(gaps.length==1&&gaps[0]==0)){ctx.mozDash=gaps;}var offset=this.style('stroke-dashoffset').numValueOrDefault(1);if(typeof ctx.lineDashOffset!='undefined'){ctx.lineDashOffset=offset;}else if(typeof ctx.webkitLineDashOffset!='undefined'){ctx.webkitLineDashOffset=offset;}else if(typeof ctx.mozDashOffset!='undefined'){ctx.mozDashOffset=offset;}}// font
if(typeof ctx.font!='undefined'){ctx.font=svg.Font.CreateFont(this.style('font-style').value,this.style('font-variant').value,this.style('font-weight').value,this.style('font-size').hasValue()?this.style('font-size').toPixels()+'px':'',this.style('font-family').value).toString();}// transform
if(this.style('transform',false,true).hasValue()){var transform=new svg.Transform(this.style('transform',false,true).value);transform.apply(ctx);}// clip
if(this.style('clip-path',false,true).hasValue()){var clip=this.style('clip-path',false,true).getDefinition();if(clip!=null)clip.apply(ctx);}// opacity
if(this.style('opacity').hasValue()){ctx.globalAlpha=this.style('opacity').numValue();}};};svg.Element.RenderedElementBase.prototype=new svg.Element.ElementBase();svg.Element.PathElementBase=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);this.path=function(ctx){if(ctx!=null)ctx.beginPath();return new svg.BoundingBox();};this.renderChildren=function(ctx){this.path(ctx);svg.Mouse.checkPath(this,ctx);if(ctx.fillStyle!=''){if(this.style('fill-rule').valueOrDefault('inherit')!='inherit'){ctx.fill(this.style('fill-rule').value);}else{ctx.fill();}}if(ctx.strokeStyle!='')ctx.stroke();var markers=this.getMarkers();if(markers!=null){if(this.style('marker-start').isUrlDefinition()){var marker=this.style('marker-start').getDefinition();marker.render(ctx,markers[0][0],markers[0][1]);}if(this.style('marker-mid').isUrlDefinition()){var marker=this.style('marker-mid').getDefinition();for(var i=1;i<markers.length-1;i++){marker.render(ctx,markers[i][0],markers[i][1]);}}if(this.style('marker-end').isUrlDefinition()){var marker=this.style('marker-end').getDefinition();marker.render(ctx,markers[markers.length-1][0],markers[markers.length-1][1]);}}};this.getBoundingBox=function(){return this.path();};this.getMarkers=function(){return null;};};svg.Element.PathElementBase.prototype=new svg.Element.RenderedElementBase();// svg element
svg.Element.svg=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);this.baseClearContext=this.clearContext;this.clearContext=function(ctx){this.baseClearContext(ctx);svg.ViewPort.RemoveCurrent();};this.baseSetContext=this.setContext;this.setContext=function(ctx){// initial values and defaults
ctx.strokeStyle='rgba(0,0,0,0)';ctx.lineCap='butt';ctx.lineJoin='miter';ctx.miterLimit=4;if(typeof ctx.font!='undefined'&&typeof window.getComputedStyle!='undefined'){ctx.font=window.getComputedStyle(ctx.canvas).getPropertyValue('font');}this.baseSetContext(ctx);// create new view port
if(!this.attribute('x').hasValue())this.attribute('x',true).value=0;if(!this.attribute('y').hasValue())this.attribute('y',true).value=0;ctx.translate(this.attribute('x').toPixels('x'),this.attribute('y').toPixels('y'));var width=svg.ViewPort.width();var height=svg.ViewPort.height();if(!this.attribute('width').hasValue())this.attribute('width',true).value='100%';if(!this.attribute('height').hasValue())this.attribute('height',true).value='100%';if(typeof this.root=='undefined'){width=this.attribute('width').toPixels('x');height=this.attribute('height').toPixels('y');var x=0;var y=0;if(this.attribute('refX').hasValue()&&this.attribute('refY').hasValue()){x=-this.attribute('refX').toPixels('x');y=-this.attribute('refY').toPixels('y');}if(this.attribute('overflow').valueOrDefault('hidden')!='visible'){ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(width,y);ctx.lineTo(width,height);ctx.lineTo(x,height);ctx.closePath();ctx.clip();}}svg.ViewPort.SetCurrent(width,height);// viewbox
if(this.attribute('viewBox').hasValue()){var viewBox=svg.ToNumberArray(this.attribute('viewBox').value);var minX=viewBox[0];var minY=viewBox[1];width=viewBox[2];height=viewBox[3];svg.AspectRatio(ctx,this.attribute('preserveAspectRatio').value,svg.ViewPort.width(),width,svg.ViewPort.height(),height,minX,minY,this.attribute('refX').value,this.attribute('refY').value);svg.ViewPort.RemoveCurrent();svg.ViewPort.SetCurrent(viewBox[2],viewBox[3]);}};};svg.Element.svg.prototype=new svg.Element.RenderedElementBase();// rect element
svg.Element.rect=function(node){this.base=svg.Element.PathElementBase;this.base(node);this.path=function(ctx){var x=this.attribute('x').toPixels('x');var y=this.attribute('y').toPixels('y');var width=this.attribute('width').toPixels('x');var height=this.attribute('height').toPixels('y');var rx=this.attribute('rx').toPixels('x');var ry=this.attribute('ry').toPixels('y');if(this.attribute('rx').hasValue()&&!this.attribute('ry').hasValue())ry=rx;if(this.attribute('ry').hasValue()&&!this.attribute('rx').hasValue())rx=ry;rx=Math.min(rx,width/2.0);ry=Math.min(ry,height/2.0);if(ctx!=null){ctx.beginPath();ctx.moveTo(x+rx,y);ctx.lineTo(x+width-rx,y);ctx.quadraticCurveTo(x+width,y,x+width,y+ry);ctx.lineTo(x+width,y+height-ry);ctx.quadraticCurveTo(x+width,y+height,x+width-rx,y+height);ctx.lineTo(x+rx,y+height);ctx.quadraticCurveTo(x,y+height,x,y+height-ry);ctx.lineTo(x,y+ry);ctx.quadraticCurveTo(x,y,x+rx,y);ctx.closePath();}return new svg.BoundingBox(x,y,x+width,y+height);};};svg.Element.rect.prototype=new svg.Element.PathElementBase();// circle element
svg.Element.circle=function(node){this.base=svg.Element.PathElementBase;this.base(node);this.path=function(ctx){var cx=this.attribute('cx').toPixels('x');var cy=this.attribute('cy').toPixels('y');var r=this.attribute('r').toPixels();if(ctx!=null){ctx.beginPath();ctx.arc(cx,cy,r,0,Math.PI*2,true);ctx.closePath();}return new svg.BoundingBox(cx-r,cy-r,cx+r,cy+r);};};svg.Element.circle.prototype=new svg.Element.PathElementBase();// ellipse element
svg.Element.ellipse=function(node){this.base=svg.Element.PathElementBase;this.base(node);this.path=function(ctx){var KAPPA=4*((Math.sqrt(2)-1)/3);var rx=this.attribute('rx').toPixels('x');var ry=this.attribute('ry').toPixels('y');var cx=this.attribute('cx').toPixels('x');var cy=this.attribute('cy').toPixels('y');if(ctx!=null){ctx.beginPath();ctx.moveTo(cx,cy-ry);ctx.bezierCurveTo(cx+KAPPA*rx,cy-ry,cx+rx,cy-KAPPA*ry,cx+rx,cy);ctx.bezierCurveTo(cx+rx,cy+KAPPA*ry,cx+KAPPA*rx,cy+ry,cx,cy+ry);ctx.bezierCurveTo(cx-KAPPA*rx,cy+ry,cx-rx,cy+KAPPA*ry,cx-rx,cy);ctx.bezierCurveTo(cx-rx,cy-KAPPA*ry,cx-KAPPA*rx,cy-ry,cx,cy-ry);ctx.closePath();}return new svg.BoundingBox(cx-rx,cy-ry,cx+rx,cy+ry);};};svg.Element.ellipse.prototype=new svg.Element.PathElementBase();// line element
svg.Element.line=function(node){this.base=svg.Element.PathElementBase;this.base(node);this.getPoints=function(){return[new svg.Point(this.attribute('x1').toPixels('x'),this.attribute('y1').toPixels('y')),new svg.Point(this.attribute('x2').toPixels('x'),this.attribute('y2').toPixels('y'))];};this.path=function(ctx){var points=this.getPoints();if(ctx!=null){ctx.beginPath();ctx.moveTo(points[0].x,points[0].y);ctx.lineTo(points[1].x,points[1].y);}return new svg.BoundingBox(points[0].x,points[0].y,points[1].x,points[1].y);};this.getMarkers=function(){var points=this.getPoints();var a=points[0].angleTo(points[1]);return[[points[0],a],[points[1],a]];};};svg.Element.line.prototype=new svg.Element.PathElementBase();// polyline element
svg.Element.polyline=function(node){this.base=svg.Element.PathElementBase;this.base(node);this.points=svg.CreatePath(this.attribute('points').value);this.path=function(ctx){var bb=new svg.BoundingBox(this.points[0].x,this.points[0].y);if(ctx!=null){ctx.beginPath();ctx.moveTo(this.points[0].x,this.points[0].y);}for(var i=1;i<this.points.length;i++){bb.addPoint(this.points[i].x,this.points[i].y);if(ctx!=null)ctx.lineTo(this.points[i].x,this.points[i].y);}return bb;};this.getMarkers=function(){var markers=[];for(var i=0;i<this.points.length-1;i++){markers.push([this.points[i],this.points[i].angleTo(this.points[i+1])]);}if(markers.length>0){markers.push([this.points[this.points.length-1],markers[markers.length-1][1]]);}return markers;};};svg.Element.polyline.prototype=new svg.Element.PathElementBase();// polygon element
svg.Element.polygon=function(node){this.base=svg.Element.polyline;this.base(node);this.basePath=this.path;this.path=function(ctx){var bb=this.basePath(ctx);if(ctx!=null){ctx.lineTo(this.points[0].x,this.points[0].y);ctx.closePath();}return bb;};};svg.Element.polygon.prototype=new svg.Element.polyline();// path element
svg.Element.path=function(node){this.base=svg.Element.PathElementBase;this.base(node);var d=this.attribute('d').value;// TODO: convert to real lexer based on http://www.w3.org/TR/SVG11/paths.html#PathDataBNF
d=d.replace(/,/gm,' ');// get rid of all commas
// As the end of a match can also be the start of the next match, we need to run this replace twice.
for(var i=0;i<2;i++){d=d.replace(/([MmZzLlHhVvCcSsQqTtAa])([^\s])/gm,'$1 $2');}// suffix commands with spaces
d=d.replace(/([^\s])([MmZzLlHhVvCcSsQqTtAa])/gm,'$1 $2');// prefix commands with spaces
d=d.replace(/([0-9])([+\-])/gm,'$1 $2');// separate digits on +- signs
// Again, we need to run this twice to find all occurances
for(var i=0;i<2;i++){d=d.replace(/(\.[0-9]*)(\.)/gm,'$1 $2');}// separate digits when they start with a comma
d=d.replace(/([Aa](\s+[0-9]+){3})\s+([01])\s*([01])/gm,'$1 $3 $4 ');// shorthand elliptical arc path syntax
d=svg.compressSpaces(d);// compress multiple spaces
d=svg.trim(d);this.PathParser=new function(d){this.tokens=d.split(' ');this.reset=function(){this.i=-1;this.command='';this.previousCommand='';this.start=new svg.Point(0,0);this.control=new svg.Point(0,0);this.current=new svg.Point(0,0);this.points=[];this.angles=[];};this.isEnd=function(){return this.i>=this.tokens.length-1;};this.isCommandOrEnd=function(){if(this.isEnd())return true;return this.tokens[this.i+1].match(/^[A-Za-z]$/)!=null;};this.isRelativeCommand=function(){switch(this.command){case'm':case'l':case'h':case'v':case'c':case's':case'q':case't':case'a':case'z':return true;break;}return false;};this.getToken=function(){this.i++;return this.tokens[this.i];};this.getScalar=function(){return parseFloat(this.getToken());};this.nextCommand=function(){this.previousCommand=this.command;this.command=this.getToken();};this.getPoint=function(){var p=new svg.Point(this.getScalar(),this.getScalar());return this.makeAbsolute(p);};this.getAsControlPoint=function(){var p=this.getPoint();this.control=p;return p;};this.getAsCurrentPoint=function(){var p=this.getPoint();this.current=p;return p;};this.getReflectedControlPoint=function(){if(this.previousCommand.toLowerCase()!='c'&&this.previousCommand.toLowerCase()!='s'&&this.previousCommand.toLowerCase()!='q'&&this.previousCommand.toLowerCase()!='t'){return this.current;}// reflect point
var p=new svg.Point(2*this.current.x-this.control.x,2*this.current.y-this.control.y);return p;};this.makeAbsolute=function(p){if(this.isRelativeCommand()){p.x+=this.current.x;p.y+=this.current.y;}return p;};this.addMarker=function(p,from,priorTo){// if the last angle isn't filled in because we didn't have this point yet ...
if(priorTo!=null&&this.angles.length>0&&this.angles[this.angles.length-1]==null){this.angles[this.angles.length-1]=this.points[this.points.length-1].angleTo(priorTo);}this.addMarkerAngle(p,from==null?null:from.angleTo(p));};this.addMarkerAngle=function(p,a){this.points.push(p);this.angles.push(a);};this.getMarkerPoints=function(){return this.points;};this.getMarkerAngles=function(){for(var i=0;i<this.angles.length;i++){if(this.angles[i]==null){for(var j=i+1;j<this.angles.length;j++){if(this.angles[j]!=null){this.angles[i]=this.angles[j];break;}}}}return this.angles;};}(d);this.path=function(ctx){var pp=this.PathParser;pp.reset();var bb=new svg.BoundingBox();if(ctx!=null)ctx.beginPath();while(!pp.isEnd()){pp.nextCommand();switch(pp.command){case'M':case'm':var p=pp.getAsCurrentPoint();pp.addMarker(p);bb.addPoint(p.x,p.y);if(ctx!=null)ctx.moveTo(p.x,p.y);pp.start=pp.current;while(!pp.isCommandOrEnd()){var p=pp.getAsCurrentPoint();pp.addMarker(p,pp.start);bb.addPoint(p.x,p.y);if(ctx!=null)ctx.lineTo(p.x,p.y);}break;case'L':case'l':while(!pp.isCommandOrEnd()){var c=pp.current;var p=pp.getAsCurrentPoint();pp.addMarker(p,c);bb.addPoint(p.x,p.y);if(ctx!=null)ctx.lineTo(p.x,p.y);}break;case'H':case'h':while(!pp.isCommandOrEnd()){var newP=new svg.Point((pp.isRelativeCommand()?pp.current.x:0)+pp.getScalar(),pp.current.y);pp.addMarker(newP,pp.current);pp.current=newP;bb.addPoint(pp.current.x,pp.current.y);if(ctx!=null)ctx.lineTo(pp.current.x,pp.current.y);}break;case'V':case'v':while(!pp.isCommandOrEnd()){var newP=new svg.Point(pp.current.x,(pp.isRelativeCommand()?pp.current.y:0)+pp.getScalar());pp.addMarker(newP,pp.current);pp.current=newP;bb.addPoint(pp.current.x,pp.current.y);if(ctx!=null)ctx.lineTo(pp.current.x,pp.current.y);}break;case'C':case'c':while(!pp.isCommandOrEnd()){var curr=pp.current;var p1=pp.getPoint();var cntrl=pp.getAsControlPoint();var cp=pp.getAsCurrentPoint();pp.addMarker(cp,cntrl,p1);bb.addBezierCurve(curr.x,curr.y,p1.x,p1.y,cntrl.x,cntrl.y,cp.x,cp.y);if(ctx!=null)ctx.bezierCurveTo(p1.x,p1.y,cntrl.x,cntrl.y,cp.x,cp.y);}break;case'S':case's':while(!pp.isCommandOrEnd()){var curr=pp.current;var p1=pp.getReflectedControlPoint();var cntrl=pp.getAsControlPoint();var cp=pp.getAsCurrentPoint();pp.addMarker(cp,cntrl,p1);bb.addBezierCurve(curr.x,curr.y,p1.x,p1.y,cntrl.x,cntrl.y,cp.x,cp.y);if(ctx!=null)ctx.bezierCurveTo(p1.x,p1.y,cntrl.x,cntrl.y,cp.x,cp.y);}break;case'Q':case'q':while(!pp.isCommandOrEnd()){var curr=pp.current;var cntrl=pp.getAsControlPoint();var cp=pp.getAsCurrentPoint();pp.addMarker(cp,cntrl,cntrl);bb.addQuadraticCurve(curr.x,curr.y,cntrl.x,cntrl.y,cp.x,cp.y);if(ctx!=null)ctx.quadraticCurveTo(cntrl.x,cntrl.y,cp.x,cp.y);}break;case'T':case't':while(!pp.isCommandOrEnd()){var curr=pp.current;var cntrl=pp.getReflectedControlPoint();pp.control=cntrl;var cp=pp.getAsCurrentPoint();pp.addMarker(cp,cntrl,cntrl);bb.addQuadraticCurve(curr.x,curr.y,cntrl.x,cntrl.y,cp.x,cp.y);if(ctx!=null)ctx.quadraticCurveTo(cntrl.x,cntrl.y,cp.x,cp.y);}break;case'A':case'a':while(!pp.isCommandOrEnd()){var curr=pp.current;var rx=pp.getScalar();var ry=pp.getScalar();var xAxisRotation=pp.getScalar()*(Math.PI/180.0);var largeArcFlag=pp.getScalar();var sweepFlag=pp.getScalar();var cp=pp.getAsCurrentPoint();// Conversion from endpoint to center parameterization
// http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
// x1', y1'
var currp=new svg.Point(Math.cos(xAxisRotation)*(curr.x-cp.x)/2.0+Math.sin(xAxisRotation)*(curr.y-cp.y)/2.0,-Math.sin(xAxisRotation)*(curr.x-cp.x)/2.0+Math.cos(xAxisRotation)*(curr.y-cp.y)/2.0);// adjust radii
var l=Math.pow(currp.x,2)/Math.pow(rx,2)+Math.pow(currp.y,2)/Math.pow(ry,2);if(l>1){rx*=Math.sqrt(l);ry*=Math.sqrt(l);}// cx', cy'
var s=(largeArcFlag==sweepFlag?-1:1)*Math.sqrt((Math.pow(rx,2)*Math.pow(ry,2)-Math.pow(rx,2)*Math.pow(currp.y,2)-Math.pow(ry,2)*Math.pow(currp.x,2))/(Math.pow(rx,2)*Math.pow(currp.y,2)+Math.pow(ry,2)*Math.pow(currp.x,2)));if(isNaN(s))s=0;var cpp=new svg.Point(s*rx*currp.y/ry,s*-ry*currp.x/rx);// cx, cy
var centp=new svg.Point((curr.x+cp.x)/2.0+Math.cos(xAxisRotation)*cpp.x-Math.sin(xAxisRotation)*cpp.y,(curr.y+cp.y)/2.0+Math.sin(xAxisRotation)*cpp.x+Math.cos(xAxisRotation)*cpp.y);// vector magnitude
var m=function m(v){return Math.sqrt(Math.pow(v[0],2)+Math.pow(v[1],2));};// ratio between two vectors
var r=function r(u,v){return(u[0]*v[0]+u[1]*v[1])/(m(u)*m(v));};// angle between two vectors
var a=function a(u,v){return(u[0]*v[1]<u[1]*v[0]?-1:1)*Math.acos(r(u,v));};// initial angle
var a1=a([1,0],[(currp.x-cpp.x)/rx,(currp.y-cpp.y)/ry]);// angle delta
var u=[(currp.x-cpp.x)/rx,(currp.y-cpp.y)/ry];var v=[(-currp.x-cpp.x)/rx,(-currp.y-cpp.y)/ry];var ad=a(u,v);if(r(u,v)<=-1)ad=Math.PI;if(r(u,v)>=1)ad=0;// for markers
var dir=1-sweepFlag?1.0:-1.0;var ah=a1+dir*(ad/2.0);var halfWay=new svg.Point(centp.x+rx*Math.cos(ah),centp.y+ry*Math.sin(ah));pp.addMarkerAngle(halfWay,ah-dir*Math.PI/2);pp.addMarkerAngle(cp,ah-dir*Math.PI);bb.addPoint(cp.x,cp.y);// TODO: this is too naive, make it better
if(ctx!=null){var r=rx>ry?rx:ry;var sx=rx>ry?1:rx/ry;var sy=rx>ry?ry/rx:1;ctx.translate(centp.x,centp.y);ctx.rotate(xAxisRotation);ctx.scale(sx,sy);ctx.arc(0,0,r,a1,a1+ad,1-sweepFlag);ctx.scale(1/sx,1/sy);ctx.rotate(-xAxisRotation);ctx.translate(-centp.x,-centp.y);}}break;case'Z':case'z':if(ctx!=null)ctx.closePath();pp.current=pp.start;}}return bb;};this.getMarkers=function(){var points=this.PathParser.getMarkerPoints();var angles=this.PathParser.getMarkerAngles();var markers=[];for(var i=0;i<points.length;i++){markers.push([points[i],angles[i]]);}return markers;};};svg.Element.path.prototype=new svg.Element.PathElementBase();// pattern element
svg.Element.pattern=function(node){this.base=svg.Element.ElementBase;this.base(node);this.createPattern=function(ctx,element){var width=this.attribute('width').toPixels('x',true);var height=this.attribute('height').toPixels('y',true);// render me using a temporary svg element
var tempSvg=new svg.Element.svg();tempSvg.attributes['viewBox']=new svg.Property('viewBox',this.attribute('viewBox').value);tempSvg.attributes['width']=new svg.Property('width',width+'px');tempSvg.attributes['height']=new svg.Property('height',height+'px');tempSvg.attributes['transform']=new svg.Property('transform',this.attribute('patternTransform').value);tempSvg.children=this.children;var c=document.createElement('canvas');c.width=width;c.height=height;var cctx=c.getContext('2d');if(this.attribute('x').hasValue()&&this.attribute('y').hasValue()){cctx.translate(this.attribute('x').toPixels('x',true),this.attribute('y').toPixels('y',true));}// render 3x3 grid so when we transform there's no white space on edges
for(var x=-1;x<=1;x++){for(var y=-1;y<=1;y++){cctx.save();tempSvg.attributes['x']=new svg.Property('x',x*c.width);tempSvg.attributes['y']=new svg.Property('y',y*c.height);tempSvg.render(cctx);cctx.restore();}}var pattern=ctx.createPattern(c,'repeat');return pattern;};};svg.Element.pattern.prototype=new svg.Element.ElementBase();// marker element
svg.Element.marker=function(node){this.base=svg.Element.ElementBase;this.base(node);this.baseRender=this.render;this.render=function(ctx,point,angle){ctx.translate(point.x,point.y);if(this.attribute('orient').valueOrDefault('auto')=='auto')ctx.rotate(angle);if(this.attribute('markerUnits').valueOrDefault('strokeWidth')=='strokeWidth')ctx.scale(ctx.lineWidth,ctx.lineWidth);ctx.save();// render me using a temporary svg element
var tempSvg=new svg.Element.svg();tempSvg.attributes['viewBox']=new svg.Property('viewBox',this.attribute('viewBox').value);tempSvg.attributes['refX']=new svg.Property('refX',this.attribute('refX').value);tempSvg.attributes['refY']=new svg.Property('refY',this.attribute('refY').value);tempSvg.attributes['width']=new svg.Property('width',this.attribute('markerWidth').value);tempSvg.attributes['height']=new svg.Property('height',this.attribute('markerHeight').value);tempSvg.attributes['fill']=new svg.Property('fill',this.attribute('fill').valueOrDefault('black'));tempSvg.attributes['stroke']=new svg.Property('stroke',this.attribute('stroke').valueOrDefault('none'));tempSvg.children=this.children;tempSvg.render(ctx);ctx.restore();if(this.attribute('markerUnits').valueOrDefault('strokeWidth')=='strokeWidth')ctx.scale(1/ctx.lineWidth,1/ctx.lineWidth);if(this.attribute('orient').valueOrDefault('auto')=='auto')ctx.rotate(-angle);ctx.translate(-point.x,-point.y);};};svg.Element.marker.prototype=new svg.Element.ElementBase();// definitions element
svg.Element.defs=function(node){this.base=svg.Element.ElementBase;this.base(node);this.render=function(ctx){// NOOP
};};svg.Element.defs.prototype=new svg.Element.ElementBase();// base for gradients
svg.Element.GradientBase=function(node){this.base=svg.Element.ElementBase;this.base(node);this.stops=[];for(var i=0;i<this.children.length;i++){var child=this.children[i];if(child.type=='stop')this.stops.push(child);}this.getGradient=function(){// OVERRIDE ME!
};this.gradientUnits=function(){return this.attribute('gradientUnits').valueOrDefault('objectBoundingBox');};this.attributesToInherit=['gradientUnits'];this.inheritStopContainer=function(stopsContainer){for(var i=0;i<this.attributesToInherit.length;i++){var attributeToInherit=this.attributesToInherit[i];if(!this.attribute(attributeToInherit).hasValue()&&stopsContainer.attribute(attributeToInherit).hasValue()){this.attribute(attributeToInherit,true).value=stopsContainer.attribute(attributeToInherit).value;}}};this.createGradient=function(ctx,element,parentOpacityProp){var stopsContainer=this;if(this.getHrefAttribute().hasValue()){stopsContainer=this.getHrefAttribute().getDefinition();this.inheritStopContainer(stopsContainer);}var addParentOpacity=function addParentOpacity(color){if(parentOpacityProp.hasValue()){var p=new svg.Property('color',color);return p.addOpacity(parentOpacityProp).value;}return color;};var g=this.getGradient(ctx,element);if(g==null)return addParentOpacity(stopsContainer.stops[stopsContainer.stops.length-1].color);for(var i=0;i<stopsContainer.stops.length;i++){g.addColorStop(stopsContainer.stops[i].offset,addParentOpacity(stopsContainer.stops[i].color));}if(this.attribute('gradientTransform').hasValue()){// render as transformed pattern on temporary canvas
var rootView=svg.ViewPort.viewPorts[0];var rect=new svg.Element.rect();rect.attributes['x']=new svg.Property('x',-svg.MAX_VIRTUAL_PIXELS/3.0);rect.attributes['y']=new svg.Property('y',-svg.MAX_VIRTUAL_PIXELS/3.0);rect.attributes['width']=new svg.Property('width',svg.MAX_VIRTUAL_PIXELS);rect.attributes['height']=new svg.Property('height',svg.MAX_VIRTUAL_PIXELS);var group=new svg.Element.g();group.attributes['transform']=new svg.Property('transform',this.attribute('gradientTransform').value);group.children=[rect];var tempSvg=new svg.Element.svg();tempSvg.attributes['x']=new svg.Property('x',0);tempSvg.attributes['y']=new svg.Property('y',0);tempSvg.attributes['width']=new svg.Property('width',rootView.width);tempSvg.attributes['height']=new svg.Property('height',rootView.height);tempSvg.children=[group];var c=document.createElement('canvas');c.width=rootView.width;c.height=rootView.height;var tempCtx=c.getContext('2d');tempCtx.fillStyle=g;tempSvg.render(tempCtx);return tempCtx.createPattern(c,'no-repeat');}return g;};};svg.Element.GradientBase.prototype=new svg.Element.ElementBase();// linear gradient element
svg.Element.linearGradient=function(node){this.base=svg.Element.GradientBase;this.base(node);this.attributesToInherit.push('x1');this.attributesToInherit.push('y1');this.attributesToInherit.push('x2');this.attributesToInherit.push('y2');this.getGradient=function(ctx,element){var bb=this.gradientUnits()=='objectBoundingBox'?element.getBoundingBox():null;if(!this.attribute('x1').hasValue()&&!this.attribute('y1').hasValue()&&!this.attribute('x2').hasValue()&&!this.attribute('y2').hasValue()){this.attribute('x1',true).value=0;this.attribute('y1',true).value=0;this.attribute('x2',true).value=1;this.attribute('y2',true).value=0;}var x1=this.gradientUnits()=='objectBoundingBox'?bb.x()+bb.width()*this.attribute('x1').numValue():this.attribute('x1').toPixels('x');var y1=this.gradientUnits()=='objectBoundingBox'?bb.y()+bb.height()*this.attribute('y1').numValue():this.attribute('y1').toPixels('y');var x2=this.gradientUnits()=='objectBoundingBox'?bb.x()+bb.width()*this.attribute('x2').numValue():this.attribute('x2').toPixels('x');var y2=this.gradientUnits()=='objectBoundingBox'?bb.y()+bb.height()*this.attribute('y2').numValue():this.attribute('y2').toPixels('y');if(x1==x2&&y1==y2)return null;return ctx.createLinearGradient(x1,y1,x2,y2);};};svg.Element.linearGradient.prototype=new svg.Element.GradientBase();// radial gradient element
svg.Element.radialGradient=function(node){this.base=svg.Element.GradientBase;this.base(node);this.attributesToInherit.push('cx');this.attributesToInherit.push('cy');this.attributesToInherit.push('r');this.attributesToInherit.push('fx');this.attributesToInherit.push('fy');this.getGradient=function(ctx,element){var bb=element.getBoundingBox();if(!this.attribute('cx').hasValue())this.attribute('cx',true).value='50%';if(!this.attribute('cy').hasValue())this.attribute('cy',true).value='50%';if(!this.attribute('r').hasValue())this.attribute('r',true).value='50%';var cx=this.gradientUnits()=='objectBoundingBox'?bb.x()+bb.width()*this.attribute('cx').numValue():this.attribute('cx').toPixels('x');var cy=this.gradientUnits()=='objectBoundingBox'?bb.y()+bb.height()*this.attribute('cy').numValue():this.attribute('cy').toPixels('y');var fx=cx;var fy=cy;if(this.attribute('fx').hasValue()){fx=this.gradientUnits()=='objectBoundingBox'?bb.x()+bb.width()*this.attribute('fx').numValue():this.attribute('fx').toPixels('x');}if(this.attribute('fy').hasValue()){fy=this.gradientUnits()=='objectBoundingBox'?bb.y()+bb.height()*this.attribute('fy').numValue():this.attribute('fy').toPixels('y');}var r=this.gradientUnits()=='objectBoundingBox'?(bb.width()+bb.height())/2.0*this.attribute('r').numValue():this.attribute('r').toPixels();return ctx.createRadialGradient(fx,fy,0,cx,cy,r);};};svg.Element.radialGradient.prototype=new svg.Element.GradientBase();// gradient stop element
svg.Element.stop=function(node){this.base=svg.Element.ElementBase;this.base(node);this.offset=this.attribute('offset').numValue();if(this.offset<0)this.offset=0;if(this.offset>1)this.offset=1;var stopColor=this.style('stop-color',true);if(stopColor.value==='')stopColor.value='#000';if(this.style('stop-opacity').hasValue())stopColor=stopColor.addOpacity(this.style('stop-opacity'));this.color=stopColor.value;};svg.Element.stop.prototype=new svg.Element.ElementBase();// animation base element
svg.Element.AnimateBase=function(node){this.base=svg.Element.ElementBase;this.base(node);svg.Animations.push(this);this.duration=0.0;this.begin=this.attribute('begin').toMilliseconds();this.maxDuration=this.begin+this.attribute('dur').toMilliseconds();this.getProperty=function(){var attributeType=this.attribute('attributeType').value;var attributeName=this.attribute('attributeName').value;if(attributeType=='CSS'){return this.parent.style(attributeName,true);}return this.parent.attribute(attributeName,true);};this.initialValue=null;this.initialUnits='';this.removed=false;this.calcValue=function(){// OVERRIDE ME!
return'';};this.update=function(delta){// set initial value
if(this.initialValue==null){this.initialValue=this.getProperty().value;this.initialUnits=this.getProperty().getUnits();}// if we're past the end time
if(this.duration>this.maxDuration){// loop for indefinitely repeating animations
if(this.attribute('repeatCount').value=='indefinite'||this.attribute('repeatDur').value=='indefinite'){this.duration=0.0;}else if(this.attribute('fill').valueOrDefault('remove')=='freeze'&&!this.frozen){this.frozen=true;this.parent.animationFrozen=true;this.parent.animationFrozenValue=this.getProperty().value;}else if(this.attribute('fill').valueOrDefault('remove')=='remove'&&!this.removed){this.removed=true;this.getProperty().value=this.parent.animationFrozen?this.parent.animationFrozenValue:this.initialValue;return true;}return false;}this.duration=this.duration+delta;// if we're past the begin time
var updated=false;if(this.begin<this.duration){var newValue=this.calcValue();// tween
if(this.attribute('type').hasValue()){// for transform, etc.
var type=this.attribute('type').value;newValue=type+'('+newValue+')';}this.getProperty().value=newValue;updated=true;}return updated;};this.from=this.attribute('from');this.to=this.attribute('to');this.values=this.attribute('values');if(this.values.hasValue())this.values.value=this.values.value.split(';');// fraction of duration we've covered
this.progress=function(){var ret={progress:(this.duration-this.begin)/(this.maxDuration-this.begin)};if(this.values.hasValue()){var p=ret.progress*(this.values.value.length-1);var lb=Math.floor(p),ub=Math.ceil(p);ret.from=new svg.Property('from',parseFloat(this.values.value[lb]));ret.to=new svg.Property('to',parseFloat(this.values.value[ub]));ret.progress=(p-lb)/(ub-lb);}else{ret.from=this.from;ret.to=this.to;}return ret;};};svg.Element.AnimateBase.prototype=new svg.Element.ElementBase();// animate element
svg.Element.animate=function(node){this.base=svg.Element.AnimateBase;this.base(node);this.calcValue=function(){var p=this.progress();// tween value linearly
var newValue=p.from.numValue()+(p.to.numValue()-p.from.numValue())*p.progress;return newValue+this.initialUnits;};};svg.Element.animate.prototype=new svg.Element.AnimateBase();// animate color element
svg.Element.animateColor=function(node){this.base=svg.Element.AnimateBase;this.base(node);this.calcValue=function(){var p=this.progress();var from=new RGBColor(p.from.value);var to=new RGBColor(p.to.value);if(from.ok&&to.ok){// tween color linearly
var r=from.r+(to.r-from.r)*p.progress;var g=from.g+(to.g-from.g)*p.progress;var b=from.b+(to.b-from.b)*p.progress;return'rgb('+parseInt(r,10)+','+parseInt(g,10)+','+parseInt(b,10)+')';}return this.attribute('from').value;};};svg.Element.animateColor.prototype=new svg.Element.AnimateBase();// animate transform element
svg.Element.animateTransform=function(node){this.base=svg.Element.AnimateBase;this.base(node);this.calcValue=function(){var p=this.progress();// tween value linearly
var from=svg.ToNumberArray(p.from.value);var to=svg.ToNumberArray(p.to.value);var newValue='';for(var i=0;i<from.length;i++){newValue+=from[i]+(to[i]-from[i])*p.progress+' ';}return newValue;};};svg.Element.animateTransform.prototype=new svg.Element.animate();// font element
svg.Element.font=function(node){this.base=svg.Element.ElementBase;this.base(node);this.horizAdvX=this.attribute('horiz-adv-x').numValue();this.isRTL=false;this.isArabic=false;this.fontFace=null;this.missingGlyph=null;this.glyphs=[];for(var i=0;i<this.children.length;i++){var child=this.children[i];if(child.type=='font-face'){this.fontFace=child;if(child.style('font-family').hasValue()){svg.Definitions[child.style('font-family').value]=this;}}else if(child.type=='missing-glyph')this.missingGlyph=child;else if(child.type=='glyph'){if(child.arabicForm!=''){this.isRTL=true;this.isArabic=true;if(typeof this.glyphs[child.unicode]=='undefined')this.glyphs[child.unicode]=[];this.glyphs[child.unicode][child.arabicForm]=child;}else{this.glyphs[child.unicode]=child;}}}};svg.Element.font.prototype=new svg.Element.ElementBase();// font-face element
svg.Element.fontface=function(node){this.base=svg.Element.ElementBase;this.base(node);this.ascent=this.attribute('ascent').value;this.descent=this.attribute('descent').value;this.unitsPerEm=this.attribute('units-per-em').numValue();};svg.Element.fontface.prototype=new svg.Element.ElementBase();// missing-glyph element
svg.Element.missingglyph=function(node){this.base=svg.Element.path;this.base(node);this.horizAdvX=0;};svg.Element.missingglyph.prototype=new svg.Element.path();// glyph element
svg.Element.glyph=function(node){this.base=svg.Element.path;this.base(node);this.horizAdvX=this.attribute('horiz-adv-x').numValue();this.unicode=this.attribute('unicode').value;this.arabicForm=this.attribute('arabic-form').value;};svg.Element.glyph.prototype=new svg.Element.path();// text element
svg.Element.text=function(node){this.captureTextNodes=true;this.base=svg.Element.RenderedElementBase;this.base(node);this.baseSetContext=this.setContext;this.setContext=function(ctx){this.baseSetContext(ctx);var textBaseline=this.style('dominant-baseline').toTextBaseline();if(textBaseline==null)textBaseline=this.style('alignment-baseline').toTextBaseline();if(textBaseline!=null)ctx.textBaseline=textBaseline;};this.getBoundingBox=function(){var x=this.attribute('x').toPixels('x');var y=this.attribute('y').toPixels('y');var fontSize=this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);return new svg.BoundingBox(x,y-fontSize,x+Math.floor(fontSize*2.0/3.0)*this.children[0].getText().length,y);};this.renderChildren=function(ctx){this.x=this.attribute('x').toPixels('x');this.y=this.attribute('y').toPixels('y');if(this.attribute('dx').hasValue())this.x+=this.attribute('dx').toPixels('x');if(this.attribute('dy').hasValue())this.y+=this.attribute('dy').toPixels('y');this.x+=this.getAnchorDelta(ctx,this,0);for(var i=0;i<this.children.length;i++){this.renderChild(ctx,this,this,i);}};this.getAnchorDelta=function(ctx,parent,startI){var textAnchor=this.style('text-anchor').valueOrDefault('start');if(textAnchor!='start'){var width=0;for(var i=startI;i<parent.children.length;i++){var child=parent.children[i];if(i>startI&&child.attribute('x').hasValue())break;// new group
width+=child.measureTextRecursive(ctx);}return-1*(textAnchor=='end'?width:width/2.0);}return 0;};this.renderChild=function(ctx,textParent,parent,i){var child=parent.children[i];if(child.attribute('x').hasValue()){child.x=child.attribute('x').toPixels('x')+textParent.getAnchorDelta(ctx,parent,i);if(child.attribute('dx').hasValue())child.x+=child.attribute('dx').toPixels('x');}else{if(child.attribute('dx').hasValue())textParent.x+=child.attribute('dx').toPixels('x');child.x=textParent.x;}textParent.x=child.x+child.measureText(ctx);if(child.attribute('y').hasValue()){child.y=child.attribute('y').toPixels('y');if(child.attribute('dy').hasValue())child.y+=child.attribute('dy').toPixels('y');}else{if(child.attribute('dy').hasValue())textParent.y+=child.attribute('dy').toPixels('y');child.y=textParent.y;}textParent.y=child.y;child.render(ctx);for(var i=0;i<child.children.length;i++){textParent.renderChild(ctx,textParent,child,i);}};};svg.Element.text.prototype=new svg.Element.RenderedElementBase();// text base
svg.Element.TextElementBase=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);this.getGlyph=function(font,text,i){var c=text[i];var glyph=null;if(font.isArabic){var arabicForm='isolated';if((i==0||text[i-1]==' ')&&i<text.length-2&&text[i+1]!=' ')arabicForm='terminal';if(i>0&&text[i-1]!=' '&&i<text.length-2&&text[i+1]!=' ')arabicForm='medial';if(i>0&&text[i-1]!=' '&&(i==text.length-1||text[i+1]==' '))arabicForm='initial';if(typeof font.glyphs[c]!='undefined'){glyph=font.glyphs[c][arabicForm];if(glyph==null&&font.glyphs[c].type=='glyph')glyph=font.glyphs[c];}}else{glyph=font.glyphs[c];}if(glyph==null)glyph=font.missingGlyph;return glyph;};this.renderChildren=function(ctx){var customFont=this.parent.style('font-family').getDefinition();if(customFont!=null){var fontSize=this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);var fontStyle=this.parent.style('font-style').valueOrDefault(svg.Font.Parse(svg.ctx.font).fontStyle);var text=this.getText();if(customFont.isRTL)text=text.split("").reverse().join("");var dx=svg.ToNumberArray(this.parent.attribute('dx').value);for(var i=0;i<text.length;i++){var glyph=this.getGlyph(customFont,text,i);var scale=fontSize/customFont.fontFace.unitsPerEm;ctx.translate(this.x,this.y);ctx.scale(scale,-scale);var lw=ctx.lineWidth;ctx.lineWidth=ctx.lineWidth*customFont.fontFace.unitsPerEm/fontSize;if(fontStyle=='italic')ctx.transform(1,0,.4,1,0,0);glyph.render(ctx);if(fontStyle=='italic')ctx.transform(1,0,-.4,1,0,0);ctx.lineWidth=lw;ctx.scale(1/scale,-1/scale);ctx.translate(-this.x,-this.y);this.x+=fontSize*(glyph.horizAdvX||customFont.horizAdvX)/customFont.fontFace.unitsPerEm;if(typeof dx[i]!='undefined'&&!isNaN(dx[i])){this.x+=dx[i];}}return;}if(ctx.fillStyle!='')ctx.fillText(svg.compressSpaces(this.getText()),this.x,this.y);if(ctx.strokeStyle!='')ctx.strokeText(svg.compressSpaces(this.getText()),this.x,this.y);};this.getText=function(){// OVERRIDE ME
};this.measureTextRecursive=function(ctx){var width=this.measureText(ctx);for(var i=0;i<this.children.length;i++){width+=this.children[i].measureTextRecursive(ctx);}return width;};this.measureText=function(ctx){var customFont=this.parent.style('font-family').getDefinition();if(customFont!=null){var fontSize=this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);var measure=0;var text=this.getText();if(customFont.isRTL)text=text.split("").reverse().join("");var dx=svg.ToNumberArray(this.parent.attribute('dx').value);for(var i=0;i<text.length;i++){var glyph=this.getGlyph(customFont,text,i);measure+=(glyph.horizAdvX||customFont.horizAdvX)*fontSize/customFont.fontFace.unitsPerEm;if(typeof dx[i]!='undefined'&&!isNaN(dx[i])){measure+=dx[i];}}return measure;}var textToMeasure=svg.compressSpaces(this.getText());if(!ctx.measureText)return textToMeasure.length*10;ctx.save();this.setContext(ctx);var width=ctx.measureText(textToMeasure).width;ctx.restore();return width;};};svg.Element.TextElementBase.prototype=new svg.Element.RenderedElementBase();// tspan
svg.Element.tspan=function(node){this.captureTextNodes=true;this.base=svg.Element.TextElementBase;this.base(node);this.text=svg.compressSpaces(node.value||node.text||node.textContent||'');this.getText=function(){// if this node has children, then they own the text
if(this.children.length>0){return'';}return this.text;};};svg.Element.tspan.prototype=new svg.Element.TextElementBase();// tref
svg.Element.tref=function(node){this.base=svg.Element.TextElementBase;this.base(node);this.getText=function(){var element=this.getHrefAttribute().getDefinition();if(element!=null)return element.children[0].getText();};};svg.Element.tref.prototype=new svg.Element.TextElementBase();// a element
svg.Element.a=function(node){this.base=svg.Element.TextElementBase;this.base(node);this.hasText=node.childNodes.length>0;for(var i=0;i<node.childNodes.length;i++){if(node.childNodes[i].nodeType!=3)this.hasText=false;}// this might contain text
this.text=this.hasText?node.childNodes[0].value:'';this.getText=function(){return this.text;};this.baseRenderChildren=this.renderChildren;this.renderChildren=function(ctx){if(this.hasText){// render as text element
this.baseRenderChildren(ctx);var fontSize=new svg.Property('fontSize',svg.Font.Parse(svg.ctx.font).fontSize);svg.Mouse.checkBoundingBox(this,new svg.BoundingBox(this.x,this.y-fontSize.toPixels('y'),this.x+this.measureText(ctx),this.y));}else if(this.children.length>0){// render as temporary group
var g=new svg.Element.g();g.children=this.children;g.parent=this;g.render(ctx);}};this.onclick=function(){window.open(this.getHrefAttribute().value);};this.onmousemove=function(){svg.ctx.canvas.style.cursor='pointer';};};svg.Element.a.prototype=new svg.Element.TextElementBase();// image element
svg.Element.image=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);var href=this.getHrefAttribute().value;if(href==''){return;}var isSvg=href.match(/\.svg$/);svg.Images.push(this);this.loaded=false;if(!isSvg){this.img=document.createElement('img');if(svg.opts['useCORS']==true){this.img.crossOrigin='Anonymous';}var self=this;this.img.onload=function(){self.loaded=true;};this.img.onerror=function(){svg.log('ERROR: image "'+href+'" not found');self.loaded=true;};this.img.src=href;}else{this.img=svg.ajax(href);this.loaded=true;}this.renderChildren=function(ctx){var x=this.attribute('x').toPixels('x');var y=this.attribute('y').toPixels('y');var width=this.attribute('width').toPixels('x');var height=this.attribute('height').toPixels('y');if(width==0||height==0)return;ctx.save();if(isSvg){ctx.drawSvg(this.img,x,y,width,height);}else{ctx.translate(x,y);svg.AspectRatio(ctx,this.attribute('preserveAspectRatio').value,width,this.img.width,height,this.img.height,0,0);ctx.drawImage(this.img,0,0);}ctx.restore();};this.getBoundingBox=function(){var x=this.attribute('x').toPixels('x');var y=this.attribute('y').toPixels('y');var width=this.attribute('width').toPixels('x');var height=this.attribute('height').toPixels('y');return new svg.BoundingBox(x,y,x+width,y+height);};};svg.Element.image.prototype=new svg.Element.RenderedElementBase();// group element
svg.Element.g=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);this.getBoundingBox=function(){var bb=new svg.BoundingBox();for(var i=0;i<this.children.length;i++){bb.addBoundingBox(this.children[i].getBoundingBox());}return bb;};};svg.Element.g.prototype=new svg.Element.RenderedElementBase();// symbol element
svg.Element.symbol=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);this.render=function(ctx){// NO RENDER
};};svg.Element.symbol.prototype=new svg.Element.RenderedElementBase();// style element
svg.Element.style=function(node){this.base=svg.Element.ElementBase;this.base(node);// text, or spaces then CDATA
var css='';for(var i=0;i<node.childNodes.length;i++){css+=node.childNodes[i].data;}css=css.replace(/(\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm,'');// remove comments
css=svg.compressSpaces(css);// replace whitespace
var cssDefs=css.split('}');for(var i=0;i<cssDefs.length;i++){if(svg.trim(cssDefs[i])!=''){var cssDef=cssDefs[i].split('{');var cssClasses=cssDef[0].split(',');var cssProps=cssDef[1].split(';');for(var j=0;j<cssClasses.length;j++){var cssClass=svg.trim(cssClasses[j]);if(cssClass!=''){var props=svg.Styles[cssClass]||{};for(var k=0;k<cssProps.length;k++){var prop=cssProps[k].indexOf(':');var name=cssProps[k].substr(0,prop);var value=cssProps[k].substr(prop+1,cssProps[k].length-prop);if(name!=null&&value!=null){props[svg.trim(name)]=new svg.Property(svg.trim(name),svg.trim(value));}}svg.Styles[cssClass]=props;svg.StylesSpecificity[cssClass]=getSelectorSpecificity(cssClass);if(cssClass=='@font-face'){var fontFamily=props['font-family'].value.replace(/"/g,'');var srcs=props['src'].value.split(',');for(var s=0;s<srcs.length;s++){if(srcs[s].indexOf('format("svg")')>0){var urlStart=srcs[s].indexOf('url');var urlEnd=srcs[s].indexOf(')',urlStart);var url=srcs[s].substr(urlStart+5,urlEnd-urlStart-6);var doc=svg.parseXml(svg.ajax(url));var fonts=doc.getElementsByTagName('font');for(var f=0;f<fonts.length;f++){var font=svg.CreateElement(fonts[f]);svg.Definitions[fontFamily]=font;}}}}}}}}};svg.Element.style.prototype=new svg.Element.ElementBase();// use element
svg.Element.use=function(node){this.base=svg.Element.RenderedElementBase;this.base(node);this.baseSetContext=this.setContext;this.setContext=function(ctx){this.baseSetContext(ctx);if(this.attribute('x').hasValue())ctx.translate(this.attribute('x').toPixels('x'),0);if(this.attribute('y').hasValue())ctx.translate(0,this.attribute('y').toPixels('y'));};var element=this.getHrefAttribute().getDefinition();this.path=function(ctx){if(element!=null)element.path(ctx);};this.getBoundingBox=function(){if(element!=null)return element.getBoundingBox();};this.renderChildren=function(ctx){if(element!=null){var tempSvg=element;if(element.type=='symbol'){// render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
tempSvg=new svg.Element.svg();tempSvg.type='svg';tempSvg.attributes['viewBox']=new svg.Property('viewBox',element.attribute('viewBox').value);tempSvg.attributes['preserveAspectRatio']=new svg.Property('preserveAspectRatio',element.attribute('preserveAspectRatio').value);tempSvg.attributes['overflow']=new svg.Property('overflow',element.attribute('overflow').value);tempSvg.children=element.children;}if(tempSvg.type=='svg'){// if symbol or svg, inherit width/height from me
if(this.attribute('width').hasValue())tempSvg.attributes['width']=new svg.Property('width',this.attribute('width').value);if(this.attribute('height').hasValue())tempSvg.attributes['height']=new svg.Property('height',this.attribute('height').value);}var oldParent=tempSvg.parent;tempSvg.parent=null;tempSvg.render(ctx);tempSvg.parent=oldParent;}};};svg.Element.use.prototype=new svg.Element.RenderedElementBase();// mask element
svg.Element.mask=function(node){this.base=svg.Element.ElementBase;this.base(node);this.apply=function(ctx,element){// render as temp svg
var x=this.attribute('x').toPixels('x');var y=this.attribute('y').toPixels('y');var width=this.attribute('width').toPixels('x');var height=this.attribute('height').toPixels('y');if(width==0&&height==0){var bb=new svg.BoundingBox();for(var i=0;i<this.children.length;i++){bb.addBoundingBox(this.children[i].getBoundingBox());}var x=Math.floor(bb.x1);var y=Math.floor(bb.y1);var width=Math.floor(bb.width());var height=Math.floor(bb.height());}// temporarily remove mask to avoid recursion
var mask=element.attribute('mask').value;element.attribute('mask').value='';var cMask=document.createElement('canvas');cMask.width=x+width;cMask.height=y+height;var maskCtx=cMask.getContext('2d');this.renderChildren(maskCtx);var c=document.createElement('canvas');c.width=x+width;c.height=y+height;var tempCtx=c.getContext('2d');element.render(tempCtx);tempCtx.globalCompositeOperation='destination-in';tempCtx.fillStyle=maskCtx.createPattern(cMask,'no-repeat');tempCtx.fillRect(0,0,x+width,y+height);ctx.fillStyle=tempCtx.createPattern(c,'no-repeat');ctx.fillRect(0,0,x+width,y+height);// reassign mask
element.attribute('mask').value=mask;};this.render=function(ctx){// NO RENDER
};};svg.Element.mask.prototype=new svg.Element.ElementBase();// clip element
svg.Element.clipPath=function(node){this.base=svg.Element.ElementBase;this.base(node);this.apply=function(ctx){var oldBeginPath=CanvasRenderingContext2D.prototype.beginPath;CanvasRenderingContext2D.prototype.beginPath=function(){};var oldClosePath=CanvasRenderingContext2D.prototype.closePath;CanvasRenderingContext2D.prototype.closePath=function(){};oldBeginPath.call(ctx);for(var i=0;i<this.children.length;i++){var child=this.children[i];if(typeof child.path!='undefined'){var transform=null;if(child.style('transform',false,true).hasValue()){transform=new svg.Transform(child.style('transform',false,true).value);transform.apply(ctx);}child.path(ctx);CanvasRenderingContext2D.prototype.closePath=oldClosePath;if(transform){transform.unapply(ctx);}}}oldClosePath.call(ctx);ctx.clip();CanvasRenderingContext2D.prototype.beginPath=oldBeginPath;CanvasRenderingContext2D.prototype.closePath=oldClosePath;};this.render=function(ctx){// NO RENDER
};};svg.Element.clipPath.prototype=new svg.Element.ElementBase();// filters
svg.Element.filter=function(node){this.base=svg.Element.ElementBase;this.base(node);this.apply=function(ctx,element){// render as temp svg
var bb=element.getBoundingBox();var x=Math.floor(bb.x1);var y=Math.floor(bb.y1);var width=Math.floor(bb.width());var height=Math.floor(bb.height());// temporarily remove filter to avoid recursion
var filter=element.style('filter').value;element.style('filter').value='';var px=0,py=0;for(var i=0;i<this.children.length;i++){var efd=this.children[i].extraFilterDistance||0;px=Math.max(px,efd);py=Math.max(py,efd);}var c=document.createElement('canvas');c.width=width+2*px;c.height=height+2*py;var tempCtx=c.getContext('2d');tempCtx.translate(-x+px,-y+py);element.render(tempCtx);// apply filters
for(var i=0;i<this.children.length;i++){if(typeof this.children[i].apply=='function'){this.children[i].apply(tempCtx,0,0,width+2*px,height+2*py);}}// render on me
ctx.drawImage(c,0,0,width+2*px,height+2*py,x-px,y-py,width+2*px,height+2*py);// reassign filter
element.style('filter',true).value=filter;};this.render=function(ctx){// NO RENDER
};};svg.Element.filter.prototype=new svg.Element.ElementBase();svg.Element.feMorphology=function(node){this.base=svg.Element.ElementBase;this.base(node);this.apply=function(ctx,x,y,width,height){// TODO: implement
};};svg.Element.feMorphology.prototype=new svg.Element.ElementBase();svg.Element.feComposite=function(node){this.base=svg.Element.ElementBase;this.base(node);this.apply=function(ctx,x,y,width,height){// TODO: implement
};};svg.Element.feComposite.prototype=new svg.Element.ElementBase();svg.Element.feColorMatrix=function(node){this.base=svg.Element.ElementBase;this.base(node);var matrix=svg.ToNumberArray(this.attribute('values').value);switch(this.attribute('type').valueOrDefault('matrix')){// http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
case'saturate':var s=matrix[0];matrix=[0.213+0.787*s,0.715-0.715*s,0.072-0.072*s,0,0,0.213-0.213*s,0.715+0.285*s,0.072-0.072*s,0,0,0.213-0.213*s,0.715-0.715*s,0.072+0.928*s,0,0,0,0,0,1,0,0,0,0,0,1];break;case'hueRotate':var a=matrix[0]*Math.PI/180.0;var c=function c(m1,m2,m3){return m1+Math.cos(a)*m2+Math.sin(a)*m3;};matrix=[c(0.213,0.787,-0.213),c(0.715,-0.715,-0.715),c(0.072,-0.072,0.928),0,0,c(0.213,-0.213,0.143),c(0.715,0.285,0.140),c(0.072,-0.072,-0.283),0,0,c(0.213,-0.213,-0.787),c(0.715,-0.715,0.715),c(0.072,0.928,0.072),0,0,0,0,0,1,0,0,0,0,0,1];break;case'luminanceToAlpha':matrix=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.2125,0.7154,0.0721,0,0,0,0,0,0,1];break;}function imGet(img,x,y,width,height,rgba){return img[y*width*4+x*4+rgba];}function imSet(img,x,y,width,height,rgba,val){img[y*width*4+x*4+rgba]=val;}function m(i,v){var mi=matrix[i];return mi*(mi<0?v-255:v);}this.apply=function(ctx,x,y,width,height){// assuming x==0 && y==0 for now
var srcData=ctx.getImageData(0,0,width,height);for(var y=0;y<height;y++){for(var x=0;x<width;x++){var r=imGet(srcData.data,x,y,width,height,0);var g=imGet(srcData.data,x,y,width,height,1);var b=imGet(srcData.data,x,y,width,height,2);var a=imGet(srcData.data,x,y,width,height,3);imSet(srcData.data,x,y,width,height,0,m(0,r)+m(1,g)+m(2,b)+m(3,a)+m(4,1));imSet(srcData.data,x,y,width,height,1,m(5,r)+m(6,g)+m(7,b)+m(8,a)+m(9,1));imSet(srcData.data,x,y,width,height,2,m(10,r)+m(11,g)+m(12,b)+m(13,a)+m(14,1));imSet(srcData.data,x,y,width,height,3,m(15,r)+m(16,g)+m(17,b)+m(18,a)+m(19,1));}}ctx.clearRect(0,0,width,height);ctx.putImageData(srcData,0,0);};};svg.Element.feColorMatrix.prototype=new svg.Element.ElementBase();svg.Element.feGaussianBlur=function(node){this.base=svg.Element.ElementBase;this.base(node);this.blurRadius=Math.floor(this.attribute('stdDeviation').numValue());this.extraFilterDistance=this.blurRadius;this.apply=function(ctx,x,y,width,height){if(typeof stackBlur.canvasRGBA=='undefined'){svg.log('ERROR: StackBlur.js must be included for blur to work');return;}// StackBlur requires canvas be on document
ctx.canvas.id=svg.UniqueId();ctx.canvas.style.display='none';document.body.appendChild(ctx.canvas);stackBlur.canvasRGBA(ctx.canvas.id,x,y,width,height,this.blurRadius);document.body.removeChild(ctx.canvas);};};svg.Element.feGaussianBlur.prototype=new svg.Element.ElementBase();// title element, do nothing
svg.Element.title=function(node){};svg.Element.title.prototype=new svg.Element.ElementBase();// desc element, do nothing
svg.Element.desc=function(node){};svg.Element.desc.prototype=new svg.Element.ElementBase();svg.Element.MISSING=function(node){svg.log('ERROR: Element \''+node.nodeName+'\' not yet implemented.');};svg.Element.MISSING.prototype=new svg.Element.ElementBase();// element factory
svg.CreateElement=function(node){var className=node.nodeName.replace(/^[^:]+:/,'');// remove namespace
className=className.replace(/\-/g,'');// remove dashes
var e=null;if(typeof svg.Element[className]!='undefined'){e=new svg.Element[className](node);}else{e=new svg.Element.MISSING(node);}e.type=node.nodeName;return e;};// load from url
svg.load=function(ctx,url){svg.loadXml(ctx,svg.ajax(url));};// load from xml
svg.loadXml=function(ctx,xml){svg.loadXmlDoc(ctx,svg.parseXml(xml));};svg.loadXmlDoc=function(ctx,dom){svg.init(ctx);var mapXY=function mapXY(p){var e=ctx.canvas;while(e){p.x-=e.offsetLeft;p.y-=e.offsetTop;e=e.offsetParent;}if(window.scrollX)p.x+=window.scrollX;if(window.scrollY)p.y+=window.scrollY;return p;};// bind mouse
if(svg.opts['ignoreMouse']!=true){ctx.canvas.onclick=function(e){var p=mapXY(new svg.Point(e!=null?e.clientX:event.clientX,e!=null?e.clientY:event.clientY));svg.Mouse.onclick(p.x,p.y);};ctx.canvas.onmousemove=function(e){var p=mapXY(new svg.Point(e!=null?e.clientX:event.clientX,e!=null?e.clientY:event.clientY));svg.Mouse.onmousemove(p.x,p.y);};}var e=svg.CreateElement(dom.documentElement);e.root=true;e.addStylesFromStyleDefinition();// render loop
var isFirstRender=true;var draw=function draw(){svg.ViewPort.Clear();if(ctx.canvas.parentNode)svg.ViewPort.SetCurrent(ctx.canvas.parentNode.clientWidth,ctx.canvas.parentNode.clientHeight);if(svg.opts['ignoreDimensions']!=true){// set canvas size
if(e.style('width').hasValue()){ctx.canvas.width=e.style('width').toPixels('x');ctx.canvas.style.width=ctx.canvas.width+'px';}if(e.style('height').hasValue()){ctx.canvas.height=e.style('height').toPixels('y');ctx.canvas.style.height=ctx.canvas.height+'px';}}var cWidth=ctx.canvas.clientWidth||ctx.canvas.width;var cHeight=ctx.canvas.clientHeight||ctx.canvas.height;if(svg.opts['ignoreDimensions']==true&&e.style('width').hasValue()&&e.style('height').hasValue()){cWidth=e.style('width').toPixels('x');cHeight=e.style('height').toPixels('y');}svg.ViewPort.SetCurrent(cWidth,cHeight);if(svg.opts['offsetX']!=null)e.attribute('x',true).value=svg.opts['offsetX'];if(svg.opts['offsetY']!=null)e.attribute('y',true).value=svg.opts['offsetY'];if(svg.opts['scaleWidth']!=null||svg.opts['scaleHeight']!=null){var xRatio=null,yRatio=null,viewBox=svg.ToNumberArray(e.attribute('viewBox').value);if(svg.opts['scaleWidth']!=null){if(e.attribute('width').hasValue())xRatio=e.attribute('width').toPixels('x')/svg.opts['scaleWidth'];else if(!isNaN(viewBox[2]))xRatio=viewBox[2]/svg.opts['scaleWidth'];}if(svg.opts['scaleHeight']!=null){if(e.attribute('height').hasValue())yRatio=e.attribute('height').toPixels('y')/svg.opts['scaleHeight'];else if(!isNaN(viewBox[3]))yRatio=viewBox[3]/svg.opts['scaleHeight'];}if(xRatio==null){xRatio=yRatio;}if(yRatio==null){yRatio=xRatio;}e.attribute('width',true).value=svg.opts['scaleWidth'];e.attribute('height',true).value=svg.opts['scaleHeight'];e.style('transform',true,true).value+=' scale('+1.0/xRatio+','+1.0/yRatio+')';}// clear and render
if(svg.opts['ignoreClear']!=true){ctx.clearRect(0,0,cWidth,cHeight);}e.render(ctx);if(isFirstRender){isFirstRender=false;if(typeof svg.opts['renderCallback']=='function')svg.opts['renderCallback'](dom);}};var waitingForImages=true;if(svg.ImagesLoaded()){waitingForImages=false;draw();}svg.intervalID=setInterval(function(){var needUpdate=false;if(waitingForImages&&svg.ImagesLoaded()){waitingForImages=false;needUpdate=true;}// need update from mouse events?
if(svg.opts['ignoreMouse']!=true){needUpdate=needUpdate|svg.Mouse.hasEvents();}// need update from animations?
if(svg.opts['ignoreAnimation']!=true){for(var i=0;i<svg.Animations.length;i++){needUpdate=needUpdate|svg.Animations[i].update(1000/svg.FRAMERATE);}}// need update from redraw?
if(typeof svg.opts['forceRedraw']=='function'){if(svg.opts['forceRedraw']()==true)needUpdate=true;}// render if needed
if(needUpdate){draw();svg.Mouse.runEvents();// run and clear our events
}},1000/svg.FRAMERATE);};svg.stop=function(){if(svg.intervalID){clearInterval(svg.intervalID);}};svg.Mouse=new function(){this.events=[];this.hasEvents=function(){return this.events.length!=0;};this.onclick=function(x,y){this.events.push({type:'onclick',x:x,y:y,run:function run(e){if(e.onclick)e.onclick();}});};this.onmousemove=function(x,y){this.events.push({type:'onmousemove',x:x,y:y,run:function run(e){if(e.onmousemove)e.onmousemove();}});};this.eventElements=[];this.checkPath=function(element,ctx){for(var i=0;i<this.events.length;i++){var e=this.events[i];if(ctx.isPointInPath&&ctx.isPointInPath(e.x,e.y))this.eventElements[i]=element;}};this.checkBoundingBox=function(element,bb){for(var i=0;i<this.events.length;i++){var e=this.events[i];if(bb.isPointInBox(e.x,e.y))this.eventElements[i]=element;}};this.runEvents=function(){svg.ctx.canvas.style.cursor='';for(var i=0;i<this.events.length;i++){var e=this.events[i];var element=this.eventElements[i];while(element){e.run(element);element=element.parent;}}// done running, clear
this.events=[];this.eventElements=[];};}();return svg;};if(typeof CanvasRenderingContext2D!='undefined'){CanvasRenderingContext2D.prototype.drawSvg=function(s,dx,dy,dw,dh,opts){var cOpts={ignoreMouse:true,ignoreAnimation:true,ignoreDimensions:true,ignoreClear:true,offsetX:dx,offsetY:dy,scaleWidth:dw,scaleHeight:dh};for(var prop in opts){if(opts.hasOwnProperty(prop)){cOpts[prop]=opts[prop];}}canvg(this.canvas,s,cOpts);};}return canvg;});

/***/ }),

/***/ "./src/extra/canvg/rgbcolor.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
 * @license Use it if you like it
 *//* eslint-disable */(function(global){function RGBColor(color_string){this.ok=false;// strip any leading #
if(color_string.charAt(0)=='#'){// remove # if any
color_string=color_string.substr(1,6);}color_string=color_string.replace(/ /g,'');color_string=color_string.toLowerCase();// before getting into regexps, try simple matches
// and overwrite the input
var simple_colors={aliceblue:'f0f8ff',antiquewhite:'faebd7',aqua:'00ffff',aquamarine:'7fffd4',azure:'f0ffff',beige:'f5f5dc',bisque:'ffe4c4',black:'000000',blanchedalmond:'ffebcd',blue:'0000ff',blueviolet:'8a2be2',brown:'a52a2a',burlywood:'deb887',cadetblue:'5f9ea0',chartreuse:'7fff00',chocolate:'d2691e',coral:'ff7f50',cornflowerblue:'6495ed',cornsilk:'fff8dc',crimson:'dc143c',cyan:'00ffff',darkblue:'00008b',darkcyan:'008b8b',darkgoldenrod:'b8860b',darkgray:'a9a9a9',darkgreen:'006400',darkkhaki:'bdb76b',darkmagenta:'8b008b',darkolivegreen:'556b2f',darkorange:'ff8c00',darkorchid:'9932cc',darkred:'8b0000',darksalmon:'e9967a',darkseagreen:'8fbc8f',darkslateblue:'483d8b',darkslategray:'2f4f4f',darkturquoise:'00ced1',darkviolet:'9400d3',deeppink:'ff1493',deepskyblue:'00bfff',dimgray:'696969',dodgerblue:'1e90ff',feldspar:'d19275',firebrick:'b22222',floralwhite:'fffaf0',forestgreen:'228b22',fuchsia:'ff00ff',gainsboro:'dcdcdc',ghostwhite:'f8f8ff',gold:'ffd700',goldenrod:'daa520',gray:'808080',green:'008000',greenyellow:'adff2f',honeydew:'f0fff0',hotpink:'ff69b4',indianred:'cd5c5c',indigo:'4b0082',ivory:'fffff0',khaki:'f0e68c',lavender:'e6e6fa',lavenderblush:'fff0f5',lawngreen:'7cfc00',lemonchiffon:'fffacd',lightblue:'add8e6',lightcoral:'f08080',lightcyan:'e0ffff',lightgoldenrodyellow:'fafad2',lightgrey:'d3d3d3',lightgreen:'90ee90',lightpink:'ffb6c1',lightsalmon:'ffa07a',lightseagreen:'20b2aa',lightskyblue:'87cefa',lightslateblue:'8470ff',lightslategray:'778899',lightsteelblue:'b0c4de',lightyellow:'ffffe0',lime:'00ff00',limegreen:'32cd32',linen:'faf0e6',magenta:'ff00ff',maroon:'800000',mediumaquamarine:'66cdaa',mediumblue:'0000cd',mediumorchid:'ba55d3',mediumpurple:'9370d8',mediumseagreen:'3cb371',mediumslateblue:'7b68ee',mediumspringgreen:'00fa9a',mediumturquoise:'48d1cc',mediumvioletred:'c71585',midnightblue:'191970',mintcream:'f5fffa',mistyrose:'ffe4e1',moccasin:'ffe4b5',navajowhite:'ffdead',navy:'000080',oldlace:'fdf5e6',olive:'808000',olivedrab:'6b8e23',orange:'ffa500',orangered:'ff4500',orchid:'da70d6',palegoldenrod:'eee8aa',palegreen:'98fb98',paleturquoise:'afeeee',palevioletred:'d87093',papayawhip:'ffefd5',peachpuff:'ffdab9',peru:'cd853f',pink:'ffc0cb',plum:'dda0dd',powderblue:'b0e0e6',purple:'800080',red:'ff0000',rosybrown:'bc8f8f',royalblue:'4169e1',saddlebrown:'8b4513',salmon:'fa8072',sandybrown:'f4a460',seagreen:'2e8b57',seashell:'fff5ee',sienna:'a0522d',silver:'c0c0c0',skyblue:'87ceeb',slateblue:'6a5acd',slategray:'708090',snow:'fffafa',springgreen:'00ff7f',steelblue:'4682b4',tan:'d2b48c',teal:'008080',thistle:'d8bfd8',tomato:'ff6347',turquoise:'40e0d0',violet:'ee82ee',violetred:'d02090',wheat:'f5deb3',white:'ffffff',whitesmoke:'f5f5f5',yellow:'ffff00',yellowgreen:'9acd32'};for(var key in simple_colors){if(color_string==key){color_string=simple_colors[key];}}// emd of simple type-in colors
// array of color definition objects
var color_defs=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:['rgb(123, 234, 45)','rgb(255,234,245)'],process:function process(bits){return[parseInt(bits[1]),parseInt(bits[2]),parseInt(bits[3])];}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:['#00ff00','336699'],process:function process(bits){return[parseInt(bits[1],16),parseInt(bits[2],16),parseInt(bits[3],16)];}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:['#fb0','f0f'],process:function process(bits){return[parseInt(bits[1]+bits[1],16),parseInt(bits[2]+bits[2],16),parseInt(bits[3]+bits[3],16)];}}];// search through the definitions to find a match
for(var i=0;i<color_defs.length;i++){var re=color_defs[i].re;var processor=color_defs[i].process;var bits=re.exec(color_string);if(bits){channels=processor(bits);this.r=channels[0];this.g=channels[1];this.b=channels[2];this.ok=true;}}// validate/cleanup values
this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r;this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g;this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b;// some getters
this.toRGB=function(){return'rgb('+this.r+', '+this.g+', '+this.b+')';};this.toHex=function(){var r=this.r.toString(16);var g=this.g.toString(16);var b=this.b.toString(16);if(r.length==1)r='0'+r;if(g.length==1)g='0'+g;if(b.length==1)b='0'+b;return'#'+r+g+b;};// help
this.getHelpXML=function(){var examples=new Array();// add regexps
for(var i=0;i<color_defs.length;i++){var example=color_defs[i].example;for(var j=0;j<example.length;j++){examples[examples.length]=example[j];}}// add type-in colors
for(var sc in simple_colors){examples[examples.length]=sc;}var xml=document.createElement('ul');xml.setAttribute('id','rgbcolor-examples');for(var i=0;i<examples.length;i++){try{var list_item=document.createElement('li');var list_color=new RGBColor(examples[i]);var example_div=document.createElement('div');example_div.style.cssText='margin: 3px; '+'border: 1px solid black; '+'background:'+list_color.toHex()+'; '+'color:'+list_color.toHex();example_div.appendChild(document.createTextNode('test'));var list_item_value=document.createTextNode(' '+examples[i]+' -> '+list_color.toRGB()+' -> '+list_color.toHex());list_item.appendChild(example_div);list_item.appendChild(list_item_value);xml.appendChild(list_item);}catch(e){}}return xml;};}// export as AMD...
if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return RGBColor;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// ...or as browserify
else if(typeof module!=='undefined'&&module.exports){module.exports=RGBColor;}global.RGBColor=RGBColor;})(typeof window!=='undefined'?window:this);

/***/ }),

/***/ "./src/hoc/withErrorHandler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ErrorComponent__ = __webpack_require__("./src/components/ErrorComponent/index.js");
/**
 * 
 * @format
 */var withErrorHandler=Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["branch"])(function(props){return props.hasError;},Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["renderComponent"])(__WEBPACK_IMPORTED_MODULE_1__components_ErrorComponent__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (withErrorHandler);

/***/ }),

/***/ "./src/hoc/withLoader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("./src/components/Loading/index.js");
/**
 * 
 * @format
 */var withLoader=Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["branch"])(function(props){return props.loading;},Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["renderComponent"])(__WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (withLoader);

/***/ }),

/***/ "./src/images/onsemifcslogo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/onsemifcslogo.92d1a604.svg";

/***/ }),

/***/ "./src/images/pswlogo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pswlogo.52fd8966.svg";

/***/ }),

/***/ "./src/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("./node_modules/bootstrap/dist/css/bootstrap.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__("./src/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfill__ = __webpack_require__("./src/polyfill.js");
/* @noflow *//* eslint-disable global-require, consistent-return *//* global __PROD__ *//**
 * Conditionally load polyfills for older browsers
 * while utilizing modern browser functionality.
 * https://hackernoon.com/polyfills-everything-you-ever-wanted-to-know-or-maybe-a-bit-less-7c8de164e423
 *//**
 * This load point is injected into the CRA pipeline via config-override.js
 * index.js should be considered the application entry point for all modern browsers
 * since the polyfills are skipped there.
 */try{Object(__WEBPACK_IMPORTED_MODULE_2__polyfill__["a" /* default */])().then(function(){if(true){__webpack_require__("./src/utils/rollbar.js");}__webpack_require__("./src/main.js");});}catch(err){console.error('Error loading polyfills: ',err);// eslint-disable-line no-console
}if(false){module.hot.accept();}

/***/ }),

/***/ "./src/main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll_up__ = __webpack_require__("./node_modules/react-scroll-up/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_scroll_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_arrow_circle_o_up__ = __webpack_require__("./node_modules/react-icons/lib/fa/arrow-circle-o-up.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_arrow_circle_o_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_arrow_circle_o_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux__ = __webpack_require__("./src/utils/react-aux.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Header__ = __webpack_require__("./src/components/Header/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer__ = __webpack_require__("./src/components/Footer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ModalWrapper__ = __webpack_require__("./src/components/ModalWrapper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__("./src/App.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sagas__ = __webpack_require__("./src/sagas/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configureStore__ = __webpack_require__("./src/configureStore.js");
/**
 * 
 * @format
 *//**
 * Old index.js file - until I figure out how to rename the CRA entry point.
 */// import registerServiceWorker from './registerServiceWorker';
// Import the index reducers, sagas, and middlware
var store=Object(__WEBPACK_IMPORTED_MODULE_12__configureStore__["a" /* default */])();// Begin our Index Saga $FlowIgnore
store.run(__WEBPACK_IMPORTED_MODULE_11__sagas__["a" /* default */]);var scrollStyle={position:'fixed',bottom:50,right:30,cursor:'pointer',transitionDuration:'0.2s',transitionTimingFunction:'linear',transitionDelay:'0s',zIndex:9990};var AppWrapper=function AppWrapper(BaseComponent,localStore){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:localStore},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_react_aux___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_scroll_up___default.a,{showUnder:160,style:scrollStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_arrow_circle_o_up___default.a,{size:80}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Header__["a" /* default */],{title:"Boost Powertrain"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Container"],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BaseComponent,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ModalWrapper__["a" /* default */],null))));};var rootEl=document.getElementById('root');if(!rootEl){throw Error('Missing root element');}__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(AppWrapper(__WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */],store),rootEl);// registerServiceWorker();
if(false){/* eslint-disable global-require */// $FlowIgnore
module.hot.accept();// module.hot.accept('./App', () => {
//   const NextApp = require('./App').default;
//   ReactDOM.render(AppWrapper(NextApp, store), rootEl);
// });
// // Enable Webpack hot module replacement for reducers
// module.hot.accept('./reducers', () => {
//   const nextReducer = require('./reducers').default;
//   store.replaceReducer(nextReducer);
// });
/* eslint-enable global-require */}

/***/ }),

/***/ "./src/middleware/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messageForHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return modalOpenHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set__ = __webpack_require__("./node_modules/lodash/set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routines__ = __webpack_require__("./src/routines/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routines_design__ = __webpack_require__("./src/routines/design.js");
/**
 * 
 * @format
 *//**
 * Middleware to handle scroll actions
 * @param {ReduxStore} store
 * @param {*} next
 * @param {Action} action
 */var scrollMiddleware=function scrollMiddleware(){return function(next){return function(action){if(action.type===__WEBPACK_IMPORTED_MODULE_3__routines__["a" /* app */].scrollToTop.toString()){setTimeout(function(){return window.scrollTo(0,0);},100);}// dumb
if(action.type===__WEBPACK_IMPORTED_MODULE_3__routines__["a" /* app */].scrollToTop.toString()){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* isBrowserIE */])()){setTimeout(function(){/**
         * IE11 doesn't support fixed table headers like other modern browers
         * so we need to use the jquery plugin to add it at runtime.
         * This is the only plugin that worked and I didn't want to rewrite it
         * in vanilla so we're loading jquery and this plugin only in IE browers.
         */var tables=window.jQuery(".TableSelectionGroup__tableFixed, .LargeTable__tableFixed");tables.floatThead({position:'absolute',autoReflow:true,scrollContainer:true});setTimeout(function(){// Fixes the 15px right offset calculation error in IE
window.jQuery('div.floatThead-container').css('overflow-x','visible');},0);},150);}}return next(action);};};};/**
 * Middleware to handle renaming fields where needed
 * @param {ReduxStore} store
 */// eslint-disable-next-line no-unused-vars
var messageForHandler=function messageForHandler(store){var fieldRemap={SuitableInductors:'IndPNsel',Pkgs_FET0:'Pkgs_FET',// Re-route No parts found meeting thermal requirements
pkgs_Diode0:'DiodesVIPTgood',// Re-route no parts found errors to the select tables
diode_sel:'Losscomp_diode',PN_list_diode:'Losscomp_diode',PN_sel_fet:'Losscomp_FET',PN_list_fet:'Losscomp_FET'};return function(next){return function(action){var messageFor=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(action,['payload','messageFor']);var content=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(action,['payload','content']);if(messageFor){var field=fieldRemap[messageFor]||messageFor;action=__WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(action,['payload','messageFor'],field);// eslint-disable-line no-param-reassign
action=__WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(action,['payload','content'],content);// eslint-disable-line no-param-reassign
}return next(action);};};};var modalOpenHelper=function modalOpenHelper(store){return function(next){return function(action){if(action.type===__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].copyDesign.TRIGGER||action.type===__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].copyDesign.SUCCESS||action.type===__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].copyDesign.FULFILL||action.type===__WEBPACK_IMPORTED_MODULE_4__routines_design__["a" /* default */].copyDesign.REQUEST){// $FlowIgnore
var isInModal=store.getState().modals.modalType!==null;action=__WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(action,['payload','fromModal'],isInModal);// eslint-disable-line no-param-reassign
}next(action);};};};/* unused harmony default export */ var _unused_webpack_default_export = ({messageForHandler:messageForHandler,scrollMiddleware:scrollMiddleware,modalOpenHelper:modalOpenHelper});

/***/ }),

/***/ "./src/polyfill.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = polyfill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfills_toBlob__ = __webpack_require__("./src/utils/polyfills/toBlob.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfills_toBlob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_polyfills_toBlob__);
/**
 * On demand polyfill import using import()
 *
 * @see https://webpack.js.org/guides/code-splitting-async/
 * @see http://anzorb.com/we-dont-need-your-polyfills/
 * @see https://hackernoon.com/polyfills-everything-you-ever-wanted-to-know-or-maybe-a-bit-less-7c8de164e423
 * @see http://anujnair.com/blog/13-conditionally-load-multiple-polyfills-using-webpack-promises-and-code-splitting
 *
 *//* eslint-disable global-require *//**
 * NOTE: CRA includes a polyfill for promise and fetch by default
 */// Small polyfill for blobs
function polyfill(){var promises=[// check core es6 features
new Promise(function(resolve){var supportsES6='assign'in Object&&'keys'in Object&&'includes'in Array.prototype&&'fill'in Array.prototype;if(supportsES6)return resolve();return __webpack_require__.e/* require.ensure */("core-js").then((function(){__webpack_require__("./node_modules/core-js/shim.js");resolve();}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);}),// check for IE11
new Promise(function(resolve){// ie11:  'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
var ua=window.navigator.userAgent;if(!(/Trident/.test(ua)&&ua.indexOf('rv:')))return resolve();return __webpack_require__.e/* require.ensure */("ie11-polyfill").then((function(){__webpack_require__("./src/utils/polyfills/ie11.js");__webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");__webpack_require__("./node_modules/floatthead/dist/jquery.floatThead.js-exposed");resolve();}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);})];return Promise.all(promises);}

/***/ }),

/***/ "./src/reducers/design.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__("./node_modules/lodash/fp/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__("./node_modules/lodash/uniq.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge__ = __webpack_require__("./node_modules/lodash/merge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_set__ = __webpack_require__("./node_modules/lodash/set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__("./node_modules/lodash/forEach.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_slice__ = __webpack_require__("./node_modules/lodash/slice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_head__ = __webpack_require__("./node_modules/lodash/head.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_reduce__ = __webpack_require__("./node_modules/lodash/reduce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__("./node_modules/lodash/isEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_omit__ = __webpack_require__("./node_modules/lodash/omit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__ = __webpack_require__("./node_modules/lodash/mapValues.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isNull__ = __webpack_require__("./node_modules/lodash/isNull.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_some__ = __webpack_require__("./node_modules/lodash/some.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_pickBy__ = __webpack_require__("./node_modules/lodash/pickBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_stepHelpers__ = __webpack_require__("./src/utils/stepHelpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_constants__ = __webpack_require__("./src/utils/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_hashid__ = __webpack_require__("./src/utils/hashid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__routines_global__ = __webpack_require__("./src/routines/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__routines_design__ = __webpack_require__("./src/routines/design.js");
/**
 * 
 * @format
 */function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// import debug from '~/utils/macros/debug.macro';
var hashId=new __WEBPACK_IMPORTED_MODULE_19__utils_hashid__["a" /* default */]();function buildChangedFields(fields){var validValues=__WEBPACK_IMPORTED_MODULE_15_lodash_pickBy___default()(fields,function(field){return!__WEBPACK_IMPORTED_MODULE_14_lodash_some___default()([field.currentValue,field.defaultValue],__WEBPACK_IMPORTED_MODULE_13_lodash_isNull___default.a);});// $FlowIgnore
var diff=__WEBPACK_IMPORTED_MODULE_15_lodash_pickBy___default()(validValues,function(field){return!__WEBPACK_IMPORTED_MODULE_12_lodash_isEqual___default()(field.currentValue,field.defaultValue);});return __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(diff,function(){return true;});}function fixSchematicSVG(str){var props=['xmlns="http://www.w3.org/2000/svg"','height="'+(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["k" /* isBrowserIE */])()?'':'100%')+'"','width="'+(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["k" /* isBrowserIE */])()?'':'100%')+'"','viewBox="0 0 500 300"'];// Replace any SVG attrs with our own
return str.replace(/<svg.+(?=>)/,'<svg '+props.join(' '));}var initialState={loading:true,initialValues:{},name:'',id:null,currentStep:__WEBPACK_IMPORTED_MODULE_18__utils_constants__["b" /* Steps */].STEP_ONE,dirtyFields:{},changedFields:{},values:{},evaluating:{},errors:{},fields:{},info:{},schematic:{loading:false,hasData:false,data:''},report:{loading:false,hasData:false,data:''},stepStatus:{},openingDesign:false,savingDesign:false};function design(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_20__actions_design__["c" /* revertField */].toString():{var field=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(action,['payload','field']);return Object.assign({},state,{values:Object.assign({},state.values,_defineProperty({},field,Object.assign({},state.values[field],{currentValue:state.values[field].defaultValue}))),dirtyFields:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.dirtyFields,field),changedFields:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.changedFields,field),errors:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.errors,field)});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].CHANGE_VALUE:{var _field=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(action,['payload','field']);return Object.assign({},state,{values:Object.assign({},state.values,_defineProperty({},_field,Object.assign({},state.values[_field],{currentValue:action.payload.value}))),changedFields:Object.assign({},state.changedFields,_defineProperty({},_field,true)),errors:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.errors,_field),dirtyFields:Object.assign({},state.dirtyFields,_defineProperty({},_field,state.values[_field].currentValue))});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].EVALUATE:{var _field2=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(action,['payload','field']);return Object.assign({},state,{evaluating:Object.assign({},state.evaluating,_defineProperty({},_field2,true)),dirtyFields:Object.assign({},state.dirtyFields,_defineProperty({},_field2,state.values[_field2].currentValue))});}case __WEBPACK_IMPORTED_MODULE_22__routines_global__["a" /* default */].fetchChartData.TRIGGER:case __WEBPACK_IMPORTED_MODULE_23__routines_design__["a" /* default */].fetchRecord.TRIGGER:case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].PENDING:{return Object.assign({},state,{loading:true});}case __WEBPACK_IMPORTED_MODULE_22__routines_global__["a" /* default */].jumpToStep.toString():{return Object.assign({},state,{currentStep:action.payload});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].AUTO_COMPLETE:{return Object.assign({},state,{currentStep:__WEBPACK_IMPORTED_MODULE_18__utils_constants__["b" /* Steps */].STEP_ANALYSIS});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].STEP_FORWARD:{var next=Object(__WEBPACK_IMPORTED_MODULE_21__selectors_design__["m" /* nextStep */])(state.currentStep);return Object.assign({},state,{currentStep:next});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].STEP_BACKWARD:{var prev=Object(__WEBPACK_IMPORTED_MODULE_21__selectors_design__["n" /* prevStep */])(state.currentStep);return Object.assign({},state,{currentStep:prev});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].RENAME_DESIGN:{return Object.assign({},state,{name:action.data});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].STEP_RESET:{// We need to reset fields values for all stages for/after this one.
var active=state.currentStep;var fields=Object(__WEBPACK_IMPORTED_MODULE_17__utils_stepHelpers__["c" /* getNextFieldsByStep */])(active);return Object.assign({},state,{loading:true,changedFields:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.changedFields,fields),dirtyFields:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.dirtyFields,fields),errors:__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.errors,fields)});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].SAVE_DESIGN:{return Object.assign({},state,{name:action.payload,savingDesign:true});}// case constants.RECEIVE_DESIGN: {
//   // const data: FieldDataType = action.payload.data;
//   // const record: RecordDataType = action.payload.message.record;
//   const {
//     actionType,
//     activityDttm,
//     activityId,
//     emailId,
//     recordName,
//     userId,
//     userIpAddress,
//     type,
//     ...rest
//   } = action.payload;
//   const formatField = (str: string): string => {
//     const fields = {
//       ambientTmpt: 'Tamb',
//       csHtsnkThrmlRest: 'RthCS',
//       dcBusVolt: 'Vbus',
//       maxHeatSinkTmpt: 'TSinkMax',
//       maxJunctnTmpt: 'TjMax1',
//       modulatnIdx: 'MI',
//       motorRmsPhsCurr: 'IPhase',
//       outputFreq: 'OutputFreq',
//       overloadPctg: 'OverLoadPercent',
//       partSelected: 'PartNumber',
//       pkg: 'SpmPackage',
//       pwmMethod: 'PWM',
//       pwrFctr: 'PF',
//       snkAmbThrmlRest: 'RthSA1',
//       snkAmbThrmlRestCalcMtd: 'ManualRSink',
//       switchingFreq: 'SwitchingFreqKhz',
//     };
//     return _.get(fields, str, 'UNKNOWN');
//   };
//   const data = _.reduce(
//     rest,
//     (obj: any, val: string, key: string) => {
//       const o = obj;
//       o[formatField(key)] = {
//         currentValue: val,
//         // defaultValue: val,
//       };
//       return o;
//     },
//     {},
//   );
//   // const diff = _.differenceWith(state.values, data, );
//   const validSteps: FieldDataType = _.pickBy(
//     data,
//     (field, key: string): boolean => _.isString(getStepByField(key)),
//   );
//   const validValues: FieldDataType = _.pickBy(
//     validSteps,
//     (field: Object): boolean =>
//       !_.some([field.currentValue, field.defaultValue], _.isNull),
//   );
//   const diff = _.pickBy(
//     validValues,
//     (field: Object): boolean =>
//       !_.isEqual(field.currentValue, field.defaultValue),
//   );
//   return {
//     ...state,
//     values: _.merge({}, state.values, data),
//     changedFields: _.mapValues(diff, () => true),
//     name: recordName,
//     loading: false,
//   };
// }
case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].NEW_DESIGN:{return Object.assign({},initialState,{id:hashId.nextId()});}case __WEBPACK_IMPORTED_MODULE_23__routines_design__["a" /* default */].fetchRecord.SUCCESS:case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].UPDATE:{// const { data, content, messageFor, message, errorSource } = action.payload;
var _payload=action.payload.response||action.payload;var emptyState=__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default()(state.initialValues);// debug(payload);
// type FieldValueType = {
//   currentValue: string[] | string[][] | number | string,
//   defaultValue: string[] | string[][] | number | string,
//   rangeValue: { min: number, max: number },
// };
var _data=__WEBPACK_IMPORTED_MODULE_7_lodash_reduce___default()(_payload.data,function(obj,val,key){var o=obj;if(key.startsWith('Col_')||key.startsWith('Desc_')||key.startsWith('Numof_')||key.startsWith('MaxI')||key.startsWith('Manf_')||key==='BOM'||key==='Charts'||key==='CritChartData'){return o;}var cleanObj=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['currentValue','rangeValue','defaultValue']);o[key]=cleanObj(val);var curVal=o[key].currentValue;// Fix the long tables
if(['DiodesVIPTgood','FETsVIPTgood'].includes(key)){var arr=curVal||[];var header=__WEBPACK_IMPORTED_MODULE_6_lodash_head___default()(arr);var index=header?header.indexOf('Package'):-1;if(index>0){var fixed=arr.map(function(a){return __WEBPACK_IMPORTED_MODULE_5_lodash_slice___default()(a,0,index+1);});o[key].currentValue=fixed;}return o;}// clean up default / current values
if(['DefaultCmin_tot'].includes(key)){o[key].currentValue=o[key].defaultValue;}// Fix MaxPchoke currentValue
if(['MaxPchoke'].includes(key)){o[key].currentValue=o[key].rangeValue.max;return o;}// Append Irating_* units
if(['Irating_HS','Irating_LS_dual'].includes(key)){var getUnit=function getUnit(index){if(index===1&&key!=='Irating_LS_dual'){return'A<sub>RMS</sub>';}if(index>0)return'A';return'';};var getText=function getText(str){var map={max:'Max',current:'Current',rating:'Rating',average:'Average',IFav:'I<sub>Fav</sub>',IDcont:'I<sub>Dcont</sub>'};if(!str)return'';return Object(__WEBPACK_IMPORTED_MODULE_16__utils__["q" /* replaceAll */])(str,map);};if(Array.isArray(curVal)){var cast=curVal;o[key].currentValue=cast.map(function(v,k){return[getText(v[0]),v[1],getUnit(k)];});}return o;}// Some fields are missing default values
// that need to be set on initial load.
var FIX_DEFAULT_VALUES=['Therm_opt','Pkgs_Diodes','Sel_diode_pkg','Sel_fet_pkg','Snub_sel','DiodesVIPTgood','FETsVIPTgood'];if(FIX_DEFAULT_VALUES.includes(key)){// This has to be checked every time or nulls get merged
o[key].defaultValue=emptyState?o[key].currentValue:state.initialValues[key].defaultValue;return o;}return o;},{});// These fields have dependancies on other fields when setting defaults
// so we can't use the reduce fn above to set them.
// If the list changes, we should update the default value of the dataTarget.
var DATA_TARGET_DEFAULT_FIX={SuitableInductors:'IndPNsel',Losscomp_FET:'PN_sel_fet',Losscomp_diode:'PN_sel_diode'};__WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(DATA_TARGET_DEFAULT_FIX,function(target,key){var nextKeyValue=_data[key].currentValue;var prevKeyValue=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(state.values,[key,'currentValue'],null);var newDefault=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(nextKeyValue,['1','0'],null);// Initial state or table array has changed so we should update
// [target].defaultValue.
if(emptyState||!__WEBPACK_IMPORTED_MODULE_12_lodash_isEqual___default()(prevKeyValue,nextKeyValue)){_data[target]=__WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(_data[target],'defaultValue',newDefault);return;}// A change occured somewhere else else use the last [target] object.
_data[target]=state.values[target];});var messageFor=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_payload,['messageFor']);var content=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_payload,['content'],{});var messageType=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_payload,['type'])||__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_payload,['message','type']);var updatedValues=_data;// const type = get(message, 'type') || get(action.payload, 'type', 'NONE');
// For some reason this has changed from MC and SyncBuck.. need to work around.
var errorSource=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_payload,['errorSource'],{});// some errors return a value that needs to be merged back into the displayed values
if(messageType==='ERROR'&&errorSource.currentVal!==null){updatedValues=__WEBPACK_IMPORTED_MODULE_2_lodash_merge___default()(updatedValues,_defineProperty({},errorSource.key,{currentValue:errorSource.currentVal}));}var indMsg=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(updatedValues,['Inductor_msg','currentValue']);var infoObject={};if(indMsg){infoObject=__WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(infoObject,'IndPNsel',[indMsg]);}if(messageType==='INFO'){/*
        10/5(BC): just as in Sync Buck, error message should be displayed in the
        3b  "Data for Qualified Devices" table.
        3b & 3c  "Estimated Worst Case Losses..." tables should be blank
        3c "Data for Qualified Devices..." table should be blank.
        3b packages table should remain functional.
        Also, see ref#52, inductor table in 2b should have "inductor_msg" asserted
        (no suitable parts found...).

        Vin min = Vin max = 48V
        Vout = 76V
        I out = 4A
        */var lossFet=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(updatedValues,['Losscomp_FET','currentValue']);if(!lossFet&&indMsg){updatedValues=__WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(updatedValues,['FETsVIPTgood','currentValue'],null);updatedValues=__WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(updatedValues,['Losscomp_diode','currentValue'],null);}infoObject=__WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(infoObject,messageFor,[content]);}var errorObj={};var changedObj=state.changedFields;if(messageType==='ERROR'||messageType==='SUCCESS'&&messageFor){errorObj=Object.assign({},errorObj,state.errors,_defineProperty({},messageFor,[content]));// We need to concat the current error fiends and the remaining fields after this one
var remainingFields=Object(__WEBPACK_IMPORTED_MODULE_17__utils_stepHelpers__["b" /* getNextFields */])(messageFor);changedObj=__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(state.changedFields,[].concat(remainingFields,messageFor));}// Loading a design record requires a rebuild of the changedFields object
var isRecord=action.type===__WEBPACK_IMPORTED_MODULE_23__routines_design__["a" /* default */].fetchRecord.SUCCESS;if(isRecord){changedObj=buildChangedFields(updatedValues);}var lastValues=Object.assign({},state.values);return Object.assign({},state,{currentStep:isRecord?'STEP_ONE':state.currentStep,loading:false,initialValues:emptyState?updatedValues:state.initialValues,values:Object.assign({},state.values,updatedValues),evaluating:{},dirtyFields:{},lastValues:lastValues,changedFields:changedObj,errors:errorObj,info:infoObject,schematic:initialState.schematic,savingDesign:false,openingDesign:false});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].VALIDATION_ERROR:{var _action$payload=action.payload,_field3=_action$payload.field,message=_action$payload.message;return Object.assign({},state,{errors:Object.assign({},state.errors,_defineProperty({},_field3,__WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(state.errors[_field3],message).filter(function(i){return i;})))),evaluating:{}});}case __WEBPACK_IMPORTED_MODULE_22__routines_global__["a" /* default */].fetchChartData.FULFILL:case __WEBPACK_IMPORTED_MODULE_23__routines_design__["a" /* default */].fetchRecord.FULFILL:{return Object.assign({},state,{loading:false});}case __WEBPACK_IMPORTED_MODULE_23__routines_design__["a" /* default */].copyDesign.TRIGGER:{if(action.payload.fromModal)return state;return Object(__WEBPACK_IMPORTED_MODULE_16__utils__["r" /* setIn */])('loading',true,state);}case __WEBPACK_IMPORTED_MODULE_23__routines_design__["a" /* default */].copyDesign.FULFILL:{return Object(__WEBPACK_IMPORTED_MODULE_16__utils__["r" /* setIn */])('loading',false,state);}case __WEBPACK_IMPORTED_MODULE_22__routines_global__["a" /* default */].fetchSchematic.TRIGGER:{return Object.assign({},state,{loading:true,schematic:Object.assign({},state.schematic,{loading:true,hasData:false})});}case __WEBPACK_IMPORTED_MODULE_22__routines_global__["a" /* default */].fetchSchematic.SUCCESS:{var svg=__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(action.payload,['response'],'');return Object.assign({},state,{schematic:Object.assign({},state.schematic,{hasData:true,data:fixSchematicSVG(svg)})});}case __WEBPACK_IMPORTED_MODULE_22__routines_global__["a" /* default */].fetchSchematic.FULFILL:{return Object.assign({},state,{loading:false,schematic:Object.assign({},state.schematic,{loading:false})});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].REQUEST_PDF:{return Object.assign({},state,{report:Object.assign({},state.report,{loading:true})});}case __WEBPACK_IMPORTED_MODULE_20__actions_design__["b" /* constants */].RECEIVE_PDF:{return Object.assign({},state,{report:Object.assign({},state.report,{loading:false,data:'ayy',hasData:true})});}default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (design);

/***/ }),

/***/ "./src/reducers/errors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_errors__ = __webpack_require__("./src/actions/errors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_design__ = __webpack_require__("./src/actions/design.js");
/**
 * 
 * @format
 */var initialState=[];function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_errors__["b" /* constants */].API_ERROR:{var err={type:action.type,data:Object.assign({},action.payload,{timestamp:Date.now()})};return state.concat(err);}case __WEBPACK_IMPORTED_MODULE_1__actions_design__["b" /* constants */].STEP_RESET:case __WEBPACK_IMPORTED_MODULE_1__actions_design__["b" /* constants */].NEW_DESIGN:{return initialState;}default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (error);

/***/ }),

/***/ "./src/reducers/global.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set__ = __webpack_require__("./node_modules/lodash/set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routines_global__ = __webpack_require__("./src/routines/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routines_design__ = __webpack_require__("./src/routines/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("./src/utils/index.js");
/**
 * 
 * @format
 */// Reducer
var initialState={BOMTable:[],chartData:{loading:false,hasData:false,data:{}},records:{loading:false,current:null,error:'',data:new Map()},critChart:{},currentUser:undefined};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3__actions_design__["b" /* constants */].UPDATE:{var _type=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(action,['payload','message','type'])||__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(action,['payload','type'],'NONE');// Short circuit for non-successful responses
if(_type==='ERROR')return state;var _BOMTable=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(action,['payload','data','BOM','currentValue'],[]);var critChart=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(action,['payload','data','CritChartData','currentValue']);return Object.assign({},state,{chartData:initialState.chartData,critChart:critChart,BOMTable:_BOMTable});}case __WEBPACK_IMPORTED_MODULE_4__routines_global__["a" /* default */].fetchChartData.TRIGGER:{return Object.assign({},state,{chartData:Object.assign({},state.chartData,{loading:true})});}case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].fetchRecord.SUCCESS:case __WEBPACK_IMPORTED_MODULE_4__routines_global__["a" /* default */].fetchChartData.REQUEST:{return Object.assign({},state,{chartData:Object.assign({},state.chartData,{hasData:false,data:{}})});}case __WEBPACK_IMPORTED_MODULE_4__routines_global__["a" /* default */].fetchChartData.FULFILL:{return Object.assign({},state,{chartData:Object.assign({},state.chartData,{loading:false})});}case __WEBPACK_IMPORTED_MODULE_4__routines_global__["a" /* default */].fetchChartData.SUCCESS:{var charts=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(action.payload,['response','Charts'],[]);var effSummary=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(action.payload,['response','Powertrain Efficiency Summary'],[]);var loadArray=Array(13).fill(0).map(function(v,k){return k*10;});charts=__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(charts,function(c,i){var cCopy=c;// 0-9 are graphs, 10-13 are piecharts
if(i<=9){var xaxis=cCopy.data['x-axis']||loadArray;delete cCopy.data['x-axis'];cCopy.data=__WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(cCopy.data,'Unit',xaxis);}if(cCopy.labels===null)return c;cCopy.labels={x:cCopy.labels.xaxis,y1:cCopy.labels.yaxis};return cCopy;});return Object.assign({},state,{chartData:Object.assign({},state.chartData,{hasData:true,data:{charts:charts,effSummary:effSummary}})});}case __WEBPACK_IMPORTED_MODULE_3__actions_design__["b" /* constants */].RECEIVE_USER:{var _currentUser=action.payload.data;return Object.assign({},state,{currentUser:_currentUser});}case __WEBPACK_IMPORTED_MODULE_3__actions_design__["b" /* constants */].NEW_DESIGN:{return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.current',null,state);}case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].updateRecordName.SUCCESS:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].deleteDesign.SUCCESS:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].fetchAllRecords.SUCCESS:{// Convert the record array to a Map
// $FlowIgnore
var response=action.payload.response;if(!response)return state;var arr=response.map(function(record){return[record.id,record];});var map=new Map(arr);return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.data',map,state);}// Single record
case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].fetchRecord.TRIGGER:{return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.current',Number(action.payload),state);}case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].copyDesign.SUCCESS:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].saveDesignRecord.SUCCESS:{// $FlowIgnore
var _response=action.payload.response;if(!_response)return state;var _id=_response.id;var _data=_response.data;// $FlowIgnore
var _arr=_data.map(function(record){return[record.id,record];});var _map2=new Map(_arr);var dataState=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.data',_map2,state);// skip updating the current design if the modal is open (we're managing)
// $FlowIgnore
if(action.payload.fromModal)return dataState;return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.current',_id,dataState);}// Save Design
case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].updateRecordName.TRIGGER:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].copyDesign.TRIGGER:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].deleteDesign.TRIGGER:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].fetchAllRecords.TRIGGER:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].saveDesignRecord.TRIGGER:{return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.loading',true,state);}case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].updateRecordName.FAILURE:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].copyDesign.FAILURE:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].deleteDesign.FAILURE:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].saveDesignRecord.FAILURE:{return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.error',action.payload,state);}case'HIDE_MODAL':{return Object.assign({},state,{records:Object.assign({},state.records,{loading:false,error:''})});}case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].updateRecordName.FULFILL:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].copyDesign.FULFILL:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].deleteDesign.FULFILL:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].fetchAllRecords.FULFILL:case __WEBPACK_IMPORTED_MODULE_5__routines_design__["a" /* default */].saveDesignRecord.FULFILL:{return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["r" /* setIn */])('records.loading',false,state);}default:return state;}});

/***/ }),

/***/ "./src/reducers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_notifications__ = __webpack_require__("./node_modules/redux-notifications/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal__ = __webpack_require__("./src/reducers/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__design__ = __webpack_require__("./src/reducers/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress__ = __webpack_require__("./src/reducers/progress.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors__ = __webpack_require__("./src/reducers/errors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__("./src/reducers/global.js");
/**
 * 
 * @format
 */// import { reducers } from '../modules';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({modals:__WEBPACK_IMPORTED_MODULE_2__modal__["a" /* default */],notifs:__WEBPACK_IMPORTED_MODULE_1_redux_notifications__["reducer"],errors:__WEBPACK_IMPORTED_MODULE_5__errors__["a" /* default */],global:__WEBPACK_IMPORTED_MODULE_6__global__["a" /* default */],design:__WEBPACK_IMPORTED_MODULE_3__design__["a" /* default */],progress:__WEBPACK_IMPORTED_MODULE_4__progress__["a" /* default */]}));

/***/ }),

/***/ "./src/reducers/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_modal__ = __webpack_require__("./src/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routines_design__ = __webpack_require__("./src/routines/design.js");
/**
 * 
 * @format
 */var initialState={modalType:null,modalProps:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_modal__["b" /* constants */].SHOW_MODAL:return{modalType:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(action.data,'modalType'),modalProps:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(action.data,'modalProps')};case __WEBPACK_IMPORTED_MODULE_1__actions_modal__["b" /* constants */].HIDE_MODAL:case __WEBPACK_IMPORTED_MODULE_2__routines_design__["a" /* default */].saveDesignRecord.SUCCESS:return initialState;default:return state;}});

/***/ }),

/***/ "./src/reducers/progress.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_set__ = __webpack_require__("./node_modules/lodash/fp/set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_slice__ = __webpack_require__("./node_modules/lodash/slice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__ = __webpack_require__("./src/utils/stepHelpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__("./src/utils/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routines_global__ = __webpack_require__("./src/routines/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routines_design__ = __webpack_require__("./src/routines/design.js");
/**
 * 
 * @format
 */function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// import debug from '~/utils/macros/debug.macro';
var NOT_STARTED=__WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* StepState */].NOT_STARTED,ERROR=__WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* StepState */].ERROR,COMPLETE=__WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* StepState */].COMPLETE,DISABLED=__WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* StepState */].DISABLED;/**
 * Helper function to create a StateType[] of given ids and status
 *
 * @param {string[]} list
 * @param {ValidStatusType} status
 * @returns {StatusType[]}
 */function updateStatus(list,status){return list.reduce(function(obj,id){return Object.assign({},obj,_defineProperty({},id,status));},{});}/**
 * Returns a StatusType[] of steps before the given step.
 *
 * @param {string} step
 * @returns {StatusType[]}
 */function getPrevSteps(step){var index=__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(id){return id===step;});return __WEBPACK_IMPORTED_MODULE_2_lodash_slice___default()(__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */],0,index);}/**
 * Returns a StatusType[] of steps after the given step.
 *
 * @param {string} step
 * @returns {StatusType[]}
 */function getNextSteps(step){var index=__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(id){return id===step;});return __WEBPACK_IMPORTED_MODULE_2_lodash_slice___default()(__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */],index);}var initialState={active:__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */][0],hasError:false,status:updateStatus(__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */],NOT_STARTED),info:{},stepProgress:{}};/**
 * StepProgress reducer
 *
 * @export
 * @param {StateType} [state=initialState]
 * @param {ActionType} action
 * @returns {StateType}
 *//* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_7__routines_global__["a" /* default */].jumpToStep.toString():{var newStep=action.payload;var prevSteps=getPrevSteps(newStep);var completed=updateStatus(prevSteps,COMPLETE);/**
       * Jumping a step should do the following:
       * Set current step
       * If step is not started and no error - set all previous steps as completed
       * if step is completed - do nothing
       */return Object.assign({},state,{status:Object.assign({},state.status,completed),active:newStep});}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].STEP_FORWARD:{var next=Object(__WEBPACK_IMPORTED_MODULE_5__selectors_design__["m" /* nextStep */])(state.active);var _prevSteps=getPrevSteps(next);var _completed=updateStatus(_prevSteps,COMPLETE);return Object.assign({},state,{status:Object.assign({},state.status,_completed),active:next});}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].STEP_BACKWARD:{var _next=Object(__WEBPACK_IMPORTED_MODULE_5__selectors_design__["n" /* prevStep */])(state.active);return Object.assign({},state,{active:_next});}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].NEW_DESIGN:{return Object.assign({},initialState);}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].AUTO_COMPLETE:{// Autocomplete should jump the user to loss review
var _completed2=updateStatus(__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["a" /* StepOrder */],COMPLETE);return{status:Object.assign({},_completed2),active:__WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* Steps */].STEP_ANALYSIS};}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].VALIDATION_ERROR:{var _field=action.payload.field;var errorStep=Object(__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["d" /* getStepByField */])(_field);// set error on `field` and set the remaining steps to disabled.
// return set(state, ['status', errorStep], ERROR);
var nextSteps=getNextSteps(errorStep);var disabled=updateStatus(nextSteps,DISABLED);if(!errorStep)return state;return Object.assign({},state,{// info: set(state, ['info', errorStep], message),
info:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_set___default()([errorStep],_field,state.info),status:Object.assign({},state.status,disabled,_defineProperty({},errorStep,ERROR))});}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].UPDATE:{var _message=action.payload.message;var _type=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(action,['payload','type'])||__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_message,['type']);var _messageFor=action.payload.messageFor;var messageForStep=_messageFor&&Object(__WEBPACK_IMPORTED_MODULE_3__utils_stepHelpers__["d" /* getStepByField */])(_messageFor);var step=messageForStep||state.active;var _prevSteps2=getPrevSteps(step);var _nextSteps=getNextSteps(step);var _completed3=updateStatus(_prevSteps2,COMPLETE);// debug(messageFor, messageForStep, prevSteps, nextSteps);
if(_type==='SUCCESS'){var notStarted=updateStatus(_nextSteps,NOT_STARTED);return Object.assign({},state,{status:Object.assign({},state.status,notStarted,_completed3,_defineProperty({},step,NOT_STARTED))});}else if(_type==='ERROR'||_type==='INFO'){var _Object$assign4;/**
         * In the event of an error:
         *   Set all following steps to 'disabled'
         *   Set step where error occured to 'error'
         *//**
         * the steps between current and field should be NOT_STARTED.
         * Fixes the cases where an error occurs >1 steps away.
         */var prevStepFix=updateStatus(__WEBPACK_IMPORTED_MODULE_2_lodash_slice___default()(_prevSteps2,_prevSteps2.indexOf(state.active)),NOT_STARTED);var _disabled=updateStatus(_nextSteps,DISABLED);return Object.assign({},state,{// info: set(state.info, [field], [content]),
info:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_set___default()([step],_messageFor,state.info),// info: Object.merge({}, state.info, { [field]: {}})
status:Object.assign({},state.status,_disabled,prevStepFix,(_Object$assign4={},_defineProperty(_Object$assign4,state.active,NOT_STARTED),_defineProperty(_Object$assign4,step,ERROR),_Object$assign4))});}return state;}case __WEBPACK_IMPORTED_MODULE_6__actions_design__["b" /* constants */].STEP_RESET:{// We need to reset any stages after this one
var _next2=Object(__WEBPACK_IMPORTED_MODULE_5__selectors_design__["m" /* nextStep */])(state.active);var _nextSteps2=getNextSteps(_next2);var _notStarted=updateStatus(_nextSteps2,NOT_STARTED);return Object.assign({},state,{status:Object.assign({},state.status,_notStarted,_defineProperty({},state.active,NOT_STARTED))});}// TODO: Open to last changed step
case __WEBPACK_IMPORTED_MODULE_8__routines_design__["a" /* default */].fetchRecord.REQUEST:{return Object.assign({},state,{active:__WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* Steps */].STEP_ONE,status:_defineProperty({},__WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* Steps */].STEP_ONE,__WEBPACK_IMPORTED_MODULE_4__utils_constants__["a" /* StepState */].STARTED)});}default:return state;}});

/***/ }),

/***/ "./src/routines/design.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__ = __webpack_require__("./node_modules/redux-saga-routines/es/index.js");
/**
 * 
 * @format
 *//* harmony default export */ __webpack_exports__["a"] = ({fetchRecord:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('FETCH_DESIGN'),fetchAllRecords:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('FETCH_ALL_DESIGNS'),saveDesignRecord:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('SAVE_DESIGN'),updateRecordName:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('UPDATE_RECORD_NAME'),copyDesign:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('COPY_DESIGN'),deleteDesign:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('DELETE_DESIGN'),updateDesign:Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_routines__["createRoutine"])('UPDATE_DESIGN')});

/***/ }),

/***/ "./src/routines/global.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return jumpToStep; });
/* unused harmony export scrollToTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_routines__ = __webpack_require__("./node_modules/redux-saga-routines/es/index.js");
/**
 * 
 * @format
 */// export const actionJumpStep = createRoutine('JUMP_TO_STEP', _.identity, (p, s) => ({ skipAnalytics: s === true }));
// Generate routine actions
var fetchChartData=Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_routines__["createRoutine"])('FETCH_CHART_DATA');var fetchSchematic=Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_routines__["createRoutine"])('FETCH_SCHEMATIC_DATA');// Generate regular actions
var jumpToStep=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])('JUMP_TO_STEP');var scrollToTop=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])('SCROLL_TO_TOP');/* harmony default export */ __webpack_exports__["a"] = ({jumpToStep:jumpToStep,scrollToTop:scrollToTop,fetchChartData:fetchChartData,fetchSchematic:fetchSchematic});

/***/ }),

/***/ "./src/routines/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__("./src/routines/global.js");
/**
 * 
 * @format
 */var app=__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */];/* unused harmony default export */ var _unused_webpack_default_export = (Object.assign({},__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */]));

/***/ }),

/***/ "./src/sagas/analytics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export watchAnalytics */
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeAnalytics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("./node_modules/lodash/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__("./node_modules/debug/src/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__("./node_modules/react-ga/dist/react-ga.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__("./node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routines_global__ = __webpack_require__("./src/routines/global.js");
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAnalytics),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(initializeAnalytics);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}const _uid2=__WEBPACK_IMPORTED_MODULE_2_debug___default()('app:sagas/analytics');/**
 * @format
 *//* eslint-disable flowtype/no-types-missing-file-annotation, no-undef */// type SagaActionType = {
//   '@@redux-saga/SAGA_ACTION'?: boolean,
//   payload: Object,
//   silent?: boolean,
//   type: string,
// };
var listenToActions=[__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].STEP_FORWARD,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].STEP_BACKWARD,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].STEP_RESET,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].AUTO_COMPLETE,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].RENAME_DESIGN,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].NEW_DESIGN,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].EVALUATE,__WEBPACK_IMPORTED_MODULE_6__routines_global__["b" /* jumpToStep */].toString(),__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].DOWNLOAD_PDF,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].DOWNLOAD_SCHEMATIC,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].EXPORT_BOM_EXCEL,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].SAVE_DESIGN,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].RECEIVE_DESIGN,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].RECEIVE_USER,__WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].OPEN_DESIGN];function watchAnalytics(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAnalytics$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["takeEvery"])(listenToActions,function(action){try{var type=action.type,payload=action.payload,silent=action.silent;switch(type){case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].AUTO_COMPLETE:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Autocomplete'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].SAVE_DESIGN:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Save Design'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].RECEIVE_DESIGN:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Open Design'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].DOWNLOAD_PDF:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Download PDF'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].EXPORT_BOM_EXCEL:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Download BOM'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].DOWNLOAD_SCHEMATIC:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Download Schematic'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].RECEIVE_USER:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.set({userId:payload.data.id});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].STEP_RESET:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'Reset Step'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].STEP_FORWARD:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'Navigation',action:'Step Forward'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].STEP_BACKWARD:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'Navigation',action:'Step Backward'});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].EVALUATE:{var field=payload.field,value=payload.value;var label=__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(value)?'label':'value';__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event(_defineProperty({category:'Evaluation',action:field},label,value));break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].NEW_DESIGN:{if(payload)break;__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'User',action:'New Design'});break;}case __WEBPACK_IMPORTED_MODULE_6__routines_global__["a" /* default */].jumpToStep.toString():{if(silent)break;__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.event({category:'Navigation',action:'Change Step',label:payload});break;}case __WEBPACK_IMPORTED_MODULE_5__actions_design__["b" /* constants */].OPEN_DESIGN:{__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.modalview('open-designs');break;}default:{break;}}}catch(e){_uid2(e);// eslint-disable-line no-console
}});case 2:case'end':return _context.stop();}}},_marked,this);}function initializeAnalytics(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function initializeAnalytics$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["all"])([Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_react_ga___default.a.initialize,''+"UA-53160035-1",{debug:true}),Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["fork"])(watchAnalytics)]);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),

/***/ "./src/sagas/design.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUrlParam */
/* unused harmony export fetchDesignData */
/* unused harmony export evaluateReport */
/* unused harmony export evaluateData */
/* unused harmony export watchStepProgression */
/* unused harmony export handleValidate */
/* unused harmony export handleDownloadPdf */
/* unused harmony export downloadSchematic */
/* unused harmony export downloadBOMCVS */
/* unused harmony export handleSavePdf */
/* unused harmony export handleOpenDesign */
/* unused harmony export handleSaveDesign */
/* unused harmony export watchDesignActions */
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeDesignActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("./node_modules/lodash/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set__ = __webpack_require__("./node_modules/lodash/set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reduce__ = __webpack_require__("./node_modules/lodash/reduce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__("./node_modules/debug/src/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga__ = __webpack_require__("./node_modules/redux-saga/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__ = __webpack_require__("./node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api__ = __webpack_require__("./src/services/api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_design__ = __webpack_require__("./src/actions/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_design__ = __webpack_require__("./src/selectors/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_global__ = __webpack_require__("./src/selectors/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_errors__ = __webpack_require__("./src/actions/errors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__routines_global__ = __webpack_require__("./src/routines/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routines_design__ = __webpack_require__("./src/routines/design.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__("./src/utils/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_createValidator__ = __webpack_require__("./src/utils/createValidator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_validators__ = __webpack_require__("./src/utils/validators.js");
/**
 *  weak
 * @format
 *//* eslint-disable flowtype/no-types-missing-file-annotation *//* global __DEV__ */var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(errorHelper),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchDesignData),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(evaluateReport),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(evaluateData),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchStepProgression),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleValidate),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleDownloadPdf),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(downloadSchematic),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(downloadBOMCVS),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleSavePdf),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleOpenDesign),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleSaveDesign),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(helperCallApi),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchDesignActions),_marked17=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(initializeDesignActions);const _uid2=__WEBPACK_IMPORTED_MODULE_5_debug___default()('app:sagas/design');// import Rollbar from '~/utils/rollbar';
var TIMEOUT=Number("25000");var MAX_DECIMAL_PLACES=Number("6");var EVALUATE_DELAY=Number("500");var evaluateActionType={CHANGE:'DATA_CHANGE',REFRESH:'REFRESH',SAVE:'AUTO_COMPLETE'};// hack :(
// TODO: Move to app-data.json
var integerFields=['Num_Cpll','Num_pll_fet'];var buildPayload=function buildPayload(actionType){var state=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:evaluateActionType.CHANGE;// Handle any step resets
// if (actionType === constants.STEP_RESET) {
//   console.log('test');
// //   // These fields need to be omited so they reset properly.
// //   const omitFields = ['DCRcust', 'Lcust', 'Irms_cust'];
// //   const newState = _.omit(state, omitFields);
//   return {
//     actionEvent: {
//       type: evaluateActionType.REFRESH,
//     },
//     data: buildData(newState, _.get(action, ['payload', 'field'])),
//   };
// }
// const value: number = _.get(action, ['payload', 'value']);
// let field: string = _.get(action, ['payload', 'field']);
// Fix some wonky API issues - pretty hacky.
// if (field === 'K_DeltaI') field = 'K_DeltaI_Entry';
var data=__WEBPACK_IMPORTED_MODULE_4_lodash_reduce___default()(state,function(obj,val,key){var value=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(state[key],'currentValue');return __WEBPACK_IMPORTED_MODULE_2_lodash_set___default()(obj,key,Object(__WEBPACK_IMPORTED_MODULE_15__utils__["l" /* isNumeric */])(value)?Number(value):value);},{});var strType=actionType===__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].STEP_RESET?evaluateActionType.REFRESH:type;return{actionEvent:{type:strType},data:data};};function errorHelper(err,message){var statusCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function errorHelper$(_context){while(1){switch(_context.prev=_context.next){case 0:statusCode=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(err,['response','status'],'-1');if(!(statusCode===401)){_context.next=8;break;}_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"],Number("2500")||10000);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["loginRedirect"]);case 6:_context.next=10;break;case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_12__actions_errors__["a" /* actions */].apiError({status:statusCode.toString(),message:message}));case 10:case'end':return _context.stop();}}},_marked,this);}function getUrlParam(key){var matches=window.location.href.match(new RegExp('[?&]'+key+'=([^&#]+)\\b'));return matches&&matches.length>0?matches[1]:null;}function fetchDesignData(){var _ref,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchDesignData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].scrollToTop());case 3:_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].pendingAction());case 5:_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["fetchDefaultData"]);case 7:_ref=_context2.sent;response=_ref.response;error=_ref.error;if(error){_context2.next=13;break;}_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].receiveData(response));case 13:_context2.next=19;break;case 15:_context2.prev=15;_context2.t0=_context2['catch'](0);_context2.next=19;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(errorHelper,_context2.t0,'API Error: Fetch design failed.');case 19:case'end':return _context2.stop();}}},_marked2,this,[[0,15]]);}function evaluateReport(){var state,payload,result,_get2,response,statusCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function evaluateReport$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["f" /* getFieldValues */]);case 2:state=_context3.sent;payload=buildPayload(null,state);_context3.prev=4;_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["race"])({evaluate:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["evaluateData"],payload),timeout:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"],TIMEOUT)});case 7:result=_context3.sent;if(!__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(result,'timeout')){_context3.next=13;break;}_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].evaluateError({field:'all',status:'-1',message:'Evaluation took longer than expected (<'+TIMEOUT/1000+'s).'}));case 11:_context3.next=16;break;case 13:_get2=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(result,'evaluate',{}),response=_get2.response;_context3.next=16;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].receiveData(response));case 16:_context3.next=28;break;case 18:_context3.prev=18;_context3.t0=_context3['catch'](4);statusCode=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context3.t0,['response','status']);if(!(statusCode===401)){_context3.next=26;break;}_context3.next=24;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["loginRedirect"]);case 24:_context3.next=28;break;case 26:_context3.next=28;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].evaluateError({field:'all',status:__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context3.t0,['response','status'],'-1'),message:__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context3.t0,['message'],'Unknown error')}));case 28:case'end':return _context3.stop();}}},_marked3,this,[[4,18]]);}function evaluateData(action){var payloadData,payload,field,result,_get3,response,fixedResponse,statusCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function evaluateData$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"],EVALUATE_DELAY);case 2:_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["k" /* getValuesForEval */]);case 4:payloadData=_context4.sent;payload=buildPayload(action.type,payloadData,evaluateActionType.CHANGE);field=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action,['payload','field']);_context4.prev=7;_context4.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["race"])({evaluate:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["evaluateData"],payload),timeout:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"],TIMEOUT)});case 10:result=_context4.sent;if(!__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(result,'timeout')){_context4.next=16;break;}_context4.next=14;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].evaluateError({field:field,status:'-1',message:'Evaluation took longer than expected (<'+TIMEOUT/1000+'s).'}));case 14:_context4.next=20;break;case 16:_get3=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(result,'evaluate',{}),response=_get3.response;// fix message.type
fixedResponse=__WEBPACK_IMPORTED_MODULE_2_lodash_set___default()(response,['message','type'],'SUCCESS');_context4.next=20;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].receiveData(fixedResponse));case 20:_context4.next=32;break;case 22:_context4.prev=22;_context4.t0=_context4['catch'](7);statusCode=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context4.t0,['response','status']);if(!(statusCode===401)){_context4.next=30;break;}_context4.next=28;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["loginRedirect"]);case 28:_context4.next=32;break;case 30:_context4.next=32;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].evaluateError({field:field,status:__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context4.t0,['response','status'],'-1'),message:__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context4.t0,['message'],'Unknown error')}));case 32:case'end':return _context4.stop();}}},_marked4,this,[[7,22]]);}function watchStepProgression(){var currentStep,chartData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchStepProgression$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["take"])([__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].jumpToStep.toString(),__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].STEP_FORWARD,__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].AUTO_COMPLETE]);case 2:if(!_context5.sent){_context5.next=22;break;}_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["b" /* getCurrentStep */]);case 5:currentStep=_context5.sent;_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].scrollToTop());case 8:if(!(currentStep==='STEP_ANALYSIS')){_context5.next=17;break;}_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_11__selectors_global__["a" /* getChartData */]);case 11:chartData=_context5.sent;if(__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(chartData,['hasData'])){_context5.next=15;break;}_context5.next=15;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].fetchChartData());case 15:_context5.next=20;break;case 17:if(!(currentStep==='SCHEMATIC')){_context5.next=20;break;}_context5.next=20;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].fetchSchematic());case 20:_context5.next=0;break;case 22:case'end':return _context5.stop();}}},_marked5,this);}function handleValidate(action){var field,value,isSelection,revert,validateChecker,validator,fixedValue,decimalCount,valid,message;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleValidate$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:field=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action,['payload','field']);value=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action,['payload','value'],null);isSelection=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action,['payload','isSelection'],false);// const revert = _.get(action, ['payload', 'revert'], false);
revert=action.type===__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].REVERT_FIELD;_context6.prev=4;if(!(isSelection||revert)){_context6.next=12;break;}_context6.next=8;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].evaluateData({field:field,value:value}));case 8:_context6.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(evaluateData,action);case 10:_context6.next=39;break;case 12:_context6.next=14;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"],500);case 14:validateChecker=integerFields.includes(field)?__WEBPACK_IMPORTED_MODULE_17__utils_validators__["a" /* isInteger */]:__WEBPACK_IMPORTED_MODULE_17__utils_validators__["b" /* isNumber */];// $FlowIgnore
_context6.next=17;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_16__utils_createValidator__["a" /* default */],validateChecker);case 17:validator=_context6.sent;fixedValue=value;if(__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(value)&&value[0]==='.'){fixedValue='0'+value;}// TODO: proper validator framekwork
decimalCount=Object(__WEBPACK_IMPORTED_MODULE_15__utils__["d" /* countDecimals */])(fixedValue);if(!(decimalCount>MAX_DECIMAL_PLACES)){_context6.next=26;break;}_context6.next=24;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].validationError({field:field,message:'Must be less than '+(MAX_DECIMAL_PLACES+1)+' decimal places.'}));case 24:_context6.next=39;break;case 26:_context6.next=28;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(validator.test,fixedValue);case 28:valid=_context6.sent;message=validator.report(value);if(!valid){_context6.next=37;break;}_context6.next=33;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].evaluateData({field:field,value:fixedValue}));case 33:_context6.next=35;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["spawn"])(__WEBPACK_IMPORTED_MODULE_15__utils__["b" /* asyncCancelOnTake */],evaluateData,[action],__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].VALIDATION_ERROR);case 35:_context6.next=39;break;case 37:_context6.next=39;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].validationError({field:field,message:message}));case 39:_context6.next=44;break;case 41:_context6.prev=41;_context6.t0=_context6['catch'](4);// if (Rollbar) {
//   Rollbar.critical('Unexpected Validation Error', { field, value });
// }
_uid2(_context6.t0);// eslint-disable-line no-console
case 44:case'end':return _context6.stop();}}},_marked6,this,[[4,41]]);}function handleDownloadPdf(){var payloadData,payload,designName,result,fileName,statusCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleDownloadPdf$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["k" /* getValuesForEval */]);case 3:payloadData=_context7.sent;payload=buildPayload(null,payloadData);_context7.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_11__selectors_global__["c" /* getDesignName */]);case 7:designName=_context7.sent;// Include a saved design name for the generated PDF
if(designName!=='Untitled Design'){payload.data.design_name={currentValue:designName};}_context7.next=11;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["downloadReportPDF"],payload);case 11:result=_context7.sent;fileName=Object(__WEBPACK_IMPORTED_MODULE_15__utils__["m" /* makeFileName */])("Boost Powertrain"+'_'+designName,'pdf');// const fileName = `${_.snakeCase(`${process.env.REACT_APP_TOOL_NAME}_${designName}`)}.pdf`;
_context7.next=15;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].receivePDF(result,fileName));case 15:_context7.next=27;break;case 17:_context7.prev=17;_context7.t0=_context7['catch'](0);statusCode=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context7.t0,['response','status']);if(!(statusCode===401)){_context7.next=25;break;}_context7.next=23;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["loginRedirect"]);case 23:_context7.next=27;break;case 25:_context7.next=27;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].apiError({status:'-1',message:'Fetch PDF Error',err:_context7.t0}));case 27:case'end':return _context7.stop();}}},_marked7,this,[[0,17]]);}function downloadSchematic(){var _ref2,data,designName,fileName;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function downloadSchematic$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["i" /* getSchematic */]);case 3:_ref2=_context8.sent;data=_ref2.data;_context8.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_11__selectors_global__["c" /* getDesignName */]);case 7:designName=_context8.sent;fileName=Object(__WEBPACK_IMPORTED_MODULE_15__utils__["m" /* makeFileName */])("Boost Powertrain"+'_'+designName);Object(__WEBPACK_IMPORTED_MODULE_15__utils__["i" /* downloadSVGImage */])(data,fileName);_context8.next=16;break;case 12:_context8.prev=12;_context8.t0=_context8['catch'](0);_context8.next=16;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].apiError({status:'-1',message:'Schematic Download Error',err:_context8.t0}));case 16:case'end':return _context8.stop();}}},_marked8,this,[[0,12]]);}function downloadBOMCVS(){var bomData,designName,filename;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function downloadBOMCVS$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(function(state){return state.global.BOMTable;});case 3:bomData=_context9.sent;_context9.next=6;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_11__selectors_global__["c" /* getDesignName */]);case 6:designName=_context9.sent;filename=Object(__WEBPACK_IMPORTED_MODULE_15__utils__["m" /* makeFileName */])("Boost Powertrain"+'_'+designName,'xlsx');// $FlowIgnore
__webpack_require__.e/* import() */("xlsx-populate-no-encryption").then(__webpack_require__.bind(null, "./node_modules/xlsx-populate/browser/xlsx-populate-no-encryption.js")).then(function(xlsx){var workbook=xlsx.fromBlankAsync().then(function(wb){var sheet=wb.sheet(0);// Set the table data
sheet.cell('A1').value(bomData);// http://polymathprogrammer.com/2010/01/18/calculating-column-widths-in-excel-open-xml/
// eslint-disable-next-line prettier/prettier
var getCellWidth=function getCellWidth(n){return Math.trunc((n*13+20)/13*256)/256;};// Set the column widths
var len=bomData.length;var width=5;// this should be taken from bomData[0]
// Loop over each column and find the longest length string
var _loop=function _loop(i){var col=String.fromCharCode(i+65);// Get the range for this column and use the parse callback to format the sheet
var maxLen=0;// eslint-disable-next-line no-unused-vars
sheet.range(col+'1:'+col+len).value(function(cell,ri,ci){var val=cell.value();if(!val)return val;if(String(val).length>maxLen){maxLen=val.length;}// Skip over the header cell for this row
if(ri===0)return val;if(col==='B'){return Number(val);}// Check the partnumber and manufacturer columns and set hyperlinks
if(col==='C'){var nextVal=cell.relativeCell(0,1).value();if(nextVal&&nextVal.startsWith('ON')){// Set ON Semi link here
cell.relativeCell(0,1)// .value(nextVal)
.style({fontColor:'0563c1',underline:true}).hyperlink(''+"https://onsemi.com");// Set part number hyperlink
cell.style({fontColor:'0563c1',underline:true}).hyperlink(''+"https://onsemi.com"+"/PowerSolutions/product.do?id="+val);}}return val;});sheet.column(col).width(getCellWidth(maxLen));};for(var i=0;i<width;i+=1){_loop(i);}// Set bold style on the first column and first row
sheet.column('A').style('bold',true);sheet.row(1).style('bold',true);return wb.outputAsync({type:undefined});});workbook.then(function(blob){return Object(__WEBPACK_IMPORTED_MODULE_15__utils__["h" /* downloadBlob */])(blob,filename);});});_context9.next=15;break;case 11:_context9.prev=11;_context9.t0=_context9['catch'](0);_context9.next=15;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].apiError({status:'-1',message:'XLSX Generation Error',err:_context9.t0}));case 15:case'end':return _context9.stop();}}},_marked9,this,[[0,11]]);}function handleSavePdf(action){var file;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleSavePdf$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;file=new Blob([action.payload.response],{type:'application/octet-stream'});_context10.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_15__utils__["h" /* downloadBlob */],file,action.filename);case 4:_context10.next=9;break;case 6:_context10.prev=6;_context10.t0=_context10['catch'](0);_uid2(_context10.t0);case 9:case'end':return _context10.stop();}}},_marked10,this,[[0,6]]);}function handleOpenDesign(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleOpenDesign$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.prev=0;_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].scrollToTop());case 3:_context11.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].receiveDesigns());case 5:_context11.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */].fetchAllRecords());case 7:_context11.next=13;break;case 9:_context11.prev=9;_context11.t0=_context11['catch'](0);_context11.next=13;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(errorHelper,_context11.t0,'Fetch All Designs Error');case 13:case'end':return _context11.stop();}}},_marked11,this,[[0,9]]);}// export function* handleFetchDesign(action: any): Generator<*, *, *> {
//   try {
//     const result = yield call(API.fetchRecord, action.payload);
//     const payload = _.get(result, ['response'], {});
//     // yield put(actions.receiveData(payload));
//     // yield put(notify.openSuccess());
//   } catch (err) {
//     const statusCode: number = _.get(err, ['response', 'status']);
//     if (statusCode === 401) {
//       yield call(API.loginRedirect);
//     } else {
//       yield put(
//         actions.apiError({
//           status: '-1',
//           message: 'Fetch All Designs Error',
//         }),
//       );
//     }
//   }
// }
function handleSaveDesign(action){var recordName,state,plData,payload,result,statusCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleSaveDesign$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:recordName=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action,'payload','');_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["f" /* getFieldValues */]);case 3:state=_context12.sent;plData=buildPayload('save',state);payload={actionEvent:{recordName:recordName,type:plData.actionEvent.type},data:plData.data};_context12.prev=6;_context12.next=9;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["race"])({evaluate:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["saveDesignRecord"],payload),timeout:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"],TIMEOUT)});case 9:result=_context12.sent;if(!__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(result,'timeout')){_context12.next=13;break;}_context12.next=13;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].apiError({status:'-1',message:'Save Design took longer than expected (<'+TIMEOUT/1000+'s).'}));case 13:_context12.next=25;break;case 15:_context12.prev=15;_context12.t0=_context12['catch'](6);statusCode=__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_context12.t0,['response','status']);if(!(statusCode===401)){_context12.next=23;break;}_context12.next=21;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8__services_api__["loginRedirect"]);case 21:_context12.next=25;break;case 23:_context12.next=25;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].apiError({status:'-1',message:'Save Design Error'}));case 25:case'end':return _context12.stop();}}},_marked12,this,[[6,15]]);}/**
 * Generic helper for making API calls and building a payload from the design state.
 *
 * @private
 * @param {Function} apiFn Service API function
 * @param {Routine} routineFn Saga Routine function
 * @param {string} action Action type
 * @param {(string[] | (() => boolean))} [cb=[]] Cancel Callback
 * @returns Iterator
 */function helperCallApi(apiFn){var routineFn=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var cb=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var _marked13,result,fetchData,cancelFn,finalPayload,actionType,payloadData,_payloadData,a;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function helperCallApi$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:fetchData=function fetchData(data){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchData$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(routineFn.request());case 2:_context13.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(apiFn,data);case 4:res=_context13.sent;console.log(res);/**
     * Non connection related API specfic errors have a type = 'ERROR'
     * and need to be handled here as they are not necessarily caught
     * in the try/catch of `helperCallApi`.
     */if(!(res&&res.response&&res.response.type==='ERROR')){_context13.next=10;break;}_context13.next=9;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(routineFn.failure(res.response.content));case 9:return _context13.abrupt('return');case 10:_context13.next=12;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(routineFn.success(res));case 12:case'end':return _context13.stop();}}},_marked13,this);};_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchData);result={};_context14.prev=3;cancelFn=void 0;finalPayload={};// TODO: shouldn't be modifying the payload here
actionType=action&&action.type;_context14.t0=actionType;_context14.next=_context14.t0===__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */].saveDesignRecord.TRIGGER?10:_context14.t0===__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */].updateRecordName.TRIGGER?16:_context14.t0===__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */].copyDesign.TRIGGER?16:_context14.t0===__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */].deleteDesign.TRIGGER?16:_context14.t0==='FETCH_DESIGN/TRIGGER'?16:18;break;case 10:_context14.next=12;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["f" /* getFieldValues */]);case 12:payloadData=_context14.sent;finalPayload=buildPayload('save',payloadData);finalPayload.actionEvent.recordName=action.payload;return _context14.abrupt('break',24);case 16:finalPayload=action.payload;return _context14.abrupt('break',24);case 18:_context14.next=20;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["select"])(__WEBPACK_IMPORTED_MODULE_10__selectors_design__["k" /* getValuesForEval */]);case 20:_payloadData=_context14.sent;finalPayload=buildPayload(null,_payloadData);if(actionType===__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */].updateDesign.TRIGGER){finalPayload.id=action.payload.id;}return _context14.abrupt('break',24);case 24:if(typeof cb==='function'){cancelFn=cb;}else{a=[].concat([__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */].jumpToStep.toString(),__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].STEP_FORWARD,__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].STEP_BACKWARD],cb);cancelFn=function cancelFn(cancelAction){return a.includes(cancelAction.type);};}_context14.next=27;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["race"])({task:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(fetchData,finalPayload),cancel:Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["take"])(cancelFn)});case 27:result=_context14.sent;_context14.next=36;break;case 30:_context14.prev=30;_context14.t1=_context14['catch'](3);_context14.next=34;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(routineFn.failure(_context14.t1.message));case 34:_context14.next=36;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(errorHelper,_context14.t1,'API call for '+routineFn+' was not completed.');case 36:_context14.prev=36;console.log(result);_context14.next=40;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(routineFn.fulfill({cancelled:result.cancel!==undefined}));case 40:return _context14.finish(36);case 41:case'end':return _context14.stop();}}},_marked14,this,[[3,30,36,41]]);}function helperAPICallRouter(type){var _marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handler);var routine=__WEBPACK_IMPORTED_MODULE_13__routines_global__["a" /* default */][type]||__WEBPACK_IMPORTED_MODULE_14__routines_design__["a" /* default */][type];var fn=__WEBPACK_IMPORTED_MODULE_8__services_api__[type];if(false){/* eslint-disable no-console */if(!type||!routine){console.warn('Invalid or missing Routine for \''+type+'\' (check \'routines/**\')');}if(typeof fn!=='function'){console.warn('API function for \''+type+'\' missing (check \'services/api.js\')');}/* eslint-enable no-console */}// Not sure why I can't return the helper from here.. but we need an intemediary function and I don't
// have time to figure out why.
function handler(action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handler$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_uid2(routine+' calling '+fn);_context15.next=3;return helperCallApi(fn,routine,action);case 3:case'end':return _context15.stop();}}},_marked15,this);}return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(routine.toString(),handler);}function watchDesignActions(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchDesignActions$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["all"])([Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].NEW_DESIGN,fetchDesignData),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])([__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].CHANGE_VALUE,__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].REVERT_FIELD],handleValidate),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].STEP_RESET,evaluateData),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].REQUEST_PDF,handleDownloadPdf),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].EXPORT_BOM_EXCEL,downloadBOMCVS),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].DOWNLOAD_SCHEMATIC,downloadSchematic),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].RECEIVE_PDF,handleSavePdf),// takeLatest(constants.SAVE_DESIGN, handleSaveDesign),
Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["takeLatest"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["b" /* constants */].OPEN_DESIGN,handleOpenDesign),// takeLatest(constants.FETCH_DESIGN, handleFetchDesign),
// takeLatest(constants.REQUEST_USER, fetchUserData),
// takeLatest(constants.REQUEST_PARTS, fetchPartsData),
helperAPICallRouter('fetchChartData'),helperAPICallRouter('fetchSchematic'),helperAPICallRouter('fetchAllRecords'),helperAPICallRouter('fetchRecord'),// TODO: fix payload being passed to the save design handler :/
helperAPICallRouter('saveDesignRecord'),helperAPICallRouter('updateRecordName'),helperAPICallRouter('copyDesign'),helperAPICallRouter('deleteDesign'),helperAPICallRouter('updateDesign')]);case 2:case'end':return _context16.stop();}}},_marked16,this);}function initializeDesignActions(){var initialActions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function initializeDesignActions$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:return _context17.delegateYield(watchDesignActions(),'t0',1);case 1:_context17.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["fork"])(watchStepProgression);case 3:// Add sagas or actions that need to be execuated after  inital setup here
initialActions=Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["all"])([Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(__WEBPACK_IMPORTED_MODULE_9__actions_design__["a" /* actions */].newDesign(true))]// silent = true so the inital load doesn't hit GA
);// Support redux-devtool's presist feature - only fire initial
// actions if off, or in production.
if(false){_context17.next=9;break;}_context17.next=7;return initialActions;case 7:_context17.next=12;break;case 9:if(getUrlParam('debug_session')){_context17.next=12;break;}_context17.next=12;return initialActions;case 12:case'end':return _context17.stop();}}},_marked17,this);}

/***/ }),

/***/ "./src/sagas/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rootSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__("./src/sagas/analytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__design__ = __webpack_require__("./src/sagas/design.js");
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(rootSaga);/**
 * 
 * @format
 *//* global __DEV__ */// import { sagas } from '../modules';
function rootSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function rootSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(!false&&"UA-53160035-1".indexOf('UA-')!==-1)){_context.next=2;break;}return _context.delegateYield(Object(__WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* default */])(),'t0',2);case 2:return _context.delegateYield(Object(__WEBPACK_IMPORTED_MODULE_2__design__["a" /* default */])(),'t1',3);case 3:case'end':return _context.stop();}}},_marked,this);}

/***/ }),

/***/ "./src/selectors/design.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSchematic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getReportPDF; });
/* harmony export (immutable) */ __webpack_exports__["m"] = nextStep;
/* harmony export (immutable) */ __webpack_exports__["n"] = prevStep;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentStep; });
/* unused harmony export getNextStep */
/* unused harmony export getPrevStep */
/* unused harmony export getAllData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFieldValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChangedFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFieldErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFieldWarnings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDirtyFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getEvaluatingFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getValuesForEval; });
/* unused harmony export getName */
/* unused harmony export getStepStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSnubberStatus; });
/* unused harmony export getResetStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__("./node_modules/lodash/isEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick__ = __webpack_require__("./node_modules/lodash/pick.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__("./node_modules/reselect/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__ = __webpack_require__("./src/utils/stepHelpers.js");
/**
 * 
 * @format
 */var isLoading=function isLoading(state){return state.design.loading;};var designData=function designData(state){return state.design;};var currentStep=function currentStep(state){return state.design.currentStep;};var stepStatus=function stepStatus(state){return state.design.stepStatus;};var initialValues=function initialValues(state){return state.design.initialValues;};var allValues=function allValues(state){return state.design.values;};var getSchematic=function getSchematic(state){return state.design.schematic;};var getReportPDF=function getReportPDF(state){return state.design.report;};function nextStep(step){var index=__WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(i){return i===step;});if(index===__WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */].length-1)return __WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */][index];return __WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */][(index+1)%__WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */].length];}function prevStep(step){var index=__WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(i){return i===step;});if(index===0)return __WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */][index];// index = index === 0 ? StepOrder.length : index;
return __WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */][(index-1)%__WEBPACK_IMPORTED_MODULE_4__utils_stepHelpers__["a" /* StepOrder */].length];}var getCurrentStep=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([currentStep],function(step){return step;});var getNextStep=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([currentStep],function(step){return nextStep(step);});var getPrevStep=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([currentStep],function(step){return prevStep(step);});var getAllData=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([designData,isLoading],function(data){return data;});var getFieldValues=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getAllData],function(data){return data.values;});var getChangedFields=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getAllData],function(data){return data.changedFields;});var getFieldErrors=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getAllData],function(data){return data.errors;});var getFieldWarnings=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getAllData],function(data){return data.info;});var getDirtyFields=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getAllData],function(data){return data.dirtyFields;});var getEvaluatingFields=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getAllData],function(data){return data.evaluating;});var getValuesForEval=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getFieldValues,getChangedFields],function(values,changedValues){return __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(values,Object.keys(changedValues));});var getName=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([designData],function(data){return data.name;});var getStepStatus=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([stepStatus],function(data){return data;});var getSnubberStatus=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([allValues],function(values){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(values,['Snub_sel','currentValue']);});var getResetStatus=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getCurrentStep,allValues,initialValues,isLoading],function(step,vals,initialVals){return!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(vals,initialVals);});

/***/ }),

/***/ "./src/selectors/errors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("./node_modules/reselect/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/**
 * 
 * @format
 */var errors=function errors(state){return state.errors;};var getErrors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([errors],function(e){return e;});var hasError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getErrors],function(e){return e.length>0;});

/***/ }),

/***/ "./src/selectors/global.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRecordsMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentRecordId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDesignName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("./node_modules/reselect/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/**
 * 
 * @format
 */var getState=function getState(state){return state.global;};var getRecordsMap=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getState],function(state){return state.records.data;});var getCurrentRecordId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getState],function(state){return state.records.current;});var getChartData=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getState],function(state){return state.chartData;});var getDesignName=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getRecordsMap,getCurrentRecordId],function(recordMap,currentId){var record=recordMap.get(currentId);var name='';if(record){name=record.rev>1?record.name+' (rev. '+record.rev+')':record.name;}return record?name:"Untitled Design";});/* unused harmony default export */ var _unused_webpack_default_export = ({getChartData:getChartData});

/***/ }),

/***/ "./src/selectors/progress.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDesignLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getStepList; });
/* unused harmony export getStepGroupData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCompleteCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getNextEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBackEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAutocompleteEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getResetEnabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__("./node_modules/lodash/isEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first__ = __webpack_require__("./node_modules/lodash/first.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_last__ = __webpack_require__("./node_modules/lodash/last.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__("./node_modules/lodash/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pickBy__ = __webpack_require__("./node_modules/lodash/pickBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__("./node_modules/lodash/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reselect__ = __webpack_require__("./node_modules/reselect/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_constants__ = __webpack_require__("./src/utils/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__ = __webpack_require__("./src/utils/stepHelpers.js");
/**
 * 
 * @format
 */// $FlowIgnore
var getState=function getState(state){return state.progress;};var getDesignState=function getDesignState(state){return state.design;};var getDesignLoading=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getDesignState],function(state){return state.loading;});var getStatus=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getState],function(state){return state.status;});var getStepList=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([function(){return __WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */];}],function(s){return s;});// export const getStatus = createSelector(
//   [getState],
//   (state): ProgressStatusType => state.status,
// );
// export const getStepDataByKey = createSelector(
//   getStatus,
//   stepStats => _.memoize(
//     (key) => getStepDataByKeyByKey(key),
//   ),
// );
var getStepGroupData=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getStatus],function(stepStatus){return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(stepStatus,function(status,key){return Object.assign({status:status},Object(__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["e" /* getStepDataByKey */])(key));});});var getActive=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getState],function(state){return state.active;});var getErrors=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getStatus],// stepList => _.pickBy(stepList, status => status === StepState.ERROR, {}),
function(stepList){return __WEBPACK_IMPORTED_MODULE_4_lodash_pickBy___default()(stepList,function(status){return status===__WEBPACK_IMPORTED_MODULE_7__utils_constants__["a" /* StepState */].ERROR;});});var getCompleteCount=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getStatus],function(status){return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(status,function(s){return s===__WEBPACK_IMPORTED_MODULE_7__utils_constants__["a" /* StepState */].COMPLETE;}).length;});var getNextEnabled=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getActive,getErrors],function(active,status){return active!==__WEBPACK_IMPORTED_MODULE_2_lodash_last___default()(__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */])&&status[active]!==__WEBPACK_IMPORTED_MODULE_7__utils_constants__["a" /* StepState */].ERROR;});var getBackEnabled=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getActive],function(active){return active!==__WEBPACK_IMPORTED_MODULE_1_lodash_first___default()(__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */]);});var getAutocompleteEnabled=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getActive,getErrors,getDesignLoading],function(active,errors,loading){if(loading)return false;var index=__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(i){return i===active;});return __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(errors)&&index<__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(i){return i===__WEBPACK_IMPORTED_MODULE_7__utils_constants__["b" /* Steps */].STEP_ANALYSIS;});});var getResetEnabled=Object(__WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"])([getActive,getDesignLoading],function(active,loading){if(loading)return false;var index=__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(i){return i===active;});return index<__WEBPACK_IMPORTED_MODULE_8__utils_stepHelpers__["a" /* StepOrder */].findIndex(function(i){return i===__WEBPACK_IMPORTED_MODULE_7__utils_constants__["b" /* Steps */].STEP_ANALYSIS;});// Steps.STEP_ANALYSIS
});/* unused harmony default export */ var _unused_webpack_default_export = ({getStatus:getStatus,getActive:getActive,getErrors:getErrors,getCompleteCount:getCompleteCount,getNextEnabled:getNextEnabled,getBackEnabled:getBackEnabled,getAutocompleteEnabled:getAutocompleteEnabled,getResetEnabled:getResetEnabled});

/***/ }),

/***/ "./src/services/api.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["APIResponseError"] = APIResponseError;
/* harmony export (immutable) */ __webpack_exports__["checkStatus"] = checkStatus;
/* harmony export (immutable) */ __webpack_exports__["fetchGet"] = fetchGet;
/* harmony export (immutable) */ __webpack_exports__["fetchPost"] = fetchPost;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchByMethod", function() { return fetchByMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentUser", function() { return fetchCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDefaultData", function() { return fetchDefaultData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllRecords", function() { return fetchAllRecords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRecord", function() { return fetchRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveDesignRecord", function() { return saveDesignRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateRecordName", function() { return updateRecordName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyDesign", function() { return copyDesign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateDesign", function() { return updateDesign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteDesign", function() { return deleteDesign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchChartData", function() { return fetchChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "evaluateData", function() { return evaluateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSchematic", function() { return fetchSchematic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadReportPDF", function() { return downloadReportPDF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginRedirect", function() { return loginRedirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("./src/utils/index.js");
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * 
 * @format
 */function APIResponseError(){var message=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';this.name='APIResponseError';this.message=message;this.stack=new Error().stack;this.response={};}APIResponseError.prototype=Object.create(Error.prototype);APIResponseError.prototype.constructor=APIResponseError;function checkStatus(response){console.log('checkStatus',response);if(response.status>=200&&response.status<=400)return response;// All errors >400 throw errors
var error=new APIResponseError(response.statusText);error.response=response;throw error;}var parseJSON=function parseJSON(res){return res.json();};var parseBlob=function parseBlob(res){return res.blob();};var parseText=function parseText(res){return res.text();};var endPoints={currentUser:'/user/retrieveCurrentUser',newDesign:'/new',evaluate:'/evaluate',typelist:'/typeinfolist',records:'/records',singleRecord:'/retrieveRecordById',saveRecord:'/save',updateRecord:'/updateRecordById/',chartData:'/chartData',downloadPDF:'/design/boost-api/v1/report/downloadPDF',downloadSVG:'/design/boost-api/v1/schematic/svg'};var getFullPath=function getFullPath(path){return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* pathJoin */])(["/","/design/boost-api/v1/ws/",path],'/');};function fetchGet(path){var fullUrl=getFullPath(path);return fetch(fullUrl,{method:'GET',credentials:'include',headers:{Accept:'application/json','Content-Type':'application/json'}}).then(checkStatus).then(function(response){return response.json();}).then(function(response){return{response:response};});}/**
 * Fetch helper function
 * fetch is a chain of promises
 * @param {string} path URL to fetch
 * @param {any} data payload
 * @param {promise} parseHandler promise to handle reponse
 */function fetchPost(path){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var parseHandler=arguments.length>2&&arguments[2]!==undefined?arguments[2]:parseJSON;var fullUrl=path.includes('design/')?path:getFullPath(path);return fetch(fullUrl,{method:'POST',credentials:'include',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(data)}).then(checkStatus).then(parseHandler).then(function(response){return{response:response};});}var fetchByMethod=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(path,method){var payload=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var fullUrl,rawResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:fullUrl=path.includes('design/')?path:getFullPath(path);// the fetchPost function does not work with this new post API... wtf
_context.next=3;return fetch(fullUrl,{method:method,credentials:'include',headers:{Accept:'application/json','Content-Type':'application/json'},body:payload});case 3:rawResponse=_context.sent;return _context.abrupt('return',rawResponse.json().then(function(response){return{response:response};}));case 5:case'end':return _context.stop();}}},_callee,this);}));return function fetchByMethod(_x5,_x6){return _ref.apply(this,arguments);};}();// export const fetchParts: Function = () => fetchGet(`${API_ROOT}/product/all`);
var fetchCurrentUser=function fetchCurrentUser(){return fetchGet(endPoints.currentUser);};var fetchDefaultData=function fetchDefaultData(){return fetchGet(endPoints.newDesign);};var fetchAllRecords=function fetchAllRecords(){return fetchGet(endPoints.records);};var fetchRecord=function fetchRecord(id){return fetchGet(endPoints.singleRecord+'/'+id);};var saveDesignRecord=function saveDesignRecord(data){return fetchPost(endPoints.saveRecord,data);};var updateRecordName=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payload){var path;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* pathJoin */])([endPoints.updateRecord,payload.id,payload.name],'/');return _context2.abrupt('return',fetchByMethod(path,'POST'));case 2:case'end':return _context2.stop();}}},_callee2,_this);}));return function updateRecordName(_x7){return _ref2.apply(this,arguments);};}();var copyDesign=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload){var path;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* pathJoin */])([endPoints.records,payload.id,'copy'],'/');return _context3.abrupt('return',fetchByMethod(path,'POST',JSON.stringify({name:payload.name})));case 2:case'end':return _context3.stop();}}},_callee3,_this);}));return function copyDesign(_x8){return _ref3.apply(this,arguments);};}();var updateDesign=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(payload){var path;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* pathJoin */])([endPoints.records,payload.id],'/');console.log('calling PUT',path,'with',payload.data);return _context4.abrupt('return',fetchByMethod(path,'PUT',JSON.stringify(payload.data)));case 3:case'end':return _context4.stop();}}},_callee4,_this);}));return function updateDesign(_x9){return _ref4.apply(this,arguments);};}();var deleteDesign=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id){var path;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* pathJoin */])([endPoints.records,id],'/');return _context5.abrupt('return',fetchByMethod(path,'DELETE'));case 2:case'end':return _context5.stop();}}},_callee5,_this);}));return function deleteDesign(_x10){return _ref5.apply(this,arguments);};}();var fetchChartData=function fetchChartData(data){return fetchPost(endPoints.chartData,data);};var evaluateData=function evaluateData(data){return fetchPost(endPoints.evaluate,data);};var fetchSchematic=function fetchSchematic(data){return fetchPost(endPoints.downloadSVG,data,parseText);};var downloadReportPDF=function downloadReportPDF(data){return fetchPost(endPoints.downloadPDF,data,parseBlob);};var ref=''+document.location.origin+"/site/design-tools/boost-powertrain";var redirect="/PowerSolutions/myon/login.do"+'?referer='+ref;var loginRedirect=function loginRedirect(){if(false)return false;// Not sure if this is needed now that the delay is controled by the Saga
return setTimeout(function(){window.location.href=redirect;},0);};

/***/ }),

/***/ "./src/utils/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StepState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Steps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaults; });
/**
 * 
 * @format
 */var StepState={NOT_STARTED:'NOT_STARTED',COMPLETE:'COMPLETE',STARTED:'STARTED',ERROR:'ERROR',DISABLED:'DISABLED'};var Steps={STEP_ONE:'STEP_ONE',STEP_TWO:'STEP_TWO',STEP_THREE:'STEP_THREE',STEP_FOUR:'STEP_FOUR',STEP_FIVE:'STEP_FIVE',STEP_ANALYSIS:'STEP_ANALYSIS',SCHEMATIC:'SCHEMATIC',BOM:'BOM',REPORT:'REPORT'};var defaults={DECIMAL_PLACES:5,EXP_THRESHOLD:5};

/***/ }),

/***/ "./src/utils/createValidator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createValidator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_castArray__ = __webpack_require__("./node_modules/lodash/castArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_castArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_castArray__);
/**
 * 
 * @format
 *//*
 * https://github.com/npbee/react-redux-saga-validation-example/blob/master/src/createValidator.js
 */// import rules from './validators';
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialSpec={message:'',params:[],test:function test(){return true;}};function createValidator(){var spec=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialSpec;// If we're given a string like 'minLength:3', we can see if it exists in
// our globally defined rules.
// if (typeof spec === 'string') {
//   const [name, params] = spec.split(':');
//   const rule = rules[name];
//   if (rule) {
//     return createValidator({
//       ...rule,
//       params,
//     },
//     state);
//   }
// }
var _spec$test=spec.test,test=_spec$test===undefined?function(){return true;}:_spec$test,_spec$message=spec.message,message=_spec$message===undefined?'':_spec$message,_spec$params=spec.params,params=_spec$params===undefined?[]:_spec$params;var args=__WEBPACK_IMPORTED_MODULE_0_lodash_castArray___default()(params);return{test:function(_test){function test(_x2){return _test.apply(this,arguments);}test.toString=function(){return _test.toString();};return test;}(function(value){// $FlowIgnore
return test.apply(undefined,[value].concat(_toConsumableArray(args)));}),report:function report(value){if(typeof message==='function')return message.apply(undefined,[value].concat(_toConsumableArray(args)));return message;}};}

/***/ }),

/***/ "./src/utils/hashid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hashids__ = __webpack_require__("./node_modules/hashids/dist/hashids.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hashids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hashids__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * 
 * @format
 *//**
 * A class wrapper around hashids - handles unique-to-project-name id generation.
 * https://github.com/ivanakimov/hashids.js
 *
 * @export
 * @class HashId
 */var baseConfig={name:'"'+"Boost Powertrain"+'"',length:8,startCount:0,chars:'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'};var HashId=function(){function HashId(){var config=arguments.length>0&&arguments[0]!==undefined?arguments[0]:baseConfig;_classCallCheck(this,HashId);this.ids=[];var instanceConfig=Object.assign({},baseConfig,config);if(!HashId.instance){HashId.instance=this;this.hashids=new __WEBPACK_IMPORTED_MODULE_0_hashids___default.a(instanceConfig.name,instanceConfig.length,instanceConfig.chars);this.count=instanceConfig.startCount;this.ids=[];}return HashId.instance;}/**
   * Returns the next id
   *
   * @returns {string}
   * @memberOf HashId
   */_createClass(HashId,[{key:'nextId',value:function nextId(){this.count+=1;var id=this.hashids.encode(this.count);this.ids=[].concat(this.ids,id);return id;}},{key:'encode',value:function encode(input){return this.hashids.encode(input);}}]);return HashId;}();/* harmony default export */ __webpack_exports__["a"] = (HashId);

/***/ }),

/***/ "./src/utils/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["p"] = placeRound;
/* harmony export (immutable) */ __webpack_exports__["n"] = midAngle;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumeric;
/* harmony export (immutable) */ __webpack_exports__["t"] = toPercent;
/* harmony export (immutable) */ __webpack_exports__["e"] = createHTMLMarkup;
/* harmony export (immutable) */ __webpack_exports__["f"] = createSVGMarkup;
/* unused harmony export isBetween */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashId; });
/* harmony export (immutable) */ __webpack_exports__["k"] = isBrowserIE;
/* unused harmony export isBrowserFF */
/* unused harmony export generateCVSBlob */
/* harmony export (immutable) */ __webpack_exports__["h"] = downloadBlob;
/* harmony export (immutable) */ __webpack_exports__["i"] = downloadSVGImage;
/* harmony export (immutable) */ __webpack_exports__["o"] = pathJoin;
/* harmony export (immutable) */ __webpack_exports__["c"] = branch;
/* harmony export (immutable) */ __webpack_exports__["b"] = asyncCancelOnTake;
/* unused harmony export waitFor */
/* harmony export (immutable) */ __webpack_exports__["d"] = countDecimals;
/* harmony export (immutable) */ __webpack_exports__["m"] = makeFileName;
/* unused harmony export noop */
/* unused harmony export uuid */
/* harmony export (immutable) */ __webpack_exports__["q"] = replaceAll;
/* harmony export (immutable) */ __webpack_exports__["u"] = toTitleCase;
/* harmony export (immutable) */ __webpack_exports__["j"] = getPosition;
/* unused harmony export shallowDiffers */
/* harmony export (immutable) */ __webpack_exports__["g"] = deepDiffer;
/* harmony export (immutable) */ __webpack_exports__["s"] = shallowEqual;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__ = __webpack_require__("./node_modules/lodash/fp/curry.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_setWith__ = __webpack_require__("./node_modules/lodash/fp/setWith.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_setWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_setWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_clone__ = __webpack_require__("./node_modules/lodash/fp/clone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hashids__ = __webpack_require__("./node_modules/hashids/dist/hashids.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hashids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hashids__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_snakeCase__ = __webpack_require__("./node_modules/lodash/snakeCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString__ = __webpack_require__("./node_modules/lodash/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html_to_react__ = __webpack_require__("./node_modules/html-to-react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html_to_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html_to_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3__ = __webpack_require__("./node_modules/d3/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__ = __webpack_require__("./node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("./src/utils/constants.js");
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(asyncCancelOnTake),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(waitFor);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * 
 * @format
 *//* global window */// import canvg from 'canvg';
// const remark = require('remark');
// const remarkHtml = require('remark-html');
// const remarkSupSuper = require('remark-sub-super');
var canvg=__webpack_require__("./src/extra/canvg/canvg.js");var htmlToReactParser=new __WEBPACK_IMPORTED_MODULE_8_html_to_react__["Parser"](__WEBPACK_IMPORTED_MODULE_4_react___default.a);// const markDownRenderer = remark().use(remarkHtml).use(remarkSupSuper);
/**
 * Round a number to the given places.
 *
 * @export
 * @param {number | string} value
 * @param {number | string} decimals
 * @returns {number}
 */function placeRound(value){var decimals=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_11__constants__["c" /* defaults */].DECIMAL_PLACES;return+(Math.round(+(value+'e+'+decimals))+'e-'+decimals);}/**
 * Calculate the mid point between two angles
 *
 * @export
 * @param {number} startAngle
 * @param {number} endAngle
 * @returns {number}
 */function midAngle(startAngle,endAngle){return startAngle+(endAngle-startAngle)/2;}/**
 *
 *
 * @export
 * @param {(number | string)} n
 * @returns {boolean}
 */function isNumeric(n){// eslint-disable-next-line no-restricted-globals
return!isNaN(parseFloat(n))&&isFinite(n);}/**
 * Calculates the percent of the whole a part is.
 *
 * @export
 * @param {number} part
 * @param {number} whole
 * @returns {number}
 */function toPercent(part,whole){return part/whole*100;}function createMarkup(string){try{return htmlToReactParser.parse(string);}catch(err){return null;}}/**
 * Create React friendly html element from a string without relying on dangerouslySetInnerHTML
 *
 * @export
 * @param {string} string
 * @returns {React$Node}
 */function createHTMLMarkup(string){var wrapper=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'span';var attr=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';if(!string||!__WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(wrapper))return null;if(wrapper===null){return createMarkup(string);}return createMarkup('<'+wrapper+' '+attr+'>'+string+'</'+wrapper+'>');}/**
 *
 *
 * @export
 * @param {string} [string]
 */// export function createMdMarkup(string?: string) {
//   if (!_.isString(string)) return null;
//   let html = null;
//   try {
//     const markup = markDownRenderer.process(string, (err, file) => { html = file; console.log(file); });
//     console.log(markup);
//   } catch (err) {
//     return null;
//   }
//   return html;
// }
/**
 * Create React friendly svg element from a string without relying on dangerouslySetInnerHTML
 *
 * @export
 * @param {string} string
 * @returns {SVGElement}
 */function createSVGMarkup(string){var wrapper=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'g';var attr=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';if(!string||__WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(wrapper)&&wrapper==='')return null;var fixString=string;fixString=string.replace(/stroke-width/g,'strokeWidth');fixString=fixString.replace(/font-size/g,'fontSize');fixString=fixString.replace(/font-weight/g,'fontWeight');fixString=fixString.replace(/text-anchor/g,'textAnchor');fixString=fixString.replace(/viewbox/g,'viewBox');return createMarkup('<'+wrapper+' '+attr+'>'+fixString+'</'+wrapper+'>');}/**
 * Check if a value is between two numbers
 *
 * @export
 * @param {number} value
 * @param {number} low
 * @param {number} high
 * @param {boolean} [inclusive=false]
 * @returns {boolean}
 */function isBetween(value,low,high){var inclusive=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var min=Math.min(low,high);var max=Math.max(low,high);return inclusive?value>=min&&value<=max:value>min&&value<max;}/**
 * A class to handle unique id generation.
 * https://github.com/ivanakimov/hashids.js
 *
 * @export
 * @class HashId
 */var HashId=function(){function HashId(){_classCallCheck(this,HashId);this.hashids=new __WEBPACK_IMPORTED_MODULE_5_hashids___default.a('Boost',8,'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890');this.count=0;}/**
   * Returns the next id
   *
   * @returns {string}
   * @memberOf HashId
   */_createClass(HashId,[{key:'nextId',value:function nextId(){this.count+=1;return this.hashids.encode(this.count);}/**
   * Returns encoded value
   *
   * @returns {string}
   * @memberOf HashId
   */},{key:'encode',value:function encode(value){return this.hashids.encode(value);}}]);return HashId;}();/**
 * Detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 * Modified from https://codepen.io/gapcode/pen/vEJNZN
 *
 * @exports
 * @param {string} User Agent to test; defaults to window.navigator.userAgent
 * @returns boolean
 */function isBrowserIE(){var ua=arguments.length>0&&arguments[0]!==undefined?arguments[0]:window.navigator.userAgent;/* eslint-disable max-len */// IE 10: 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
// IE 11: 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
// Edge 12 (Spartan): 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
// Edge 13: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
/* eslint-enable max-len */var version=0;var msie=ua.indexOf('MSIE ');if(msie>0){// IE 10 or older => return version number
version=parseInt(ua.substring(msie+5,ua.indexOf('.',msie)),10);}var trident=ua.indexOf('Trident/');if(trident>0){// IE 11 => return version number
var rv=ua.indexOf('rv:');version=parseInt(ua.substring(rv+3,ua.indexOf('.',rv)),10);}var edge=ua.indexOf('Edge/');if(edge>0){// Edge (IE 12+) => return version number
version=parseInt(ua.substring(edge+5,ua.indexOf('.',edge)),10);}return version>0;}/**
 * @export
 * @param {string} ua
 * @returns boolean
 */function isBrowserFF(){var ua=arguments.length>0&&arguments[0]!==undefined?arguments[0]:window.navigator.userAgent;return /Firefox\/([0-9]+)\./.test(ua);}function generateCVSBlob(data){var csv=data.map(function(d){return d.map(function(f){return JSON.stringify(f);}).join(',');});/**
   * The byte-order-marker (\ufeff) needs to be prepended to automatically
   * set the UTF character mode when importing.
   * https://stackoverflow.com/a/17879474
   */var forceUTF8='\uFEFF'+csv.join('\r\n');return new window.Blob([forceUTF8],{type:'text/csv'});}function downloadBlob(blob){var fileName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'untitled';// ie11 throws a security error when trying to download blobs like real browers.
if(isBrowserIE()&&window.navigator.msSaveOrOpenBlob){window.navigator.msSaveOrOpenBlob(blob,fileName);}else{var anchor=window.document.createElement('a');if(anchor){anchor.href=window.URL.createObjectURL(blob);anchor.download=fileName;window.document.body.appendChild(anchor);anchor.click();window.document.body.removeChild(anchor);}}}function downloadSVGImage(data,fileName){var width=640;var height=350;var exportName=fileName+'.png';var svg=data.replace(/\n\s+/g,'').replace(/&mu;/g,'μ');var canvas=__WEBPACK_IMPORTED_MODULE_9_d3__["select"]('body').append('canvas').attr('hidden',true).node();var forceClick=function forceClick(uri){var a=window.document.createElement('a');a.setAttribute('href',uri);a.setAttribute('target','_blank');a.setAttribute('download',exportName);window.document.body.appendChild(a);a.click();window.document.body.removeChild(a);};var ctx=canvas.getContext('2d',{preserveDrawingBuffer:true});canvas.width=width*2;canvas.height=height*2;ctx.fillStyle='white';ctx.fillRect(0,0,width*2,height*2);canvg(canvas,svg,{ignoreMouse:true,ignoreAnimation:true});if('msToBlob'in canvas){// $FlowIgnore
window.navigator.msSaveOrOpenBlob(canvas.msToBlob(),exportName);return;}forceClick(canvas.toDataURL('image/png'));}/**
 * Join URL paths
 * http://stackoverflow.com/a/29855282
 *
 * @export
 * @param {string[]} parts
 * @param {string} separator
 */function pathJoin(parts){var separator=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'/';var replace=new RegExp(separator+'{1,}','g');return parts.join(separator).replace(replace,separator);}/**
 * Branch helper function
 * @export
 * @param {boolean} predicate
 * @param {any} Comp1
 * @param {any} Comp2
 * @returns Comp1 || Comp2
 */function branch(predicate,left){var right=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return predicate?left:right;}/**
 * Takes a saga and a callback and spawns a new task
 * that will cancel based on take(cb)
 *
 * @param {Generator} fn
 * @param {Function | [] | string} cb
 * @returns {Generator}
 */function asyncCancelOnTake(fn,args,cb){var task;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function asyncCancelOnTake$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["fork"])(fn,args);case 2:task=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["take"])(cb);case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["cancel"])(task);case 7:case'end':return _context.stop();}}},_marked,this);}/**
 * Helper to Wait on a specfic selector condition before returning
 * https://goshakkk.name/detect-state-change-redux-saga/
 *
 * @param {selector} selector
 */function waitFor(selector){var cond;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function waitFor$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["select"])(selector);case 2:cond=_context2.sent;if(!cond){_context2.next=5;break;}return _context2.abrupt('return');case 5:if(false){_context2.next=15;break;}_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["take"])('*');case 8:_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["select"])(selector);case 10:cond=_context2.sent;if(!cond){_context2.next=13;break;}return _context2.abrupt('return');case 13:_context2.next=5;break;case 15:case'end':return _context2.stop();}}},_marked2,this);}/**
 * Count decimal places of a given number or string
 * http://stackoverflow.com/a/17369384
 * http://stackoverflow.com/a/10454560
 * @param {number | string} value
 */function countDecimals(value){if(typeof value==='string'){var match=value.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);if(match){return Math.max(0,// Number of digits right of decimal point.
(match[1]?match[1].length:0)-(// Adjust for scientific notation.
match[2]?+match[2]:0));}}if(typeof value!=='string'){if(Math.floor(value)!==value){return value.toString().split('.')[1].length||0;}}return 0;}function makeFileName(filename,ext){if(!ext)return __WEBPACK_IMPORTED_MODULE_6_lodash_snakeCase___default()(filename);return[__WEBPACK_IMPORTED_MODULE_6_lodash_snakeCase___default()(filename),ext].join('.');}/**
 * nope.
 */var noop=function noop(){};/**
 * Small UUID funciton
 * https://www.npmjs.com/package/uuid
 *
 * @export
 * @param {uuid} a
 * @returns
 *//* eslint-disable */// prettier-ignore
// $FlowIgnore
function uuid(a){return a?(a^Math.random()*16>>a/4).toString(16):([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,uuid);}/* eslint-enable *//**
 * Find and replace multiple strings with the passed object.
 * https://stackoverflow.com/a/15604206
 *
 * @export
 * @param {string} str
 * @param {Object} mapObj
 * @returns string
 */function replaceAll(str,mapObj){var re=new RegExp(Object.keys(mapObj).join('|'),'gi');return str.replace(re,function(matched){return mapObj[matched];});}/**
 * A simple string title capilization function
 *
 * @export
 * @param {string} str
 * @returns string
 */function toTitleCase(str){// prettier-ignore
var lowers=['a','an','the','and','but','or','for','nor','as','at','by','in','of','on','to','vs.'];if(typeof str!=='string')return null;return str.replace(/\w\S*/g,function(txt){if(lowers.indexOf(txt)!==-1)return txt;return''+txt.charAt(0).toUpperCase()+txt.substr(1).toLowerCase();});}/**
 * Gets an element's potition from the top of the page
 * https://stackoverflow.com/a/24829409
 *
 * @export
 * @param {HTMLElement} el
 * @returns {| x: number, y: number |}
 */function getPosition(element){var xPos=0;var yPos=0;if(element instanceof HTMLElement){while(element){// $FlowIgnore
xPos+=element.offsetLeft-element.scrollLeft+element.clientLeft;// $FlowIgnore
yPos+=element.offsetTop-element.scrollTop+element.clientTop;/* eslint-disable no-param-reassign */// $FlowIgnore
element=element.offsetParent;/* eslint-enable */}}return{x:xPos,y:yPos};}// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(a,b){/* eslint-disable no-restricted-syntax, prefer-const */for(var i in a){if(!(i in b))return true;}for(var _i in b){if(a[_i]!==b[_i])return true;}/* eslint-enable no-restricted-syntax, prefer-const */return false;}/**
 * Recursive deep diff two things
 * https://github.com/facebook/react-native/blob/master/Libraries/Utilities/differ/deepDiffer.js
 * @param {*} one
 * @param {*} two
 * @returns {bool} true if different, false if equal
 */function deepDiffer(one,two){/* eslint-disable no-restricted-syntax, prefer-const */if(one===two){// Short circuit on identical object references instead of traversing them.
return false;}if(typeof one==='function'&&typeof two==='function'){// We consider all functions equal
return false;}if((typeof one==='undefined'?'undefined':_typeof(one))!=='object'||one===null){// Primitives can be directly compared
return one!==two;}if((typeof two==='undefined'?'undefined':_typeof(two))!=='object'||two===null){// We know they are different because the previous case would have triggered
// otherwise.
return true;}if(one.constructor!==two.constructor){return true;}if(Array.isArray(one)){// We know two is also an array because the constructors are equal
var len=one.length;if(two.length!==len){return true;}for(var ii=0;ii<len;ii+=1){if(deepDiffer(one[ii],two[ii])){return true;}}}else{for(var _key in one){if(deepDiffer(one[_key],two[_key])){return true;}}for(var twoKey in two){// The only case we haven't checked yet is keys that are in two but aren't
// in one, which means they are different.
if(one[twoKey]===undefined&&two[twoKey]!==undefined){return true;}}}return false;/* eslint-enable no-restricted-syntax, prefer-const */}/**
 * Performs equality by iterating through keys on an object and returning
 * false when any key has values which are not strictly equal between
 * objA and objB. Returns true when the values of all keys are strictly equal.
 *
 * @return {boolean}
 */function shallowEqual(objA,objB){/* eslint-disable no-restricted-syntax, no-prototype-builtins */if(objA==null||objB==null)return false;if(objA===objB){return true;}var key=void 0;// Test for A's keys different from B.
for(key in objA){// prettier-ignore
if(objA.hasOwnProperty(key)&&(!objB.hasOwnProperty(key)||objA[key]!==objB[key])){return false;}}// Test for B's keys missing from A.
for(key in objB){// prettier-ignore
if(objB.hasOwnProperty(key)&&!objA.hasOwnProperty(key)){return false;}}return true;/* eslint-enable no-restricted-syntax, prefer-const */}/**
 * A curried helper function to set an object path without mutation.
 * This is needed because lodash.set mutates the object.
 *
 * ! Once the project is switched to typesript this will be handled differently.
 *
 * @param {string} path
 * @param {any} value
 * @param {Object} obj
 */// $FlowIgnore
var setIn=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(path,value,obj){return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_setWith___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_clone___default.a,path,value,__WEBPACK_IMPORTED_MODULE_3_lodash_fp_clone___default()(obj));});

/***/ }),

/***/ "./src/utils/polyfills/toBlob.js":
/***/ (function(module, exports) {

/* eslint-disable */// Only polyfill toBlob if needed (IE11 grr)
if(!HTMLCanvasElement.prototype.toBlob){Object.defineProperty(HTMLCanvasElement.prototype,'toBlob',{value:function value(callback,type,quality){var canvas=this;setTimeout(function(){var binStr=atob(canvas.toDataURL(type,quality).split(',')[1]),len=binStr.length,arr=new Uint8Array(len);for(var i=0;i<len;i++){arr[i]=binStr.charCodeAt(i);}callback(new Blob([arr],{type:type||'image/png'}));});}});}

/***/ }),

/***/ "./src/utils/react-aux.js":
/***/ (function(module, exports) {

/**
 * 
 * @format
 *//**
 * Simple function to collapse react children.
 * https://github.com/gajus/react-aux
 *
 * @param {{ children: any }} props
 * @returns {T}
 */function aux(props){return props.children;}module.exports=aux;

/***/ }),

/***/ "./src/utils/rollbar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * 
 * @format
 */var baseConfig={verbose:"production"!=='production',accessToken:"4c5d12f6f54543d4b283608826989868",captureUncaught:"production"==='production',handleUncaughtExceptions:"production"==='production',handleUnhandledRejections:"production"==='production',autoInstrument:true,payload:{environment:"production"}};var Rollbar=__webpack_require__("./node_modules/rollbar/dist/rollbar.umd.min.js");// const Rollbar = new rollbar(baseConfig); // eslint-disable-line new-cap
var baseClientConfig={source_map_enabled:true,code_version:"865943b97b",guess_uncaught_frames:true};var RollbarWrapper=function(){function RollbarWrapper(){var clientConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,RollbarWrapper);this.rollBar=null;if(!RollbarWrapper.instance){RollbarWrapper.instance=this;var config={payload:{client:{javascript:Object.assign({},baseClientConfig,clientConfig)}}};var rollBar=new Rollbar(clientConfig);// eslint-disable-line new-cap
// https://rollbar.com/docs/source-maps/
rollBar.configure(config);this.rollBar=rollBar;}return this.rollBar;}// https://github.com/netguru/redux-rollbar-middleware#state-sanitization
_createClass(RollbarWrapper,null,[{key:'stateSanitizer',value:function stateSanitizer(state){return Object.assign({},state);}}]);return RollbarWrapper;}();// export const middleware = rollbarMiddleware(stateSanitizer);
var instance=new RollbarWrapper(baseConfig);// Object.freeze(instance);
/* harmony default export */ __webpack_exports__["default"] = (instance);

/***/ }),

/***/ "./src/utils/stepHelpers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StepOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getStepDataByKey; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getStepByField;
/* unused harmony export getStepFields */
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextFieldsByStep;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNextFields;
/* unused harmony export getFieldData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__("./node_modules/lodash/reduce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("./node_modules/lodash/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_flatten__ = __webpack_require__("./node_modules/lodash/flatten.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_slice__ = __webpack_require__("./node_modules/lodash/slice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__ = __webpack_require__("./node_modules/lodash/findIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__("./node_modules/lodash/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__("./node_modules/debug/src/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/**
 * 
 * @format
 */const _uid2=__WEBPACK_IMPORTED_MODULE_6_debug___default()('app:utils/stepHelpers');var prevaled={stepData:{},KeyToStepMap:{},StepToKeyMap:[]};if(false){prevaled=require('./stepPreval');// eslint-disable-line global-require
}else{prevaled={"stepData":{"STEP_ONE":{"name":"Design Requirements","badge":"1","id":"STEP_ONE","image-span":"a, b, c","steps":{"a":{"name":"Input","badge":"1a","images":[{"file":"step1_img1.png"}],"fields":{"Vin_min":{"name":"Min Input Voltage (DC)","unit":"V","tooltip":" Lower limit of minimum input voltage is 1.0V. Upper limit of min V<sub>IN</sub> is 150V."},"Vin_max":{"name":"Max Input Voltage (DC)","unit":"V","tooltip":"Max input voltage is limited as a function of min V<sub>IN</sub> to keep steady state duty cycle within the operating range of a typical controller. Absolute upper limit of V<sub>IN</sub> is 150V."},"Vin_nom":{"name":"Nom Input Voltage (DC)","unit":"V"}}},"b":{"name":"Output","badge":"1b","fields":{"Vout":{"name":"Output Voltage (DC)","unit":"V","tooltip":"Permissible output voltage is limited by input voltage and the duty cycle (D) range of a typical controller. Absolute upper limit of V<sub>OUT</sub> is 185V."},"Iout":{"name":"Max Output Current","unit":"A"},"Pout":{"name":"Max Output Power","unit":"W","calculated":true}}},"c":{"name":"Output Voltage Ripple & Overshoot","badge":"1c","images":[{"file":"VOUT Ripple.png"},{"file":"step1_img3.png"}],"fields":{"DeltaVout_spec":{"name":"Max Ripple Voltage (pk-pk)","unit":"mV<sub>pp</sub>","tooltip":"Switching frequency ripple, neglecting high-frequency noise. A lower ripple spec might require a larger output capacitor."},"Kos":{"name":"Overshoot Factor (load interrupt, % of V<sub>OUT</sub>)","unit":"%","tooltip":"Defines max allowed transient output voltage for a load step of 100% Iout to 0A. A lower overshoot spec might require a greater output capacitor value. However, for a boost converter, needed capacitance is typically dominated by the ripple voltage requirement.<br />V<sub>OS</sub>(pk) = V<sub>OUT</sub> x (1 + K<sub>OS</sub>)"},"Voutpk_spec":{"name":"Max Overshoot Voltage (pk)","unit":"V<sub>pk</sub>","calculated":true,"tooltip":"Assuming an output DC (steady-state) regulation upper tolerance of +2%."}}},"d":{"name":"Operating Conditions","badge":"1d","description":"Thermal management options appear in Step 3a, Power Semiconductor Derating Requirements.","images":[{"file":"CCM Operation.png"},{"file":"DCM Operation.png"}],"fields":{"Fsw":{"name":"Switching Frequency","unit":"kHz","tooltip":"Can be a fixed or user-set value depending on the controller. A higher F<sub>SW</sub> can result in a smaller inductor, but might also reduce efficiency due to increased switching losses."},"Vgate":{"name":"Gate Drive Voltage","unit":"V","tooltip":"Output of the gate driver (applied to FET gate-source) in the on state."},"Rsrc":{"name":"Gate Driver Source Resistance","unit":"Ω","tooltip":"Internal resistance of the driver when sourcing current to the FET gate. External gate damping resistors can be entered in Step 3c, MOSFET Selection."},"Rsnk":{"name":"Gate Driver Sink Resistance","unit":"Ω","tooltip":"Internal resistance of the driver when sinking current from the FET gate. External gate damping resistors can be entered in Step 3c, MOSFET Selection."},"Pdrv_bias":{"name":"Driver Bias Power (quiescent)","unit":"mW","tooltip":"Quiescent or bias power of the driver (while operating). Typically (V<sub>DD</sub> x I<sub>DD</sub>). Internal bias currents only, does not include gate drive currents."},"Ta_max":{"name":"Max Ambient Temperature","unit":"°C","tooltip":"Typically the max air temperature of the circuit board environment."},"Opmode":{"name":"Conduction Mode","type":"radio","options":[{"name":"Continuous Conduction Mode (CCM)","value":"CCM","key":"CCM","display":"CCM"},{"name":"Discontinuous Conduction Mode (DCM)","value":"DCM","key":"DCM","display":"DCM"}],"tooltip":"In CCM, the inductor current is never zero during full-load operation. This mode offers low ripple current at the expense of a larger inductor. CCM is typically chosen for moderate to high-power converters. In DCM, the inductor current remains zero for a portion of each switching cycle. DCM generally offers a smaller inductor, but with greater RMS and peak currents flowing in the switches. The higher currents can reduce efficiency, and might require a larger output capacitor or input filter. A benefit of DCM is that there is no reverse recovery loss at FET turn-on, so an ultrafast diode is not necessary (fast-recovery will typically suffice). DCM is typically chosen for  low-power applications. CCM designs will typically enter DCM operation under light-load conditions."},"Etaest_hl":{"name":"Estimated Efficiency @ V<sub>IN</sub> max","unit":"%","tooltip":"Efficiency (η) is a complex result of operating parameters and selected components. If the calculated efficiency reported in Step 6c differs significantly from this estimate, accuracy might be improved by entering that value here and iterating the design."},"Etaest_ll":{"name":"Estimated Efficiency @ V<sub>IN</sub> min","unit":"%","tooltip":"Efficiency (η) is a complex result of operating parameters and selected components. If the calculated efficiency reported in Step 6c differs significantly from this estimate, accuracy might be improved by entering that value here and iterating the design. Efficiency can also limit V<sub>IN</sub> min, since V<sub>OUT</sub> ≈ V<sub>IN</sub> x η / (1 - D) for CCM."}}}}},"STEP_TWO":{"name":"Inductor Selection","badge":"2","id":"STEP_TWO","steps":{"a":{"name":"Inductor Value","badge":"2a","images":[{"file":"Inductor current sch.png"},{"name":"CCM Operation","file":"Inductor current CCM_R1.png","condition":{"Opmode":"CCM"}},{"name":"DCM Operation","file":"Inductor Current DCM.png","condition":{"Opmode":"DCM"}}],"fields":{"K_deltaI":{"name":"Inductor Current Ripple Factor","step":"0.1","tooltip":"Maximum ratio of permissible AC (peak-to-peak) inductor ripple current to DC (average) current. Typically ≈ 0.3-0.6. Greater  ripple can result in a smaller indcutor, but increases current in the switches and filter capacitors.  Maximum value is 2.0 for boundary mode (BCM). For the boost converter, worst case ripple factor occurs when V<sub>IN</sub> ≈ 2/3 x V<sub>OUT</sub> (in CCM).<br />K<sub>RF</sub> = ΔI<sub>L</sub> / I<sub>IN</sub>","dependancies":{"Opmode":"CCM"}},"T_idlemin":{"name":"Minimum Non-conduction time (t<sub>idle</sub>)","unit":"μs","step":"0.01","tooltip":"Minimum permissible time when inductor current is zero in DCM (idle time). Worst case occurs at either min or max V<sub>IN</sub> for the boost converter. Set to 0 for boundary mode (BCM). Longer idle time gives a smaller inductor value but results in higher peak currents and might require a larger output capcitor.","dependancies":{"Opmode":"DCM"}},"Lmin":{"name":"Minimum Inductor Value","unit":"μH","calculated":true,"tooltip":"Minimum required value to meet ripple factor requirement at max load. To reduce this value, increase switching frequency (F<sub>SW</sub>) or inductor current ripple factor.","dependancies":{"Opmode":"CCM"}},"Lmax":{"name":"Maximum Inductor Value","unit":"μH","calculated":true,"tooltip":"Maximum allowed value to maintain specified minimum non-conduction time in DCM operation at max load. To reduce this value, increase idle time or switching frequency (F<sub>SW</sub>).","dependancies":{"Opmode":"DCM"}},"ILpk_pre":{"name":"Peak Inductor Current (preliminary estimate)","unit":"A<sub>pk</sub>","calculated":true,"tooltip":"Maximum inductor peak current in steady state assuming the default inductor value above. Also the max peak current switched by the FETs. Occurs at minimum input voltage and max load for the boost converter. To lower this value, reduce the inductor current ripple factor (CCM) or non-conduction time (DCM)."},"Iocp":{"name":"Over-Current Protection Threshold","unit":"A<sub>pk</sub>","tooltip":"OCP threshold of the controller for short-circuit/overload protection. Typically set 10%-25% above the maximum steady-state peak inductor current to allow for startup and transient response. Inductor saturation rating must be above this value"},"DF_IL":{"name":"Inductor RMS Current Derating Factor","unit":"%","tooltip":"For inductor RMS current rating, DF =  I<sub>L</sub> / (I<sub>RMS</sub> rating), maximum input current divided by RMS current rating of the part; used to limit temperature rise due to conduction loss in the inductor."}}},"b":{"name":"Component Selection","badge":"2b","fields":{"SuitableInductors":{"name":"Suitable Inductors","type":"selecttable","dataTarget":"IndPNsel"}}},"customInductor":{"name":"Use Custom Inductor (optional)","badge":"","description":"If you wish to use an inductor not found in the list of recommended parts, enter the custom inductance, DCR, and RMS current rating values below. <br />Leave custom value inputs zero to use the inductor selected above.<br />Recommended values shown if no suitable inductor was found.","fields":{"Lcust":{"name":"Custom Inductance Value","unit":"μH","tooltip":"Leave zero to use the value from the inductor selected above.<br />Recommended value shown if no suitable inductor was found."},"DCRcust":{"name":"Custom DCR Value","unit":"mΩ","tooltip":"Leave zero to use the value from the inductor selected above..<br />Recommended value shown if no suitable inductor was found."},"Irms_cust":{"name":"Custom RMS Current Rating","unit":"A","tooltip":"Leave zero to use the value from the inductor selected above..<br />Recommended value shown if no suitable inductor was found."}}},"perfSummary":{"name":"Inductor Performance Summary","badge":"","graphs":{"CritChartData":{"name":"Critical Load vs. Input Voltage"}},"fields":{"Act_maxDeltaIL":{"name":"Actual Max Inductor Ripple Current (worst-case V<sub>IN</sub>)","calculated":true,"unit":"A<sub>pp</sub>","tooltip":"With the selected inductor. Occurs when V<sub>IN</sub> is near V<sub>OUT</sub>/2 for CCM, at min V<sub>IN</sub> for DCM."},"Act_KDeltaI":{"name":"Actual Inductor Current Ripple Factor (worst-case V<sub>IN</sub>)","calculated":true,"tooltip":"With the selected inductor. Occurs when V<sub>IN</sub> is near 2/3 x V<sub>OUT</sub>. For CCM operation only.","dependancies":{"Opmode":"CCM"}},"Act_ILpk":{"name":"Actual Peak Inductor Current (min V<sub>IN</sub>)","calculated":true,"unit":"A<sub>pk</sub>","tooltip":"With the selected inductor (steady-state)."},"Act_ILrms":{"name":"Actual Max RMS Inductor Current (min V<sub>IN</sub>)","calculated":true,"unit":"A<sub>RMS</sub>","tooltip":"With the selected inductor."},"OCP_message":{"calculated":true,"name":"","type":"message"},"DtyCy_message":{"calculated":true,"name":"","type":"message"},"MaxPchoke":{"name":"Max Inductor Loss (min V<sub>IN</sub>)","calculated":true,"unit":"W","tooltip":"Max inductor loss includes DC plus estimated AC losses."},"group-Vin_th":{"name":"Input Voltage Conduction Mode Bounds (max load)","type":"stack","calculated":true,"tooltip":"Output current above the critical load curve indicates CCM operation, DCM below the curve. Intersection of the I<sub>OUT</sub> line with the critical load curve indicates a conduction mode boundary at the respective V<sub>IN</sub> (x-axis).","fields":[{"id":"Vin_th0","unit":"V"},{"id":"Vin_th1","unit":"V"}]},"Dmin_pre":{"calculated":true,"name":"Min Duty Cycle (max load)","tooltip":"Applies for maximum V<sub>IN</sub>. D = t<sub>ON</sub> / T<sub>SW</sub>, where t<sub>ON</sub> is the on-time of the active switch and T<sub>SW</sub> is the switching period. Duty cycle is load-dependent in DCM, but not in CCM."},"Dmax_pre":{"calculated":true,"name":"Max Duty Cycle (max load)","tooltip":"Applies for minimum V<sub>IN</sub>. D = t<sub>ON</sub> / T<sub>SW</sub>, where t<sub>ON</sub> is the on-time of the active switch and T<sub>SW</sub> is the switching period. Duty cycle is load-dependent in DCM, but not in CCM."}}}}},"STEP_THREE":{"name":"Power Semiconductor Selection","badge":"3","id":"STEP_THREE","steps":{"a":{"name":"Derating Requirements","badge":"3a","images":[{"file":"MOSFET Voltage Derating SCH.png"},{"file":"MOSFET Voltage Derating CCM.png","condition":{"Opmode":"CCM"}},{"file":"MOSFET Voltage Derating DCM.png","condition":{"Opmode":"DCM"}}],"fields":{"Therm_opt":{"name":"Choose Thermal Management Option","type":"radio","tooltip":"<p>Determines the thermal resistance used to estimate junction temperature, where T<sub>J</sub> = (P<sub>LOSS</sub> x R<sub>θJA</sub>) + T<sub>A</sub>. P<sub>LOSS</sub> is total device loss and R<sub>θJA</sub> is the junction-to-ambient thermal resistance. R<sub>θJA</sub> is the sum of the junction-to-case (R<sub>θJC</sub>) and case-to-ambient (R<sub>θCA</sub>) thermal resistances, where the case thermal reference is generally defined as the solder mounting surface of the drain for FETs and one of the leads for diodes. R<sub>θJC</sub> is fixed by the selected device, while R<sub>θCA</sub> is determined by the user's board design.<p /><p>The datasheet R<sub>θJA</sub> is determined using the recommended PWB pad, typically 1in<sup>2</sup>, 2oz. copper for MOSFETs.</p><p>For advanced users, enter a custom R<sub>θCA</sub> if the PWB pad copper area is larger or smaller than the recommended pad in the datasheet, or if a heatsink is to be used.</p>","options":[{"name":"Use R<sub>θJA</sub> from Datasheet","value":0,"key":0},{"name":"Enter your custom R<sub>θCA</sub> Value","value":1,"key":1}]},"Rthca_f":{"name":"Custom R<sub>θCA</sub> Value - MOSFET","unit":"°C/W","dependancies":{"Therm_opt":1}},"Rthca_d":{"name":"Custom R<sub>θCA</sub> Value - Diode","unit":"°C/W","tooltip":"R<sub>θJL</sub> value may be used by some diode datasheets in place of R<sub>θJC</sub>.","dependancies":{"Therm_opt":1}},"DF_MV":{"name":"Voltage Derating Factor - MOSFET","unit":"%","tooltip":"Used to provide safety margin between peak drain voltage and the device BV<sub>DSS</sub> rating. Each switch must block V<sub>OUT</sub>, plus the diode forward drop (V<sub>F</sub>), plus turn-off ringing voltage.<br />DF = max V<sub>OUT</sub> / min BV<sub>DSS</sub> , typically 60%-75%."},"DF_DV":{"name":"Voltage Derating Factor - Diode","unit":"%","tooltip":"Used to provide safety margin between peak diode voltage and the device V<sub>RRM</sub> rating. The diode must block V<sub>OUT</sub>, plus turn-off ringing voltage.<br />DF = max V<sub>OUT</sub> / min V<sub>RRM</sub> , typically 60%-75%."},"DF_MI":{"name":"Current Derating Factor - MOSFET","unit":"%","tooltip":"Derating factor applies to the I<sub>D</sub> cont (T<sub>A</sub>=25°C) device rating if Thermal Option 1 is selected,  or to the I<sub>D</sub> cont (T<sub>C</sub>=25°C) rating if Option 2 is selected. If no T<sub>C</sub>=25°C current rating is available, then the T<sub>A</sub>=25° value is used.<br />DF = I<sub>RMS</sub> / min I<sub>D</sub> cont"},"DF_DI":{"name":"Current Derating Factor - Diode","unit":"%","tooltip":"Derating factor applies to the I<sub>F(AV)</sub> device rating.<br />DF = I<sub>DC</sub> / min I<sub>F(AV)</sub>."},"Tj_marginF":{"name":"Min  Junction Temp. Margin - MOSFET","unit":"°C","tooltip":"Typically 25°C for reliability. Datasheet T<sub>J</sub> ratings vary. Absolute max allowed operating T<sub>J</sub> is the lesser of 150°C or the part rating."},"Tj_marginD":{"name":"Min  Junction Temp. Margin - Diode","unit":"°C","tooltip":"Typically 25°C for reliability. Datasheet T<sub>J</sub> ratings vary. Absolute max allowed operating T<sub>J</sub> is the lesser of 150°C or the part rating."}}},"b":{"name":"Diode Selection","badge":"3b","images":[],"fields":{"VRRM_min":{"name":"Min Voltage Rating (V<sub>RRM</sub>)","unit":"V","calculated":true,"tooltip":"Determined from parts meeting the voltage derating requirement entered in Step 3a."},"VRRM_max":{"name":"Max Voltage Rating (V<sub>RRM</sub>)","unit":"V","tooltip":"Enter a lower or higher value to adjust the range of V<sub>RRM</sub> ratings available in the diode selection list below.  Reducing max V<sub>RRM</sub> might also limit the maximum available current rating."},"Irating_LS_dual":{"name":"","calculated":true,"type":"fieldstack","tooltip":["","Determined from the current derating requirement entered in Step 3a."]},"Pkgs_Diodes":{"name":"Select Diode Package","type":"dropdown","dataTarget":"Sel_diode_pkg","multiple":true},"DiodesVIPTgood":{"name":"Data for Qualified Devices","type":"largetable"},"Losscomp_diode":{"name":"Estimated Losses & T<sub>j</sub>","tooltip":"R<sub>θJA</sub> in the device data table is the datasheet value. Custom R<sub>θJA</sub> (R<sub>θJC</sub> or R<sub>θJL</sub> + R<sub>θCA</sub>) is shown in the loss comparison table if the custom thermal option is selected (Thermal Option 2).","type":"selecttable","dataTarget":"PN_sel_diode"}}},"c":{"name":"MOSFET Selection","badge":"3c","images":[],"fields":{"Num_pll_fet":{"name":"Num. of Parallel Devices","step":"1","tooltip":"Up to four single MOSFETs may be used in parallel."},"Rdamp":{"name":"Gate Damping Resistor","unit":"Ω","tooltip":"Optional external resistor to reduce MOSFET gate ringing. If parallel FETs are used, a separate resistor will be added for each gate. Enter 0 if not used (default)."},"BVdss_min":{"name":"Min Voltage Rating (BV<sub>DSS</sub>)","unit":"V","calculated":true,"tooltip":"Determined from parts meeting the voltage derating requirement entered in Step 3a."},"BVdss_max":{"name":"Max Voltage Rating (BV<sub>DSS</sub>)","unit":"V","tooltip":"Enter a lower or higher value to adjust the range of BV<sub>DSS</sub> ratings available in the FET selection list below."},"Irating_HS":{"calculated":true,"type":"fieldstack","tooltip":["","Determined from the current derating requirement entered in Step 3a."]},"Pkgs_FET":{"name":"Select FET Package","type":"dropdown","dataTarget":"Sel_fet_pkg","multiple":true},"FETsVIPTgood":{"name":"Data for Qualified Devices","type":"largetable"},"Losscomp_FET":{"name":"Estimated Losses & T<sub>j</sub> (per device)","type":"selecttable","dataTarget":"PN_sel_fet","tooltip":"R<sub>θJA</sub> in the device data table is the datasheet value. Custom R<sub>θJA</sub> (R<sub>θJC</sub> + R<sub>θCA</sub>) is shown in the loss comparison table if the custom thermal option is selected (Thermal Option 2)."}}},"d":{"name":"Power Semiconductor Loss Summary ","badge":"3d","images":[],"fields":{"group-selected-diode-fet":{"type":"stack","calculated":true,"fields":[{"id":"SelectedMOSFET","name":"Selected MOSFET"},{"id":"SelectedDiode","name":"Selected Diode"}]},"SemiconLossSummaryTable":{"name":"Power Semi Loss Summary (per dev.):","type":"unknown"}}}}},"STEP_FOUR":{"name":"Output Capacitor","badge":"1","id":"STEP_FOUR","steps":{"a":{"name":"Capacitor Derating Requirements","badge":"4a","images":[{"file":"Capacitor Current SCH.png"},{"file":"Capacitor Current CCM.png","condition":{"Opmode":"CCM"}},{"file":"Capacitor Current DCM.png","condition":{"Opmode":"DCM"}}],"fields":{"DeltaVout_spec":{"name":"Ripple Voltage Spec. (pk-pk)","calculated":true,"unit":"mV<sub>pp</sub>","tooltip":"From Step 1c."},"Voutpk_spec":{"name":"Overshoot Spec. (load intrpt)","calculated":true,"unit":"V<sub>pk</sub>","tooltip":"From Step 1c."},"DF_CV":{"name":"DC Voltage Derating Factor","unit":"%","tooltip":"Capacitor DC voltage rating should be greater than the highest peak output voltage (typically the load-interrupt overshoot voltage).  Use the derating factor to provide safety margin.<br />DF = max V<sub>OUT</sub>(pk) / min VDC rating,  Typically ~80%"},"DF_CI":{"name":"Ripple Current Derating Factor","unit":"%","tooltip":"Capacitor ripple current is approximately equal to the AC portion of the diode current.  Use the derating factor to lower capacitor internal temperature and improve reliability, especially for electrolytic caps.<br />DF = max I<sub>CO</sub>(RMS) / min I<sub>ripple</sub> rating (RMS)."},"DgF_Cout":{"name":"Capacitor Degradation Factor","unit":"%","tooltip":"Lowest percentage of nominal capacitance available considering initial tolerance, temperature & aging effects."}}},"b":{"name":"Capacitor Value and Ratings","badge":"4b","images":[],"fields":{"group-total-output-cap":{"name":"Recommended Min. Total Output Capacitance","type":"stack","calculated":true,"tooltip":"Total value needed to satisfy both ripple and overshoot requirements entered in Step 1c. Values may be equivalent in cases where overshoot is dominant.","fields":[{"id":"Cmin_tot_100PercentESR","name":"with 100% of max ripple voltage from ESR","unit":"μF"},{"id":"DefaultCmin_tot","name":"with at least 50% of max ripple voltage from ESR","unit":"μF"},{"id":"Cmin_tot","name":"with minimal ESR","unit":"μF"}]},"Num_Cpll":{"name":"Number of Parallel Capacitors","step":"1","tooltip":"Up to six caps may be used in parallel. The recommended quantity assumes use of typical, low-cost aluminum electrolytic caps. Improved performance or reduced size may be possible with ceramic or organic polymer capacitors with lower ESR and greater ripple current capability."},"Cout_per":{"name":"Capacitor Value (per capacitor)","unit":"μF","tooltip":"Recommended value is the minimum needed to satisfy output ripple and overshoot voltage requirements entered in Step 1c. Select a standard value greater than the recommended minimum value."},"ESRmax_per":{"name":"Max ESR (per capacitor)","unit":"Ω","tooltip":"Recommended value is the maximum permissible to satisfy the output ripple voltage requirement entered in Step 1c with the capacitor value specified above. Select a cap with ESR less than the recommended value. Increase cap value or parallel quantity to raise permissible ESR per cap (up to ripple limit)."},"Vminrat_cap":{"name":"Min DC Voltage Rating","unit":"V","tooltip":"Minimum value is the voltage rating needed to satisfy the derating requirement specified in Step 4a, applied to the actual peak overshoot voltage."},"Iminrat_cap":{"name":"Min Ripple Current Rating (per cap)","unit":"A","tooltip":"Select a cap with ripple current rating (at the switching frequency) greater than the recommended value. Increase the parallel quantity to lower the ripple current per cap. Consider ceramic or organic polymer caps for higher current ratings."},"DeltaVout_max":{"name":"Actual Worst Case Ripple Voltage","calculated":true,"unit":"mV<sub>pp</sub>"},"Voutpk_max":{"name":"Actual w/c Overshoot (load interrupt)","calculated":true,"unit":"V<sub>pk</sub>"},"Icaprms_maxper":{"name":"Actual Ripple Current (per capacitor)","calculated":true,"unit":"A<sub>RMS</sub>"}}}}},"STEP_FIVE":{"name":"Snubber","badge":"1","id":"STEP_FIVE","steps":{"a":{"name":"Snubber Design (optional)","badge":"5a","images":[{"file":"Boost Schematic 2.png"}],"fields":{"Snub_sel":{"name":"Use RC Snubber?","type":"radio","tooltip":"Adding an RC snubber can reduce ringing at the switch node and reduce EMI, especially if PWB layout is not ideal. Overall efficiency is typically slightly lower with this type of snubber.","options":[{"name":"Yes","value":1,"key":1},{"name":"No","value":0,"key":0}]},"Lpar":{"name":"Est. Circuit Parasitic Inductance","unit":"nH","tooltip":"Stray inductance is highly dependent upon PWB layout. Refer to AN-4162 for further information.","dependancies":{"Snub_sel":1}},"Cpar":{"name":"Est. Switch Node Par. Capacitance","unit":"pF","tooltip":"Typically dominated by the total output capacitance (C<sub>oss</sub>) of the MOSFET(s).","dependancies":{"Snub_sel":1}},"Csnub":{"name":"Snubber Capacitor Value","unit":"pF","tooltip":"Typically ceramic or other low-ESR, non-polarized technology. Increasing C-value increases power dissipation in the snubber resistor.","dependancies":{"Snub_sel":1}},"Vrat_Csnub":{"name":"Snubber Cap. Min Voltage Rating","unit":"V","tooltip":"Select a voltage rating at least equal to the  MOSFET BV<sub>DSS</sub>.","dependancies":{"Snub_sel":1}},"Rsnub":{"name":"Snubber Resistor Value","unit":"Ω","tooltip":"Recommended value is calulated to provide ideal damping of the parasitic resonant circuit. Value may be tuned without affecting power disspation. See AN-4162 for more information.","dependancies":{"Snub_sel":1}},"Psnub":{"name":"Snubber Resistor Max Power Dissipation","calculated":true,"unit":"W","tooltip":"P<sub>snub</sub> = C<sub>snub</sub> x V<sub>OUT</sub><sup>2</sup> x F<sub>SW</sub>","dependancies":{"Snub_sel":1}},"Prat_Rsnub":{"name":"Snubber Resistor Min Power Rating","unit":"W","tooltip":"Refer to resistor datasheet for recommended power derating under actual operating temperature conditions.","dependancies":{"Snub_sel":1}}}}}},"STEP_ANALYSIS":{"name":"Loss Review","badge":"6","id":"STEP_ANALYSIS"},"SCHEMATIC":{"name":"Schematic","icon":"<g transform=\"scale(0.3)\"><path d=\"M60 37V1c0-.6-.4-1-1-1H1C.4 0 0 .4 0 1v47c0 .6.4 1 1 1h10v-2H2V2h56v34H48c-.6 0-1 .4-1 1v10H25v2h23c.3 0 .5 0 .7-.3l11-11s0-.2.2-.3V37zm-11 1h7.6l-3.8 3.8-3.8 3.8V38z\"/><path d=\"M19 9.7c-.2-.4-.6-.7-1-.7s-.8.3-1 .7l-2.8 8.7-.2.6v40c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V19c0-.2 0-.5-.2-.6l-3-8.7zM16 20h1v31h-1V20zm3 0h1v31h-1V20zm-1-6.8l1.6 4.8h-3.2l1.6-4.8zM20 58h-4v-5h4v5zM35 6c-5 0-9 4-9 9v2h2v-2c0-4 3-7 7-7s7 3 7 7v2h2v-2c0-5-4-9-9-9z\"/><path d=\"M54 16v-2h-2v2c0 4-3 7-7 7s-7-3-7-7v-2h-2v2c0 5 4 9 9 9s9-4 9-9zM25 33v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V33c0-.6-.4-1-1-1H26c-.6 0-1 .4-1 1zm2 1h8v8h-8v-8z\"/><path d=\"M39 35v2h2c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1h-8c-.6 0-1 .4-1 1v2h2v-1h6v6h-1zM6 5h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2zM6 9h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6z\"/></g>","id":"SCHEMATIC"},"BOM":{"name":"BOM","icon":"<g transform=\"scale(0.035)\"><path d=\"M449.4 0h-430c-6.6 0-12 5.4-12 12s5.4 12 12 12h26v432.4c0 4.4 2.3 8.5 6.2 10.6s8.6 2 12.3-.6l52-34.7 52 34.8c4 2.7 9.2 2.7 13.2 0l52.2-34.7 52.3 34.8c4 2.7 9 2.7 13 0L351 432l52.4 34.5c2 1.3 4.3 2 6.6 2 2 0 4-.5 5.7-1.4 4-2 6.2-6 6.2-10.4V24.3h27.3c6.6 0 12-5.4 12-12S456 0 449.3 0zm-51 434L358 407.2c-4-2.7-9.2-2.7-13.2 0L292.6 442l-52.3-34.8c-4-2.7-9.3-2.7-13.3 0L175 442l-52.5-35c-4-2.7-9.3-2.7-13.3 0l-40 26.7V24h329v410z\"/><path d=\"M124.5 191.6h125.7c6.6 0 12-5.4 12-12s-5.5-12-12-12h-126c-6.5 0-12 5.4-12 12s5.4 12 12 12zm0 41.7h94.2c6.6 0 12-5.4 12-12s-5.4-12-12-12h-94.2c-6.6 0-12 5.4-12 12s5.3 12 12 12zM313 191.6h31.3c6.6 0 12-5.4 12-12s-5.4-12-12-12H313c-6.7 0-12 5.4-12 12s5.3 12 12 12zm0 41.7h31.3c6.6 0 12-5.4 12-12s-5.4-12-12-12H313c-6.7 0-12 5.4-12 12s5.3 12 12 12zm-188.5-138h125.7c6.6 0 12-5.4 12-12s-5.5-12-12-12h-126c-6.5 0-12 5.4-12 12s5.4 12 12 12zm0 41.7h94.2c6.6 0 12-5.5 12-12s-5.4-12-12-12h-94.2c-6.6 0-12 5.3-12 12s5.3 12 12 12zM313 95.3h31.3c6.6 0 12-5.4 12-12s-5.4-12-12-12H313c-6.7 0-12 5.4-12 12s5.3 12 12 12zm0 41.7h31.3c6.6 0 12-5.5 12-12s-5.4-12-12-12H313c-6.7 0-12 5.3-12 12s5.3 12 12 12zM124.5 289h125.7c6.6 0 12-5.3 12-12s-5.5-12-12-12h-126c-6.5 0-12 5.5-12 12s5.4 12 12 12zm0 41.7h94.2c6.6 0 12-5.4 12-12s-5.4-12-12-12h-94.2c-6.6 0-12 5.4-12 12s5.3 12 12 12zM313 289h31.3c6.6 0 12-5.3 12-12s-5.4-12-12-12H313c-6.7 0-12 5.5-12 12s5.3 12 12 12zm0 41.7h31.3c6.6 0 12-5.4 12-12s-5.4-12-12-12H313c-6.7 0-12 5.4-12 12s5.3 12 12 12z\"/></g>","id":"BOM"},"REPORT":{"name":"Report","icon":"<path d=\"M2 14h14v2h-16v-16h2zM4.5 13c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.044 0 0.088 0.002 0.131 0.006l1.612-2.687c-0.154-0.235-0.243-0.517-0.243-0.819 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.302-0.090 0.583-0.243 0.819l1.612 2.687c0.043-0.004 0.087-0.006 0.131-0.006 0.033 0 0.066 0.001 0.099 0.004l2.662-4.658c-0.165-0.241-0.261-0.532-0.261-0.845 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5-0.033 0-0.066-0.001-0.099-0.004l-2.662 4.658c0.165 0.241 0.261 0.532 0.261 0.845 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.302 0.090-0.583 0.243-0.819l-1.612-2.687c-0.043 0.004-0.087 0.006-0.131 0.006s-0.088-0.002-0.131-0.006l-1.612 2.687c0.154 0.235 0.243 0.517 0.243 0.819 0 0.828-0.672 1.5-1.5 1.5z\" />","id":"REPORT"}},"StepToKeyMap":[{"id":"STEP_ONE","fields":["Vin_min","Vin_max","Vin_nom","Vout","Iout","Pout","DeltaVout_spec","Kos","Voutpk_spec","Fsw","Vgate","Rsrc","Rsnk","Pdrv_bias","Ta_max","Opmode","Etaest_hl","Etaest_ll"]},{"id":"STEP_TWO","fields":["K_deltaI","T_idlemin","Lmin","Lmax","ILpk_pre","Iocp","DF_IL","SuitableInductors","Lcust","DCRcust","Irms_cust","Act_maxDeltaIL","Act_KDeltaI","Act_ILpk","Act_ILrms","OCP_message","DtyCy_message","MaxPchoke","group-Vin_th","Dmin_pre","Dmax_pre"]},{"id":"STEP_THREE","fields":["Therm_opt","Rthca_f","Rthca_d","DF_MV","DF_DV","DF_MI","DF_DI","Tj_marginF","Tj_marginD","VRRM_min","VRRM_max","Irating_LS_dual","Pkgs_Diodes","DiodesVIPTgood","Losscomp_diode","Num_pll_fet","Rdamp","BVdss_min","BVdss_max","Irating_HS","Pkgs_FET","FETsVIPTgood","Losscomp_FET","group-selected-diode-fet","SemiconLossSummaryTable"]},{"id":"STEP_FOUR","fields":["DeltaVout_spec","Voutpk_spec","DF_CV","DF_CI","DgF_Cout","group-total-output-cap","Num_Cpll","Cout_per","ESRmax_per","Vminrat_cap","Iminrat_cap","DeltaVout_max","Voutpk_max","Icaprms_maxper"]},{"id":"STEP_FIVE","fields":["Snub_sel","Lpar","Cpar","Csnub","Vrat_Csnub","Rsnub","Psnub","Prat_Rsnub"]}],"KeyToStepMap":{"Vin_min":"STEP_ONE","Vin_max":"STEP_ONE","Vin_nom":"STEP_ONE","Vout":"STEP_ONE","Iout":"STEP_ONE","Pout":"STEP_ONE","DeltaVout_spec":"STEP_FOUR","Kos":"STEP_ONE","Voutpk_spec":"STEP_FOUR","Fsw":"STEP_ONE","Vgate":"STEP_ONE","Rsrc":"STEP_ONE","Rsnk":"STEP_ONE","Pdrv_bias":"STEP_ONE","Ta_max":"STEP_ONE","Opmode":"STEP_ONE","Etaest_hl":"STEP_ONE","Etaest_ll":"STEP_ONE","K_deltaI":"STEP_TWO","T_idlemin":"STEP_TWO","Lmin":"STEP_TWO","Lmax":"STEP_TWO","ILpk_pre":"STEP_TWO","Iocp":"STEP_TWO","DF_IL":"STEP_TWO","SuitableInductors":"STEP_TWO","Lcust":"STEP_TWO","DCRcust":"STEP_TWO","Irms_cust":"STEP_TWO","Act_maxDeltaIL":"STEP_TWO","Act_KDeltaI":"STEP_TWO","Act_ILpk":"STEP_TWO","Act_ILrms":"STEP_TWO","OCP_message":"STEP_TWO","DtyCy_message":"STEP_TWO","MaxPchoke":"STEP_TWO","group-Vin_th":"STEP_TWO","Dmin_pre":"STEP_TWO","Dmax_pre":"STEP_TWO","Therm_opt":"STEP_THREE","Rthca_f":"STEP_THREE","Rthca_d":"STEP_THREE","DF_MV":"STEP_THREE","DF_DV":"STEP_THREE","DF_MI":"STEP_THREE","DF_DI":"STEP_THREE","Tj_marginF":"STEP_THREE","Tj_marginD":"STEP_THREE","VRRM_min":"STEP_THREE","VRRM_max":"STEP_THREE","Irating_LS_dual":"STEP_THREE","Pkgs_Diodes":"STEP_THREE","DiodesVIPTgood":"STEP_THREE","Losscomp_diode":"STEP_THREE","Num_pll_fet":"STEP_THREE","Rdamp":"STEP_THREE","BVdss_min":"STEP_THREE","BVdss_max":"STEP_THREE","Irating_HS":"STEP_THREE","Pkgs_FET":"STEP_THREE","FETsVIPTgood":"STEP_THREE","Losscomp_FET":"STEP_THREE","group-selected-diode-fet":"STEP_THREE","SemiconLossSummaryTable":"STEP_THREE","DF_CV":"STEP_FOUR","DF_CI":"STEP_FOUR","DgF_Cout":"STEP_FOUR","group-total-output-cap":"STEP_FOUR","Num_Cpll":"STEP_FOUR","Cout_per":"STEP_FOUR","ESRmax_per":"STEP_FOUR","Vminrat_cap":"STEP_FOUR","Iminrat_cap":"STEP_FOUR","DeltaVout_max":"STEP_FOUR","Voutpk_max":"STEP_FOUR","Icaprms_maxper":"STEP_FOUR","Snub_sel":"STEP_FIVE","Lpar":"STEP_FIVE","Cpar":"STEP_FIVE","Csnub":"STEP_FIVE","Vrat_Csnub":"STEP_FIVE","Rsnub":"STEP_FIVE","Psnub":"STEP_FIVE","Prat_Rsnub":"STEP_FIVE"},"StepOrder":["STEP_ONE","STEP_TWO","STEP_THREE","STEP_FOUR","STEP_FIVE","STEP_ANALYSIS","SCHEMATIC","BOM","REPORT"]};}var _prevaled=prevaled;var StepOrder=_prevaled.StepOrder;var getStepDataByKey=function getStepDataByKey(key){return prevaled.stepData[key];};/**
 * Returns the parent step given a field.
 *
 * @export
 * @param {string} field
 * @returns {string | null}
 */function getStepByField(field){return field?prevaled.KeyToStepMap[field]:null;}/**
 * Returns a list of fields given a step id
 *
 * @export
 * @param {string} field
 * @returns {string[]}
 */function getStepFields(field){return __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(prevaled.StepToKeyMap,function(step){return step.fields.includes(field);});}// eslint-disable-next-line no-unused-vars
function getNextFieldsByStep(step){var index=__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(prevaled.StepToKeyMap,function(s){return s.id===step;});var remaining=__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(prevaled.StepToKeyMap,index).filter(function(i){return i;}).map(function(i){return i.fields;});_uid2(step,remaining);return __WEBPACK_IMPORTED_MODULE_2_lodash_flatten___default()(remaining);}/**
 * Returns a list of fields after the given fields
 * @param {string} field
 * @returns {string[]}
 */function getNextFields(field,forSameStep){var step=getStepByField(field);var stepIndex=__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(prevaled.StepToKeyMap,['id',step]);var remaininSteps=__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(prevaled.StepToKeyMap,stepIndex+1);// Get any remaining fields for this step
var partialStep=prevaled.StepToKeyMap[stepIndex];var fieldIndex=__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(partialStep.fields,function(f){return f===field;});var rest=__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(partialStep.fields,fieldIndex+1);if(forSameStep){return rest;}// $FlowIgnore
return[].concat(rest,remaininSteps.reduce(function(a,s){return[].concat(s.fields,a);},[]));}function getFieldData(field){var step=getStepByField(field);if(!step)return{};var data=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(prevaled.stepData,[step,'steps']);return __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(data,function(s,d){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(d,['fields',field],{});},{});}

/***/ }),

/***/ "./src/utils/validators.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minLength */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isInteger; });
/* unused harmony export inRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange__ = __webpack_require__("./node_modules/lodash/inRange.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./src/utils/index.js");
/**
 * 
 * @format
 */var minLength={test:function test(val,threshold){return val.length>parseInt(threshold,10);},message:function message(val,threshold){return'Value must be greater than '+threshold+'.';}};var isNumber={test:function test(val){return Object(__WEBPACK_IMPORTED_MODULE_1____["l" /* isNumeric */])(val);},message:function message(){return'Must be a number.';}};var isInteger={test:function test(val){// eslint-disable-next-line no-restricted-globals
if(isNaN(+val))return false;// eslint-disable-next-line no-bitwise
return(parseFloat(+val)|0)===+val;},message:function message(){return'Must be an integer.';}};var inRange={test:function test(val,range){return __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(Number(val),range.min,range.max)||Number(val)===range.max;},message:function message(){return'Value out of range.';}};/* unused harmony default export */ var _unused_webpack_default_export = ({minLength:minLength,isNumber:isNumber,inRange:inRange});

/***/ })

},["./src/index.js"]);


// WEBPACK FOOTER //
// static/js/2.0ff4cd3f.js